/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Always sent */
export enum BandFinalHistoryState {
  PLAYED = "PLAYED",
  CARRIED = "CARRIED",
}

export enum BandFinalState {
  RUNNING = "RUNNING",
  LOCKED = "LOCKED",
  PLAYED = "PLAYED",
  CARRIED = "CARRIED",
}

export enum ArenaReportRoundWinnerEnum {
  T = "t",
  Ct = "ct",
}

export enum ArenaResultReportWinnerSideEnum {
  T = "t",
  Ct = "ct",
}

export enum ArenaAccessReasonEnum {
  COMING_SOON = "COMING_SOON",
  SKIN_EXCHANGE_REQUIRED = "SKIN_EXCHANGE_REQUIRED",
}

export enum CaseBattleLobbyMode {
  Classic = "classic",
  Crazy = "crazy",
  Sharing = "sharing",
  LastCase = "last_case",
}

export enum CaseBattleLobbySort {
  PriceDesc = "price_desc",
  PriceAsc = "price_asc",
  Newest = "newest",
}

export enum Cs2MatchStatus {
  Pending = "pending",
  Parsed = "parsed",
  Expired = "expired",
  Failed = "failed",
}

/** offline / online in CS2 / on a game server */
export enum Cs2PresenceState {
  Offline = "offline",
  Online = "online",
  InMatch = "in_match",
}

export enum Cs2MatchLinkStatus {
  AwaitingShareCode = "awaiting_share_code",
  Active = "active",
  InvalidAuth = "invalid_auth",
  InvalidCode = "invalid_code",
  Error = "error",
}

export enum GetShopSkinsSortBy {
  PriceDesc = "price_desc",
  PriceAsc = "price_asc",
}

/** held / review — reward waits for the check; released — paid; voided — not paid; null — before the hold existed */
export enum ReferralRewardStatus {
  Held = "held",
  Review = "review",
  Released = "released",
  Voided = "voided",
}

export enum NewsTwitterCard {
  SummaryLargeImage = "summary_large_image",
}

export enum NewsOgType {
  Article = "article",
}

export enum NewsTextDirection {
  Ltr = "ltr",
  Rtl = "rtl",
}

export enum NewsInlineType {
  Text = "text",
  Code = "code",
  Break = "break",
  Strong = "strong",
  Emphasis = "emphasis",
  Link = "link",
}

export enum NewsBlockType {
  Heading = "heading",
  Paragraph = "paragraph",
  List = "list",
  Quote = "quote",
  EditorialComment = "editorial_comment",
  Code = "code",
  Divider = "divider",
}

export enum NewsCategory {
  TournamentsMatches = "tournaments_matches",
  TeamsTransfers = "teams_transfers",
  PlayersCommunity = "players_community",
  Cs2Updates = "cs2_updates",
  RankingsStatistics = "rankings_statistics",
  IndustryRules = "industry_rules",
}

export enum NewsLang {
  Ru = "ru",
  En = "en",
  Uz = "uz",
  Fa = "fa",
  Pt = "pt",
  Tr = "tr",
  Uk = "uk",
  De = "de",
  Es = "es",
  Pl = "pl",
}

export enum WikiSearchType {
  Skin = "skin",
  Weapon = "weapon",
  Container = "container",
  Collection = "collection",
  Sticker = "sticker",
  Agent = "agent",
  Charm = "charm",
  MusicKit = "music_kit",
  Patch = "patch",
  Graffiti = "graffiti",
  Highlight = "highlight",
  Pin = "pin",
  Pass = "pass",
  Collectible = "collectible",
  Key = "key",
}

/** pairs — скины идут парами (нож + перчатки), показывать блоками по два */
export enum WikiSelectionLayout {
  Grid = "grid",
  Pairs = "pairs",
}

export enum WikiPathEntityType {
  Skin = "skin",
  Weapon = "weapon",
  Container = "container",
  Sticker = "sticker",
  Agent = "agent",
  Charm = "charm",
  MusicKit = "music_kit",
  Patch = "patch",
  Graffiti = "graffiti",
  Highlight = "highlight",
  Pin = "pin",
  Pass = "pass",
  Collectible = "collectible",
  Key = "key",
}

export enum WikiCollectibleKind {
  Coin = "coin",
  Trophy = "trophy",
  Medal = "medal",
  Other = "other",
}

export enum WikiAgentSide {
  T = "t",
  Ct = "ct",
}

export enum WikiStickerKind {
  Autograph = "autograph",
  Team = "team",
  Event = "event",
  Other = "other",
}

/** sticker_pack — набор наклеек из «Мастерской», а не коллекция */
export enum WikiCollectionKind {
  Collection = "collection",
  StickerPack = "sticker_pack",
}

export enum ItemSource {
  CASE_OPENING = "CASE_OPENING",
  CASE_BATTLE = "CASE_BATTLE",
  ADMIN_GRANT = "ADMIN_GRANT",
  AUCTION = "AUCTION",
  CONTRACT = "CONTRACT",
  UPGRADE = "UPGRADE",
  GIFT = "GIFT",
  FROM_SHOP = "FROM_SHOP",
  DRAW = "DRAW",
  CONTEST = "CONTEST",
  DAILY_GIVEAWAY = "DAILY_GIVEAWAY",
  RUSH_MID = "RUSH_MID",
  ARENA = "ARENA",
  RUSH_RAFFLE = "RUSH_RAFFLE",
  ROULETTE = "ROULETTE",
  BAND_CASE = "BAND_CASE",
  BAND_RAFFLE = "BAND_RAFFLE",
  BAND_RACE = "BAND_RACE",
  RAIN = "RAIN",
}

export enum WikiStickerEffect {
  Paper = "paper",
  Glitter = "glitter",
  Holo = "holo",
  Foil = "foil",
  Gold = "gold",
  Lenticular = "lenticular",
  Embroidered = "embroidered",
}

export enum WikiVariantKind {
  Normal = "normal",
  Stattrak = "stattrak",
  Souvenir = "souvenir",
}

export enum WikiExterior {
  Fn = "fn",
  Mw = "mw",
  Ft = "ft",
  Ww = "ww",
  Bs = "bs",
}

export enum WikiSkinSort {
  Rarity = "rarity",
  Name = "name",
  Release = "release",
  Price = "price",
}

export enum WikiItemType {
  Sticker = "sticker",
  Agent = "agent",
  Charm = "charm",
  MusicKit = "music_kit",
  Patch = "patch",
  Graffiti = "graffiti",
  Highlight = "highlight",
  Pin = "pin",
  Pass = "pass",
  Collectible = "collectible",
  Key = "key",
}

export enum WikiContainerKind {
  Case = "case",
  StickerCapsule = "sticker_capsule",
  AutographCapsule = "autograph_capsule",
  SouvenirPackage = "souvenir_package",
  MusicKitBox = "music_kit_box",
  PatchCapsule = "patch_capsule",
  PinsCapsule = "pins_capsule",
  GraffitiBox = "graffiti_box",
  Other = "other",
}

export enum WikiRareKind {
  Knives = "knives",
  Gloves = "gloves",
  KnivesAndGloves = "knives_and_gloves",
}

export enum WikiCategory {
  Pistols = "pistols",
  Rifles = "rifles",
  Smgs = "smgs",
  Heavy = "heavy",
  Knives = "knives",
  Gloves = "gloves",
  Equipment = "equipment",
}

export enum WikiLang {
  En = "en",
  Ru = "ru",
  Uz = "uz",
  Tr = "tr",
  Pt = "pt",
  Fa = "fa",
  Uk = "uk",
  De = "de",
  Es = "es",
  Pl = "pl",
}

export enum WikiSitemapEntryType {
  Home = "home",
  Weapon = "weapon",
  Skin = "skin",
  Container = "container",
  Collection = "collection",
  Guide = "guide",
  Selection = "selection",
  Sticker = "sticker",
  Agent = "agent",
  Charm = "charm",
  MusicKit = "music_kit",
  Patch = "patch",
  Graffiti = "graffiti",
  Highlight = "highlight",
  Pin = "pin",
  Pass = "pass",
  Collectible = "collectible",
  Key = "key",
}

export enum PartnerTransactionType {
  RegistrationCommission = "registration_commission",
  DepositCommission = "deposit_commission",
  Withdrawal = "withdrawal",
  Deposit = "deposit",
  BalanceTransfer = "balance_transfer",
}

export interface GameStatsResponse {
  /**
   * Total number of case openings
   * @example 12345
   */
  caseOpenings: number;
  /**
   * Total number of contracts
   * @example 678
   */
  contracts: number;
  /**
   * Total number of upgrades
   * @example 910
   */
  upgrades: number;
  /**
   * Total number of case battles
   * @example 42
   */
  battles: number;
}

export interface Partner {
  /** Partner ID */
  id: string;
  /** User ID */
  userId: string;
  /** Partner referral code */
  partnerCode: string;
  /** Commission in rubles */
  registrationCommission: number;
  /** Commission rate (0.15 = 15%) */
  depositCommissionRate: number;
  /** Current balance in rubles */
  balance: number;
  /** Total earned in rubles */
  totalEarned: number;
  /** Total withdrawn in rubles */
  totalWithdrawn: number;
  status: PartnerStatusEnum;
  /**
   * Creation date
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update date
   * @format date-time
   */
  updatedAt: string;
  /** Total users (direct + referrals) */
  totalUsers?: number;
  /** Total profit from all users in rubles */
  totalProfit?: number;
  user?: {
    id: string;
    telegramId?: string | null;
    username?: string | null;
    firstName?: string | null;
    lastName?: string | null;
  };
}

export interface PartnerTransferInfo {
  /** Current partner balance in rubles */
  balance: number;
  status: PartnerTransferInfoStatusEnum;
  /** Credits credited per ruble transferred */
  creditsPerRuble: number;
  /** Minimum transfer amount in rubles */
  minTransferRubles: number;
}

export interface TransferPartnerBalance {
  /**
   * Amount to transfer from the partner balance, in whole rubles
   * @min 1
   * @example 500
   */
  amountRubles: number;
}

export interface TransferPartnerBalanceResponse {
  /** Transferred amount in rubles */
  amountRubles: number;
  /** Credits added to the partner account balance */
  credits: number;
  /** Partner balance after the transfer, in rubles */
  partnerBalance: number;
}

export interface PartnerDailyStats {
  /** Date (YYYY-MM-DD) */
  date: string;
  /** Number of registrations */
  registrationCount: number;
  /** Profit from registrations in rubles */
  registrationProfit: number;
  /** Profit from deposits in rubles */
  depositProfit: number;
  /** Total profit in rubles */
  totalProfit: number;
}

export interface ListPartnerDailyStatsResponse {
  stats: PartnerDailyStats[];
  /** Total number of records */
  total: number;
  /** Current page number */
  page: number;
  /** Number of records per page */
  limit: number;
}

export interface PartnerWithdrawal {
  /** Withdrawal ID */
  id: string;
  /** Partner ID */
  partnerId: string;
  /** Amount in rubles. Negative = withdrawal, Positive = deposit */
  amount: number;
  comment?: string;
  /**
   * Creation date
   * @format date-time
   */
  createdAt: string;
  partner?: Partner;
}

export interface ListPartnerWithdrawalsResponse {
  withdrawals: PartnerWithdrawal[];
  /** Total number of records */
  total: number;
  /** Current page number */
  page: number;
  /** Number of records per page */
  limit: number;
}

export interface PartnerTransaction {
  /** Transaction ID */
  id: string;
  /** Partner ID */
  partnerId: string;
  type: PartnerTransactionType;
  /** Amount in rubles */
  amount: number;
  /** Balance before transaction in rubles */
  balanceBefore: number;
  /** Balance after transaction in rubles */
  balanceAfter: number;
  referredUserId?: string;
  referredUser?: {
    id: string;
    telegramId?: string | null;
    username?: string | null;
    firstName?: string | null;
    lastName?: string | null;
  };
  metadata?: object;
  /**
   * Creation date
   * @format date-time
   */
  createdAt: string;
}

export interface ListPartnerTransactionsResponse {
  transactions: PartnerTransaction[];
  /** Total number of records */
  total: number;
  /** Current page number */
  page: number;
  /** Number of records per page */
  limit: number;
}

export interface PublicConfigResponse {
  /**
   * Yandex Metrika counter ID
   * @example 106798999
   */
  yandexMetrikaCounterId: number | null;
  /**
   * Whether Ya Mode is enabled
   * @example false
   */
  yaModeEnabled: boolean;
  /**
   * Meta (Facebook) Pixel ID
   * @example "986321990805045"
   */
  metaPixelId: string | null;
  /**
   * Whether Turnstile captcha verification is enabled
   * @example true
   */
  turnstileEnabled: boolean;
}

export interface WikiSitemapLangDate {
  lang: WikiLang;
  /**
   * Когда менялся текст на этом языке
   * @format date-time
   */
  updatedAt: string;
}

export interface WikiSitemapEntry {
  type: WikiSitemapEntryType;
  slug: string;
  /**
   * Адрес страницы без языка
   * @example "/wiki/stickers/s1mple-london-2018"
   */
  path: string;
  langs: WikiLang[];
  /**
   * Последняя правка текста на любом из языков
   * @format date-time
   */
  updatedAt: string;
  langDates: WikiSitemapLangDate[];
}

export interface WikiSitemap {
  entries: WikiSitemapEntry[];
}

export interface WikiFaqItem {
  q: string;
  a: string;
}

export interface WikiPageText {
  title: string;
  description: string;
  h1: string;
  intro: string;
  /** Markdown */
  body: string;
  faq: WikiFaqItem[];
  /** @format date-time */
  reviewedAt: string | null;
  /**
   * Когда текст впервые опубликован
   * @format date-time
   */
  publishedAt: string | null;
  /**
   * Последняя правка текста
   * @format date-time
   */
  updatedAt: string;
  /** Всегда true: наружу отдаётся только опубликованный текст */
  indexable: boolean;
}

export interface WikiCategoryCard {
  category: WikiCategory;
  name: string;
  skinCount: number;
  /** Скин высшей редкости категории, с текстом на языке — в приоритете */
  imageUrl: string | null;
  rarityColor: string | null;
}

export interface WikiSkinWeaponRef {
  slug: string;
  name: string;
}

export interface WikiRarity {
  /** @example "rarity_legendary_weapon" */
  id: string;
  name: string;
  /** @example "#d32ce6" */
  color: string;
  rank: number;
}

export interface WikiSkinCard {
  /** @example "ak-47-redline" */
  slug: string;
  name: string;
  nameEn: string;
  weapon: WikiSkinWeaponRef;
  rarity: WikiRarity;
  imageUrl: string;
  hasStatTrak: boolean;
  hasSouvenir: boolean;
  minPriceUsd: number | null;
  /** Базовая модель ножа без раскраски: это не скин, ссылка ведёт на страницу оружия */
  vanilla: boolean;
}

export interface WikiWeaponCard {
  /** @example "ak-47" */
  slug: string;
  name: string;
  category: WikiCategory;
  skinCount: number;
  imageUrl: string | null;
}

export interface WikiSelectionCard {
  slug: string;
  /** h1 опубликованного текста на языке */
  title: string;
  description: string;
  intro: string;
  skinCount: number;
  imageUrl: string | null;
  /** Картинки первых скинов подборки, до 4 */
  previewImages: string[];
}

export interface WikiGuideCard {
  slug: string;
  /** h1 опубликованного текста на языке */
  title: string;
  description: string;
  intro: string;
  coverImageUrl: string | null;
  /** @format date-time */
  reviewedAt: string | null;
}

export interface WikiContainerCard {
  slug: string;
  name: string;
  nameEn: string;
  imageUrl: string;
  /**
   * Ранняя дата выхода коллекций кейса
   * @format date
   */
  firstSaleDate: string | null;
  /** Оружейные скины кейса без редкой группы */
  skinCount: number;
  rareKind: WikiRareKind | null;
  kind: WikiContainerKind;
  /** Записи содержимого капсулы или набора: каждый эффект наклейки и StatTrak™-набор — отдельная */
  itemCount: number;
}

export interface WikiItemTypeCard {
  type: WikiItemType;
  count: number;
  imageUrl: string;
}

export interface WikiHome {
  page: WikiPageText | null;
  availableLangs: WikiLang[];
  /** Категории оружия с числом скинов, в порядке pistols…equipment */
  categories: WikiCategoryCard[];
  /** До 12 скинов с опубликованным текстом на языке, по одному на оружие в первую очередь */
  featuredSkins: WikiSkinCard[];
  weapons: WikiWeaponCard[];
  featuredSelections: WikiSelectionCard[];
  guides: WikiGuideCard[];
  containers: WikiContainerCard[];
  /** Разделы предметов, где они есть, в порядке WikiItemType; обложка — предмет высшей редкости */
  itemTypes: WikiItemTypeCard[];
  /** Всего кейсов, капсул и наборов игры */
  containerCount: number;
}

export interface WikiCategoryPage {
  category: WikiCategoryCard;
  /** Оружие категории, у которого есть скины */
  weapons: WikiWeaponCard[];
  /** Скинов категории с опубликованным текстом на языке */
  articleCount: number;
  /** До 12 скинов категории с опубликованным текстом на языке, по одному на оружие в первую очередь */
  featuredSkins: WikiSkinCard[];
  /** Подборки со скинами категории, сначала те, где их больше */
  selections: WikiSelectionCard[];
  guides: WikiGuideCard[];
}

export interface WikiWeaponFacet {
  slug: string;
  name: string;
  category: WikiCategory;
}

export interface WikiNamedRef {
  slug: string;
  name: string;
}

export interface WikiSkinFacets {
  weapons: WikiWeaponFacet[];
  rarities: WikiRarity[];
  collections: WikiNamedRef[];
  containers: WikiNamedRef[];
}

export interface WikiSkinsPage {
  items: WikiSkinCard[];
  total: number;
  page: number;
  pageCount: number;
  perPage: number;
  /** Варианты для формы фильтров на языке :lang */
  facets: WikiSkinFacets;
}

export interface WikiSkinWeaponDetailsRef {
  slug: string;
  name: string;
  category: WikiCategory;
}

export interface WikiSkinPhase {
  phase: string;
  imageUrl: string;
}

export interface WikiVariant {
  exterior: WikiExterior | null;
  kind: WikiVariantKind;
  phase: string | null;
  marketHashName: string;
  imageUrl: string;
  priceUsd: number | null;
  /** @format date-time */
  priceUpdatedAt: string | null;
}

export interface WikiWearImage {
  imageUrl: string;
  exteriors: WikiExterior[];
}

export interface WikiSkinCollectionRef {
  slug: string;
  name: string;
  imageUrl: string;
}

export interface WikiSkinContainerRef {
  slug: string;
  name: string;
  imageUrl: string;
  rare: boolean;
  kind: WikiContainerKind;
}

export interface WikiShotCaseRef {
  slug: string;
  name: string;
  imageUrl: string;
  imageCutoutUrl: string | null;
  priceInCredits: number;
}

export interface WikiSkinDetails {
  slug: string;
  name: string;
  nameEn: string;
  /** Пустая строка у ванильного ножа без покраски */
  finishName: string;
  description: string | null;
  weapon: WikiSkinWeaponDetailsRef;
  rarity: WikiRarity;
  minFloat: number | null;
  maxFloat: number | null;
  hasStatTrak: boolean;
  hasSouvenir: boolean;
  phases: WikiSkinPhase[];
  variants: WikiVariant[];
  wearImages: WikiWearImage[];
  collections: WikiSkinCollectionRef[];
  containers: WikiSkinContainerRef[];
  similar: WikiSkinCard[];
  shotCases: WikiShotCaseRef[];
  /** @format date */
  releaseDate: string | null;
  page: WikiPageText | null;
  availableLangs: WikiLang[];
  /** @format date-time */
  updatedAt: string;
  /** Только у ножа без раскраски: это не скин, его страница — страница оружия с этим slug */
  weaponSlug?: string;
}

export interface WikiSkinRedirect {
  redirectSlug: string;
}

export interface WikiItemTint {
  /** @example "Brick Red" */
  name: string;
  /** @example "#874444" */
  color: string;
}

export interface WikiDropItemVariant {
  effect: WikiStickerEffect | null;
  /** Наклейка в слэбе */
  slab: boolean;
  stattrak: boolean;
  /** Цвет граффити */
  tint: WikiItemTint | null;
}

export interface WikiDrop {
  /** Id выпавшего предмета в инвентаре */
  id: string;
  /** Кому выпал: аватар — /api/users/avatar/{userId} */
  userId: string;
  /** Имя без рекламы чужих ботов; пустое — Anonymous */
  userName: string;
  marketHashName: string;
  kind: WikiVariantKind;
  exterior: WikiExterior | null;
  /** Версия предмета вики: эффект, слэб, цвет, StatTrak™; у скина и ножа — null, версию задают kind и exterior */
  itemVariant: WikiDropItemVariant | null;
  source: ItemSource;
  /** Кейс SHOT, из которого выпал предмет; у остальных игр — null */
  caseName: string | null;
  /** @format date-time */
  acquiredAt: string;
}

export interface WikiDrops {
  /** До 10 последних выпадений во всех версиях предмета, новые первыми; source — CASE_OPENING, BAND_CASE, GIFT (кейс), CASE_BATTLE, UPGRADE, CONTRACT, RUSH_MID или ROULETTE */
  drops: WikiDrop[];
}

export interface WikiWeapon {
  /** @example "ak-47" */
  slug: string;
  name: string;
  category: WikiCategory;
  skinCount: number;
  imageUrl: string | null;
  nameEn: string;
}

export interface WikiWeaponPage {
  weapon: WikiWeapon;
  page: WikiPageText | null;
  availableLangs: WikiLang[];
  skins: WikiSkinCard[];
}

export interface WikiContainerKindCount {
  kind: WikiContainerKind;
  count: number;
}

export interface WikiContainers {
  items: WikiContainerCard[];
  kind: WikiContainerKind | null;
  /** Виды, у которых есть контейнеры, в порядке вкладок */
  kinds: WikiContainerKindCount[];
  total: number;
  page: number;
  pageCount: number;
  perPage: number;
}

export interface WikiItemCard {
  type: WikiItemType;
  slug: string;
  name: string;
  imageUrl: string;
  rarity: WikiRarity | null;
  minPriceUsd: number | null;
}

export interface WikiItemsPage {
  type: WikiItemType;
  items: WikiItemCard[];
  total: number;
  page: number;
  pageCount: number;
  perPage: number;
  /** Предметов этого типа с опубликованным текстом на языке: без них список не индексируется */
  articleCount: number;
}

export interface WikiItemVariant {
  /** null — предмет не продаётся на торговой площадке */
  marketHashName: string | null;
  effect: WikiStickerEffect | null;
  /** Наклейка в слэбе */
  slab: boolean;
  stattrak: boolean;
  /** Цвет граффити */
  tint: WikiItemTint | null;
  imageUrl: string;
  rarity: WikiRarity | null;
  priceUsd: number | null;
  /** @format date-time */
  priceUpdatedAt: string | null;
}

export interface WikiContainerRef {
  slug: string;
  name: string;
  imageUrl: string;
  kind: WikiContainerKind;
}

export interface WikiCollectionRef {
  slug: string;
  name: string;
  imageUrl: string;
  /** sticker_pack — набор наклеек из «Мастерской», а не коллекция */
  kind: WikiCollectionKind;
}

export interface WikiStickerFacts {
  kind: WikiStickerKind;
  tournament: string | null;
  team: string | null;
  player: string | null;
}

export interface WikiAgentFacts {
  side: WikiAgentSide;
}

export interface WikiMusicKitFacts {
  artist: string | null;
  title: string;
}

export interface WikiHighlightFacts {
  /** @example "Austin 2025" */
  event: string;
  /** @example "Quarterfinal" */
  stage: string | null;
  /** @example "Mirage" */
  map: string | null;
  teams: string[];
  player: string | null;
  videoUrl: string | null;
}

export interface WikiCollectibleFacts {
  kind: WikiCollectibleKind;
}

export interface WikiItemDetails {
  type: WikiItemType;
  slug: string;
  name: string;
  nameEn: string;
  /** null у наклейки — редкость у каждого эффекта своя */
  rarity: WikiRarity | null;
  imageUrl: string;
  description: string | null;
  variants: WikiItemVariant[];
  /** Капсулы, наборы и кейсы, из которых выпадает предмет */
  containers: WikiContainerRef[];
  collections: WikiCollectionRef[];
  shotCases: WikiShotCaseRef[];
  /** @format date */
  releaseDate: string | null;
  page: WikiPageText | null;
  availableLangs: WikiLang[];
  /** @format date-time */
  updatedAt: string;
  sticker: WikiStickerFacts | null;
  agent: WikiAgentFacts | null;
  musicKit: WikiMusicKitFacts | null;
  highlight: WikiHighlightFacts | null;
  /** Только у монет, трофеев, медалей и прочих наград */
  collectible: WikiCollectibleFacts | null;
  /** Только у ключа: кейсы, которые он открывает */
  opens: WikiContainerRef[];
}

export interface WikiPathsRequest {
  /**
   * market_hash_name предметов
   * @maxItems 500
   * @minItems 1
   */
  names: string[];
}

export interface WikiPath {
  marketHashName: string;
  entityType: WikiPathEntityType;
  slug: string;
  /**
   * Адрес страницы без языка
   * @example "/wiki/stickers/s1mple-london-2018"
   */
  path: string;
}

export interface WikiPaths {
  /** Только названия, у которых есть страница; порядок — как в запросе */
  items: WikiPath[];
}

export interface WikiRarityGroup {
  rarity: WikiRarity;
  skins: WikiSkinCard[];
}

export interface WikiEntityLink {
  slug: string;
  name: string;
  imageUrl: string;
}

export interface WikiItemRarityGroup {
  rarity: WikiRarity | null;
  items: WikiItemCard[];
}

export interface WikiContainerPage {
  container: WikiContainerCard;
  page: WikiPageText | null;
  availableLangs: WikiLang[];
  groups: WikiRarityGroup[];
  rareSkins: WikiSkinCard[];
  /** Коллекции оружейных скинов кейса */
  collections: WikiEntityLink[];
  /** Содержимое капсулы или набора по редкости; у кейса со скинами пусто */
  itemGroups: WikiItemRarityGroup[];
  /** Кейсы SHOT, в которых сам контейнер — приз */
  shotCases: WikiShotCaseRef[];
}

export interface WikiCollectionCard {
  slug: string;
  name: string;
  nameEn: string;
  imageUrl: string;
  /** @format date */
  releaseDate: string | null;
  skinCount: number;
  /** Предметов коллекции кроме скинов: агенты, брелоки, наклейки, граффити */
  itemCount: number;
}

export interface WikiCollections {
  items: WikiCollectionCard[];
}

export interface WikiCollectionPage {
  collection: WikiCollectionCard;
  page: WikiPageText | null;
  availableLangs: WikiLang[];
  groups: WikiRarityGroup[];
  /** Кейсы, из которых выпадают скины коллекции */
  containers: WikiEntityLink[];
  /** Агенты, брелоки, наклейки и граффити коллекции по редкости */
  itemGroups: WikiItemRarityGroup[];
}

export interface WikiGuides {
  items: WikiGuideCard[];
}

export interface WikiGuideRef {
  slug: string;
  coverImageUrl: string | null;
}

export interface WikiGuidePage {
  guide: WikiGuideRef;
  page: WikiPageText;
  availableLangs: WikiLang[];
}

export interface WikiSelections {
  items: WikiSelectionCard[];
}

export interface WikiSelectionRef {
  slug: string;
  skinCount: number;
  /** pairs — скины идут парами (нож + перчатки), показывать блоками по два */
  layout: WikiSelectionLayout;
}

export interface WikiSelectionPage {
  selection: WikiSelectionRef;
  page: WikiPageText;
  availableLangs: WikiLang[];
  skins: WikiSkinCard[];
}

export interface WikiSearchHit {
  type: WikiSearchType;
  slug: string;
  /**
   * Адрес страницы без языка
   * @example "/wiki/skins/ak-47-redline"
   */
  path: string;
  name: string;
  nameEn: string;
  imageUrl: string | null;
  rarityColor: string | null;
}

export interface WikiSearchPage {
  items: WikiSearchHit[];
  total: number;
  page: number;
  pageCount: number;
}

export interface NewsSitemapTranslation {
  lang: NewsLang;
  slug: string;
  url: string;
  title: string;
}

export interface NewsSitemapEntry {
  /** @format date-time */
  publishedAt: string | null;
  /** @format date-time */
  updatedAt: string;
  translations: NewsSitemapTranslation[];
}

export interface NewsSitemap {
  items: NewsSitemapEntry[];
}

export interface RegisterNewsView {
  /** @format uuid */
  articleId: string;
  /**
   * Random per-tab session id kept in sessionStorage
   * @pattern /^[A-Za-z0-9-]{8,64}$/
   */
  sessionId: string;
}

export interface NewsViewResult {
  counted: boolean;
}

export interface NewsPublicImage {
  /** Absolute URL of the 1200×630 image */
  url: string;
  width: number;
  height: number;
  alt: string;
}

export interface NewsListEntry {
  id: string;
  slug: string;
  title: string;
  description: string;
  category: NewsCategory;
  categoryName: string;
  /** @format date-time */
  publishedAt: string | null;
  url: string;
  image: NewsPublicImage;
}

export interface NewsListCategory {
  category: NewsCategory;
  name: string;
}

export interface NewsList {
  /** Языки, на которых в этом фильтре есть новости */
  languages: NewsLang[];
  items: NewsListEntry[];
  categories: NewsListCategory[];
  total: number;
  page: number;
  limit: number;
}

export interface NewsInline {
  type: NewsInlineType;
  /** Text for text and code nodes */
  value?: string;
  /** Absolute http(s) URL for link nodes */
  href?: string;
  children?: NewsInline[];
}

export interface NewsListItemBlocks {
  blocks: NewsBlock[];
}

export interface NewsCommentParagraph {
  text: string;
  children: NewsInline[];
}

export interface NewsBlock {
  type: NewsBlockType;
  /** Heading level 2–6 */
  level?: number;
  children?: NewsInline[];
  ordered?: boolean;
  start?: number | null;
  items?: NewsListItemBlocks[];
  /** Nested blocks of a regular quote */
  blocks?: NewsBlock[];
  /** Paragraphs of an editorial comment */
  paragraphs?: NewsCommentParagraph[];
  /** Code block text */
  value?: string;
}

export interface NewsTranslation {
  lang: NewsLang;
  slug: string;
  url: string;
}

export interface NewsSeoAlternate {
  lang: NewsLang;
  hreflang: string;
  url: string;
}

export interface NewsSeo {
  documentTitle: string;
  description: string;
  canonicalUrl: string;
  htmlLang: string;
  dir: NewsTextDirection;
  indexable: boolean;
  alternates: NewsSeoAlternate[];
  xDefaultUrl: string | null;
  ogType: NewsOgType;
  ogTitle: string;
  ogDescription: string;
  ogUrl: string;
  ogSiteName: string;
  ogLocale: string;
  ogLocaleAlternates: string[];
  image: NewsPublicImage;
  /** @format date-time */
  publishedTime: string | null;
  /** @format date-time */
  modifiedTime: string;
  section: string;
  twitterCard: NewsTwitterCard;
  twitterTitle: string;
  twitterDescription: string;
  twitterImage: string;
  twitterImageAlt: string;
  /** NewsArticle JSON-LD, already escaped for a <script> tag */
  jsonLd: string;
}

export interface NewsArticle {
  id: string;
  lang: NewsLang;
  slug: string;
  title: string;
  description: string;
  lead: string;
  blocks: NewsBlock[];
  category: NewsCategory;
  categoryName: string;
  /** @format date-time */
  publishedAt: string | null;
  /** @format date-time */
  updatedAt: string;
  readingMinutes: number;
  image: NewsPublicImage;
  translations: NewsTranslation[];
  canonicalUrl: string;
  seo: NewsSeo;
  /** Global switch: send a view event and show the counter */
  viewCounterEnabled: boolean;
  /** Null while the counter is switched off */
  totalViews: number | null;
}

export interface BasicHealth {
  /** @example "ok" */
  status: BasicHealthStatusEnum;
  /** @example "2024-01-15T12:00:00.000Z" */
  timestamp: string;
  /** @example 123.45 */
  uptime: number;
}

export interface DependencyCheck {
  /** @example "ok" */
  status: DependencyCheckStatusEnum;
  /** @example 5 */
  latency?: number;
}

export interface DependencyChecks {
  database: DependencyCheck;
  redis: DependencyCheck;
}

export interface ReadinessCheck {
  /** @example "ok" */
  status: ReadinessCheckStatusEnum;
  /** @example "2024-01-15T12:00:00.000Z" */
  timestamp: string;
  checks: DependencyChecks;
}

export interface HealthCheck {
  /** @example "ok" */
  status: HealthCheckStatusEnum;
  /** @example "2024-01-15T12:00:00.000Z" */
  timestamp: string;
}

export interface RegisterUser {
  /**
   * Referral code from the inviter
   * @example "123456789"
   */
  referralCode?: string;
  /**
   * Start parameter from Telegram (startapp or bot start parameter)
   * @example "ref_123456789"
   */
  startParam?: string;
  /**
   * Yandex Metrica Client ID
   * @example "1234567890123456789"
   */
  yaClientId?: string;
  /** Account ids previously seen on this device */
  u?: string[];
}

export interface RegisterResponse {
  /**
   * Indicates if the registration was successful
   * @example true
   */
  success: boolean;
  /**
   * The unique identifier of the created user
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  userId: string;
  /**
   * Whether this is the first registration (new user) or an existing user login
   * @example true
   */
  isNewUser: boolean;
}

export interface UserProfileResponse {
  /**
   * Unique user identifier
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  id: string;
  /**
   * User first name
   * @example "John"
   */
  firstName?: string | null;
  /**
   * User last name
   * @example "Doe"
   */
  lastName?: string | null;
  /**
   * User full name (computed)
   * @example "John Doe"
   */
  fullName: string;
  /**
   * Current credit balance
   * @example 25000
   */
  balanceInCredits: number;
  /**
   * ID of the user who referred this user
   * @example "b2c3d4e5-f6g7-8901-bcde-f23456789012"
   */
  referrerId?: string | null;
  /**
   * ISO 3166-1 alpha-2 country code
   * @example "US"
   */
  countryCode?: string | null;
  /**
   * User language preference
   * @example "ru"
   */
  languageCode?: string | null;
  /**
   * Whether case opening animations are enabled
   * @example true
   */
  animationsEnabled: boolean;
  /**
   * Whether notifications are enabled
   * @example true
   */
  notificationsEnabled: boolean;
  /**
   * Steam trade URL
   * @example "https://steamcommunity.com/tradeoffer/new/?partner=123456789&token=AbCdEfGh"
   */
  steamTradeUrl?: string;
  /**
   * Whether user has linked a Steam account
   * @example false
   */
  isSteamLinked: boolean;
  /**
   * Whether user has a linked Telegram identity (registered via Telegram)
   * @example true
   */
  hasTelegramIdentity: boolean;
  /**
   * Whether skins exchange feature is enabled for this user
   * @example false
   */
  skinsExchangeEnabled: boolean;
  /**
   * Whether case battles are restricted to skinExchangeEnabled users only
   * @example true
   */
  caseBattlesRestrictedMode: boolean;
  /**
   * Whether Russian Roulette is restricted to skinExchangeEnabled users only
   * @example true
   */
  rouletteRestrictedMode: boolean;
  /**
   * Whether user has opened at least one case
   * @example false
   */
  hasOpenedCases: boolean;
  /**
   * Whether user has made at least one successful payment
   * @example false
   */
  hasPayments: boolean;
  /**
   * Whether the withdrawal flow must present a Turnstile captcha for this user
   * @example true
   */
  withdrawalCaptchaRequired: boolean;
  /**
   * Account creation timestamp
   * @format date-time
   * @example "2024-01-15T10:30:00.000Z"
   */
  createdAt: string;
  /**
   * Last account update timestamp
   * @format date-time
   * @example "2024-01-15T10:30:00.000Z"
   */
  updatedAt: string;
  /**
   * Last time the trade link (partner ID) was changed
   * @format date-time
   * @example "2024-01-15T10:30:00.000Z"
   */
  lastTradeLinkChangedAt?: string | null;
}

export interface TopInventoryItem {
  /**
   * Inventory item ID
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  inventoryItemId: string;
  item: {
    hashName: string;
    name: string;
    imageUrl: string | null;
    rarityColor: string | null;
    rarityName: string | null;
    weapon: string | null;
    category: string | null;
    statTrak: boolean;
    souvenir: boolean;
  };
  /**
   * Price when the item was acquired (in credits)
   * @example 625000
   */
  acquiredPriceInCredits: number;
  /**
   * Price when the item was acquired (in rubles)
   * @example 2500
   */
  acquiredPriceInRubles: number;
  /**
   * Price when the item was acquired (in USD)
   * @example 27.78
   */
  acquiredPriceInUsd?: number;
  /**
   * When the item was acquired
   * @format date-time
   * @example "2024-01-15T10:30:00.000Z"
   */
  acquiredAt: string;
  /**
   * Source of the item (e.g., CASE, UPGRADE, CONTRACT)
   * @example "CASE"
   */
  source: string;
}

export interface CaseOpeningStats {
  /**
   * Case ID
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  caseId: string;
  /**
   * Case address segment: /cases/<slug>
   * @example "awp-case"
   */
  caseSlug: string;
  /**
   * Case name
   * @example "AWP Case"
   */
  caseName: string;
  /**
   * Case image URL
   * @example "https://example.com/cases/awp-case.png"
   */
  caseImageUrl: string;
  /**
   * Number of times this case was opened by the user
   * @example 45
   */
  openingsCount: number;
}

export interface Presence {
  /**
   * Whether the user is currently online
   * @example true
   */
  online: boolean;
  /**
   * What the user is currently doing (null when offline)
   * @example "opening_case"
   */
  activity?: PresenceActivityEnum;
  /**
   * When the user was last seen (ISO, null while online or if never tracked)
   * @example "2026-06-28T10:30:00.000Z"
   */
  lastSeenAt?: string | null;
}

export interface ProfileStatsResponse {
  /**
   * Full name of the user
   * @example "John Doe"
   */
  fullName: string;
  /**
   * Registration date
   * @format date-time
   * @example "2024-01-15T10:30:00.000Z"
   */
  createdAt: string;
  /**
   * User level
   * @example 15
   */
  level: number;
  /**
   * Total number of cases opened by the user
   * @example 142
   */
  totalCaseOpenings: number;
  /**
   * Total value of items received from case openings (in credits)
   * @example 28750
   */
  totalItemsValueCredits: number;
  /**
   * Number of friends referred by the user
   * @example 12
   */
  referralsCount: number;
  /**
   * Total number of upgrades performed by the user
   * @example 25
   */
  totalUpgrades: number;
  /**
   * Total number of contracts executed by the user
   * @example 18
   */
  totalContracts: number;
  /**
   * Total number of Rush Mid matches the user played
   * @example 7
   */
  totalRushMidGames: number;
  /**
   * Total number of case battles the user participated in
   * @example 42
   */
  totalCaseBattles: number;
  /** Top 3 most expensive items ever acquired by the user */
  topItems: TopInventoryItem[];
  /** Aggregated statistics of case openings (grouped by case) */
  caseOpeningsStats: CaseOpeningStats[];
  /**
   * User rank position based on XP (null if excluded from rating)
   * @example 1247
   */
  xpRank?: number | null;
  /** Active SHOT BAND membership — drives the profile aura/badge */
  bandMember: boolean;
  /** Online presence and current activity of the user */
  presence: Presence;
}

export interface Referral {
  /**
   * Unique identifier of the referred user
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  id: string;
  /**
   * Username of the referred user
   * @example "johndoe"
   */
  username: string | null;
  /**
   * First name of the referred user
   * @example "John"
   */
  firstName: string | null;
  /**
   * Last name of the referred user
   * @example "Doe"
   */
  lastName: string | null;
  /**
   * Display name (computed from firstName, lastName, or username)
   * @example "John Doe"
   */
  fullName: string;
  /**
   * Credits awarded for this referral
   * @example 500
   */
  creditsAwarded: number;
  /**
   * Indicates if this is a bonus referral
   * @example false
   */
  isBonus: boolean;
  /**
   * Whether the referral has been activated (first deposit or withdrawal)
   * @example true
   */
  activated: boolean;
  /** held / review — reward waits for the check; released — paid; voided — not paid; null — before the hold existed */
  rewardStatus: ReferralRewardStatus | null;
  /**
   * Reward amount waiting for the check
   * @example 6000
   */
  pendingCredits: number;
  /**
   * Date when the user was referred and registered
   * @format date-time
   * @example "2024-01-15T10:30:00.000Z"
   */
  registeredAt: string;
}

export interface PaginationMeta {
  /**
   * Total number of items
   * @example 100
   */
  totalItems: number;
  /**
   * Number of items on current page
   * @example 20
   */
  itemCount: number;
  /**
   * Number of items per page
   * @example 20
   */
  itemsPerPage: number;
  /**
   * Total number of pages
   * @example 5
   */
  totalPages: number;
  /**
   * Current page number
   * @example 1
   */
  currentPage: number;
}

export interface PaginatedReferralsResponse {
  /** List of referred users */
  referrals: Referral[];
  /** Pagination metadata */
  meta: PaginationMeta;
}

export interface ReferralStatsResponse {
  /**
   * Total number of referred users
   * @example 8
   */
  totalReferrals: number;
  /**
   * Total credits earned from referrals (base bonuses + 10th friend bonuses + deposit percentages)
   * @example 5500
   */
  totalEarned: number;
  /**
   * Progress towards next referral bonus (0-9). Every 10th valid referral gives a bonus.
   * @min 0
   * @max 9
   * @example 3
   */
  progressToBonus: number;
  /**
   * Credits paid for the next activated friend (raised during the contest)
   * @example 6000
   */
  rewardCredits: number;
}

export interface SavePreparedInlineMessageAnimatedItem {
  /**
   * Caller's inventory item to share; the item and the drop style come from its source on the server
   * @format uuid
   */
  inventoryItemId: string;
}

export interface SavePreparedInlineMessageButton {
  /** Button text */
  text: string;
  /** Button URL */
  url: string;
}

export interface SavePreparedInlineMessage {
  /** Dropped item to share as a personal animation; falls back to imageUrl when it cannot be rendered */
  animatedItem?: SavePreparedInlineMessageAnimatedItem;
  /** Image URL for the inline message */
  imageUrl?: string;
  /** Caption text for the image */
  caption?: string;
  /** Description of the message */
  description?: string;
  /** MPEG4 GIF URL for animated inline messages */
  gifUrl?: string;
  /** Thumbnail URL for GIF inline messages */
  thumbnailUrl?: string;
  /** Message text for article-type inline messages */
  messageText?: string;
  /** Title for article-type inline messages */
  title?: string;
  /** Inline keyboard button */
  button?: SavePreparedInlineMessageButton;
}

export interface SavePreparedInlineMessageResponse {
  /** Prepared inline message ID */
  preparedMessageId: string;
}

export interface HealthCheckResponse {
  /**
   * Service health status
   * @example "ok"
   */
  status: string;
  /**
   * Current timestamp
   * @example "2024-01-15T10:30:00.000Z"
   */
  timestamp: string;
}

export interface ComebackBonus {
  /** @example "f47ac10b-58cc-4372-a567-0e02b2c3d479" */
  id: string;
  /** @example "days_7" */
  type: ComebackBonusTypeEnum;
  /** @example 500 */
  amount: number;
  /**
   * @format date-time
   * @example "2024-01-20T12:00:00Z"
   */
  expiresAt: string;
  /** @example true */
  canClaim: boolean;
}

export interface ComebackBonusResponse {
  bonuses: ComebackBonus[];
}

export interface SubscriptionChannel {
  /**
   * Channel ID
   * @example "c47e8c4e-4b6e-4f86-8c7e-c4e34b6e3f86"
   */
  id: string;
  /**
   * Telegram channel ID (starts with -100)
   * @example "-1001234567890"
   */
  channelId: string;
  /**
   * Channel username without @
   * @example "csshot_channel"
   */
  channelUsername: string;
  /**
   * Link to the channel
   * @example "https://t.me/csshot_channel"
   */
  channelLink: string;
  /**
   * Channel description
   * @example "Official SHOT channel"
   */
  description?: string | null;
  /**
   * Bonus amount in credits for subscribing
   * @example 500
   */
  bonusAmount: number;
  /**
   * Whether the user is subscribed to this channel
   * @example true
   */
  isSubscribed: boolean;
  /**
   * Whether the bonus has been awarded for this channel
   * @example true
   */
  bonusAwarded: boolean;
  /**
   * Date when user subscribed
   * @format date-time
   * @example "2024-01-15T12:00:00Z"
   */
  subscribedAt?: string | null;
}

export interface SubscriptionChannelsResponse {
  /** List of available subscription channels */
  channels: SubscriptionChannel[];
  /**
   * Total number of channels user is subscribed to
   * @example 2
   */
  totalSubscribed: number;
  /**
   * Total amount of bonuses awarded
   * @example 1000
   */
  totalBonusesAwarded: number;
}

export interface UserBoostStatus {
  /**
   * Boost status
   * @example "ACTIVE"
   */
  status: UserBoostStatusStatusEnum;
  /**
   * Whether the user can claim the daily reward
   * @example true
   */
  canClaimReward: boolean;
  /**
   * Next reward available timestamp
   * @example "2024-01-16T10:30:00.000Z"
   */
  nextRewardAvailableAt?: string;
  /**
   * Total number of rewards claimed
   * @example 5
   */
  totalRewardsClaimed: number;
  /**
   * Total credits earned from this boost
   * @example 500
   */
  totalCreditsEarned: number;
}

export interface BoostChannelWithStatus {
  /**
   * Channel ID
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  id: string;
  /**
   * Telegram channel ID
   * @example "@csshot_channel"
   */
  channelId: string;
  /**
   * Channel username for display
   * @example "SHOT Channel"
   */
  channelUsername: string;
  /**
   * Channel link
   * @example "https://t.me/csshot_channel"
   */
  channelLink: string;
  /**
   * Channel description
   * @example "Boost our channel for daily rewards"
   */
  description?: string;
  /**
   * Daily reward amount
   * @example 100
   */
  dailyRewardAmount: number;
  /** User boost status (null if not boosted) */
  userBoost?: UserBoostStatus;
}

export interface BoostChannelsStatusResponse {
  /** List of boost channels with user status */
  channels: BoostChannelWithStatus[];
}

export interface ReferralBonusProgressResponse {
  /**
   * Progress towards next referral bonus (0-9). Every 10th valid referral gives a bonus.
   * @min 0
   * @max 9
   * @example 3
   */
  progressToBonus: number;
}

export interface UsernameTaskStatus {
  /** Whether task is active */
  isActive: boolean;
  /** Whether user can claim daily reward */
  canClaimReward: boolean;
  /**
   * Last validation timestamp
   * @format date-time
   */
  lastValidatedAt?: string | null;
  /**
   * Last bonus claim timestamp
   * @format date-time
   */
  lastBonusClaimedAt?: string | null;
  /** Total bonuses claimed */
  totalBonusesClaimed: number;
  /** Total credits earned from this task */
  totalCreditsEarned: number;
  /** Current streak days */
  streakDays: number;
  /**
   * When next reward will be available
   * @format date-time
   */
  nextRewardAvailable?: string | null;
  /** Next reward amount in credits */
  nextRewardAmount: number;
  /** Whether maximum reward has been reached */
  maxRewardReached: boolean;
  /** Bot username to add to lastName */
  botUsername: string;
}

export interface BioTaskStatus {
  /** Whether task is active */
  isActive: boolean;
  /** Whether user can claim daily reward */
  canClaimReward: boolean;
  /**
   * Last validation timestamp
   * @format date-time
   */
  lastValidatedAt?: string | null;
  /**
   * Last bonus claim timestamp
   * @format date-time
   */
  lastBonusClaimedAt?: string | null;
  /** Total bonuses claimed */
  totalBonusesClaimed: number;
  /** Total credits earned from this task */
  totalCreditsEarned: number;
  /** Current streak days */
  streakDays: number;
  /**
   * When next reward will be available
   * @format date-time
   */
  nextRewardAvailable?: string | null;
  /** Next reward amount in credits */
  nextRewardAmount: number;
  /** Whether maximum reward has been reached */
  maxRewardReached: boolean;
  /** Referral link to add to bio */
  referralLink: string;
}

export interface ProfileTaskStatusResponse {
  /** Username in lastName task status */
  usernameTask: UsernameTaskStatus;
  /** Referral link in bio task status */
  bioTask: BioTaskStatus;
}

export interface StreakMilestone {
  /** День streak */
  day: number;
  /** Сумма бонуса в кредитах */
  amount: number;
}

export interface DailyBonusStatusResponse {
  /** Можно ли получить бонус сейчас */
  canClaim: boolean;
  /** Текущий streak (дни подряд) */
  currentStreak: number;
  /** Максимальный streak всех времен */
  maxStreak: number;
  /** Общее количество полученных бонусов */
  totalBonusesClaimed: number;
  /** Общее количество заработанных кредитов */
  totalCreditsEarned: number;
  /** Время до следующего бонуса в миллисекундах */
  timeUntilNextBonus: number;
  /** Время до следующего бонуса (форматированное) */
  timeUntilNextFormatted: string;
  /** Сумма следующего бонуса в кредитах */
  nextBonusAmount: number;
  /** Описание следующего бонуса */
  nextBonusDescription: string;
  /** Вехи streak */
  streakMilestones: StreakMilestone[];
  /**
   * Время последнего получения бонуса
   * @format date-time
   */
  lastClaimedAt: string | null;
}

export interface ItemResponse {
  /** Unique hash name from Steam */
  hashName: string;
  /** Name of the item */
  name: string;
  /** Rarity ID */
  rarityId?: string | null;
  /** Rarity name */
  rarityName?: string | null;
  /** Rarity color */
  rarityColor?: string | null;
  /** Weapon name */
  weapon?: string | null;
  /** Category name */
  category?: string | null;
  /** Wear name */
  wear?: string | null;
  /** Image URL */
  imageUrl?: string | null;
  /** Whether item has StatTrak */
  statTrak: boolean;
  /** Whether item is Souvenir */
  souvenir: boolean;
  /** Price in rubles */
  priceInRubles?: number;
  /** Price in USD */
  priceInUsd?: number;
  /** Price on Steam market in USD */
  steamPrice?: number | null;
  /** Item type (e.g., "sticker", "skin") */
  type?: string | null;
  /** SkinViewer3D payload for in-browser 3D rendering. Null = no 3D available. */
  viewerData?: object | null;
}

export interface RecentInventoryItem {
  /**
   * Inventory item ID
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  id: string;
  /**
   * User ID who owns the item
   * @example "b2c3d4e5-f6g7-8901-bcde-f23456789012"
   */
  userId: string;
  /**
   * Price when the item was acquired (in credits)
   * @example 2500
   */
  acquiredPriceInCredits: number;
  /**
   * Source of the item
   * @example "CASE_OPENING"
   */
  source: ItemSource;
  /**
   * ID of the source (e.g., case opening ID)
   * @example "c3d4e5f6-g7h8-9012-cdef-g34567890123"
   */
  sourceId?: string | null;
  /**
   * When the item was acquired
   * @format date-time
   * @example "2024-01-15T10:30:00.000Z"
   */
  acquiredAt: string;
  /** Item details */
  item: ItemResponse;
}

export interface TopRecentDropsResponse {
  /** List of top recent drops from the last 24 hours, sorted by price (descending) */
  items: RecentInventoryItem[];
}

export interface RecentItemsResponse {
  /** List of recent inventory items */
  items: RecentInventoryItem[];
}

export interface PrizeItem {
  name: string;
  imageUrl: string;
  price: number;
  rarityColor: string | null;
}

export interface DrawParticipant {
  /** Participant ID */
  id: string;
  /** User ID */
  userId: string;
  /** User first name */
  firstName: string | null;
  /** User last name */
  lastName: string | null;
  /**
   * User level
   * @example 5
   */
  level: number;
  /** Number of tickets owned by this participant */
  ticketsCount: number;
  /**
   * Time when user joined the draw
   * @format date-time
   */
  joinedAt: string;
}

export interface ActiveDraw {
  id: string;
  type: string;
  prizeItem: PrizeItem;
  /** @format date-time */
  completionTime: string;
  /** Total number of unique participants */
  totalParticipants: number;
  /** Total number of tickets (including multiple tickets from same user) */
  totalTickets: number;
  /** Whether current user is participating */
  userParticipating: boolean;
  /** Number of tickets current user owns (null if not participating) */
  userTicketsCount: number | null;
  /** Current user win chance in percentage (null if not participating) */
  userWinChance: number | null;
  /** Entry price in credits (null for free draws) */
  entryPrice: number | null;
  /** Last 3 participants who joined the draw */
  recentParticipants: DrawParticipant[];
}

export interface ActiveDrawsResponse {
  depositDraw: ActiveDraw | null;
  referralDraw: ActiveDraw | null;
  paid5000Draw: ActiveDraw | null;
  paid10000Draw: ActiveDraw | null;
  paid25000Draw: ActiveDraw | null;
}

export interface ActivePromocodeBuffResponse {
  /**
   * Promocode buff ID
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  id: string;
  /**
   * Promocode that was activated
   * @example "BONUS20"
   */
  promocodeCode: string;
  /**
   * Bonus percentage
   * @example 20
   */
  bonusPercentage: number;
  /**
   * Buff type
   * @example "time_limited"
   */
  type: ActivePromocodeBuffResponseTypeEnum;
  /**
   * Expiration date (for time limited buffs)
   * @example "2024-12-31T23:59:59.000Z"
   */
  expiresAt?: string;
  /**
   * Remaining usages (for usage limited buffs)
   * @example 3
   */
  remainingUsages?: number | null;
  /**
   * Buff activation date
   * @example "2024-01-15T10:30:00.000Z"
   */
  createdAt: string;
  /**
   * Whether buff is valid (not expired, has usages left)
   * @example true
   */
  isValid: boolean;
}

export interface GlobalPromocodeBuffResponse {
  /**
   * Whether global promocode buff is active
   * @example true
   */
  isActive: boolean;
  /**
   * Bonus percentage
   * @example 50
   */
  bonusPercentage: number;
  /**
   * Buff start date
   * @example "2025-11-10T00:00:00.000Z"
   */
  startDate: string;
  /**
   * Buff end date
   * @example "2025-11-17T23:59:59.999Z"
   */
  endDate: string;
}

export interface DailyGiveawayCase {
  id: string;
  /**
   * Case address segment: /cases/<slug>
   * @example "maracana"
   */
  slug: string;
  name: string;
  imageUrl: string;
}

export interface DailyGiveawayPrize {
  hashName: string;
  name: string;
  imageUrl: string | null;
  rarityName: string | null;
  rarityColor: string | null;
  /** Prize value in credits */
  price: number;
  /** Prize price on Steam market in USD */
  steamPrice: number | null;
}

export interface DailyGiveawayRound {
  id: string;
  /** Round end (Moscow midnight) as ISO string */
  endAt: string;
  participantsCount: number;
}

export interface DailyGiveawayLeader {
  userId: string;
  firstName: string | null;
  lastName: string | null;
  level: number;
  openCount: number;
  /** Total dropped value in credits */
  dropValueSum: number;
}

export interface DailyGiveawayMe {
  rank: number;
  openCount: number;
  /** Total dropped value in credits */
  dropValueSum: number;
}

export interface DailyGiveawayPublic {
  id: string;
  sortOrder: number;
  /** Scoring mode */
  type: DailyGiveawayPublicTypeEnum;
  case: DailyGiveawayCase;
  prize: DailyGiveawayPrize;
  round: DailyGiveawayRound | null;
  leader: DailyGiveawayLeader | null;
  me: DailyGiveawayMe | null;
}

export interface DailyGiveawaysResponse {
  giveaways: DailyGiveawayPublic[];
}

export interface XpStatusResponse {
  /**
   * Current user level
   * @example 5
   */
  level: number;
  /**
   * Total XP accumulated
   * @example 1250
   */
  totalXp: number;
  /**
   * XP progress in current level
   * @example 75
   */
  currentLevelXp: number;
  /**
   * XP needed to reach next level
   * @example 175
   */
  xpToNextLevel: number;
  /**
   * Progress percentage in current level
   * @example 30
   */
  progressPercent: number;
  /**
   * Whether user is at max level
   * @example false
   */
  isMaxLevel: boolean;
  /**
   * User rank position based on XP
   * @example 1247
   */
  xpRank?: number | null;
}

export interface BandRateMilestone {
  /** Level that unlocks the next shown cashback step */
  level: number;
  /** Cashback percent at that level */
  ratePct: number;
}

export interface BandMechanicRate {
  /** Mechanic key: CASE, CASE_BATTLE, RUSH_MID, ROULETTE, UPGRADE, CONTRACT */
  mechanic: string;
  /** Effective cashback percent on this mechanic (level curve × multiplier) */
  ratePct: number;
}

export interface BandStatusResponse {
  isMember: boolean;
  /** @format date-time */
  bandExpiresAt?: string | null;
  bonusBalance: number;
  bandTickets: number;
  ticketPriceCredits: number;
  /** Sparks accruing in the current cycle, not yet matured */
  pendingCashbackCredits: number;
  /** Matured sparks waiting for the claim button */
  claimableCashbackCredits: number;
  /** @format date-time */
  nextAccrualAt?: string | null;
  /** Cashback percent the current level earns, before mechanic multipliers */
  currentRatePct: number;
  level: number;
  /** Next level milestone and its rate, null at the top milestone */
  nextMilestone?: BandRateMilestone | null;
  /** Per-mechanic effective rates; differ from currentRatePct only while a multiplier is active */
  mechanicRates: BandMechanicRate[];
  /** Admin toggle: show the club promo block on the home screen */
  homePromoEnabled: boolean;
}

export interface BandMembersPreviewResponse {
  /** Active members right now */
  memberCount: number;
  /** Freshest member ids — the promo renders their avatars */
  recentMemberIds: string[];
}

export interface HomeSnapshot {
  comebackBonus?: ComebackBonusResponse | null;
  subscriptionChannels?: SubscriptionChannelsResponse | null;
  boostChannels?: BoostChannelsStatusResponse | null;
  referralBonusProgress?: ReferralBonusProgressResponse | null;
  profileTasks?: ProfileTaskStatusResponse | null;
  dailyBonus?: DailyBonusStatusResponse | null;
  topRecentDrops?: TopRecentDropsResponse | null;
  recentDrops?: RecentItemsResponse | null;
  draws?: ActiveDrawsResponse | null;
  activeBuff?: ActivePromocodeBuffResponse | null;
  globalBuff?: GlobalPromocodeBuffResponse | null;
  dailyGiveaways?: DailyGiveawaysResponse | null;
  profile?: UserProfileResponse | null;
  xpStatus?: XpStatusResponse | null;
  bandStatus?: BandStatusResponse | null;
  bandMembersPreview?: BandMembersPreviewResponse | null;
  /** Секции, чей источник ответил ошибкой */
  failedSections: string[];
}

export interface ExecuteContract {
  /**
   * Array of user inventory item IDs to use in the contract
   * @maxItems 10
   * @minItems 3
   * @uniqueItems true
   * @example ["uuid1","uuid2","uuid3"]
   */
  inputItemIds: string[];
}

export interface ContractOutputItem {
  /** Output item ID */
  id: string;
  /** Output item hash name */
  hashName: string;
  /** Output item display name */
  name: string;
  /** Output item value in credits */
  value: number;
  /** Output item image URL */
  imageUrl: string;
  /** Output item rarity name */
  rarityName?: string;
  /** Output item rarity color */
  rarityColor?: string;
  /** Item price on Steam market in USD */
  steamPrice?: number | null;
  /** SkinViewer3D payload for in-browser 3D rendering. Null = no 3D available. */
  viewerData?: object | null;
}

export interface ContractResult {
  /** Contract ID */
  contractId: string;
  /** Output item details */
  outputItem: ContractOutputItem;
  /** Profit or loss in credits (positive = profit, negative = loss) */
  profitLoss: number;
  /** Total value of input items in credits */
  totalInputValue: number;
}

export interface ContractPreview {
  /** Minimum possible output value in credits */
  minValue: number;
  /** Maximum possible output value in credits */
  maxValue: number;
  /** Total input value in credits */
  totalInputValue: number;
}

export interface ContractHistoryInputItem {
  /** Input item ID */
  id: string;
  /** Input item display name */
  name: string;
  /** Input item value in credits */
  value: number;
  /** Input item image URL */
  imageUrl: string;
}

export interface ContractHistoryOutputItem {
  /** Output item ID */
  id: string;
  /** Output item display name */
  name: string;
  /** Output item value in credits */
  value: number;
  /** Output item image URL */
  imageUrl: string;
}

export interface ContractHistoryItem {
  /** Contract ID */
  id: string;
  /** Input items used in the contract */
  inputItems: ContractHistoryInputItem[];
  /** Total value of input items in credits */
  inputTotalValue: number;
  /** Output item received */
  outputItem: ContractHistoryOutputItem;
  /** Profit or loss in credits (positive = profit, negative = loss) */
  profitLoss: number;
  /**
   * Contract creation date
   * @format date-time
   */
  createdAt: string;
}

export interface ContractHistory {
  /** List of contract history items */
  contracts: ContractHistoryItem[];
  /** Total number of contracts */
  totalCount: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface CalculateProbability {
  /**
   * Source item ID from user inventory
   * @example "user-inventory-item-123"
   */
  sourceItemId: string;
  /**
   * Extra credits added on top of the item price
   * @min 1
   * @example 2500
   */
  sourceAmount?: number;
  /**
   * Target item hash name
   * @example "AK-47 | Redline (Field-Tested)"
   */
  targetItemId: string;
}

export interface UpgradeProbabilityResponse {
  /**
   * Whether the upgrade is available
   * @example true
   */
  isAvailable: boolean;
  /**
   * Calculated probability (0-1)
   * @example 0.25
   */
  probability: number;
  /**
   * Upgrade coefficient
   * @example 4
   */
  coefficient: number;
  /**
   * Source price in credits — item price or the credits amount staked
   * @example 1250
   */
  sourcePrice: number;
  /**
   * Target item price in credits
   * @example 5000
   */
  targetPrice: number;
  /**
   * Reason why upgrade is not available
   * @example "Probability too low"
   */
  reason?: string;
}

export interface PerformItemUpgrade {
  /**
   * Source inventory item ID
   * @example "user-inventory-item-123"
   */
  sourceItemId: string;
  /**
   * Target item hash name
   * @example "AK-47 | Redline (Field-Tested)"
   */
  targetItemId: string;
  /**
   * Extra credits added on top of the item price
   * @min 1
   * @example 2500
   */
  sourceAmount?: number;
}

export interface UpgradeResult {
  /**
   * Unique upgrade ID
   * @example "upgrade-uuid-123"
   */
  upgradeId: string;
  /**
   * Whether the upgrade was successful
   * @example true
   */
  isSuccess: boolean;
  /**
   * Probability that was used
   * @example 0.25
   */
  probability: number;
  /**
   * Coefficient that was used
   * @example 4
   */
  coefficient: number;
  /**
   * Result item hash name if successful
   * @example "AK-47 | Redline (Field-Tested)"
   */
  resultItemId?: string;
  /** SkinViewer3D payload for in-browser 3D rendering of the target item. Null = no 3D available. */
  viewerData?: object | null;
}

export interface UpgradeHistoryItem {
  /**
   * Upgrade ID
   * @example "upgrade-uuid-123"
   */
  id: string;
  /**
   * Source item ID
   * @example "source-item-123"
   */
  sourceItemId: string;
  /**
   * Source item name
   * @example "Glock-18 | Water Elemental"
   */
  sourceItemName: string;
  /**
   * Source item image URL
   * @example "https://example.com/glock-water-elemental.png"
   */
  sourceItemImage: string | null;
  /**
   * Extra credits added on top of the item. Null when only the item was staked.
   * @example 2500
   */
  sourceAmount: number | null;
  /**
   * Target item ID
   * @example "AK-47 | Redline (Field-Tested)"
   */
  targetItemId: string;
  /**
   * Target item name
   * @example "AK-47 | Redline"
   */
  targetItemName: string;
  /**
   * Target item image URL
   * @example "https://example.com/ak47-redline.png"
   */
  targetItemImage: string | null;
  /**
   * Target item price at the time of upgrade
   * @example 5000
   */
  targetItemPrice: number;
  /**
   * Probability that was used
   * @example 0.25
   */
  probability: number;
  /**
   * Coefficient that was used
   * @example 4
   */
  coefficient: number;
  /**
   * Whether the upgrade was successful
   * @example true
   */
  isSuccess: boolean;
  /**
   * Result item ID if successful; null when the upgrade failed
   * @example "result-item-456"
   */
  resultItemId?: string | null;
  /**
   * When the upgrade was performed
   * @format date-time
   * @example "2024-01-15T10:30:00.000Z"
   */
  createdAt: string;
}

export interface UpgradeHistoryResponse {
  /** List of upgrade history items */
  items: UpgradeHistoryItem[];
  /** Pagination metadata */
  meta: PaginationMeta;
}

export interface UpgradeTopItem {
  hashName: string;
  name: string;
  imageUrl: string | null;
  rarityColor: string | null;
  /** Цена в монетах */
  price: number;
}

export interface UpgradeTopEntry {
  /** Место в топе; null — игрок вне рейтинга */
  rank: number | null;
  upgradeId: string;
  userId: string;
  firstName: string | null;
  lastName: string | null;
  level: number;
  coefficient: number;
  /** Шанс 0..1 */
  probability: number;
  /** Доплата монетами */
  sourceAmount: number | null;
  source: UpgradeTopItem;
  target: UpgradeTopItem;
}

export interface UpgradeTopResponse {
  period: UpgradeTopResponsePeriodEnum;
  /** @format date-time */
  periodStart: string;
  /** @format date-time */
  periodEnd: string;
  entries: UpgradeTopEntry[];
  me: UpgradeTopEntry | null;
}

export interface AvailableUpgradeTargetItem {
  /** Steam market hash name of the item */
  hashName: string;
  /** Display name of the item */
  name: string;
  /** Item category */
  category: string | null;
  /** URL of the item image */
  imageUrl: string | null;
  /** Price of the item in credits */
  price: number;
  /** Price in USD */
  priceInUsd?: number;
  /** Item price on Steam market in USD */
  steamPrice?: number | null;
  /** Probability of successful upgrade (0-1) */
  probability: number;
  /** Coefficient of the upgrade */
  coefficient: number;
  /** Rarity color of the item */
  rarityColor: string;
  /** Rarity name of the item */
  rarityName?: string | null;
  /** Whether the item has StatTrak */
  statTrak: boolean;
  /** Whether the item is Souvenir */
  souvenir: boolean;
}

export interface AvailableUpgradeTargetsResponse {
  /** Paginated available upgrade targets */
  items: AvailableUpgradeTargetItem[];
  /** Pagination metadata */
  meta: PaginationMeta;
}

export interface ActivatePromocode {
  /**
   * Promocode to activate
   * @minLength 3
   * @maxLength 50
   * @example "BONUS20"
   */
  code: string;
}

export interface PromocodeHistoryItem {
  /**
   * Usage record ID
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  id: string;
  /**
   * Promocode that was used
   * @example "BONUS20"
   */
  promocodeCode: string;
  /**
   * Bonus percentage that was applied
   * @example 20
   */
  bonusPercentage: number;
  /**
   * Date when promocode was used
   * @example "2024-01-15T10:30:00.000Z"
   */
  usedAt: string;
}

export interface PromocodeHistoryResponse {
  /** List of used promocodes */
  history: PromocodeHistoryItem[];
}

export interface WheelSegment {
  /** Bonus percentage for this segment */
  percentage: number;
}

export interface ActiveWheelBuff {
  /** Bonus percentage */
  bonusPercentage: number;
  /** Buff expiration date */
  expiresAt: string;
}

export interface WheelStatusResponse {
  /** Number of available wheel spins */
  availableSpins: number;
  /** Wheel segments */
  segments: WheelSegment[];
  /** Whether user has active wheel buff */
  hasActiveWheelBuff: boolean;
  /** Whether user has any active promocode (wheel or regular) */
  hasActivePromo: boolean;
  /** Active wheel buff details */
  activeWheelBuff?: ActiveWheelBuff;
}

export interface DeactivatedPromo {
  /** Bonus percentage of the deactivated promo */
  bonusPercentage: number;
}

export interface SpinWheelResponse {
  /** Won bonus percentage */
  bonusPercentage: number;
  /** Created buff ID */
  buffId: string;
  /** Buff expiration date */
  expiresAt: string;
  /** Remaining wheel spins after this spin */
  remainingSpins: number;
  /** Info about deactivated promo if one was active */
  deactivatedPromo?: DeactivatedPromo;
}

export interface ActivateProfileTask {
  /**
   * Type of profile task to activate
   * @example "USERNAME_IN_LASTNAME"
   */
  taskType: ActivateProfileTaskTaskTypeEnum;
}

export interface ClaimProfileTaskReward {
  /**
   * Type of profile task to claim reward for
   * @example "USERNAME_IN_LASTNAME"
   */
  taskType: ClaimProfileTaskRewardTaskTypeEnum;
}

export interface ShopItem {
  hashName: string;
  name: string;
  imageUrl: string | null;
  priceInCredits: number;
  priceInRubles: number;
  /** Price in USD */
  priceInUsd?: number;
  volume: number;
  category: string | null;
  weapon: string | null;
  type: string | null;
  statTrak: boolean;
  rarity: string | null;
  rarityColor: string | null;
  /** Price in Telegram Stars with commission */
  priceInStars: number;
  /** Price in RUB with Wata.pro SBP commission */
  priceInRub: number;
  /** Price in UZS with NOROS P2P commission */
  priceInUzs: number;
}

export interface GetShopItemsResponse {
  items: ShopItem[];
  meta: PaginationMeta;
}

export interface ShopSkin {
  /**
   * Skin name
   * @example "Asiimov"
   */
  skinName: string;
  /**
   * Image URL
   * @example "https://..."
   */
  imageUrl: string;
  /**
   * Rarity color hex
   * @example "#eb4b4b"
   */
  rarityColor: string;
  /**
   * Rarity name
   * @example "Covert"
   */
  rarityName: string;
  /**
   * Minimum price in credits
   * @example 50000
   */
  minPriceInCredits: number;
  /**
   * Number of available items for this skin
   * @example 5
   */
  itemsCount: number;
}

export interface GetShopSkinsResponse {
  /** List of skins */
  skins: ShopSkin[];
}

export interface CreateShopPurchaseInvoice {
  /** Hash name of the item to purchase */
  itemHashName: string;
  /** Payment provider */
  provider: CreateShopPurchaseInvoiceProviderEnum;
  /** Payment currency (defaults to RUB) */
  currency?: CreateShopPurchaseInvoiceCurrencyEnum;
  /** Return URL after payment completion */
  returnUrl?: string;
}

export interface CreateShopPurchaseInvoiceResponse {
  /** Payment ID */
  paymentId: string;
  /** Invoice URL for payment */
  invoiceUrl: string;
  /** Payment amount in provider currency */
  amount: number;
  /** Payment currency */
  currency: string;
  /** Item name */
  itemName: string;
  /** Item image URL */
  itemImageUrl: string | null;
  /**
   * Invoice expiration date
   * @format date-time
   */
  expiresAt?: string | null;
}

export interface UserShopPurchase {
  id: string;
  itemHashName: string;
  itemName: string;
  itemImageUrl: string;
  itemRarity?: string;
  itemRarityColor?: string;
  priceInCredits: number;
  priceInRubles: number;
  status: UserShopPurchaseStatusEnum;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  completedAt?: string;
}

export interface UserShopPurchasesResponse {
  purchases: UserShopPurchase[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface CaseOpening {
  /**
   * Unique case opening ID
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  id: string;
  /**
   * Case ID that was opened
   * @example "case_123"
   */
  caseId: string;
  /**
   * Case name
   * @example "Operation Bravo Case"
   */
  caseName: string;
  /**
   * Case price at the time of opening (in credits)
   * @example 1000
   */
  casePriceInCredits: number;
  /** Full dropped item information */
  droppedItem: ItemResponse;
  /**
   * Item price at the time of dropping (in credits, may differ from current price)
   * @example 5000
   */
  droppedItemPriceInCredits: number;
  /**
   * Date when case was opened
   * @example "2024-01-15T10:30:00.000Z"
   */
  openedAt: string;
}

export interface PaginatedCaseOpeningsResponse {
  /** List of case openings */
  openings: CaseOpening[];
  /** Pagination metadata */
  meta: PaginationMeta;
}

export interface CaseOpeningDetailsItem {
  /**
   * Item hash name
   * @example "AK-47 | Redline (Field-Tested)"
   */
  hashName: string;
  /**
   * Item display name
   * @example "AK-47 | Redline"
   */
  displayName: string;
  /**
   * Item rarity
   * @example "Covert"
   */
  rarity: string | null;
  /**
   * Item rarity color
   * @example "#eb4b4b"
   */
  rarityColor: string | null;
  /**
   * Item image URL
   * @example "https://steamcdn-a.akamaihd.net/apps/730/icons/econ/default_generated/weapon_ak47_cu_ak47_cobra_light_large.png"
   */
  imageUrl: string | null;
  /**
   * Item price in credits
   * @example 5000
   */
  priceInCredits: number;
  /**
   * Item price on Steam market in USD
   * @example 41.41
   */
  steamPrice: number | null;
  /**
   * Item wear condition
   * @example "Field-Tested"
   */
  condition?: string | null;
  /**
   * Weapon type
   * @example "AK-47"
   */
  weapon?: string | null;
  /**
   * Item category
   * @example "Rifle"
   */
  category?: string | null;
}

export interface CaseOpeningDetailsResponse {
  /**
   * Case opening ID
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  id: string;
  /**
   * Case ID
   * @example "case_123"
   */
  caseId: string;
  /**
   * Case name
   * @example "Operation Bravo Case"
   */
  caseName: string;
  /**
   * Case price at time of opening (in credits)
   * @example 1000
   */
  casePriceInCredits: number;
  /**
   * Case image URL
   * @example "https://steamcdn-a.akamaihd.net/apps/730/icons/econ/weapon_cases/crate_community_1.png"
   */
  caseImageUrl: string;
  /** Dropped item details */
  droppedItem: CaseOpeningDetailsItem;
  /**
   * Inventory item ID for the dropped item
   * @example "inv_123456"
   */
  inventoryItemId: string | null;
  /**
   * User balance after opening (in credits)
   * @example 25000
   */
  balanceAfterInCredits: number;
  /**
   * Date when case was opened
   * @example "2024-01-15T10:30:00Z"
   */
  openedAt: string;
}

export interface CaseResponse {
  /**
   * Unique case identifier
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  id: string;
  /**
   * Stable readable case address segment: /cases/<slug>. Never changes on rename
   * @example "maracana"
   */
  slug: string;
  /**
   * Case name
   * @example "Operation Bravo Case"
   */
  name: string;
  /**
   * Case price in credits
   * @example 1000
   */
  priceInCredits: number;
  /**
   * Case image URL
   * @example "https://steamcdn-a.akamaihd.net/apps/730/icons/econ/weapon_cases/crate_community_1.png"
   */
  imageUrl: string;
  /**
   * Base64-encoded 16x16 placeholder image for instant loading (LQIP)
   * @example "data:image/jpeg;base64,/9j/4AAQSkZJRg..."
   */
  imagePlaceholder: string | null;
  /**
   * Case image without background (transparent, same framing as imageUrl)
   * @example "https://shot.band/images/new2/Caliber-nobg.webp"
   */
  imageCutoutUrl?: string | null;
  /**
   * Whether the case is active
   * @example true
   */
  isActive: boolean;
  /**
   * Sort order for display
   * @example 1
   */
  sortOrder: number;
  /**
   * Total number of openings
   * @example 1500
   */
  openingsCount: number;
  /**
   * Whether the case is marked as new
   * @example false
   */
  isNew: boolean;
  /**
   * One of the most opened cases in the list
   * @example false
   */
  isPopular: boolean;
  /**
   * XP reward for opening this case
   * @example 15
   */
  xpReward: number;
  /**
   * Currency spent to open this case — credits, or SHOT BAND bonus balance
   * @example "credits"
   */
  openCurrency: CaseResponseOpenCurrencyEnum;
  /**
   * When the case was added
   * @example "2026-09-01T00:00:00.000Z"
   */
  createdAt: string;
  /**
   * Language codes whose users see this case first in the catalog (empty = regular order)
   * @example ["pt"]
   */
  priorityLanguages: string[];
}

export interface CaseCategoryName {
  ru: string;
  en: string;
  uz: string;
  fa: string;
  pt: string;
  tr: string;
  uk: string;
  de: string;
  es: string;
  pl: string;
}

export interface CaseCatalogCategory {
  /**
   * Latin id used in deep links: `cat_<slug>`, `?category=<slug>`
   * @example "knives"
   */
  slug: string;
  /** Per-locale name; client picks display locale */
  name: CaseCategoryName;
  /** Cases in display order; always a subset of `general` */
  cases: CaseResponse[];
}

export interface CaseCatalogResponse {
  /** All shop cases, admin order */
  general: CaseResponse[];
  /** Active non-empty categories in admin order */
  categories: CaseCatalogCategory[];
}

export interface CaseItem {
  /**
   * Item hash name
   * @example "AK-47 | Redline (Field-Tested)"
   */
  hashName: string;
  /**
   * Item display name
   * @example "AK-47 | Redline"
   */
  name: string;
  /**
   * Item rarity
   * @example "Covert"
   */
  rarity: string;
  /**
   * Item rarity color
   * @example "#eb4b4b"
   */
  rarityColor: string;
  /**
   * Item image URL
   * @example "https://steamcdn-a.akamaihd.net/apps/730/icons/econ/default_generated/weapon_ak47_cu_ak47_cobra_light_large.png"
   */
  imageUrl: string;
  /**
   * Item price in credits
   * @example 5000
   */
  priceInCredits: number;
  /**
   * Item price in USD
   * @example 55.5
   */
  priceInUsd?: number;
  /**
   * Item price on Steam market in USD
   * @example 41.41
   */
  steamPrice: number | null;
  /**
   * Drop probability (0-1)
   * @example 0.025
   */
  probability: number;
  /**
   * Drop chance as a display percent, rounded to 2 decimals, floored at 0.01%
   * @example 2.5
   */
  chancePercent: number;
  /**
   * Item wear condition
   * @example "Field-Tested"
   */
  wear?: string | null;
  /**
   * Wiki page of the item without language prefix; null when the item has no wiki page
   * @example "/wiki/skins/ak-47-redline"
   */
  wikiPath: string | null;
}

export interface CaseDetailsResponse {
  /**
   * Time the current odds table was created
   * @format date-time
   */
  oddsUpdatedAt?: string;
  /**
   * Unique case identifier
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  id: string;
  /**
   * Stable readable case address segment: /cases/<slug>. Never changes on rename
   * @example "maracana"
   */
  slug: string;
  /**
   * Case name
   * @example "Operation Bravo Case"
   */
  name: string;
  /**
   * Case price in credits
   * @example 1000
   */
  priceInCredits: number;
  /**
   * Case image URL
   * @example "https://steamcdn-a.akamaihd.net/apps/730/icons/econ/weapon_cases/crate_community_1.png"
   */
  imageUrl: string;
  /**
   * Base64-encoded 16x16 placeholder image for instant loading (LQIP)
   * @example "data:image/jpeg;base64,/9j/4AAQSkZJRg..."
   */
  imagePlaceholder: string | null;
  /**
   * Case image without background (transparent, same framing as imageUrl)
   * @example "https://shot.band/images/new2/Caliber-nobg.webp"
   */
  imageCutoutUrl?: string | null;
  /**
   * Whether the case is active
   * @example true
   */
  isActive: boolean;
  /**
   * Sort order for display
   * @example 1
   */
  sortOrder: number;
  /**
   * Total number of openings
   * @example 1500
   */
  openingsCount: number;
  /** Items that can be dropped from this case */
  items: CaseItem[];
  /**
   * XP reward for opening this case
   * @example 15
   */
  xpReward: number;
  /**
   * Currency spent to open this case — credits, or SHOT BAND bonus balance
   * @example "credits"
   */
  openCurrency: CaseDetailsResponseOpenCurrencyEnum;
}

export interface OpenCaseRequest {
  /**
   * Number of cases to open in a single request (defaults to 1)
   * @min 1
   * @max 10
   * @default 1
   * @example 1
   */
  count?: number;
}

export interface DroppedItem {
  /**
   * Item hash name
   * @example "AK-47 | Redline (Field-Tested)"
   */
  hashName: string;
  /**
   * Item display name
   * @example "AK-47 | Redline"
   */
  displayName: string;
  /**
   * Item rarity
   * @example "Covert"
   */
  rarity: string | null;
  /**
   * Item rarity color
   * @example "#eb4b4b"
   */
  rarityColor: string | null;
  /**
   * Item image URL
   * @example "https://steamcdn-a.akamaihd.net/apps/730/icons/econ/default_generated/weapon_ak47_cu_ak47_cobra_light_large.png"
   */
  imageUrl: string | null;
  /**
   * Item price in credits
   * @example 5000
   */
  priceInCredits: number;
  /**
   * Item price on Steam market in USD
   * @example 41.41
   */
  steamPrice: number | null;
  /**
   * Item wear condition
   * @example "Field-Tested"
   */
  condition?: string | null;
  /**
   * Weapon type
   * @example "AK-47"
   */
  weapon?: string | null;
  /**
   * Item category
   * @example "Rifle"
   */
  category?: string | null;
  /** SkinViewer3D payload for in-browser 3D rendering. Null = no 3D available. */
  viewerData?: object | null;
}

export interface OpenCaseResponse {
  /**
   * Case opening ID
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  openingId: string;
  /** Dropped item details */
  droppedItem: DroppedItem;
  /**
   * Inventory item ID for the dropped item
   * @example "inv_123456"
   */
  inventoryItemId: string | null;
  /**
   * User balance after opening
   * @example 25000
   */
  balanceAfter: number;
  /**
   * Whether the drop qualifies as a big win (item >= 125000 credits AND item > casePrice * 3.5)
   * @example false
   */
  isBigWin: boolean;
}

export interface InventoryItemOwner {
  /** User ID */
  userId: string;
  /** User first name */
  firstName?: string | null;
  /**
   * User level
   * @example 5
   */
  level: number;
}

export interface UserInventoryItemResponse {
  /** Inventory item ID */
  id: string;
  /** User ID who owns this item */
  userId: string;
  /** Owner of the item */
  owner: InventoryItemOwner;
  /** Price in credits when acquired */
  acquiredPriceInCredits: number;
  /** Price in rubles when acquired */
  acquiredPriceInRubles: number;
  /** Source of the item */
  source: UserInventoryItemResponseSourceEnum;
  /** Source ID (case opening, battle, etc) */
  sourceId?: string | null;
  /** Upgrade win chance (0–100) when the item came from an upgrade */
  upgradePercent?: number | null;
  /** Current status of the item */
  status: UserInventoryItemResponseStatusEnum;
  /**
   * Date when item was acquired
   * @format date-time
   */
  acquiredAt: string;
  /** Item details */
  item: ItemResponse;
  /**
   * Wiki page of the item without language prefix; null when the item has no wiki page. Only in item details
   * @example "/wiki/skins/ak-47-redline"
   */
  wikiPath?: string | null;
}

export interface PaginatedInventoryResponse {
  /** List of inventory items */
  items: UserInventoryItemResponse[];
  /** Whether more items exist beyond this page */
  hasMore: boolean;
}

export interface SellItemResponse {
  /** Amount of credits received from selling the item */
  amountInCredits: number;
}

export interface SellAllItemsResponse {
  /** Number of items sold */
  soldCount: number;
  /** Total amount of credits received from selling all items */
  totalAmountInCredits: number;
}

export interface SellItems {
  /**
   * Inventory item ids to sell
   * @maxItems 500
   * @minItems 1
   */
  itemIds: string[];
}

export interface WithdrawItem {
  /** Cloudflare Turnstile token proving the withdrawal was requested by a human */
  captchaToken?: string;
  /** Why the widget produced no token; absent on requests that did not go through the UI */
  captchaFailReason?: WithdrawItemCaptchaFailReasonEnum;
}

export interface WithdrawItemResponse {
  /**
   * Whether the withdrawal was successful
   * @example true
   */
  success: boolean;
  /**
   * Steam trade offer ID
   * @example "1234567890"
   */
  tradeId?: string;
  /**
   * Trade price in cents (for Steam trade API)
   * @example 1500
   */
  tradePrice?: number;
  /** Error code if withdrawal failed */
  errorCode?: WithdrawItemResponseErrorCodeEnum;
}

export interface UpdateTradeLink {
  /**
   * Steam trade URL
   * @pattern /https:\/\/steamcommunity\.com\/tradeoffer\/new\/\?partner=\d+&token=[A-Za-z0-9_-]+/
   * @example "https://steamcommunity.com/tradeoffer/new/?partner=123456789&token=AbCdEfGh"
   */
  tradeUrl: string;
}

export interface UpdateTradeLinkResponse {
  /**
   * Whether the update was successful
   * @example true
   */
  success: boolean;
  /**
   * Success message
   * @example "Trade link updated successfully"
   */
  message: string;
}

export interface SteamInventoryItem {
  /**
   * Steam asset id
   * @example "53307055342"
   */
  assetId: string;
  /**
   * Steam market hash name
   * @example "AUG | Contractor (Field-Tested)"
   */
  hashName: string;
  /**
   * Display name
   * @example "AUG | Contractor"
   */
  name: string;
  /** Item image */
  imageUrl: string | null;
  /**
   * Wear
   * @example "ft"
   */
  wear: string | null;
  /**
   * Rarity name
   * @example "Mil-Spec Grade"
   */
  rarityName: string | null;
  /**
   * Rarity color
   * @example "#4b69ff"
   */
  rarityColor: string | null;
  /** StatTrak */
  statTrak: boolean;
  /** Souvenir */
  souvenir: boolean;
  /** Tradable in Steam */
  tradable: boolean;
  /**
   * Steam price in USD, null until PriceEmpire has one
   * @example 12.34
   */
  steamPrice: number | null;
}

export interface SteamInventoryResponse {
  /**
   * Snapshot state. null — snapshot has not been taken yet
   * @example "ok"
   */
  status: SteamInventoryResponseStatusEnum;
  /**
   * When the snapshot was taken
   * @example "2026-09-04T16:14:17.000Z"
   */
  fetchedAt: string | null;
  /**
   * Items in the Steam inventory, including ones missing from our catalog
   * @example 12
   */
  totalCount: number;
  /**
   * Sum of Steam prices over items that have one, USD
   * @example 128.4
   */
  totalSteamPrice: number;
  /** Items resolved against our catalog */
  items: SteamInventoryItem[];
  /**
   * A newer snapshot is being fetched — poll until this clears
   * @example false
   */
  refreshing: boolean;
}

export interface Cs2MatchLink {
  status: Cs2MatchLinkStatus;
  /** @example "76561198012345678" */
  steamId: string;
  /** ISO date */
  linkedAt: string;
  /** ISO date */
  lastPolledAt: string | null;
  /** ISO date of the next scheduled share code check */
  nextPollAt: string;
  /** Steam profile is public (needed for presence) */
  profilePublic: boolean;
  /** offline / online in CS2 / on a game server */
  presenceState: Cs2PresenceState;
  /** ISO date of the last presence check */
  presenceCheckedAt: string | null;
}

export interface Cs2MatchPlayer {
  /**
   * Side at the end of the match
   * @example "CT"
   */
  side: string | null;
  won: boolean;
  kills: number;
  deaths: number;
  assists: number;
  headshotKills: number;
  damage: number;
  mvps: number;
  score: number;
  aces: number;
  /** Rounds won as the last player alive */
  clutchesWon: number;
  /** Largest clutch won, e.g. 3 for a 1v3; 0 if none */
  bestClutch: number;
  entryKills: number;
  /** Premier rating before the match */
  rankOld: number | null;
  /** Premier rating after the match */
  rankNew: number | null;
  /** Premier rating delta */
  rankChange: number | null;
}

export interface Cs2Match {
  /** @example "3736456444682174484" */
  matchId: string;
  /** @example "CSGO-AbCdE-FhJKM-NoPqR-sTUvW-xy234" */
  shareCode: string;
  status: Cs2MatchStatus;
  /** @example "de_ancient" */
  mapName: string | null;
  /** ISO date */
  playedAt: string | null;
  scoreT: number | null;
  scoreCT: number | null;
  /** T, CT or null for a draw / unparsed match */
  winner: string | null;
  durationSec: number | null;
  /** Own row; null until the demo is parsed */
  me: Cs2MatchPlayer | null;
}

export interface Cs2MatchesResponse {
  /** Section is closed for this account: the skin-exchange gate is on and the user is not allowed in. The client hides the entry point; every write endpoint rejects with rule `cs2_matches_locked`. */
  locked: boolean;
  /** Whether a Steam account is linked; without it linking is impossible */
  steamLinked: boolean;
  link: Cs2MatchLink | null;
  matches: Cs2Match[];
}

export interface CheckCs2ProfileResponse {
  /** Whether the Steam profile is public; presence works only for public profiles */
  profilePublic: boolean;
}

export interface LinkCs2Matches {
  /**
   * CS2 match history authentication code from help.steampowered.com
   * @pattern /^[A-Za-z0-9]{4}-[A-Za-z0-9]{5}-[A-Za-z0-9]{4}$/
   * @example "AAAA-BBBBB-CCCC"
   */
  authCode: string;
  /**
   * Share code of any of your matches; omit to add it later (matches are not counted until then)
   * @pattern /^CSGO(-[A-Za-z0-9]{5}){5}$/
   * @example "CSGO-AbCdE-FhJKM-NoPqR-sTUvW-xy234"
   */
  shareCode?: string | null;
}

export interface LinkCs2MatchesResponse {
  /**
   * Steam id the history is linked to
   * @example "76561198012345678"
   */
  steamId: string;
  status: Cs2MatchLinkStatus;
  /** Match from the submitted share code, queued for parsing; null when the code was skipped */
  matchId: string | null;
}

export interface SetCs2ShareCode {
  /**
   * Share code of any of your matches
   * @pattern /^CSGO(-[A-Za-z0-9]{5}){5}$/
   * @example "CSGO-AbCdE-FhJKM-NoPqR-sTUvW-xy234"
   */
  shareCode: string;
}

export interface SetCs2ShareCodeResponse {
  /** Match from the submitted share code, queued for parsing */
  matchId: string;
}

export interface RefreshCs2MatchesResponse {
  /** How many new matches were found and queued */
  newMatches: number;
}

export interface CreateInvoice {
  /** Payment provider */
  provider: CreateInvoiceProviderEnum;
  /** Specific amount to pay (optional for flexible payments) */
  amount?: number;
  /** Minimum amount for flexible payments */
  minAmount?: number;
  /** Maximum amount for flexible payments */
  maxAmount?: number;
  /** Allow user to specify custom amount */
  allowFlexibleAmount?: boolean;
  /** Return URL after payment */
  returnUrl?: string;
  /** Additional metadata (Steam ID, Trade URL for skins, etc.) */
  metadata?: object;
}

export interface PaymentResponse {
  id: string;
  invoiceUrl: string;
  amount?: number | null;
  currency: PaymentResponseCurrencyEnum;
  status: PaymentResponseStatusEnum;
  /** @format date-time */
  expiresAt?: string | null;
  /** Provider-specific metadata */
  providerMetadata?: object | null;
}

export interface PaymentSettingsResponse {
  /**
   * Whether skin exchange is enabled for this user
   * @example true
   */
  skinsExchangeEnabled: boolean;
  /**
   * Payment providers currently enabled for this user (globally on + not blocked + skin-exchange-gate passes)
   * @example ["NOROS_P2P","WATAPRO_SBP","TELEGRAM_STARS"]
   */
  enabledProviders: string[];
}

export interface PaymentProviderPackage {
  credits: number;
  amount: number;
  currency: PaymentProviderPackageCurrencyEnum;
  bonus: Record<string, any>;
}

export interface PaymentProvider {
  id: PaymentProviderIdEnum;
  kind: PaymentProviderKindEnum;
  currency: PaymentProviderCurrencyEnum;
  packages: PaymentProviderPackage[];
}

export interface PaymentProvidersResponse {
  providers: PaymentProvider[];
}

export interface ClickCardResponse {
  id: string;
  /** Mask Click returns on verify */
  maskedPan?: string | null;
  phoneNumber?: string | null;
  isVerified: boolean;
}

export interface ClickCardListResponse {
  cards: ClickCardResponse[];
}

export interface BindClickCard {
  /**
   * Card number, 16 digits
   * @pattern /^[\d\s]{16,19}$/
   * @example "8600123412341234"
   */
  cardNumber: string;
  /**
   * Expiry date, MMYY
   * @pattern /^\d{4}$/
   * @example "0526"
   */
  expireDate: string;
}

export interface BindClickCardResponse {
  cardId: string;
  /** Masked number the SMS went to */
  phoneNumber?: string | null;
}

export interface VerifyClickCard {
  /**
   * SMS code Click sent to the card holder
   * @pattern /^\d{4,8}$/
   */
  smsCode: string;
}

export interface PayWithClickCard {
  /**
   * Amount in UZS
   * @min 1000
   */
  amount: number;
}

export interface PayWithClickCardResponse {
  /** Our payment id; credits land on the Click callback */
  paymentId: string;
  clickPaymentId?: number | null;
}

export interface UpdateAnimationSetting {
  /**
   * Whether case opening animations are enabled
   * @example true
   */
  animationsEnabled: boolean;
}

export interface UpdateAnimationSettingResponse {
  /**
   * Whether the update was successful
   * @example true
   */
  success: boolean;
  /**
   * Success message
   * @example "Animation setting updated successfully"
   */
  message: string;
}

export interface ToggleNotifications {
  /**
   * Enable or disable notifications
   * @example true
   */
  enabled: boolean;
}

export interface ToggleNotificationsResponse {
  /**
   * Current state of notifications
   * @example true
   */
  enabled: boolean;
}

export interface UpdateLanguage {
  /**
   * Language code
   * @example "ru"
   */
  languageCode: UpdateLanguageLanguageCodeEnum;
}

export interface UpdateLanguageResponse {
  /**
   * Updated language code
   * @example "ru"
   */
  languageCode: string;
}

export interface NextBonusInfo {
  /** Сумма следующего бонуса в кредитах */
  amount: number;
  /** Описание следующего бонуса */
  description: string;
}

export interface ClaimDailyBonusResponse {
  /** Количество полученных кредитов */
  creditsEarned: number;
  /** Новый streak */
  newStreak: number;
  /** Новый баланс пользователя */
  newBalance: number;
  /** Описание полученного бонуса */
  description: string;
  /** Информация о следующем бонусе */
  nextBonusInfo: NextBonusInfo;
}

export interface ClaimComebackBonusResponse {
  /** @example 500 */
  amount: number;
  /** @example 1500 */
  newBalance: number;
}

export interface OnboardingTaskConfig {
  /**
   * Task identifier
   * @example "dailyLogin"
   */
  key: string;
  /**
   * Reward amount in credits
   * @example 50
   */
  reward: number;
}

export interface OnboardingReferralConfig {
  /**
   * Credits when a friend starts playing
   * @example 2000
   */
  friendStartReward: number;
  /**
   * Credits for every Nth referral milestone
   * @example 4000
   */
  milestoneReward: number;
  /**
   * Referral milestone interval (every N friends)
   * @example 10
   */
  milestoneInterval: number;
  /**
   * Percentage of friend deposit as bonus (0.05 = 5%)
   * @example 0.05
   */
  depositBonusRate: number;
}

export interface OnboardingCaseConfig {
  /**
   * Minimum case price in credits
   * @example 500
   */
  minPriceCredits: number;
  /**
   * Minimum case price in rubles
   * @example 2
   */
  minPriceRubles: number | null;
}

export interface OnboardingConfigResponse {
  /** Task rewards for onboarding display */
  tasks: OnboardingTaskConfig[];
  /** Referral bonus configuration */
  referral: OnboardingReferralConfig;
  /** Cheapest case pricing */
  cheapestCase: OnboardingCaseConfig;
}

export interface ActivateBoostResponse {
  /**
   * User boost ID
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  id: string;
  /**
   * Boost status
   * @example "PENDING"
   */
  status: ActivateBoostResponseStatusEnum;
  /**
   * Next reward available timestamp (24 hours after activation)
   * @example "2024-01-16T10:30:00.000Z"
   */
  nextRewardAvailableAt: string;
  /**
   * Message for the user
   * @example "Boost activated! Your first reward will be available in 24 hours."
   */
  message: string;
}

export interface ClaimBoostRewardResponse {
  /**
   * Credits earned from the reward
   * @example 100
   */
  creditsEarned: number;
  /**
   * New user balance after claiming
   * @example 1500
   */
  newBalance: number;
  /**
   * Total rewards claimed for this boost
   * @example 5
   */
  totalRewardsClaimed: number;
  /**
   * Total credits earned from this boost
   * @example 500
   */
  totalCreditsEarned: number;
  /**
   * Next reward available timestamp
   * @example "2024-01-17T10:30:00.000Z"
   */
  nextRewardAvailableAt?: string;
}

export interface ChickenTickResponse {
  /** ID активного спавна для отображения (null если курицы нет) */
  spawnId: string | null;
  /** Тип курицы: regular — обычная, cyber — кибер-курица для участников SHOT BAND */
  kind: ChickenTickResponseKindEnum;
  /** Награда за клейм этой курицы в кредитах */
  amount: number | null;
}

export interface ClaimChickenReward {
  /**
   * ID of the chicken spawn to claim
   * @format uuid
   */
  spawnId: string;
}

export interface ClaimChickenRewardResponse {
  /** Количество полученных кредитов */
  creditsEarned: number;
  /** Новый баланс пользователя */
  newBalance: number;
  /** Сколько раз сегодня ещё можно получить награду */
  remainingToday: number;
}

export interface XpTransactionItem {
  /** Transaction ID */
  id: string;
  /** Transaction type */
  type: XpTransactionItemTypeEnum;
  /**
   * XP amount (positive or negative)
   * @example 50
   */
  amount: number;
  /**
   * XP before transaction
   * @example 1200
   */
  xpBefore: number;
  /**
   * XP after transaction
   * @example 1250
   */
  xpAfter: number;
  /**
   * Level before transaction
   * @example 5
   */
  levelBefore: number;
  /**
   * Level after transaction
   * @example 5
   */
  levelAfter: number;
  /** Description */
  description?: string;
  /** Additional metadata */
  metadata?: object;
  /**
   * Transaction timestamp
   * @format date-time
   */
  createdAt: string;
}

export interface XpHistoryMeta {
  /**
   * Current page
   * @example 1
   */
  page: number;
  /**
   * Items per page
   * @example 20
   */
  limit: number;
  /**
   * Total items count
   * @example 100
   */
  total: number;
  /**
   * Total pages
   * @example 5
   */
  totalPages: number;
}

export interface XpHistoryResponse {
  /** XP transactions */
  transactions: XpTransactionItem[];
  /** Pagination metadata */
  meta: XpHistoryMeta;
}

export interface LevelInfoItem {
  /**
   * Level number
   * @example 5
   */
  level: number;
  /**
   * XP required for this level
   * @example 250
   */
  xpRequired: number;
  /**
   * Total XP required to reach this level
   * @example 1000
   */
  totalXpRequired: number;
}

export interface XpRewardsConfig {
  /**
   * XP for daily login
   * @example 50
   */
  dailyLogin: number;
  /**
   * XP for weekly streak completion
   * @example 200
   */
  weeklyStreak: number;
  /**
   * XP for referral invite
   * @example 30
   */
  referralInvite: number;
  /**
   * XP for referral deposit
   * @example 20
   */
  referralDeposit: number;
  /**
   * XP for contract
   * @example 40
   */
  contract: number;
  /**
   * XP for successful upgrade
   * @example 30
   */
  upgradeSuccess: number;
  /**
   * XP for failed upgrade
   * @example 5
   */
  upgradeFail: number;
  /**
   * XP for draw participation
   * @example 10
   */
  drawParticipation: number;
  /**
   * XP for draw win
   * @example 200
   */
  drawWin: number;
  /**
   * XP for case battle win
   * @example 30
   */
  caseBattleWin: number;
  /**
   * XP for case battle loss
   * @example 5
   */
  caseBattleLose: number;
  /**
   * XP for roulette win
   * @example 15
   */
  rouletteWin: number;
  /**
   * XP for roulette loss
   * @example 3
   */
  rouletteLose: number;
}

export interface CaseXpTier {
  /**
   * Maximum price in RUB for this tier
   * @example 50
   */
  maxPriceRub: number;
  /**
   * XP multiplier for this tier
   * @example 0.5
   */
  multiplier: number;
}

export interface DepositMultiplier {
  /**
   * Minimum credits for this multiplier
   * @example 625000
   */
  minCredits: number;
  /**
   * XP multiplier value
   * @example 1.25
   */
  multiplier: number;
}

export interface CaseXpGroup {
  /**
   * Group name (cheap, medium, expensive)
   * @example "medium"
   */
  name: string;
  /**
   * Minimum XP for cases in this group
   * @example 30
   */
  minXp: number;
  /**
   * Maximum XP for cases in this group
   * @example 80
   */
  maxXp: number;
}

export interface KeyLevel {
  /**
   * Key level number
   * @example 10
   */
  level: number;
  /**
   * Total XP required to reach this level
   * @example 13912
   */
  xpRequired: number;
  /**
   * Bonus credits awarded for reaching this level
   * @example 24500
   */
  bonus: number;
}

export interface XpConfigResponse {
  /** Level table */
  levels: LevelInfoItem[];
  /**
   * Maximum level
   * @example 100
   */
  maxLevel: number;
  /** XP rewards configuration */
  rewards: XpRewardsConfig;
  /** Case XP tiers with progressive multipliers */
  caseXpTiers: CaseXpTier[];
  /** Deposit XP multipliers based on amount */
  depositMultipliers: DepositMultiplier[];
  /** Case XP groups by price tier */
  caseXpGroups: CaseXpGroup[];
  /** Key levels with bonus rewards */
  keyLevels: KeyLevel[];
}

export interface LevelBonusStatusItem {
  /**
   * Level number
   * @example 5
   */
  level: number;
  /**
   * Bonus amount in credits
   * @example 3500
   */
  bonus: number;
  /**
   * XP required to reach this level
   * @example 2830
   */
  xpRequired: number;
  /**
   * Whether user has reached this level
   * @example true
   */
  isUnlocked: boolean;
  /**
   * Whether bonus has been claimed
   * @example false
   */
  isClaimed: boolean;
  /**
   * Whether bonus is forfeit (unavailable)
   * @example false
   */
  isForfeit: boolean;
  /**
   * Whether bonus can be claimed now
   * @example true
   */
  canClaim: boolean;
}

export interface LevelBonusesStatusResponse {
  /** List of all key level bonuses */
  bonuses: LevelBonusStatusItem[];
  /**
   * Number of bonuses available to claim
   * @example 2
   */
  claimableBonusesCount: number;
  /**
   * Total credits available to claim
   * @example 4000
   */
  totalClaimableCredits: number;
}

export interface ClaimLevelBonusResponse {
  /**
   * Level for which bonus was claimed
   * @example 5
   */
  level: number;
  /**
   * Credits earned from the bonus
   * @example 3500
   */
  creditsEarned: number;
  /**
   * New user balance after claiming
   * @example 15000
   */
  newBalance: number;
}

export interface XpLeaderboardEntry {
  /** User ID */
  userId: string;
  /** First name */
  firstName: string | null;
  /** Last name */
  lastName: string | null;
  /**
   * Total XP
   * @example 5000
   */
  totalXp: number;
  /**
   * User level
   * @example 10
   */
  level: number;
  /**
   * XP rank position
   * @example 42
   */
  xpRank: number;
}

export interface XpLeaderboardResponse {
  /** Leaderboard entries */
  entries: XpLeaderboardEntry[];
  /** Pagination metadata */
  meta: PaginationMeta;
}

export interface XpLeaderboardNeighborsResponse {
  /** Neighboring users in the leaderboard (up to 7 users: 3 above + current + 3 below) */
  entries: XpLeaderboardEntry[];
  /**
   * Current user rank position (null if excluded from rating)
   * @example 42
   */
  currentUserRank: number | null;
}

export interface DrawWinnerUser {
  id: string;
  firstName: string | null;
  lastName: string | null;
  /**
   * User level
   * @example 5
   */
  level: number;
}

export interface DrawWinner {
  id: string;
  type: string;
  prizeItemName: string;
  prizeItemImage: string;
  prizeItemPrice: number;
  winner: DrawWinnerUser;
  /** @format date-time */
  completedAt: string;
}

export interface DrawParticipants {
  /** List of participants */
  participants: DrawParticipant[];
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
  /** Total number of pages */
  totalPages: number;
  /** Total number of participants */
  total: number;
}

export interface BuyDrawEntry {
  /**
   * Type of draw to participate in
   * @example "paid_5000"
   */
  drawType: BuyDrawEntryDrawTypeEnum;
}

export interface GiveawayWinner {
  id: string;
  firstName: string | null;
  lastName: string | null;
  /** @example 5 */
  level: number;
}

export interface GiveawayWonItem {
  inventoryItemId: string;
  hashName: string;
  name: string;
  imageUrl: string | null;
  rarityColor: string | null;
  priceInCredits: number;
}

export interface GiveawayCaseItemDetail {
  hashName: string;
  name: string;
  priceInRubles: number;
  priceInCredits: number;
  priceInUsd?: number;
  imageUrl: string | null;
  rarityName: string | null;
  rarityColor: string | null;
  weapon: string | null;
  category: string | null;
  wear: string | null;
  statTrak: boolean;
  souvenir: boolean;
  volume: number;
}

export interface GiveawayCaseItem {
  id: string;
  itemHashName: string;
  probability: number;
  item: GiveawayCaseItemDetail;
}

export interface GiveawayCase {
  id: string;
  name: string;
  priceInCredits: number;
  imageUrl: string;
  imagePlaceholder: string | null;
  isActive: boolean;
  sortOrder: number;
  openingsCount: number;
  items: GiveawayCaseItem[];
}

export interface GiveawayDetailsResponse {
  id: string;
  type: GiveawayDetailsResponseTypeEnum;
  status: GiveawayDetailsResponseStatusEnum;
  requiredParticipants: number | null;
  durationMinutes: number | null;
  /** @format date-time */
  expiresAt: string;
  /** @format date-time */
  createdAt: string;
  participantsCount: number;
  userParticipating: boolean;
  winner: GiveawayWinner | null;
  wonItem: GiveawayWonItem | null;
  case: GiveawayCase;
}

export interface GiveawayParticipant {
  id: string;
  userId: string;
  firstName: string | null;
  lastName: string | null;
  /** @example 5 */
  level: number;
  /** @format date-time */
  joinedAt: string;
}

export interface GiveawayParticipantsResponse {
  participants: GiveawayParticipant[];
  total: number;
  page: number;
  limit: number;
}

export interface JoinGiveawayResponse {
  success: boolean;
}

export interface RainCase {
  id: string;
  name: string;
  imageUrl: string;
  imageCutoutUrl: string | null;
  /** Base64 LQIP used as the blur-up backdrop while the image loads */
  imagePlaceholder?: string | null;
  /** Case price in credits */
  price: number;
}

export interface CurrentRain {
  id: string;
  /** When the rain opened. With endAt it gives the round its real length, so a countdown scales to this rain instead of an assumed maximum duration. */
  startAt: string;
  /** When joining closes and winners are drawn */
  endAt: string;
  winnersCount: number;
  participantsCount: number;
  /** Whether the requesting user already joined */
  isParticipating: boolean;
  /** Whether the user clears the standing prerequisites. True can still lose to a per-rain gate (IP, referral, multiacc) on join, since those depend on the current participant set. */
  canJoin: boolean;
  /** Reason code when canJoin is false; the client owns the wording. */
  joinBlockedReason?: CurrentRainJoinBlockedReasonEnum;
  /** Account level the rain asks for; pairs with LEVEL_TOO_LOW */
  minLevel: number;
  case: RainCase;
}

export interface CurrentRainResponse {
  rain?: CurrentRain | null;
}

export interface RainItem {
  hashName: string;
  name: string;
  imageUrl?: string | null;
  rarityColor?: string | null;
  priceInCredits: number;
}

export interface RainHistoryWinner {
  userId: string;
  firstName?: string | null;
  lastName?: string | null;
  level: number;
  /** The minted inventory row, linking the winner to their item */
  inventoryItemId: string;
  item: RainItem;
}

export interface RainHistoryEntry {
  id: string;
  finalizedAt: string;
  participantsCount: number;
  case: RainCase;
  winners: RainHistoryWinner[];
}

export interface RainHistoryPage {
  rains: RainHistoryEntry[];
  total: number;
  hasMore: boolean;
}

export interface RainParticipant {
  userId: string;
  firstName?: string | null;
  lastName?: string | null;
  level: number;
  joinedAt: string;
}

export interface RainParticipantsPage {
  participants: RainParticipant[];
  total: number;
  hasMore: boolean;
}

export interface RainDetail {
  id: string;
  status: RainDetailStatusEnum;
  startAt?: string | null;
  endAt?: string | null;
  /** Prize slots the rain opened with; null while it is still SCHEDULED */
  winnersCount?: number | null;
  participantsCount: number;
  isParticipating: boolean;
  /** Prerequisites only — a per-rain gate can still refuse on join */
  canJoin: boolean;
  /** Reason code when canJoin is false; the client owns the wording */
  joinBlockedReason?: RainDetailJoinBlockedReasonEnum;
  /** Account level the rain asks for; pairs with LEVEL_TOO_LOW */
  minLevel: number;
  case?: RainCase | null;
  /** Filled once the rain is COMPLETED */
  winners: RainHistoryWinner[];
}

export interface RainDetailResponse {
  rain?: RainDetail | null;
}

export interface JoinRainResponse {
  success: boolean;
}

export interface DailyGiveawayDetailResponse {
  id: string;
  sortOrder: number;
  /** Scoring mode */
  type: DailyGiveawayDetailResponseTypeEnum;
  case: DailyGiveawayCase;
  prize: DailyGiveawayPrize;
  round: DailyGiveawayRound | null;
  me: DailyGiveawayMe | null;
}

export interface DailyGiveawayLeaderboardEntry {
  rank: number;
  userId: string;
  firstName: string | null;
  lastName: string | null;
  level: number;
  openCount: number;
  /** Total dropped value in credits */
  dropValueSum: number;
}

export interface DailyGiveawayLeaderboardPage {
  /** Scoring mode */
  type: DailyGiveawayLeaderboardPageTypeEnum;
  entries: DailyGiveawayLeaderboardEntry[];
  total: number;
  hasMore: boolean;
}

export interface DailyGiveawayWinnerPrize {
  name: string;
  imageUrl: string | null;
  rarityColor: string | null;
}

export interface DailyGiveawayWinner {
  localDate: string;
  userId: string;
  firstName: string | null;
  lastName: string | null;
  level: number;
  openCount: number;
  /** Total dropped value in credits */
  dropValueSum: number;
  prize: DailyGiveawayWinnerPrize;
}

export interface DailyGiveawayWinnersPage {
  /** Scoring mode */
  type: DailyGiveawayWinnersPageTypeEnum;
  winners: DailyGiveawayWinner[];
  total: number;
  hasMore: boolean;
}

export interface ReferralContestPrizeItem {
  hashName: string;
  name: string;
  imageUrl: string | null;
  rarityColor: string | null;
  /** Catalogue price in credits */
  price: number;
  /** Steam market price in USD */
  steamPrice: number | null;
}

export interface ReferralContestPrize {
  place: number;
  /** Credit payout, null when the place takes an item */
  credits: number | null;
  item: ReferralContestPrizeItem | null;
}

export interface ReferralContestEntry {
  rank: number;
  userId: string;
  firstName: string | null;
  lastName: string | null;
  level: number;
  /** Activated referrals invited inside the contest window */
  activatedCount: number;
}

export interface ReferralContestMe {
  /** Null while the user has no activated referrals yet */
  rank: number | null;
  activatedCount: number;
}

export interface ReferralContestLeaderboardResponse {
  status: ReferralContestLeaderboardResponseStatusEnum;
  /**
   * Contest window start (ISO, 1 Aug 2026 00:00 MSK)
   * @format date-time
   */
  startsAt: string;
  /**
   * Contest window end, exclusive (ISO, 1 Sep 2026 00:00 MSK)
   * @format date-time
   */
  endsAt: string;
  totalParticipants: number;
  prizes: ReferralContestPrize[];
  /** One page of the board, 20 entries */
  entries: ReferralContestEntry[];
  /** Another page follows this one */
  hasMore: boolean;
  me: ReferralContestMe | null;
}

export interface CentrifugoTokenResponse {
  /**
   * JWT token for Centrifugo connection
   * @example "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..."
   */
  token: string;
  /**
   * Channel prefix for environment separation (e.g., dev, prod)
   * @example "prod"
   */
  channelPrefix: string;
}

export interface HeartbeatRequest {
  /**
   * What the user is currently doing
   * @example "opening_case"
   */
  activity: HeartbeatRequestActivityEnum;
}

export interface HeartbeatResponse {
  /**
   * Heartbeat accepted
   * @example true
   */
  ok: boolean;
}

export interface OnlineCountResponse {
  /**
   * Number of online users
   * @example 42
   */
  online: number;
}

export interface CreateCaseBattleRequest {
  /**
   * Maximum number of players (2-4)
   * @min 2
   * @max 4
   */
  maxPlayers: number;
  /**
   * Array of case IDs for each round
   * @minItems 1
   */
  caseIds: string[];
  /** @default "classic" */
  mode?: CreateCaseBattleRequestModeEnum;
  /**
   * 2×2 (only with maxPlayers = 4)
   * @default false
   */
  isTeam?: boolean;
  /** @default "public" */
  visibility?: CreateCaseBattleRequestVisibilityEnum;
  /** Creator side in 2×2: 0 or 1 */
  side?: CreateCaseBattleRequestSideEnum;
}

export interface CreateCaseBattleResponse {
  battleId: string;
}

export interface CaseBattleTopDropResponse {
  /** Market hash name — по нему силуэт-заглушка картинки */
  hashName: string;
  /** Место игрока, которому выпал */
  slot: number;
  /** Цена в кредитах */
  price: number;
  imageUrl?: string | null;
  rarityColor?: string | null;
}

export interface CaseBattleRoundResponse {
  id: string;
  roundNumber: number;
  caseId: string;
  caseName: string;
  caseImageUrl: string;
  /** Base64 16x16 placeholder image */
  caseImagePlaceholder?: string | null;
  casePriceInCredits: number;
  /** Крупных дропов в раунде — у каждого свой показ, показ раунда длиннее */
  bigDrops: number;
  /** Сумма дропов раунда в кредитах — банк на карточке растёт по ходу показа */
  droppedValue: number;
  /** Самый дорогой дроп раунда */
  topDrop?: CaseBattleTopDropResponse | null;
}

export interface CaseBattleParticipantResponse {
  id: string;
  slot: number;
  userId: string;
  firstName?: string | null;
  /**
   * Player level
   * @default 1
   */
  level?: number;
  /** Ready to start without a full roster */
  startNow: boolean;
  totalDroppedValue: number;
  /** Credits paid out (team / sharing / tie; for a Headliners battle — the place payout); 0 when items were awarded */
  payout: number;
  /** Headliners battle only: place by own drops, ties share a place */
  place?: number | null;
  /** Headliners battle only: share of the pot in percent */
  sharePct?: number | null;
}

export interface CaseBattleReactionCountResponse {
  emoji: string;
  count: number;
}

export interface CaseBattleListItemResponse {
  id: string;
  creatorId: string;
  status: CaseBattleListItemResponseStatusEnum;
  mode: CaseBattleListItemResponseModeEnum;
  isTeam: boolean;
  visibility: CaseBattleListItemResponseVisibilityEnum;
  /** BAND — Headliners battle paid by the club */
  fundedBy: CaseBattleListItemResponseFundedByEnum;
  maxPlayers: number;
  currentPlayers: number;
  totalCost: number;
  deadlineAt?: string | null;
  /** Viewer plays in this battle */
  mine: boolean;
  rounds: CaseBattleRoundResponse[];
  participants: CaseBattleParticipantResponse[];
  createdAt: string;
  /** Set once the outcome is computed; the client still plays the reveal */
  completedAt?: string | null;
  /** Crowd reactions, most used first */
  reactions: CaseBattleReactionCountResponse[];
}

export interface CaseBattleListResponse {
  items: CaseBattleListItemResponse[];
  /** Battles running right now */
  activeCount: number;
  /** Server clock at response time; clients align the show to it */
  serverNow: string;
}

export interface CaseBattleConfigResponse {
  /** @example 600 */
  waitingSeconds: number;
  /** @example 20 */
  maxRounds: number;
  /** @example 2 */
  maxActiveBattles: number;
  /** @example 20 */
  rematchInviteSeconds: number;
  /** @example 10 */
  reactionsAfterFinishSeconds: number;
  reactions: string[];
  /** @example 10 */
  maxSavedTemplates: number;
}

export interface CaseBattleTemplateCaseResponse {
  caseId: string;
  caseName: string;
  caseImageUrl: string;
  caseImagePlaceholder?: string | null;
  casePriceInCredits: number;
}

export interface CaseBattleTemplateResponse {
  /** null for recent (derived from history) */
  id?: string | null;
  name?: string | null;
  mode: CaseBattleTemplateResponseModeEnum;
  maxPlayers: number;
  isTeam: boolean;
  cases: CaseBattleTemplateCaseResponse[];
  /** Entry price at current case prices */
  totalCost: number;
}

export interface CaseBattleTemplatesResponse {
  saved: CaseBattleTemplateResponse[];
  recent: CaseBattleTemplateResponse[];
  recommended: CaseBattleTemplateResponse[];
}

export interface SaveCaseBattleTemplateRequest {
  /** @maxLength 64 */
  name?: string;
  mode: SaveCaseBattleTemplateRequestModeEnum;
  /**
   * @min 2
   * @max 4
   */
  maxPlayers: number;
  isTeam: boolean;
  /** @minItems 1 */
  caseIds: string[];
}

export interface UserActiveBattlesCountResponse {
  /** Current number of active battles */
  count: number;
  /** Maximum allowed active battles */
  limit: number;
  /** Whether user can create/join more battles */
  canCreate: boolean;
}

export interface CaseBattleHistoryItemResponse {
  id: string;
  creatorId: string;
  status: CaseBattleHistoryItemResponseStatusEnum;
  mode: CaseBattleHistoryItemResponseModeEnum;
  isTeam: boolean;
  visibility: CaseBattleHistoryItemResponseVisibilityEnum;
  /** BAND — Headliners battle paid by the club */
  fundedBy: CaseBattleHistoryItemResponseFundedByEnum;
  maxPlayers: number;
  currentPlayers: number;
  totalCost: number;
  deadlineAt?: string | null;
  /** Viewer plays in this battle */
  mine: boolean;
  rounds: CaseBattleRoundResponse[];
  participants: CaseBattleParticipantResponse[];
  createdAt: string;
  /** Set once the outcome is computed; the client still plays the reveal */
  completedAt?: string | null;
  /** Crowd reactions, most used first */
  reactions: CaseBattleReactionCountResponse[];
  winnerId?: string | null;
  winnerTeam?: number | null;
  isTie: boolean;
}

export interface CaseBattleHistoryPaginatedResponse {
  items: CaseBattleHistoryItemResponse[];
  /** Whether more battles exist beyond this page */
  hasMore: boolean;
}

export interface CaseBattleRematchInviteResponse {
  userId: string;
  firstName?: string | null;
  status: CaseBattleRematchInviteResponseStatusEnum;
}

export interface CaseBattleRematchResponse {
  rematchBattleId: string;
  invites: CaseBattleRematchInviteResponse[];
  myInvite?: CaseBattleRematchResponseMyInviteEnum;
  expiresAt: string;
}

export interface CaseBattleRoundResultResponse {
  participantId: string;
  droppedItemHashName: string;
  droppedItemPrice: number;
  inventoryItemId?: string | null;
  rarityColor?: string | null;
  /** Item price on Steam market in USD */
  steamPrice?: number | null;
  /** Крупный дроп — на показе получает свой оверлей */
  isBigWin: boolean;
}

export interface CaseBattleRoundDetailResponse {
  id: string;
  roundNumber: number;
  caseId: string;
  caseName: string;
  caseImageUrl: string;
  /** Base64 16x16 placeholder image */
  caseImagePlaceholder?: string | null;
  casePriceInCredits: number;
  /** Крупных дропов в раунде — у каждого свой показ, показ раунда длиннее */
  bigDrops: number;
  /** Сумма дропов раунда в кредитах — банк на карточке растёт по ходу показа */
  droppedValue: number;
  /** Самый дорогой дроп раунда */
  topDrop?: CaseBattleTopDropResponse | null;
  status: CaseBattleRoundDetailResponseStatusEnum;
  results: CaseBattleRoundResultResponse[];
}

export interface CaseBattleParticipantDetailResponse {
  id: string;
  slot: number;
  userId: string;
  firstName?: string | null;
  /**
   * Player level
   * @default 1
   */
  level?: number;
  /** Ready to start without a full roster */
  startNow: boolean;
  totalDroppedValue: number;
  /** Credits paid out (team / sharing / tie; for a Headliners battle — the place payout); 0 when items were awarded */
  payout: number;
  /** Headliners battle only: place by own drops, ties share a place */
  place?: number | null;
  /** Headliners battle only: share of the pot in percent */
  sharePct?: number | null;
  joinedAt: string;
}

export interface CaseBattleDetailsResponse {
  id: string;
  creatorId: string;
  status: CaseBattleDetailsResponseStatusEnum;
  mode: CaseBattleDetailsResponseModeEnum;
  isTeam: boolean;
  visibility: CaseBattleDetailsResponseVisibilityEnum;
  /** BAND — Headliners battle paid by the club */
  fundedBy: CaseBattleDetailsResponseFundedByEnum;
  maxPlayers: number;
  totalCost: number;
  deadlineAt?: string | null;
  /** timeout | empty | processing_timeout */
  cancelReason?: string | null;
  winnerId?: string | null;
  winnerTeam?: number | null;
  isTie: boolean;
  tiedPlayerIds: string[];
  /** Sum of all drops */
  bank: number;
  /** Refunded to the viewer when the battle was cancelled; 0 otherwise */
  myRefund: number;
  viewers: number;
  /** Crowd reactions, most used first */
  reactions: CaseBattleReactionCountResponse[];
  rematchOfId?: string | null;
  rematch?: CaseBattleRematchResponse | null;
  /** Actions the viewer may take now */
  actions: string[];
  /** action → reason it is unavailable */
  actionReasons: Record<string, string>;
  rounds: CaseBattleRoundDetailResponse[];
  participants: CaseBattleParticipantDetailResponse[];
  createdAt: string;
  startedAt?: string | null;
  completedAt?: string | null;
  /** Server clock at response time; clients align the show to it */
  serverNow: string;
}

export interface CaseBattleViewerResponse {
  userId: string;
  firstName?: string | null;
  level: number;
  /** Plays in the battle, not only watching */
  participant: boolean;
}

export interface CaseBattleViewersResponse {
  viewers: CaseBattleViewerResponse[];
}

export interface JoinCaseBattleRequest {
  /**
   * Seat to take (2×2); omitted — first free seat
   * @min 0
   * @max 3
   */
  slot?: number;
}

export interface StartNowCaseBattleRequest {
  /** true — ready to start with the current roster; false — wait for more players */
  startNow: boolean;
}

export interface RematchCaseBattleResponse {
  rematchBattleId: string;
}

export interface SellAllCaseBattleResponse {
  /** Credits received */
  credits: number;
  itemsSold: number;
}

export interface ReactCaseBattleRequest {
  /**
   * One of the configured reactions
   * @maxLength 8
   */
  emoji: string;
}

export interface CaseBattleViewersCountResponse {
  viewers: number;
}

export interface RushMidConfigResponse {
  /** true = show the «Скоро» tease and refuse entry (launch gate or per-user restriction) */
  comingSoon: boolean;
  /** true = deploy drain: lobby shows the updating banner, match-prep actions are rejected, live matches play out */
  maintenance: boolean;
  /** ticket tiers that currently accept new entries */
  activeTickets: number[];
}

export interface CreateOpenGameRequest {
  /** Entry ticket / stake */
  ticket: CreateOpenGameRequestTicketEnum;
  /** Team size: 1v1, 2v2 or 5v5 */
  mode: CreateOpenGameRequestModeEnum;
  /** Side to fight on */
  side: CreateOpenGameRequestSideEnum;
  /** Match mode: 'ranked' (default, public + listed) or 'bots' (practice — no stake, rating, rewards, drops or listing) */
  matchMode?: CreateOpenGameRequestMatchModeEnum;
}

export interface RushMidOpenSeat {
  userId: string;
  name: string;
  /** app-wide XP level */
  level: number;
  /** ELO for this game's mode; absent when the player is unrated in this mode */
  rating?: number;
  /** dense per-game party index (1, 2, …); absent for a solo */
  partyGroup?: number;
}

export interface RushMidOpenSeatsGrid {
  /** `mode` slots, null while free */
  t: (RushMidOpenSeat | null)[];
  /** `mode` slots, null while free */
  ct: (RushMidOpenSeat | null)[];
}

export interface RushMidLoadout {
  /** Weapon class */
  weapon: RushMidLoadoutWeaponEnum;
  /** Whole-vest armor tier */
  armor: RushMidLoadoutArmorEnum;
  /** Carries one grenade */
  grenade: boolean;
  /** Carries one smoke (denies the gunfight for a round) */
  smoke: boolean;
  /** Carries one medkit (single-use self heal) */
  medkit: boolean;
  /** Carries one flashbang (blinds an enemy cluster — team mode only) */
  flash: boolean;
}

export interface RushMidBuyRosterEntry {
  index: number;
  name: string;
  isBot: boolean;
  /** chosen loadout, or null while a real teammate is still picking (always null for enemies) */
  loadout?: RushMidLoadout | null;
  /** ELO rating for this mode (absent for bots) */
  rating?: number;
  /** absent for bots */
  userId?: string;
}

export interface RushMidPublicFighter {
  id: string;
  team: RushMidPublicFighterTeamEnum;
  hp: number;
  maxHp: number;
  armor: number;
  hasGrenade: boolean;
  hasSmoke: boolean;
  hasMedkit: boolean;
  hasFlash: boolean;
  alive: boolean;
  /** Current shooting stance */
  stance: RushMidPublicFighterStanceEnum;
}

export interface RushMidPayout {
  pot: number;
  prize: number;
  won: boolean;
  /** Draw — both teams wiped; stake refunded, net 0 */
  draw: boolean;
  survived: boolean;
  share: number;
  net: number;
}

export interface RushMidScoreEntry {
  fighterId: string;
  name: string;
  team: RushMidScoreEntryTeamEnum;
  kills: number;
  /** contribution points = dealt damage + credited utility (smoke/flash/medkit) */
  pts: number;
  alive: boolean;
  /** winning-side fighter with the most contribution points (== the reward MVP) */
  mvp: boolean;
  /** net coin result for this seat (share − stake): + on a win, − on a loss, 0 for a draw/bot — same figure as the history screen */
  payout: number;
  /** ELO change this match (real players only) */
  ratingDelta?: number;
}

export interface RushMidSnapshot {
  /** Current Rush Mid phase for this user */
  status: RushMidSnapshotStatusEnum;
  /** Active / finished match id */
  matchId?: string;
  /** Monotonic write counter of the match row — apply only strictly newer snapshots of the same match */
  stateVersion?: number;
  /** The user's side preference ('any' = either team) */
  side?: RushMidSnapshotSideEnum;
  /** Team size (1/2/5) */
  mode?: number;
  /** Entry ticket / stake */
  ticket?: number;
  /** OPEN: the side the caller is seated on */
  yourSide?: RushMidSnapshotYourSideEnum;
  /** OPEN: per-side seat grid */
  seats?: RushMidOpenSeatsGrid;
  /** OPEN: ISO deadline when free slots get bot-filled and the match starts — absent when the global bot-fill toggle is off */
  botFillAt?: string;
  /** BUYING: same-side teammates */
  allies?: RushMidBuyRosterEntry[];
  /** BUYING: opposing-side players (no loadout — buys hidden) */
  enemies?: RushMidBuyRosterEntry[];
  /** BUYING: epoch ms the buy window closes */
  buyDeadline?: number;
  /** PLAYING/OVER: the round about to be played (or final round) */
  round?: number;
  /** PLAYING/OVER: fighter placements + names (FighterInit[]) */
  inits?: Record<string, any>[];
  /** PLAYING/OVER: current fighter snapshot */
  fighters?: RushMidPublicFighter[];
  /** PLAYING/OVER: events of the round that just resolved ([] before the first resolve) — RoundEvent[] */
  lastEvents?: Record<string, any>[];
  /** PLAYING/OVER: each fighter's resolved action for lastEvents, keyed by fighter id — { kind, stance? } (Record<string, RushMidRoundAction>) */
  lastActions?: Record<string, Record<string, any>>;
  /** PLAYING: epoch ms to choose the next action */
  roundDeadline?: number;
  /** PLAYING/OVER: the user's fighter id (`${side}${index}`) */
  yourFighterId?: string | null;
  /** PLAYING: whether this user already submitted an action this round */
  yourActionSubmitted?: boolean;
  /** OVER: winning side (null = mutual wipe) */
  winner?: RushMidSnapshotWinnerEnum;
  /** OVER: this user's payout */
  payout?: RushMidPayout;
  /** OVER: end-of-match scoreboard */
  scoreboard?: RushMidScoreEntry[];
  /** OVER: provably-fair reveal */
  serverSeed?: string;
  /** OVER: provably-fair reveal */
  serverSeedHash?: string;
  /** OVER: provably-fair reveal */
  clientSeed?: string;
}

export interface OpenGame {
  matchId: string;
  /** Entry ticket / stake */
  ticket: OpenGameTicketEnum;
  /** Team size: 1v1, 2v2 or 5v5 */
  mode: OpenGameModeEnum;
  /** the arena rolled at creation (mirage/dust2/inferno/nuke) — cards show its cover */
  map: string;
  createdAt: string;
  /** per-side seat grid */
  seats: RushMidOpenSeatsGrid;
  /** ISO deadline when free slots get bot-filled and the match starts — absent when the global bot-fill toggle is off */
  botFillAt?: string;
  /** whether the caller's unit may sit down — false while the newbie grace fences this lobby off. Absent on the Centrifugo payload (one broadcast for every viewer, so no unit to judge) */
  joinable?: boolean;
  /** why the join is blocked */
  joinBlockedReason?: OpenGameJoinBlockedReasonEnum;
  /** ISO instant the block lifts — the card counts down to it */
  joinableAt?: string;
}

export interface OpenGamesListResponse {
  games: OpenGame[];
}

export interface LiveGame {
  matchId: string;
  /** Entry ticket / stake */
  ticket: LiveGameTicketEnum;
  /** Team size: 1v1, 2v2 or 5v5 */
  mode: LiveGameModeEnum;
  /** the arena rolled at creation (mirage/dust2/inferno/nuke) — cards show its cover */
  map: string;
  /** the round currently being fought (for the «раунд N» badge) */
  round: number;
  /** per-side seat grid */
  seats: RushMidOpenSeatsGrid;
}

export interface LiveGamesListResponse {
  games: LiveGame[];
}

export interface RushMidSpectateView {
  /** Watched match phase */
  status: RushMidSpectateViewStatusEnum;
  matchId: string;
  /** Monotonic write counter of the match row — apply only strictly newer views */
  stateVersion?: number;
  /** Team size (1/2/5) */
  mode: number;
  /** Entry ticket / stake */
  ticket: number;
  /** battle map */
  map: RushMidSpectateViewMapEnum;
  /** PLAYING/OVER: the round about to be played (or final round) */
  round: number;
  /** fighter placements + names (FighterInit[]) */
  inits: Record<string, any>[];
  /** current fighter snapshot */
  fighters: RushMidPublicFighter[];
  /** events of the round that just resolved ([] before the first resolve) — RoundEvent[] */
  lastEvents: Record<string, any>[];
  /** each fighter's resolved action for lastEvents, keyed by fighter id — { kind, stance? } */
  lastActions?: Record<string, Record<string, any>>;
  /** PLAYING: epoch ms to the next round resolve */
  roundDeadline?: number;
  /** OVER: winning side (null = mutual wipe) */
  winner?: RushMidSpectateViewWinnerEnum;
  /** OVER: end-of-match scoreboard */
  scoreboard?: RushMidScoreEntry[];
  /** OVER: provably-fair reveal */
  serverSeed?: string;
  /** OVER: provably-fair reveal */
  serverSeedHash?: string;
  /** OVER: provably-fair reveal */
  clientSeed?: string;
}

export interface JoinOpenGameRequest {
  /** Side to join */
  side: JoinOpenGameRequestSideEnum;
}

export interface PartyJoinRequest {
  /** Secret party code (case-insensitive) */
  code: string;
}

export interface PartyConfigRequest {
  /** Team size (must be >= party size) */
  mode: PartyConfigRequestModeEnum;
  /** Entry ticket / stake */
  ticket: PartyConfigRequestTicketEnum;
  /** Side the whole party fights on ('any' = whichever team has room) */
  side: PartyConfigRequestSideEnum;
  /** Match mode: 'ranked' (default) or 'bots' (practice vs bots — no stake, rating, rewards or drops) */
  matchMode?: PartyConfigRequestMatchModeEnum;
}

export interface PartyKickRequest {
  /** userId of the member to remove (leader-only) */
  userId: string;
}

export interface PartyReadyRequest {
  /** ready confirmation (leader starts once every member is ready) */
  ready: boolean;
}

export interface SubmitLoadoutRequest {
  /** Player loadout for this match */
  loadout: RushMidLoadout;
  /** true = "to battle" (ready to start); false = just save this selection (buy window stays open) */
  ready: boolean;
}

export interface SubmitActionRequest {
  /** The round this action is for; rejected if the match has already advanced past it */
  round?: number;
  /** Action kind for this round */
  kind: SubmitActionRequestKindEnum;
  /** Shooting stance (for kind=shoot) */
  stance?: SubmitActionRequestStanceEnum;
  /** Enemy fighter id to shoot/knife (`${side}${index}`); omit for a random enemy */
  shootTargetId?: string | null;
  /** Enemy fighter id to throw a grenade at (consumes the grenade) */
  grenadeTargetId?: string | null;
  /** Enemy fighter id to smoke out of the gunfight (consumes the smoke); omit for a random enemy */
  smokeTargetId?: string | null;
  /** Enemy fighter id to flash (blinds it + nearby enemies; consumes the flashbang); omit for a random enemy */
  flashTargetId?: string | null;
}

export interface RushMidHistorySeat {
  /** Player id — null for a bot seat */
  userId: string | null;
  /** Display name (empty for bots) */
  name: string;
  /** Bot-filled seat (rendered with the generic avatar) */
  bot: boolean;
}

export interface RushMidHistoryTeams {
  /** T-side final roster (length = mode) */
  t: RushMidHistorySeat[];
  /** CT-side final roster (length = mode) */
  ct: RushMidHistorySeat[];
}

export interface RushMidHistoryItem {
  id: string;
  /** Match id — open the detail / replay screen with this */
  matchId: string;
  mode: number;
  /** Entry ticket (stake) — shown in the card header */
  ticket: number;
  /** Arena the match was played on — drives the card cover */
  map: string;
  /** Net credit change (payout - stake) */
  net: number;
  won: boolean;
  /** Draw (both teams wiped) — stake refunded, net 0 */
  draw: boolean;
  /** Both sides' final rosters for the card VS strip */
  teams: RushMidHistoryTeams;
  createdAt: string;
}

export interface RushMidHistoryResponse {
  items: RushMidHistoryItem[];
  total: number;
}

export interface RushMidRatingEntry {
  /** Leaderboard rank (1-based) */
  rank: number;
  userId: string;
  /** Display name (joined from the user) */
  name: string;
  /** ELO rating for this mode */
  rating: number;
  /** Matches played in this mode */
  played: number;
  wins: number;
  losses: number;
  /** Win rate %, one decimal */
  winrate: number;
  /** Cumulative net coins earned in this mode */
  coins: number;
  /** Cumulative kills in this mode */
  kills: number;
  /** Cumulative deaths in this mode */
  deaths: number;
}

export interface RushMidRatingResponse {
  /** The caller's own rating in this mode, or null if unrated */
  you: RushMidRatingEntry | null;
  /** Top players in this mode */
  top: RushMidRatingEntry[];
}

export interface RushMidWeaponSkinOption {
  /** catalog name, also the sprite file `wpn_<name>.webp` */
  name: string;
  /** ak / m4 / awp / lmg */
  weaponKey: string;
  /** shown to the player */
  title: string;
  /** milspec / restricted / classified / covert */
  rarity: string;
  /** откуда брать картинку: статика лендинга или бэкенд, если её залили из админки */
  spriteUrl: string;
  /** how the skin is earned */
  unlock: RushMidWeaponSkinOptionUnlockEnum;
  /** average ELO that opens an `elo` skin */
  minElo: number | null;
  /** may the player wear it right now */
  owned: boolean;
  /** ELO still to climb, or null when already open / not ELO-gated */
  eloToUnlock: number | null;
}

export interface RushMidSkinsResponse {
  /** saved T-side skin (e.g. `t3`), or null */
  t: string | null;
  /** saved CT-side skin (e.g. `ct7`), or null */
  ct: string | null;
  /** weapon skin per class (ak/m4/awp/lmg) → skin name */
  weapons: Record<string, string>;
  /** whether the weapon-skin block is open to this player (skinsExchangeEnabled) */
  weaponSkinsEnabled: boolean;
  /** enabled weapon-skin catalog, locked rows included */
  weaponCatalog: RushMidWeaponSkinOption[];
  /** weighted average ELO across modes — what the thresholds compare to */
  avgElo: number;
  /** weapon skins granted outright by an admin */
  grants: string[];
  /** last ticket the user searched with */
  ticket: number | null;
  /** last mode (1/2/5) */
  mode: number | null;
  /** last side ('t'/'ct'/'any') */
  side: string | null;
  /** last match mode ('ranked'/'bots') */
  matchMode: string | null;
}

export interface JoinMatchmakingRequest {
  /** Entry ticket / stake */
  ticket: JoinMatchmakingRequestTicketEnum;
  /** Team size: 1v1, 2v2 or 5v5 */
  mode: JoinMatchmakingRequestModeEnum;
  /** Side to fight on ('any' = whichever team has room) */
  side: JoinMatchmakingRequestSideEnum;
  /** Match mode: 'ranked' (default) or 'bots' (practice vs bots — no stake, rating, rewards or drops) */
  matchMode?: JoinMatchmakingRequestMatchModeEnum;
}

export interface SetRushMidSkinRequest {
  /** side the skin belongs to */
  side: SetRushMidSkinRequestSideEnum;
  /** skin file-prefix (e.g. `t3` / `ct7`); must match the side */
  skin: string;
}

export interface SetRushMidWeaponSkinRequest {
  /** weapon key the skin belongs to */
  weaponKey: SetRushMidWeaponSkinRequestWeaponKeyEnum;
  /** catalog skin name, or null for the stock weapon */
  skin: string | null;
}

export interface RushMidDrop {
  itemHashName: string;
  name: string;
  image: string | null;
  /** rarity label from the catalog, for the ItemCard pass gradient */
  rarity?: string;
  rarityColor?: string;
  /** the item's credit value frozen at settlement time */
  priceCredits: number;
}

export interface RushMidMatchDetail {
  id: string;
  mode: number;
  /** entry ticket / stake */
  stake: number;
  /** battle map */
  map: RushMidMatchDetailMapEnum;
  winner: RushMidMatchDetailWinnerEnum;
  createdAt: string;
  /** the requesting user's fighter id */
  yourFighterId: string | null;
  scoreboard: RushMidScoreEntry[];
  payout: RushMidPayout;
  /** the skin this viewer received in that match (null for losers, draws and old matches) */
  drop: RushMidDrop | null;
  serverSeed: string;
  serverSeedHash: string;
  clientSeed: string;
  /** Replay: { inits: FighterInit[], rounds: RoundEvent[][] } */
  replay: Record<string, any>;
}

export interface RushMidReplay {
  id: string;
  mode: number;
  /** entry ticket / stake */
  stake: number;
  /** battle map */
  map: RushMidReplayMapEnum;
  winner: RushMidReplayWinnerEnum;
  createdAt: string;
  scoreboard: RushMidScoreEntry[];
  /** Replay: { inits: FighterInit[], rounds: RoundEvent[][] } */
  replay: Record<string, any>;
}

export interface ArenaFighterCosmetics {
  ct: ArenaFighterCosmeticsCtEnum | null;
  t: ArenaFighterCosmeticsTEnum | null;
}

export interface ArenaCosmetics {
  fighter: ArenaFighterCosmetics;
  /** Empty until arena weapon skins are available. */
  weapons: Record<string, string>;
}

export interface ArenaCosmeticsResponse {
  cosmetics: ArenaCosmetics;
}

export interface SetArenaFighter {
  side: SetArenaFighterSideEnum;
  fighterId: string | null;
}

export interface ArenaPlayer {
  userId: string | null;
  seatIndex: number;
  partyCode: string | null;
  bot: boolean;
  side: ArenaPlayerSideEnum;
  name: string;
}

export interface ArenaScore {
  /** @min 0 */
  t: number;
  /** @min 0 */
  ct: number;
}

export interface ArenaRound {
  winner: ArenaRoundWinnerEnum | null;
  reason: string;
}

export interface ArenaMatchPlayer {
  userId: string | null;
  seatIndex: number;
  partyCode: string | null;
  bot: boolean;
  side: ArenaMatchPlayerSideEnum;
  name: string;
  won: boolean;
  payoutShare: number;
  netResult: number;
  ratingDelta: number;
  droppedItemHashName: string | null;
  droppedItemPrice: number | null;
  kills: number;
  deaths: number;
  damage: number;
  utility: number;
  afk: boolean;
}

export interface ArenaDetail {
  mode: ArenaDetailModeEnum;
  filled: number;
  maxPlayers: number;
  mvpUserId: string | null;
  id: string;
  ticket: number;
  prize: number;
  mapId: string;
  winner: ArenaDetailWinnerEnum | null;
  reason: ArenaDetailReasonEnum;
  score: ArenaScore;
  rounds: ArenaRound[];
  inputLogHash: string;
  durationMs: number;
  rulesVersion: string;
  /** @format date-time */
  createdAt: string;
  players: ArenaMatchPlayer[];
}

export interface ArenaSnapshot {
  mode: ArenaSnapshotModeEnum;
  filled: number;
  maxPlayers: number;
  matchId: string;
  status: ArenaSnapshotStatusEnum;
  ticket: number;
  mapId: string;
  winsToWin: number;
  /** @format date-time */
  phaseDeadline: string | null;
  roomId: string | null;
  /** @format date-time */
  startedAt: string | null;
  stateVersion: number;
  /** @format date-time */
  createdAt: string;
  players: ArenaPlayer[];
  result: ArenaDetail | null;
}

export interface ArenaGames {
  games: ArenaSnapshot[];
}

export interface ArenaCreateGame {
  /** @default 1 */
  mode?: ArenaCreateGameModeEnum;
  /** @min 1 */
  ticket: number;
  side: ArenaCreateGameSideEnum;
  mapId: string;
  /** @min 1 */
  winsToWin: number;
}

export interface ArenaJoinGame {
  side: ArenaJoinGameSideEnum;
}

export interface ArenaLeave {
  left: boolean;
}

export interface ArenaTicket {
  ticket: string;
}

export interface ArenaHistory {
  matches: ArenaDetail[];
  total: number;
}

export interface ArenaRating {
  mode: ArenaRatingModeEnum;
  userId: string;
  name: string;
  rating: number;
  peakRating: number;
  rank: number;
  winrate: number;
  played: number;
  wins: number;
  losses: number;
  coins: number;
  kills: number;
  deaths: number;
}

export interface ArenaRatings {
  mode: ArenaRatingsModeEnum;
  own: ArenaRating;
  top: ArenaRating[];
}

export interface ArenaAccess {
  allowed: boolean;
  reason: ArenaAccessReasonEnum | null;
}

export interface ArenaConfig {
  access: ArenaAccess;
  serverUrl: string;
  maintenance: boolean;
  comingSoon: boolean;
  requireSkinExchange: boolean;
  activeTickets: number[];
  houseEdge: number;
}

export interface ArenaPartyMember {
  userId: string;
  name: string;
  ready: boolean;
}

export interface ArenaPartySnapshot {
  status: ArenaPartySnapshotStatusEnum;
  code: string;
  isLeader: boolean;
  leaderUserId: string;
  youUserId: string;
  members: ArenaPartyMember[];
  allowedModes: number[];
}

export interface ArenaNoParty {
  status: ArenaNoPartyStatusEnum;
}

export interface ArenaPartyJoin {
  /**
   * @minLength 6
   * @maxLength 6
   */
  code: string;
}

export interface ArenaPartyReady {
  ready: boolean;
}

export interface ArenaPartyKick {
  /** @format uuid */
  userId: string;
}

export interface ArenaStartedReport {
  /** @format uuid */
  matchId: string;
  roomId: string;
  /** @format date-time */
  startedAt: string;
  /** @format uuid */
  nonce: string;
  /** Unix timestamp in seconds */
  ts: number;
}

export interface ArenaReportAck {
  matchId: string;
  status: ArenaReportAckStatusEnum;
}

export interface ArenaProgressReport {
  /** @format uuid */
  matchId: string;
  roomId: string;
  phase: ArenaProgressReportPhaseEnum;
  /** @format date-time */
  progressAt: string;
  /** @format uuid */
  nonce: string;
  /** Unix timestamp in seconds */
  ts: number;
}

export interface ArenaReportPlayer {
  /**
   * @min 0
   * @max 4
   */
  seatIndex?: number;
  /** @min 0 */
  utility?: number;
  afk?: boolean;
  /** @format uuid */
  userId: string | null;
  side: ArenaReportPlayerSideEnum;
  /** @min 0 */
  kills: number;
  /** @min 0 */
  deaths: number;
  /** @min 0 */
  damage: number;
  /** @min 0 */
  inputs: number;
  /** @min 0 */
  distance: number;
  /** @min 0 */
  shots: number;
  connected: boolean;
}

export interface ArenaReportRound {
  winner: ArenaReportRoundWinnerEnum | null;
  reason: string;
}

export interface ArenaResultReport {
  /** @format uuid */
  matchId: string;
  roomId: string;
  /** @format date-time */
  startedAt: string;
  /** @format uuid */
  nonce: string;
  /** Unix timestamp in seconds */
  ts: number;
  mode?: ArenaResultReportModeEnum;
  winnerSide?: ArenaResultReportWinnerSideEnum | null;
  outcome: ArenaResultReportOutcomeEnum;
  /** @format uuid */
  winnerUserId: string | null;
  reason: ArenaResultReportReasonEnum;
  score: ArenaScore;
  /**
   * Full seated roster for win/draw; a subset, including empty, for void.
   * @maxItems 10
   * @minItems 0
   */
  players: ArenaReportPlayer[];
  rounds: ArenaReportRound[];
  /** @pattern /^[a-fA-F0-9]{64}$/ */
  inputLogHash: string;
  /** @min 0 */
  durationMs: number;
  rulesVersion: string;
  /** @format date-time */
  endedAt: string;
}

export interface RouletteGameSeat {
  /** Seated player id (avatar is fetched by id) */
  userId: string;
  /** Sanitized display name */
  name: string;
  /** Player level */
  level: number;
}

export interface RouletteOpenGame {
  /** Match id — join this specific game via POST games/:id/join */
  matchId: string;
  /** Entry ticket of this game (one of the presets) */
  stake: number;
  /** Seats in this game — the house is full at this many players */
  maxSeats: number;
  /** Bullets loaded in the 8-chamber drum of this game */
  bullets: number;
  /** Seats already taken */
  seatsTaken: number;
  /** OPEN lobby still collecting players, or a full house counting down to the start */
  status: RouletteOpenGameStatusEnum;
  /** Seated players (for avatar/name previews) */
  seats: RouletteGameSeat[];
  /** ISO deadline — OPEN lobby TTL (cancel) or COUNTDOWN start; null only in transient states */
  phaseDeadline: string | null;
}

export interface RouletteGames {
  /** Ticket presets a game may be created with */
  presets: number[];
  /** Every live game (OPEN + COUNTDOWN), oldest first */
  games: RouletteOpenGame[];
}

export interface RouletteCreateGameRequest {
  /** Entry ticket — one of the presets */
  stake: RouletteCreateGameRequestStakeEnum;
  /**
   * Seats in the game
   * @min 2
   * @max 4
   */
  seats: number;
  /**
   * Bullets loaded in the 8-chamber drum
   * @min 1
   * @max 4
   */
  bullets: number;
}

export interface RouletteState {
  /** The caller's current roulette status */
  status: RouletteStateStatusEnum;
  /** Match id seated in (status = match) — the lobby, countdown or live match */
  matchId?: string;
  /** The seated match's status (present only with status = match). Seats deactivate on finish, so this only ever carries a LIVE status (OPEN/COUNTDOWN/ACTIVE) — the client always follows it in. */
  matchStatus?: RouletteStateMatchStatusEnum;
}

export interface RoulettePrizeItem {
  /** Inventory row granted to the winner */
  inventoryItemId: string;
  /** Market hash name — the item key */
  hashName: string;
  name: string;
  imageUrl: string | null;
  rarityName: string | null;
  rarityColor: string | null;
  /** Price in credits at the moment of the grant */
  price: number;
}

export interface RoulettePrize {
  /** The skin the winner took — the prize is always an item */
  item: RoulettePrizeItem;
  /** Payout minus the skin price. Positive = the small gap stays with the house on top of the rake; negative = the skin cost a touch MORE than the payout and the house covered the overage. */
  shortfall: number;
}

export interface RouletteLastSkip {
  /** Chamber the drum stood on when the shooter skipped (0-based) */
  chamber: number;
  /** Drum positions that held a bullet in the ABANDONED round — the resolved layout (rotation applied). A skip reshuffles the drum, so this leaks nothing about the current round; it is the reveal of the round just dodged. */
  revealedBullets: number[];
  /** Whether the skipped chamber itself was loaded — the near-miss («did I dodge a bullet?») */
  activeWasLoaded: boolean;
}

export interface RouletteLastShot {
  /** Chamber under the hammer when the shot landed (0-based) — the fired/spent chamber */
  chamber: number;
  /** The fired round's REAL bullet positions (rotation applied) — so the client draws the spent case exactly where the shot happened, and any other loaded chambers at their true spots. The round is over (reloaded/finished), so this leaks nothing about the live round. */
  revealedBullets: number[];
}

export interface RouletteSeat {
  userId: string;
  /** Sanitized display name */
  name: string;
  /** Avatar URL, when available */
  avatar?: string;
  status: RouletteSeatStatusEnum;
}

export interface RouletteMatch {
  id: string;
  status: RouletteMatchStatusEnum;
  /** Entry ticket of this game */
  stake: number;
  /** Seats in this game — the house was full at this many players */
  maxSeats: number;
  /** Total credits in the pot */
  pot: number;
  /** Projected prize value shown in-game — the winner's skin worth: the FULL-house pot (every seat filled, whatever has actually joined so far) minus the rake, plus any skip-buys. Render as-is; the client does not recompute it. */
  prizeValue: number;
  /** SHA-256 hash of the (still secret, unless FINISHED/CANCELLED) server seed */
  seedHash: string;
  /** Current round number */
  round: number;
  /** Chamber position the drum is currently on (0-based) */
  chamberPos: number;
  /** Bullets loaded per round — a count */
  bulletsCount: number;
  /** The current charge's PUBLIC bullet pattern — the chamber indices loaded before the secret rotation. Empty until the match is ACTIVE. A hit fires when the drum stops on a rotated pattern chamber; the rotation offset stays secret until the match ends. */
  pattern: number[];
  /** Current shooter — null once the match is over */
  shooterId?: string | null;
  /** The ALIVE players in the exact order they will shoot, starting from the current shooter (element 0 === shooterId). Server-owned turn sequence — the client renders the seat row in this order and never computes it. Dead players are excluded. Empty until the match is ACTIVE. */
  turnOrder: string[];
  /** ISO deadline of the current phase — null once the match is over */
  stepDeadline?: string | null;
  /** Credits cost of a skip in this game (half the ticket) */
  skipCost: number;
  /** The caller's remaining skips this match (0 when not seated or the match is over) */
  mySkipsLeft: number;
  /** Everything this caller has actually paid into this match: the entry they were seated at plus every skip they bought (skips are half the ticket each). Server-computed because the client never sees the whole match — a spectator, a re-entry or a late join would each add up to a different number. Null when the caller has no seat in this match (spectator, or they left an OPEN lobby and were refunded); 0 on a CANCELLED match, where the entry was refunded and no skip can have happened. */
  mySpent?: number | null;
  /** Winner — set once FINISHED */
  winnerUserId?: string | null;
  /** Winner payout (pot minus rake) — set once FINISHED */
  payout?: number | null;
  /** What the winner actually received — a skin worth the payout. Set once FINISHED */
  prize?: RoulettePrize | null;
  /** The most recent skip's reveal — the abandoned round's resolved bullet layout and whether the skipped chamber was loaded. Safe to show (a skip reshuffles the drum, so it says nothing about the current round). Null when no skip has happened yet or after the next pull clears it. */
  lastSkip?: RouletteLastSkip | null;
  /** The most recent shot's reveal — the fired round's REAL bullet layout and the spent chamber, so the client draws the shot exactly where it happened (not on the pre-rotation public pattern). The round is over, so this leaks nothing about the live round. Null until a shot lands or after the next pull clears it. */
  lastShot?: RouletteLastShot | null;
  seats: RouletteSeat[];
}

export interface RouletteHistoryOpponent {
  userId: string;
  /** Sanitized display name */
  name: string;
  /** Player level */
  level: number;
}

export interface RouletteHistoryPrize {
  /** The skin I took — present only on a match I won */
  item: RoulettePrizeItem;
}

export interface RouletteHistoryItem {
  matchId: string;
  /** ISO timestamp the match settled */
  finishedAt: string;
  status: RouletteHistoryItemStatusEnum;
  /** Entry ticket of this game */
  stake: number;
  /** Seats in this game */
  maxSeats: number;
  /** Bullets loaded per round */
  bulletsCount: number;
  /** Total credits in the pot */
  pot: number;
  /** Whether I won this match */
  iWon: boolean;
  /** Who won — one of the seated players (me or an opponent); null only for CANCELLED */
  winnerUserId: string | null;
  /** The other seated players (me excluded) */
  opponents: RouletteHistoryOpponent[];
  /** The winner’s prize skin — shown on every finished row; null only for CANCELLED */
  prize: RouletteHistoryPrize | null;
}

export interface RouletteHistoryResponse {
  /** My finished/cancelled matches, newest first */
  items: RouletteHistoryItem[];
  /** Pass as `cursor` to fetch the next page — null once there are no more matches */
  nextCursor: string | null;
}

export interface RouletteFeedPlayer {
  userId: string;
  /** Sanitized display name */
  name: string;
  /** Player level */
  level: number;
}

export interface RouletteFeedPrize {
  /** The skin the winner took */
  item: RoulettePrizeItem;
}

export interface RouletteFeedItem {
  matchId: string;
  /** ISO timestamp the match settled */
  finishedAt: string;
  /** Entry ticket of this game */
  stake: number;
  /** Seats in this game */
  maxSeats: number;
  /** Bullets loaded per round */
  bulletsCount: number;
  /** Who won */
  winner: RouletteFeedPlayer;
  /** Every seated player, winner included */
  players: RouletteFeedPlayer[];
  /** The skin the winner took */
  prize: RouletteFeedPrize;
}

export interface RouletteFeedResponse {
  /** Every player's finished matches, newest first */
  items: RouletteFeedItem[];
  /** Pass as `cursor` to fetch the next page — null once there are no more matches */
  nextCursor: string | null;
}

export interface RouletteFairnessEvent {
  step: number;
  type: RouletteFairnessEventTypeEnum;
  shooterId?: string;
  chamber?: number;
  round: number;
}

export interface RouletteBulletLayout {
  /** Drum-shuffle index (1-based; a shuffle happens on match start, every reload and every skip) */
  shuffle: number;
  /** PUBLIC bullet pattern for this shuffle — chamber indices loaded before rotation */
  pattern: number[];
  /** Secret drum rotation for this shuffle — a hit fires when chamber (chamberPos + offset) mod 8 is in the pattern */
  offset: number;
}

export interface RoulettePrizeDraw {
  /** Which rung produced the candidates: 'band' = skins priced in [payout × 0.85, payout], 'below' = the nearest-below skins with no floor, 'cheapest' = the single cheapest tradable skin (above the payout, the house covers the difference) */
  poolLevel: RoulettePrizeDrawPoolLevelEnum;
  /** Size of the candidate band — tradable skins (volume > 20) of that rung, ordered by price DESC then hashName ASC */
  candidateCount: number;
  /** Index of the drawn item in that band — recompute it as drawInt(serverSeed, `{matchId}:prize`, candidateCount) */
  drawnIndex: number;
  /** Market hash name of the drawn item */
  hashName: string;
}

export interface RouletteFairness {
  /** SHA-256 hash of the server seed — published up front, always visible */
  seedHash: string;
  /** The server seed itself — revealed only once the match is FINISHED/CANCELLED */
  serverSeed?: string;
  /** Full event log — revealed only once FINISHED/CANCELLED */
  log?: RouletteFairnessEvent[];
  /** Every drum load of the match — revealed only once FINISHED/CANCELLED */
  bulletLayouts?: RouletteBulletLayout[];
  /** How the prize skin was drawn — revealed once FINISHED */
  prizeDraw?: RoulettePrizeDraw;
}

export interface RushRafflePrize {
  hashName: string;
  name: string;
  imageUrl: string | null;
  /** Item rarity label (e.g. Classified) */
  rarityName: string | null;
  /** Item rarity color hex — drives the card gradient */
  rarityColor: string | null;
  /** Prize value in credits */
  priceCredits: number;
  /** Prize price on Steam market in USD */
  steamPriceUsd: number | null;
}

export interface RushRaffleRoundListItem {
  roundId: string;
  /** Entry ticket (stake) tier this round belongs to */
  ticket: number;
  prize: RushRafflePrize;
  /** Round end as ISO string */
  endsAt: string;
  totalTickets: number;
  participantsCount: number;
  /** Caller's ticket count in this round (0 if not participating) */
  myTickets: number;
}

export interface RushRaffleRoundsResponse {
  /** Today's active rounds, ticket ASC */
  rounds: RushRaffleRoundListItem[];
}

export interface RushRaffleParticipant {
  /** Participant user id (avatar + profile link) */
  userId: string;
  name: string;
  tickets: number;
  /** tickets / totalTickets * 100, rounded to 1 decimal */
  sharePct: number;
}

export interface RushRaffleWinner {
  name: string;
  tickets: number;
}

export interface RushRaffleRoundDetail {
  roundId: string;
  /** Entry ticket (stake) tier this round belongs to */
  ticket: number;
  prize: RushRafflePrize;
  /** Round end as ISO string */
  endsAt: string;
  totalTickets: number;
  participantsCount: number;
  /** Caller's ticket count in this round (0 if not participating) */
  myTickets: number;
  status: RushRaffleRoundDetailStatusEnum;
  /** Top-50 by tickets */
  participants: RushRaffleParticipant[];
  /** Caller's chance of winning, percent rounded to 1 decimal */
  myChancePct: number;
  /** Set once the round is COMPLETED */
  winner: RushRaffleWinner | null;
}

export interface RushRaffleWinnerPrize {
  hashName: string;
  name: string;
  imageUrl: string | null;
  rarityColor: string | null;
}

export interface RushRaffleWinnerEntry {
  roundId: string;
  /** Entry ticket (stake) tier this round belongs to */
  ticket: number;
  /** Calendar day this round ran, format YYYY-MM-DD */
  localDate: string;
  prize: RushRaffleWinnerPrize;
  /** Winner user id (avatar + profile link) */
  winnerId: string;
  winnerName: string;
  winnerTickets: number;
  totalTickets: number;
}

export interface RushRaffleWinnersResponse {
  /** Completed rounds from the last 14 days, newest first */
  winners: RushRaffleWinnerEntry[];
}

export interface RushRaffleTicketBreakdown {
  base: number;
  mvp: number;
  multiKill: number;
  oneHp: number;
  clutch: number;
  total: number;
}

export interface RushRaffleMatchAward {
  tickets: number;
  breakdown: RushRaffleTicketBreakdown;
}

export interface BandTicketProviderPrice {
  /** Payment provider id */
  provider: string;
  /** Exact charge in the provider currency — same math as the invoice */
  amount: number;
  currency: string;
}

export interface BandTicketPricesResponse {
  ticketPriceCredits: number;
  prices: BandTicketProviderPrice[];
}

export interface CreateBandTicketInvoice {
  provider: CreateBandTicketInvoiceProviderEnum;
  returnUrl?: string;
}

export interface BandTicketInvoiceResponse {
  paymentId: string;
  invoiceUrl: string;
  amount: number;
  currency: string;
  /** @format date-time */
  expiresAt?: string | null;
}

export interface PayBandTicketWithClickCard {
  /**
   * Bound Click card to charge the SHOT BAND price to
   * @format uuid
   */
  cardId: string;
}

export interface PayBandTicketWithClickCardResponse {
  paymentId: string;
  /** 'pending' until Click's callback lands and membership switches on */
  status: PayBandTicketWithClickCardResponseStatusEnum;
}

export interface ClaimBandCashbackResponse {
  /** Sparks credited by this claim; 0 when nothing was claimable */
  creditedCredits: number;
  bonusBalance: number;
}

export interface BandFreeCaseState {
  caseId: string;
  imageCutoutUrl: string | null;
  /** Day turnover in coins that unlocks a free open of this case */
  requiredWager: number;
  /** Today's turnover already reached the threshold */
  unlocked: boolean;
  /** Today's free open of this case is already spent */
  claimedToday: boolean;
}

export interface BandFreeCasesResponse {
  /** Member's wager turnover for the current Moscow day, in coins */
  wageredToday: number;
  /**
   * Moscow midnight when progress and claims reset
   * @format date-time
   */
  resetsAt: string;
  cases: BandFreeCaseState[];
}

export interface BandQuest {
  questId: string;
  slot: BandQuestSlotEnum;
  tickets: number;
  progress: number;
  target: number;
  completed: boolean;
  claimed: boolean;
}

export interface BandQuestsResponse {
  quests: BandQuest[];
  /** Consecutive Moscow days with at least one completed quest */
  streakDays: number;
  /** True for non-members: quests are shown but cannot progress */
  locked: boolean;
}

export interface BandRafflePrize {
  hashName: string;
  name: string;
  imageUrl: string | null;
  /** Item rarity label (e.g. Covert) */
  rarityName: string | null;
  /** Item rarity color hex — drives the card gradient */
  rarityColor: string | null;
  /** Prize value in credits */
  priceCredits: number;
  /** Prize price on Steam market in USD */
  steamPriceUsd: number | null;
}

export interface BandRaffleCurrentRound {
  roundId: string;
  prize: BandRafflePrize;
  /** Round start as ISO string — Moscow Monday 00:00 */
  startsAt: string;
  /** Round end as ISO string — next Moscow Monday 00:00 */
  endsAt: string;
  /** Tickets invested by everyone so far */
  totalTickets: number;
  participantsCount: number;
  /** Caller's tickets invested into this round (0 if not participating) */
  myTickets: number;
  /** Caller's chance of winning, percent rounded to 1 decimal */
  myChancePct: number;
}

export interface BandRaffleRoundResponse {
  /** null between rounds — no week is open yet */
  round: BandRaffleCurrentRound | null;
  /** Caller's uninvested raffle ticket balance */
  ticketBalance: number;
  /** Whether the caller holds an active SHOT BAND membership */
  isMember: boolean;
}

export interface InvestBandRaffleTickets {
  /**
   * How many tickets to invest — cannot be taken back
   * @min 1
   */
  tickets: number;
}

export interface InvestBandRaffleTicketsResponse {
  roundId: string;
  /** Caller's tickets in the round after the investment */
  myTickets: number;
  /** Caller's chance of winning, percent rounded to 1 decimal */
  myChancePct: number;
  totalTickets: number;
  participantsCount: number;
  /** Caller's remaining uninvested ticket balance */
  ticketBalance: number;
}

export interface BandRaffleParticipant {
  /** Participant user id (avatar + profile link) */
  userId: string;
  name: string;
  tickets: number;
  /** tickets / totalTickets * 100, rounded to 1 decimal */
  sharePct: number;
}

export interface BandRaffleWinner {
  name: string;
  tickets: number;
}

export interface BandRaffleRoundDetail {
  roundId: string;
  /** Monday of the Moscow week this round covers, YYYY-MM-DD */
  localWeekStart: string;
  prize: BandRafflePrize;
  /** Round start as ISO string */
  startsAt: string;
  /** Round end as ISO string */
  endsAt: string;
  totalTickets: number;
  participantsCount: number;
  /** Caller's tickets in this round (0 if not participating) */
  myTickets: number;
  status: BandRaffleRoundDetailStatusEnum;
  /** Top-50 by tickets */
  participants: BandRaffleParticipant[];
  /** Caller's chance of winning, percent rounded to 1 decimal */
  myChancePct: number;
  /** Set once the round is COMPLETED */
  winner: BandRaffleWinner | null;
}

export interface BandRaffleWinnerPrize {
  hashName: string;
  name: string;
  imageUrl: string | null;
  rarityColor: string | null;
}

export interface BandRaffleWinnerEntry {
  roundId: string;
  /** Monday of the Moscow week this round ran, YYYY-MM-DD */
  localWeekStart: string;
  prize: BandRaffleWinnerPrize;
  /** Winner user id (avatar + profile link) */
  winnerId: string;
  winnerName: string;
  winnerTickets: number;
  totalTickets: number;
}

export interface BandRaffleWinnersResponse {
  /** Completed rounds from the last 30 days, newest first */
  winners: BandRaffleWinnerEntry[];
}

export interface BandRaceRound {
  id: string;
  /** @format date-time */
  endAt: string;
  participantsCount: number;
}

export interface BandRacePrize {
  hashName: string;
  name: string;
  imageUrl?: string | null;
  rarityName?: string | null;
  rarityColor?: string | null;
  /** Prize value in credits */
  price: number;
  /** Prize price on Steam market in USD */
  steamPriceUsd: number | null;
}

export interface BandRaceMe {
  /** 1-based place in the current round */
  rank: number;
  /** My wagered credits inside the round window */
  wageredSum: number;
}

export interface BandRaceDetailsResponse {
  /** null — race is off today */
  round?: BandRaceRound | null;
  prize?: BandRacePrize | null;
  /** null — no wagers today */
  me?: BandRaceMe | null;
}

export interface BandRaceLeaderboardEntry {
  rank: number;
  userId: string;
  firstName?: string | null;
  lastName?: string | null;
  level: number;
  /** Wagered credits inside the round window */
  wageredSum: number;
}

export interface BandRaceLeaderboardResponse {
  entries: BandRaceLeaderboardEntry[];
  total: number;
  hasMore: boolean;
}

export interface BandRaceWinner {
  roundId: string;
  /** Moscow day of the round, YYYY-MM-DD */
  localDate: string;
  winnerUserId: string;
  firstName?: string | null;
  lastName?: string | null;
  level: number;
  wageredSum: number;
  prize?: BandRacePrize | null;
}

export interface BandRaceWinnersResponse {
  winners: BandRaceWinner[];
  total: number;
  hasMore: boolean;
}

export interface BandFinalEntry {
  userId: string;
  firstName?: string | null;
  lastName?: string | null;
  level: number;
  /** 1-based place in the week table by entries, earlier sum wins ties */
  rank: number;
  /** Case battle entries this week, credits */
  wageredSum: number;
  /** Completed case battles this week (threshold progress) */
  battlesPlayed: number;
  /** SHOT BAND ticket has run out — still plays if selected */
  membershipExpired: boolean;
}

export interface BandFinalCase {
  id: string;
  name: string;
  priceCredits: number;
  imageUrl: string;
  imageCutoutUrl: string | null;
  imagePlaceholder?: string | null;
}

export interface BandFinalShowRound {
  bigDrops: number;
}

export interface BandFinalShowParticipant {
  userId: string;
}

export interface BandFinalShowBattle {
  id: string;
  /** Case battle status (PROCESSING / IN_PROGRESS / COMPLETED) */
  status: string;
  /** @format date-time */
  completedAt?: string | null;
  /**
   * Server end of the show
   * @format date-time
   */
  showEndsAt?: string | null;
  rounds: BandFinalShowRound[];
  participants: BandFinalShowParticipant[];
}

export interface BandFinalPlace {
  userId: string;
  firstName?: string | null;
  lastName?: string | null;
  level: number;
  /** Place by own drops in the battle; tied players share the best place */
  place: number;
  /** Credits paid for the place */
  wonCredits: number;
  /** Share of the pot, percent (2 decimals) */
  sharePct: number;
}

export interface BandFinalResult {
  places: BandFinalPlace[];
  /** Pot — sum of all drops of the battle, credits */
  totalWonCredits: number;
}

export interface BandFinalRound {
  roundId: string;
  state: BandFinalState;
  /** Week bank: live while RUNNING, frozen from LOCKED on */
  poolCredits: number;
  /** Bank carried in from a week that was not played */
  carriedCredits: number;
  /**
   * Line-up lock moment (end of the selection window)
   * @format date-time
   */
  endsAt: string;
  /**
   * Headliners battle start
   * @format date-time
   */
  showStartsAt: string;
  /** Top 20 of the week table */
  entries: BandFinalEntry[];
  /** null — no entries this week */
  me?: BandFinalEntry | null;
  /** RUNNING — current shelf of active credits cases; LOCKED/PLAYED — the frozen set of the final */
  availableCases: BandFinalCase[];
  /** LOCKED/PLAYED — the frozen rounds of the final in play order, with repeats; null while RUNNING */
  finalCases?: BandFinalCase[] | null;
  /** Rounds per final (setting while RUNNING, snapshot after the lock) */
  maxRounds: number;
  minBattles: number;
  shares: number[];
  finalBattleId?: string | null;
  /** Show timing of the final battle (enough for the client to know whether the show is still running) */
  finalBattle?: BandFinalShowBattle | null;
  /** Set once the battle is settled */
  result?: BandFinalResult | null;
}

export interface BandFinalResponse {
  /** Week in progress (RUNNING) */
  round?: BandFinalRound | null;
  /** Latest closed week: LOCKED until settled, then PLAYED; CARRIED when the final did not happen */
  lastFinal?: BandFinalRound | null;
}

export interface BandFinalBattleInfoResponse {
  roundId: string;
  /** LOCKED until the battle is settled */
  state: BandFinalState;
  /** When the battle starts; it waits with the headliners seated from the lock until then */
  showStartsAt: string;
  /** Frozen week bank that paid for the cases */
  poolCredits: number;
  /** Shares snapshot of the week */
  shares: number[];
  /** Threshold snapshot of the week */
  minBattles: number;
  /** Set once the battle is settled */
  result?: BandFinalResult | null;
}

export interface BandFinalLeaderboardResponse {
  roundId?: string | null;
  entries: BandFinalEntry[];
  total: number;
  hasMore: boolean;
}

export interface BandFinalWinnerItem {
  roundId: string;
  /** Moscow date of the lock / battle day, YYYY-MM-DD */
  localDate: string;
  /** Always sent */
  state?: BandFinalHistoryState;
  /**
   * Always sent. Battle start; for a carried week — the lock moment
   * @format date-time
   */
  showStartsAt?: string;
  /** Week bank (for a carried week — the amount carried to the next one) */
  poolCredits: number;
  /** Pot of the battle; 0 for a carried week */
  totalWonCredits: number;
  /** null — the week was carried, no battle */
  finalBattleId?: string | null;
  /** First place; null for a carried week */
  userId?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  level?: number | null;
  /** Always sent. Places with shares and payouts; empty for a carried week */
  places?: BandFinalPlace[];
}

export interface BandFinalWinnersResponse {
  winners: BandFinalWinnerItem[];
  total: number;
  hasMore: boolean;
}

export interface LocalizedText {
  title: string;
  description: string;
}

export interface AchievementI18N {
  ru: LocalizedText;
  en: LocalizedText;
  uz: LocalizedText;
  fa: LocalizedText;
  pt: LocalizedText;
  tr: LocalizedText;
  uk: LocalizedText;
  de: LocalizedText;
  es: LocalizedText;
  pl: LocalizedText;
}

export interface CatalogReward {
  /** XP reward at unlock time */
  xp?: number;
  /** Coin reward at unlock time */
  credits?: number;
}

export interface CatalogItem {
  key: string;
  category: string;
  /** UI tab the rule belongs to (cases, upgrades, ...) */
  uiTab: string;
  /** Full per-locale title+description map; client picks display locale */
  i18n: AchievementI18N;
  /** Asset filename under /achievements/*.png */
  iconFile: string;
  /** Threshold for progress rules; null for synthetic-event one-shots */
  threshold: number | null;
  reward: CatalogReward;
  /** True when rule is hidden until unlocked (drives reveal animation client-side) */
  secret: boolean;
}

export interface CatalogResponse {
  items: CatalogItem[];
}

export interface AchievementProgress {
  value: number;
  threshold: number;
}

export interface MergedAchievement {
  key: string;
  category: string;
  uiTab: string;
  i18n: AchievementI18N;
  iconFile: string;
  threshold: number | null;
  reward: CatalogReward;
  /** Whether this unlock's bonus was actually credited (false = claimable later) */
  rewardClaimed: boolean;
  secret: boolean;
  /** ISO timestamp when this user unlocked the rule; null if still locked */
  unlockedAt: string | null;
  /** Progress snapshot for progress-typed rules; null otherwise */
  progress: AchievementProgress | null;
}

export interface MergedAchievementsResponse {
  items: MergedAchievement[];
}

export interface ClaimableAchievementRewards {
  /** Total claimable XP across uncredited unlocks */
  claimableXp: number;
  /** Total claimable credits across uncredited unlocks */
  claimableCoins: number;
  /** Number of uncredited unlocked achievements */
  count: number;
  /** User has a COMPLETED payment in the last 30 days */
  hasRecentPayment: boolean;
  /** Sum of credits received from ALL COMPLETED deposits ever */
  totalDepositCredits: number;
  /** Deposit credits required to claim — 100% of claimableCoins */
  requiredDeposit: number;
  /** How many more deposit credits are needed to cover the claimable bonus (0 when already covered) */
  depositShortfall: number;
  /** Claim endpoint may be called (all-time deposits cover 100% of the claimable bonus, and there is something to claim) */
  canClaim: boolean;
}

export interface ClaimAchievementRewardsResult {
  /** XP credited by this claim */
  claimedXp: number;
  /** Credits granted by this claim */
  claimedCoins: number;
  /** Number of achievements credited */
  count: number;
}

export interface AchievementStats {
  /** Total users who have unlocked this key */
  unlockedCount: number;
  /** Active-user denominator (users with activity in the last 30 days) */
  totalActiveUsers: number;
  /** unlockedCount / totalActiveUsers * 100, clamped 0..100 */
  percentage: number;
}

export interface RecentReceiver {
  /** Receiver user id (for profile link / avatar) */
  userId: string;
  /** First name */
  firstName: string | null;
  /** ISO timestamp of the unlock */
  unlockedAt: string;
}

export interface RecentReceiversResponse {
  recentUnlocks: RecentReceiver[];
  /** Total users that have unlocked this key */
  totalReceivers: number;
}

export interface SurveyAnswers {
  usagePeriod?: SurveyAnswersUsagePeriodEnum;
  playFrequency?: SurveyAnswersPlayFrequencyEnum;
  /** @minItems 1 */
  usedFeatures?: SurveyAnswersUsedFeaturesEnum[];
  /**
   * @min 1
   * @max 5
   */
  overallLike?: number;
  depositStatus?: SurveyAnswersDepositStatusEnum;
  /** @maxLength 5000 */
  bestPart?: string;
  /** @maxLength 5000 */
  worstPart?: string;
  /** @maxLength 5000 */
  oneChange?: string;
  /** @maxLength 5000 */
  competitorDescriptions?: string;
  /** @maxLength 5000 */
  shotRole?: string;
  /** @maxLength 5000 */
  usageMoment?: string;
  matchesCount?: SurveyAnswersMatchesCountEnum;
  /** @minItems 1 */
  playedModes?: SurveyAnswersPlayedModesEnum[];
  clarityFirstTime?: SurveyAnswersClarityFirstTimeEnum;
  /** @maxLength 5000 */
  unclearPoints?: string;
  /** @maxLength 5000 */
  difficulties?: string;
  /** @maxLength 5000 */
  hookedBy?: string;
  /** @maxLength 5000 */
  missingForReturn?: string;
  /** @maxItems 3 */
  pros?: string[];
  /** @maxItems 3 */
  cons?: string[];
  /** @maxLength 5000 */
  firstChange?: string;
}

export interface SubmitSurveyResponse {
  /**
   * Which survey this answers (slug). Omit for the original 'default' survey.
   * @maxLength 64
   * @pattern /^[a-z0-9][a-z0-9-]*$/
   */
  slug?: string;
  language: SubmitSurveyResponseLanguageEnum;
  answers: SurveyAnswers;
}

export interface SubmitSurveyResult {
  id: string;
  submittedAt: string;
}

export interface SurveyDraftAnswers {
  usagePeriod?: SurveyDraftAnswersUsagePeriodEnum;
  playFrequency?: SurveyDraftAnswersPlayFrequencyEnum;
  /** @minItems 1 */
  usedFeatures?: SurveyDraftAnswersUsedFeaturesEnum[];
  /**
   * @min 1
   * @max 5
   */
  overallLike?: number;
  depositStatus?: SurveyDraftAnswersDepositStatusEnum;
  /** @maxLength 5000 */
  bestPart?: string;
  /** @maxLength 5000 */
  worstPart?: string;
  /** @maxLength 5000 */
  oneChange?: string;
  /** @maxLength 5000 */
  competitorDescriptions?: string;
  /** @maxLength 5000 */
  shotRole?: string;
  /** @maxLength 5000 */
  usageMoment?: string;
  matchesCount?: SurveyDraftAnswersMatchesCountEnum;
  /** @minItems 1 */
  playedModes?: SurveyDraftAnswersPlayedModesEnum[];
  clarityFirstTime?: SurveyDraftAnswersClarityFirstTimeEnum;
  /** @maxLength 5000 */
  unclearPoints?: string;
  /** @maxLength 5000 */
  difficulties?: string;
  /** @maxLength 5000 */
  hookedBy?: string;
  /** @maxLength 5000 */
  missingForReturn?: string;
  /** @maxItems 3 */
  pros?: string[];
  /** @maxItems 3 */
  cons?: string[];
  /** @maxLength 5000 */
  firstChange?: string;
}

export interface SaveSurveyDraft {
  /**
   * Which survey this answers (slug). Omit for the original 'default' survey.
   * @maxLength 64
   * @pattern /^[a-z0-9][a-z0-9-]*$/
   */
  slug?: string;
  language: SaveSurveyDraftLanguageEnum;
  /**
   * @min 0
   * @max 11
   */
  currentStep: number;
  answers: SurveyDraftAnswers;
}

export interface SaveSurveyDraftResult {
  currentStep: number;
  completed: boolean;
}

export interface SurveyDraft {
  language: string;
  currentStep: number;
  answers: SurveyDraftAnswers;
}

export interface SurveyStatus {
  completed: boolean;
  submittedAt?: string | null;
  draft?: SurveyDraft | null;
}

export interface ReportDeviceSignal {
  /**
   * SHA-256 hex of device fingerprint components
   * @pattern /^[a-f0-9]{64}$/
   */
  fpHash: string;
  /**
   * Версия схемы отпечатка (1 — legacy без поля)
   * @min 1
   * @max 10
   */
  fpVersion?: number;
  /** Сырые компоненты отпечатка для серверного анализа */
  components?: object;
}

export interface TmaAuth {
  /** Telegram WebApp initData (URL-encoded query string from Telegram.WebApp.initData) */
  initData: string;
  /** Account ids previously seen on this device */
  u?: string[];
}

export interface AuthSessionResponse {
  userId: string;
  /** Auth provider — telegram | steam */
  provider: string;
  /** Provider-specific user id (telegramId or steamId, as string) */
  providerUserId: string;
}

export interface TelegramLogin {
  /** Telegram user ID */
  id: number;
  /** First name */
  first_name?: string;
  /** Last name */
  last_name?: string;
  /** Username */
  username?: string;
  /** Photo URL */
  photo_url?: string;
  /** Auth date (unix timestamp) */
  auth_date: number;
  /** Hash for verification */
  hash: string;
  /** Account ids previously seen on this device */
  u?: string[];
}

export interface TelegramOidcInitResponse {
  /** Bot Client ID registered in BotFather */
  clientId: string;
  /** Single-use nonce for the Telegram Login library */
  nonce: string;
}

export interface TelegramOidc {
  /** ID token issued by oauth.telegram.org */
  idToken: string;
  /** Account ids previously seen on this device */
  u?: string[];
}

export interface WebHandoffInitResponse {
  /** Opaque single-use token. TTL 60s. Append to web URL as ?handoff=... */
  token: string;
}

export interface WebHandoffRedeem {
  /** Token returned by /api/auth/web-handoff/init */
  token: string;
}

export interface SteamLinkInitResponse {
  /** URL to redirect user to Steam for authentication */
  redirectUrl: string;
}

export interface SteamConnect {
  /** Pending Steam state token */
  state: string;
  /** ID token issued by oauth.telegram.org */
  idToken: string;
}

export interface SteamRegister {
  /** Pending Steam state token */
  state: string;
}

export interface LinkTelegramResponse {
  /** Whether the linking was successful */
  success: boolean;
}

export interface SupportUserSummary {
  /** False until the person writes their first message */
  hasThread: boolean;
  /** Operator answers the person has not read yet */
  unreadCount: number;
  /** False when the person may not write; writing then answers 403 with the same reason */
  canWrite: boolean;
  /** blocked — support blocked the account; payment_required — no payment yet, so no conversation may be opened */
  writeRefusal?: SupportUserSummaryWriteRefusalEnum;
  lastMessageAt?: string | null;
}

export interface SupportUserAttachment {
  /** Fetch the bytes from GET /api/users/support/attachments/{id}/content */
  id: string;
  kind: SupportUserAttachmentKindEnum;
  mimeType?: string | null;
  fileName?: string | null;
  fileSize?: number | null;
  durationSec?: number | null;
  width?: number | null;
  height?: number | null;
}

export interface SupportUserMessage {
  id: string;
  /** operator — support answered; user — the person themselves */
  author: SupportUserMessageAuthorEnum;
  kind: SupportUserMessageKindEnum;
  text?: string | null;
  /** Kind-specific data: sticker emoji/animated flag, contact phone/name, location coordinates, poll question/options */
  payload?: object | null;
  /** Messages sharing it were sent as one album */
  mediaGroupId?: string | null;
  createdAt: string;
  attachments: SupportUserAttachment[];
}

export interface SupportUserMessageList {
  /** Oldest first */
  items: SupportUserMessage[];
  /** Pass as `before` to load older messages */
  nextCursor?: string | null;
}

export interface SendSupportMessage {
  /** @maxLength 4000 */
  text: string;
}

export enum PartnerStatusEnum {
  Active = "active",
  Inactive = "inactive",
}

export enum PartnerTransferInfoStatusEnum {
  Active = "active",
  Inactive = "inactive",
}

/** @example "ok" */
export enum BasicHealthStatusEnum {
  Ok = "ok",
  Error = "error",
}

/** @example "ok" */
export enum DependencyCheckStatusEnum {
  Ok = "ok",
  Error = "error",
  Unknown = "unknown",
}

/** @example "ok" */
export enum ReadinessCheckStatusEnum {
  Ok = "ok",
  Error = "error",
}

/** @example "ok" */
export enum HealthCheckStatusEnum {
  Ok = "ok",
  Error = "error",
}

/**
 * What the user is currently doing (null when offline)
 * @example "opening_case"
 */
export enum PresenceActivityEnum {
  Browsing = "browsing",
  ViewingCases = "viewing_cases",
  OpeningCase = "opening_case",
  Upgrades = "upgrades",
  Contracts = "contracts",
  CaseBattles = "case_battles",
  Shop = "shop",
  Inventory = "inventory",
  Topup = "topup",
  Auctions = "auctions",
  Wheel = "wheel",
  Giveaway = "giveaway",
  RushMid = "rush_mid",
  Arena = "arena",
}

/** @example "days_7" */
export enum ComebackBonusTypeEnum {
  Days7 = "days_7",
  Days14 = "days_14",
  Days30 = "days_30",
}

/**
 * Boost status
 * @example "ACTIVE"
 */
export enum UserBoostStatusStatusEnum {
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
  ERROR = "ERROR",
}

/**
 * Buff type
 * @example "time_limited"
 */
export enum ActivePromocodeBuffResponseTypeEnum {
  TimeLimited = "time_limited",
  UsageLimited = "usage_limited",
  Hybrid = "hybrid",
}

/** Scoring mode */
export enum DailyGiveawayPublicTypeEnum {
  OPEN_COUNT = "OPEN_COUNT",
  DROP_VALUE = "DROP_VALUE",
}

export enum UpgradeTopResponsePeriodEnum {
  Day = "day",
  Month = "month",
}

/**
 * Type of profile task to activate
 * @example "USERNAME_IN_LASTNAME"
 */
export enum ActivateProfileTaskTaskTypeEnum {
  USERNAME_IN_LASTNAME = "USERNAME_IN_LASTNAME",
  REFERRAL_LINK_IN_BIO = "REFERRAL_LINK_IN_BIO",
}

/**
 * Type of profile task to claim reward for
 * @example "USERNAME_IN_LASTNAME"
 */
export enum ClaimProfileTaskRewardTaskTypeEnum {
  USERNAME_IN_LASTNAME = "USERNAME_IN_LASTNAME",
  REFERRAL_LINK_IN_BIO = "REFERRAL_LINK_IN_BIO",
}

/** Payment provider */
export enum CreateShopPurchaseInvoiceProviderEnum {
  TELEGRAM_STARS = "TELEGRAM_STARS",
  SKINSBACK = "SKINSBACK",
  CRYPTO_BOT = "CRYPTO_BOT",
  ADVANCED_PAY = "ADVANCED_PAY",
  NIRVANA = "NIRVANA",
  SAFON = "SAFON",
  BREENX = "BREENX",
  NOROSP2P = "NOROS_P2P",
  DRESDALE_DIGITAL = "DRESDALE_DIGITAL",
  WATAPRO_SBP = "WATAPRO_SBP",
  PAYTREE_STRIPE = "PAYTREE_STRIPE",
  FUTURITY_PAY = "FUTURITY_PAY",
  OVERPAY = "OVERPAY",
  PULSE_UZS = "PULSE_UZS",
  PLATEGA_MC_EUR = "PLATEGA_MC_EUR",
  TENET_SBP = "TENET_SBP",
  CLICK_UZ = "CLICK_UZ",
  RIOPAY_SBP = "RIOPAY_SBP",
  UZUM_CHECKOUT = "UZUM_CHECKOUT",
  PAY2328 = "PAY_2328",
  EASYPAY = "EASYPAY",
  ONEPAYMENT_SBP = "ONEPAYMENT_SBP",
}

/** Payment currency (defaults to RUB) */
export enum CreateShopPurchaseInvoiceCurrencyEnum {
  RUB = "RUB",
  USD = "USD",
  EUR = "EUR",
  STARS = "STARS",
  UZS = "UZS",
  AMD = "AMD",
}

export enum UserShopPurchaseStatusEnum {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

/**
 * Currency spent to open this case — credits, or SHOT BAND bonus balance
 * @example "credits"
 */
export enum CaseResponseOpenCurrencyEnum {
  Credits = "credits",
  Bonus = "bonus",
}

/**
 * Currency spent to open this case — credits, or SHOT BAND bonus balance
 * @example "credits"
 */
export enum CaseDetailsResponseOpenCurrencyEnum {
  Credits = "credits",
  Bonus = "bonus",
}

/** Source of the item */
export enum UserInventoryItemResponseSourceEnum {
  CASE_OPENING = "CASE_OPENING",
  CASE_BATTLE = "CASE_BATTLE",
  ADMIN_GRANT = "ADMIN_GRANT",
  AUCTION = "AUCTION",
  CONTRACT = "CONTRACT",
  UPGRADE = "UPGRADE",
  GIFT = "GIFT",
  FROM_SHOP = "FROM_SHOP",
  DRAW = "DRAW",
  CONTEST = "CONTEST",
  DAILY_GIVEAWAY = "DAILY_GIVEAWAY",
  RUSH_MID = "RUSH_MID",
  ARENA = "ARENA",
  RUSH_RAFFLE = "RUSH_RAFFLE",
  ROULETTE = "ROULETTE",
  BAND_CASE = "BAND_CASE",
  BAND_RAFFLE = "BAND_RAFFLE",
  BAND_RACE = "BAND_RACE",
  RAIN = "RAIN",
}

/** Current status of the item */
export enum UserInventoryItemResponseStatusEnum {
  AVAILABLE = "AVAILABLE",
  PROCESSING = "PROCESSING",
  SENT = "SENT",
  CONFIRMED = "CONFIRMED",
  SOLD = "SOLD",
  CONTRACT_CONSUMED = "CONTRACT_CONSUMED",
  UPGRADE_CONSUMED = "UPGRADE_CONSUMED",
}

/** Why the widget produced no token; absent on requests that did not go through the UI */
export enum WithdrawItemCaptchaFailReasonEnum {
  ScriptBlocked = "script_blocked",
  Timeout = "timeout",
  ChallengeError = "challenge_error",
}

/** Error code if withdrawal failed */
export enum WithdrawItemResponseErrorCodeEnum {
  TradeLinkError = "trade_link_error",
  TradeLinkNotConfigured = "trade_link_not_configured",
  SteamGuardHold = "steam_guard_hold",
  PrivateInventory = "private_inventory",
  InventoryFull = "inventory_full",
  ItemUnavailable = "item_unavailable",
  ProviderUnavailable = "provider_unavailable",
  WithdrawalsBlocked = "withdrawals_blocked",
  WithdrawalsDisabled = "withdrawals_disabled",
  VerificationRequired = "verification_required",
  DailyLimitExceeded = "daily_limit_exceeded",
  GeneralError = "general_error",
  CaptchaFailed = "captcha_failed",
  WithdrawalLimitExceeded = "withdrawal_limit_exceeded",
  ItemNotAvailable = "item_not_available",
}

/**
 * Snapshot state. null — snapshot has not been taken yet
 * @example "ok"
 */
export enum SteamInventoryResponseStatusEnum {
  Ok = "ok",
  Empty = "empty",
  Private = "private",
  Error = "error",
}

/** Payment provider */
export enum CreateInvoiceProviderEnum {
  TELEGRAM_STARS = "TELEGRAM_STARS",
  SKINSBACK = "SKINSBACK",
  CRYPTO_BOT = "CRYPTO_BOT",
  ADVANCED_PAY = "ADVANCED_PAY",
  NIRVANA = "NIRVANA",
  SAFON = "SAFON",
  BREENX = "BREENX",
  NOROSP2P = "NOROS_P2P",
  DRESDALE_DIGITAL = "DRESDALE_DIGITAL",
  WATAPRO_SBP = "WATAPRO_SBP",
  PAYTREE_STRIPE = "PAYTREE_STRIPE",
  FUTURITY_PAY = "FUTURITY_PAY",
  OVERPAY = "OVERPAY",
  PULSE_UZS = "PULSE_UZS",
  PLATEGA_MC_EUR = "PLATEGA_MC_EUR",
  TENET_SBP = "TENET_SBP",
  CLICK_UZ = "CLICK_UZ",
  RIOPAY_SBP = "RIOPAY_SBP",
  UZUM_CHECKOUT = "UZUM_CHECKOUT",
  PAY2328 = "PAY_2328",
  EASYPAY = "EASYPAY",
  ONEPAYMENT_SBP = "ONEPAYMENT_SBP",
}

export enum PaymentResponseCurrencyEnum {
  RUB = "RUB",
  USD = "USD",
  EUR = "EUR",
  STARS = "STARS",
  UZS = "UZS",
  AMD = "AMD",
}

export enum PaymentResponseStatusEnum {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
  REFUNDED = "REFUNDED",
  EXPIRED = "EXPIRED",
  APPEAL = "APPEAL",
}

export enum PaymentProviderPackageCurrencyEnum {
  UZS = "UZS",
  RUB = "RUB",
  EUR = "EUR",
  USD = "USD",
  STARS = "STARS",
  USDT = "USDT",
}

export enum PaymentProviderIdEnum {
  TELEGRAM_STARS = "TELEGRAM_STARS",
  SKINSBACK = "SKINSBACK",
  CRYPTO_BOT = "CRYPTO_BOT",
  ADVANCED_PAY = "ADVANCED_PAY",
  NIRVANA = "NIRVANA",
  SAFON = "SAFON",
  BREENX = "BREENX",
  NOROSP2P = "NOROS_P2P",
  DRESDALE_DIGITAL = "DRESDALE_DIGITAL",
  WATAPRO_SBP = "WATAPRO_SBP",
  PAYTREE_STRIPE = "PAYTREE_STRIPE",
  FUTURITY_PAY = "FUTURITY_PAY",
  OVERPAY = "OVERPAY",
  PULSE_UZS = "PULSE_UZS",
  PLATEGA_MC_EUR = "PLATEGA_MC_EUR",
  TENET_SBP = "TENET_SBP",
  CLICK_UZ = "CLICK_UZ",
  RIOPAY_SBP = "RIOPAY_SBP",
  UZUM_CHECKOUT = "UZUM_CHECKOUT",
  PAY2328 = "PAY_2328",
  EASYPAY = "EASYPAY",
  ONEPAYMENT_SBP = "ONEPAYMENT_SBP",
}

export enum PaymentProviderKindEnum {
  Packages = "packages",
  Exchange = "exchange",
}

export enum PaymentProviderCurrencyEnum {
  UZS = "UZS",
  RUB = "RUB",
  EUR = "EUR",
  USD = "USD",
  STARS = "STARS",
  USDT = "USDT",
}

/**
 * Language code
 * @example "ru"
 */
export enum UpdateLanguageLanguageCodeEnum {
  En = "en",
  Ru = "ru",
  Uz = "uz",
  Fa = "fa",
  Pt = "pt",
  Tr = "tr",
  Uk = "uk",
  De = "de",
  Es = "es",
  Pl = "pl",
}

/**
 * Boost status
 * @example "PENDING"
 */
export enum ActivateBoostResponseStatusEnum {
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
  ERROR = "ERROR",
}

/** Тип курицы: regular — обычная, cyber — кибер-курица для участников SHOT BAND */
export enum ChickenTickResponseKindEnum {
  Regular = "regular",
  Cyber = "cyber",
}

/** Transaction type */
export enum XpTransactionItemTypeEnum {
  DailyLogin = "daily_login",
  WeeklyStreak = "weekly_streak",
  CaseOpen = "case_open",
  Deposit = "deposit",
  ReferralInvite = "referral_invite",
  ReferralDeposit = "referral_deposit",
  Contract = "contract",
  UpgradeSuccess = "upgrade_success",
  UpgradeFail = "upgrade_fail",
  DrawParticipation = "draw_participation",
  DrawWin = "draw_win",
  TelegramVote = "telegram_vote",
  CaseBattleWin = "case_battle_win",
  CaseBattleLose = "case_battle_lose",
  RouletteWin = "roulette_win",
  RouletteLose = "roulette_lose",
  AdminAdjust = "admin_adjust",
  Achievement = "achievement",
}

/**
 * Type of draw to participate in
 * @example "paid_5000"
 */
export enum BuyDrawEntryDrawTypeEnum {
  Deposit = "deposit",
  Referral = "referral",
  Paid5000 = "paid_5000",
  Paid10000 = "paid_10000",
  Paid25000 = "paid_25000",
}

export enum GiveawayDetailsResponseTypeEnum {
  Participants = "participants",
  Time = "time",
}

export enum GiveawayDetailsResponseStatusEnum {
  Active = "active",
  Completed = "completed",
  Cancelled = "cancelled",
  Expired = "expired",
}

/** Reason code when canJoin is false; the client owns the wording. */
export enum CurrentRainJoinBlockedReasonEnum {
  NOT_AUTHENTICATED = "NOT_AUTHENTICATED",
  NO_TRADE_URL = "NO_TRADE_URL",
  NO_DEPOSIT = "NO_DEPOSIT",
  LEVEL_TOO_LOW = "LEVEL_TOO_LOW",
}

export enum RainDetailStatusEnum {
  SCHEDULED = "SCHEDULED",
  ACTIVE = "ACTIVE",
  COMPLETED = "COMPLETED",
  EMPTY = "EMPTY",
  SKIPPED = "SKIPPED",
}

/** Reason code when canJoin is false; the client owns the wording */
export enum RainDetailJoinBlockedReasonEnum {
  NOT_AUTHENTICATED = "NOT_AUTHENTICATED",
  NO_TRADE_URL = "NO_TRADE_URL",
  NO_DEPOSIT = "NO_DEPOSIT",
  LEVEL_TOO_LOW = "LEVEL_TOO_LOW",
}

/** Scoring mode */
export enum DailyGiveawayDetailResponseTypeEnum {
  OPEN_COUNT = "OPEN_COUNT",
  DROP_VALUE = "DROP_VALUE",
}

/** Scoring mode */
export enum DailyGiveawayLeaderboardPageTypeEnum {
  OPEN_COUNT = "OPEN_COUNT",
  DROP_VALUE = "DROP_VALUE",
}

/** Scoring mode */
export enum DailyGiveawayWinnersPageTypeEnum {
  OPEN_COUNT = "OPEN_COUNT",
  DROP_VALUE = "DROP_VALUE",
}

export enum ReferralContestLeaderboardResponseStatusEnum {
  Upcoming = "upcoming",
  Active = "active",
  Finished = "finished",
}

/**
 * What the user is currently doing
 * @example "opening_case"
 */
export enum HeartbeatRequestActivityEnum {
  Browsing = "browsing",
  ViewingCases = "viewing_cases",
  OpeningCase = "opening_case",
  Upgrades = "upgrades",
  Contracts = "contracts",
  CaseBattles = "case_battles",
  Shop = "shop",
  Inventory = "inventory",
  Topup = "topup",
  Auctions = "auctions",
  Wheel = "wheel",
  Giveaway = "giveaway",
  RushMid = "rush_mid",
  Arena = "arena",
}

/** @default "classic" */
export enum CreateCaseBattleRequestModeEnum {
  Classic = "classic",
  Crazy = "crazy",
  Sharing = "sharing",
  LastCase = "last_case",
}

/** @default "public" */
export enum CreateCaseBattleRequestVisibilityEnum {
  Public = "public",
  Private = "private",
}

/** Creator side in 2×2: 0 or 1 */
export enum CreateCaseBattleRequestSideEnum {
  Value0 = 0,
  Value1 = 1,
}

export enum CaseBattleListItemResponseStatusEnum {
  WAITING = "WAITING",
  PROCESSING = "PROCESSING",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

export enum CaseBattleListItemResponseModeEnum {
  Classic = "classic",
  Crazy = "crazy",
  Sharing = "sharing",
  LastCase = "last_case",
}

export enum CaseBattleListItemResponseVisibilityEnum {
  Public = "public",
  Private = "private",
}

/** BAND — Headliners battle paid by the club */
export enum CaseBattleListItemResponseFundedByEnum {
  USER = "USER",
  BAND = "BAND",
}

export enum CaseBattleTemplateResponseModeEnum {
  Classic = "classic",
  Crazy = "crazy",
  Sharing = "sharing",
  LastCase = "last_case",
}

export enum SaveCaseBattleTemplateRequestModeEnum {
  Classic = "classic",
  Crazy = "crazy",
  Sharing = "sharing",
  LastCase = "last_case",
}

export enum CaseBattleHistoryItemResponseStatusEnum {
  WAITING = "WAITING",
  PROCESSING = "PROCESSING",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

export enum CaseBattleHistoryItemResponseModeEnum {
  Classic = "classic",
  Crazy = "crazy",
  Sharing = "sharing",
  LastCase = "last_case",
}

export enum CaseBattleHistoryItemResponseVisibilityEnum {
  Public = "public",
  Private = "private",
}

/** BAND — Headliners battle paid by the club */
export enum CaseBattleHistoryItemResponseFundedByEnum {
  USER = "USER",
  BAND = "BAND",
}

export enum CaseBattleRematchInviteResponseStatusEnum {
  Pending = "pending",
  Accepted = "accepted",
  Declined = "declined",
  Expired = "expired",
}

export enum CaseBattleRematchResponseMyInviteEnum {
  Pending = "pending",
  Accepted = "accepted",
  Declined = "declined",
  Expired = "expired",
}

export enum CaseBattleRoundDetailResponseStatusEnum {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
}

export enum CaseBattleDetailsResponseStatusEnum {
  WAITING = "WAITING",
  PROCESSING = "PROCESSING",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

export enum CaseBattleDetailsResponseModeEnum {
  Classic = "classic",
  Crazy = "crazy",
  Sharing = "sharing",
  LastCase = "last_case",
}

export enum CaseBattleDetailsResponseVisibilityEnum {
  Public = "public",
  Private = "private",
}

/** BAND — Headliners battle paid by the club */
export enum CaseBattleDetailsResponseFundedByEnum {
  USER = "USER",
  BAND = "BAND",
}

/** Entry ticket / stake */
export enum CreateOpenGameRequestTicketEnum {
  Value100 = 100,
  Value500 = 500,
  Value1000 = 1000,
  Value5000 = 5000,
  Value25000 = 25000,
  Value100000 = 100000,
}

/** Team size: 1v1, 2v2 or 5v5 */
export enum CreateOpenGameRequestModeEnum {
  Value1 = 1,
  Value2 = 2,
  Value5 = 5,
}

/** Side to fight on */
export enum CreateOpenGameRequestSideEnum {
  T = "t",
  Ct = "ct",
}

/** Match mode: 'ranked' (default, public + listed) or 'bots' (practice — no stake, rating, rewards, drops or listing) */
export enum CreateOpenGameRequestMatchModeEnum {
  Ranked = "ranked",
  Bots = "bots",
}

/** Weapon class */
export enum RushMidLoadoutWeaponEnum {
  Awp = "awp",
  Rifle = "rifle",
  Lmg = "lmg",
}

/** Whole-vest armor tier */
export enum RushMidLoadoutArmorEnum {
  None = "none",
  Light = "light",
  Heavy = "heavy",
}

export enum RushMidPublicFighterTeamEnum {
  T = "t",
  Ct = "ct",
}

/** Current shooting stance */
export enum RushMidPublicFighterStanceEnum {
  Attack = "attack",
  Defense = "defense",
  Maneuver = "maneuver",
}

export enum RushMidScoreEntryTeamEnum {
  T = "t",
  Ct = "ct",
}

/** Current Rush Mid phase for this user */
export enum RushMidSnapshotStatusEnum {
  NONE = "NONE",
  OPEN = "OPEN",
  BUYING = "BUYING",
  PLAYING = "PLAYING",
  OVER = "OVER",
}

/** The user's side preference ('any' = either team) */
export enum RushMidSnapshotSideEnum {
  T = "t",
  Ct = "ct",
  Any = "any",
}

/** OPEN: the side the caller is seated on */
export enum RushMidSnapshotYourSideEnum {
  T = "t",
  Ct = "ct",
}

/** OVER: winning side (null = mutual wipe) */
export enum RushMidSnapshotWinnerEnum {
  T = "t",
  Ct = "ct",
}

/** Entry ticket / stake */
export enum OpenGameTicketEnum {
  Value100 = 100,
  Value500 = 500,
  Value1000 = 1000,
  Value5000 = 5000,
  Value25000 = 25000,
  Value100000 = 100000,
}

/** Team size: 1v1, 2v2 or 5v5 */
export enum OpenGameModeEnum {
  Value1 = 1,
  Value2 = 2,
  Value5 = 5,
}

/** why the join is blocked */
export enum OpenGameJoinBlockedReasonEnum {
  Grace = "grace",
}

/** Entry ticket / stake */
export enum LiveGameTicketEnum {
  Value100 = 100,
  Value500 = 500,
  Value1000 = 1000,
  Value5000 = 5000,
  Value25000 = 25000,
  Value100000 = 100000,
}

/** Team size: 1v1, 2v2 or 5v5 */
export enum LiveGameModeEnum {
  Value1 = 1,
  Value2 = 2,
  Value5 = 5,
}

/** Watched match phase */
export enum RushMidSpectateViewStatusEnum {
  PLAYING = "PLAYING",
  OVER = "OVER",
}

/** battle map */
export enum RushMidSpectateViewMapEnum {
  Dust2 = "dust2",
  Mirage = "mirage",
  Inferno = "inferno",
  Nuke = "nuke",
}

/** OVER: winning side (null = mutual wipe) */
export enum RushMidSpectateViewWinnerEnum {
  T = "t",
  Ct = "ct",
}

/** Side to join */
export enum JoinOpenGameRequestSideEnum {
  T = "t",
  Ct = "ct",
}

/** Team size (must be >= party size) */
export enum PartyConfigRequestModeEnum {
  Value1 = 1,
  Value2 = 2,
  Value5 = 5,
}

/** Entry ticket / stake */
export enum PartyConfigRequestTicketEnum {
  Value100 = 100,
  Value500 = 500,
  Value1000 = 1000,
  Value5000 = 5000,
  Value25000 = 25000,
  Value100000 = 100000,
}

/** Side the whole party fights on ('any' = whichever team has room) */
export enum PartyConfigRequestSideEnum {
  T = "t",
  Ct = "ct",
  Any = "any",
}

/** Match mode: 'ranked' (default) or 'bots' (practice vs bots — no stake, rating, rewards or drops) */
export enum PartyConfigRequestMatchModeEnum {
  Ranked = "ranked",
  Bots = "bots",
}

/** Action kind for this round */
export enum SubmitActionRequestKindEnum {
  Shoot = "shoot",
  Knife = "knife",
  Grenade = "grenade",
  Medkit = "medkit",
  Smoke = "smoke",
  Flash = "flash",
}

/** Shooting stance (for kind=shoot) */
export enum SubmitActionRequestStanceEnum {
  Attack = "attack",
  Defense = "defense",
  Maneuver = "maneuver",
}

/** how the skin is earned */
export enum RushMidWeaponSkinOptionUnlockEnum {
  Public = "public",
  Elo = "elo",
  Grant = "grant",
}

/** Entry ticket / stake */
export enum JoinMatchmakingRequestTicketEnum {
  Value100 = 100,
  Value500 = 500,
  Value1000 = 1000,
  Value5000 = 5000,
  Value25000 = 25000,
  Value100000 = 100000,
}

/** Team size: 1v1, 2v2 or 5v5 */
export enum JoinMatchmakingRequestModeEnum {
  Value1 = 1,
  Value2 = 2,
  Value5 = 5,
}

/** Side to fight on ('any' = whichever team has room) */
export enum JoinMatchmakingRequestSideEnum {
  T = "t",
  Ct = "ct",
  Any = "any",
}

/** Match mode: 'ranked' (default) or 'bots' (practice vs bots — no stake, rating, rewards or drops) */
export enum JoinMatchmakingRequestMatchModeEnum {
  Ranked = "ranked",
  Bots = "bots",
}

/** side the skin belongs to */
export enum SetRushMidSkinRequestSideEnum {
  T = "t",
  Ct = "ct",
}

/** weapon key the skin belongs to */
export enum SetRushMidWeaponSkinRequestWeaponKeyEnum {
  Ak = "ak",
  M4 = "m4",
  Awp = "awp",
  Lmg = "lmg",
}

/** battle map */
export enum RushMidMatchDetailMapEnum {
  Dust2 = "dust2",
  Mirage = "mirage",
  Inferno = "inferno",
  Nuke = "nuke",
}

export enum RushMidMatchDetailWinnerEnum {
  T = "t",
  Ct = "ct",
}

/** battle map */
export enum RushMidReplayMapEnum {
  Dust2 = "dust2",
  Mirage = "mirage",
  Inferno = "inferno",
  Nuke = "nuke",
}

export enum RushMidReplayWinnerEnum {
  T = "t",
  Ct = "ct",
}

export enum ArenaFighterCosmeticsCtEnum {
  Ct = "ct",
  CtGign = "ct-gign",
  CtSwat = "ct-swat",
  CtDesert = "ct-desert",
}

export enum ArenaFighterCosmeticsTEnum {
  T = "t",
  TMilitia = "t-militia",
  TUrban = "t-urban",
  TMerc = "t-merc",
  TRaider = "t-raider",
}

export enum SetArenaFighterSideEnum {
  Ct = "ct",
  T = "t",
}

export enum ArenaPlayerSideEnum {
  T = "t",
  Ct = "ct",
}

export enum ArenaRoundWinnerEnum {
  T = "t",
  Ct = "ct",
}

export enum ArenaMatchPlayerSideEnum {
  T = "t",
  Ct = "ct",
}

export enum ArenaDetailModeEnum {
  Value1 = 1,
  Value2 = 2,
  Value5 = 5,
}

export enum ArenaDetailWinnerEnum {
  T = "t",
  Ct = "ct",
}

export enum ArenaDetailReasonEnum {
  Rounds = "rounds",
  Forfeit = "forfeit",
  Timeout = "timeout",
  Abandoned = "abandoned",
}

export enum ArenaSnapshotModeEnum {
  Value1 = 1,
  Value2 = 2,
  Value5 = 5,
}

export enum ArenaSnapshotStatusEnum {
  FORMING = "FORMING",
  READY = "READY",
  PLAYING = "PLAYING",
  SETTLED = "SETTLED",
  VOIDED = "VOIDED",
}

/** @default 1 */
export enum ArenaCreateGameModeEnum {
  Value1 = 1,
  Value2 = 2,
  Value5 = 5,
}

export enum ArenaCreateGameSideEnum {
  T = "t",
  Ct = "ct",
}

export enum ArenaJoinGameSideEnum {
  T = "t",
  Ct = "ct",
}

export enum ArenaRatingModeEnum {
  Value1 = 1,
  Value2 = 2,
  Value5 = 5,
}

export enum ArenaRatingsModeEnum {
  Value1 = 1,
  Value2 = 2,
  Value5 = 5,
}

export enum ArenaPartySnapshotStatusEnum {
  PARTY = "PARTY",
}

export enum ArenaNoPartyStatusEnum {
  NONE = "NONE",
}

export enum ArenaReportAckStatusEnum {
  FORMING = "FORMING",
  READY = "READY",
  PLAYING = "PLAYING",
  SETTLED = "SETTLED",
  VOIDED = "VOIDED",
}

export enum ArenaProgressReportPhaseEnum {
  Ready = "ready",
  Playing = "playing",
}

export enum ArenaReportPlayerSideEnum {
  T = "t",
  Ct = "ct",
}

export enum ArenaResultReportModeEnum {
  Value1 = 1,
  Value2 = 2,
  Value5 = 5,
}

export enum ArenaResultReportOutcomeEnum {
  Win = "win",
  Draw = "draw",
  Void = "void",
}

export enum ArenaResultReportReasonEnum {
  Rounds = "rounds",
  Forfeit = "forfeit",
  Timeout = "timeout",
  Abandoned = "abandoned",
}

/** OPEN lobby still collecting players, or a full house counting down to the start */
export enum RouletteOpenGameStatusEnum {
  OPEN = "OPEN",
  COUNTDOWN = "COUNTDOWN",
}

/** Entry ticket — one of the presets */
export enum RouletteCreateGameRequestStakeEnum {
  Value100 = 100,
  Value250 = 250,
  Value500 = 500,
  Value1000 = 1000,
  Value5000 = 5000,
  Value10000 = 10000,
  Value50000 = 50000,
  Value100000 = 100000,
  Value500000 = 500000,
  Value1000000 = 1000000,
}

/** The caller's current roulette status */
export enum RouletteStateStatusEnum {
  None = "none",
  Match = "match",
}

/** The seated match's status (present only with status = match). Seats deactivate on finish, so this only ever carries a LIVE status (OPEN/COUNTDOWN/ACTIVE) — the client always follows it in. */
export enum RouletteStateMatchStatusEnum {
  OPEN = "OPEN",
  COUNTDOWN = "COUNTDOWN",
  ACTIVE = "ACTIVE",
  FINISHED = "FINISHED",
  CANCELLED = "CANCELLED",
}

export enum RouletteSeatStatusEnum {
  Alive = "alive",
  Dead = "dead",
  Winner = "winner",
}

export enum RouletteMatchStatusEnum {
  OPEN = "OPEN",
  COUNTDOWN = "COUNTDOWN",
  ACTIVE = "ACTIVE",
  FINISHED = "FINISHED",
  CANCELLED = "CANCELLED",
}

export enum RouletteHistoryItemStatusEnum {
  FINISHED = "FINISHED",
  CANCELLED = "CANCELLED",
}

export enum RouletteFairnessEventTypeEnum {
  Click = "click",
  Shot = "shot",
  Skip = "skip",
  Reload = "reload",
  Finished = "finished",
}

/** Which rung produced the candidates: 'band' = skins priced in [payout × 0.85, payout], 'below' = the nearest-below skins with no floor, 'cheapest' = the single cheapest tradable skin (above the payout, the house covers the difference) */
export enum RoulettePrizeDrawPoolLevelEnum {
  Band = "band",
  Below = "below",
  Cheapest = "cheapest",
}

export enum RushRaffleRoundDetailStatusEnum {
  ACTIVE = "ACTIVE",
  COMPLETED = "COMPLETED",
  EMPTY = "EMPTY",
}

export enum CreateBandTicketInvoiceProviderEnum {
  TELEGRAM_STARS = "TELEGRAM_STARS",
  SKINSBACK = "SKINSBACK",
  CRYPTO_BOT = "CRYPTO_BOT",
  ADVANCED_PAY = "ADVANCED_PAY",
  NIRVANA = "NIRVANA",
  SAFON = "SAFON",
  BREENX = "BREENX",
  NOROSP2P = "NOROS_P2P",
  DRESDALE_DIGITAL = "DRESDALE_DIGITAL",
  WATAPRO_SBP = "WATAPRO_SBP",
  PAYTREE_STRIPE = "PAYTREE_STRIPE",
  FUTURITY_PAY = "FUTURITY_PAY",
  OVERPAY = "OVERPAY",
  PULSE_UZS = "PULSE_UZS",
  PLATEGA_MC_EUR = "PLATEGA_MC_EUR",
  TENET_SBP = "TENET_SBP",
  CLICK_UZ = "CLICK_UZ",
  RIOPAY_SBP = "RIOPAY_SBP",
  UZUM_CHECKOUT = "UZUM_CHECKOUT",
  PAY2328 = "PAY_2328",
  EASYPAY = "EASYPAY",
  ONEPAYMENT_SBP = "ONEPAYMENT_SBP",
}

/** 'pending' until Click's callback lands and membership switches on */
export enum PayBandTicketWithClickCardResponseStatusEnum {
  Completed = "completed",
  Pending = "pending",
}

export enum BandQuestSlotEnum {
  Easy = "easy",
  Medium = "medium",
  Hard = "hard",
}

export enum BandRaffleRoundDetailStatusEnum {
  ACTIVE = "ACTIVE",
  COMPLETED = "COMPLETED",
  EMPTY = "EMPTY",
}

export enum SurveyAnswersUsagePeriodEnum {
  LtWeek = "lt_week",
  Value14Weeks = "1_4_weeks",
  Value13Months = "1_3_months",
  Value36Months = "3_6_months",
  Gt6Months = "gt_6_months",
}

export enum SurveyAnswersPlayFrequencyEnum {
  ManyDaily = "many_daily",
  Daily = "daily",
  FewWeek = "few_week",
  Weekly = "weekly",
  Rare = "rare",
}

export enum SurveyAnswersUsedFeaturesEnum {
  Cases = "cases",
  Upgrades = "upgrades",
  Contracts = "contracts",
  Battles = "battles",
  Achievements = "achievements",
  Withdrawals = "withdrawals",
  Referral = "referral",
}

export enum SurveyAnswersDepositStatusEnum {
  Many = "many",
  Value25 = "2_5",
  Once = "once",
  Planned = "planned",
  Never = "never",
}

export enum SurveyAnswersMatchesCountEnum {
  Value1 = "1",
  Value23 = "2_3",
  Value47 = "4_7",
  Value8Plus = "8_plus",
  DontRemember = "dont_remember",
}

export enum SurveyAnswersPlayedModesEnum {
  Value1X1 = "1x1",
  Value2X2 = "2x2",
  Value5X5 = "5x5",
  Bots = "bots",
  RealPlayers = "real_players",
  Party = "party",
  LookOnly = "look_only",
}

export enum SurveyAnswersClarityFirstTimeEnum {
  Clear = "clear",
  MostlyClear = "mostly_clear",
  FiguredOut = "figured_out",
  ManyUnclear = "many_unclear",
  NothingClear = "nothing_clear",
}

export enum SubmitSurveyResponseLanguageEnum {
  Ru = "ru",
  Uz = "uz",
  En = "en",
}

export enum SurveyDraftAnswersUsagePeriodEnum {
  LtWeek = "lt_week",
  Value14Weeks = "1_4_weeks",
  Value13Months = "1_3_months",
  Value36Months = "3_6_months",
  Gt6Months = "gt_6_months",
}

export enum SurveyDraftAnswersPlayFrequencyEnum {
  ManyDaily = "many_daily",
  Daily = "daily",
  FewWeek = "few_week",
  Weekly = "weekly",
  Rare = "rare",
}

export enum SurveyDraftAnswersUsedFeaturesEnum {
  Cases = "cases",
  Upgrades = "upgrades",
  Contracts = "contracts",
  Battles = "battles",
  Achievements = "achievements",
  Withdrawals = "withdrawals",
  Referral = "referral",
}

export enum SurveyDraftAnswersDepositStatusEnum {
  Many = "many",
  Value25 = "2_5",
  Once = "once",
  Planned = "planned",
  Never = "never",
}

export enum SurveyDraftAnswersMatchesCountEnum {
  Value1 = "1",
  Value23 = "2_3",
  Value47 = "4_7",
  Value8Plus = "8_plus",
  DontRemember = "dont_remember",
}

export enum SurveyDraftAnswersPlayedModesEnum {
  Value1X1 = "1x1",
  Value2X2 = "2x2",
  Value5X5 = "5x5",
  Bots = "bots",
  RealPlayers = "real_players",
  Party = "party",
  LookOnly = "look_only",
}

export enum SurveyDraftAnswersClarityFirstTimeEnum {
  Clear = "clear",
  MostlyClear = "mostly_clear",
  FiguredOut = "figured_out",
  ManyUnclear = "many_unclear",
  NothingClear = "nothing_clear",
}

export enum SaveSurveyDraftLanguageEnum {
  Ru = "ru",
  Uz = "uz",
  En = "en",
}

/** blocked — support blocked the account; payment_required — no payment yet, so no conversation may be opened */
export enum SupportUserSummaryWriteRefusalEnum {
  Blocked = "blocked",
  PaymentRequired = "payment_required",
}

export enum SupportUserAttachmentKindEnum {
  Text = "text",
  Photo = "photo",
  Video = "video",
  VideoNote = "video_note",
  Voice = "voice",
  Audio = "audio",
  Document = "document",
  Sticker = "sticker",
  Animation = "animation",
  Contact = "contact",
  Location = "location",
  Poll = "poll",
  Other = "other",
}

/** operator — support answered; user — the person themselves */
export enum SupportUserMessageAuthorEnum {
  User = "user",
  Operator = "operator",
  System = "system",
}

export enum SupportUserMessageKindEnum {
  Text = "text",
  Photo = "photo",
  Video = "video",
  VideoNote = "video_note",
  Voice = "voice",
  Audio = "audio",
  Document = "document",
  Sticker = "sticker",
  Animation = "animation",
  Contact = "contact",
  Location = "location",
  Poll = "poll",
  Other = "other",
}

export interface PublicControllerGetItemImageParams {
  /**
   * Steam market hash name of the item
   * @example "AK-47 | Redline (Field-Tested)"
   */
  hashName: string;
}

export interface PublicControllerGetDropAnimationParams {
  /** Signed drop token */
  t: string;
  /** @example "v5" */
  version: string;
}

export interface PublicControllerGetCaseImageParams {
  /** Return thumbnail version (320x320) */
  thumbnail?: boolean;
  /**
   * UUID of the case
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  caseId: string;
}

export interface PartnerPublicControllerGetPartnerDailyStatsParams {
  /** Start date (YYYY-MM-DD) */
  fromDate: string;
  /** End date (YYYY-MM-DD) */
  toDate: string;
  /** Page number (default: 1) */
  page?: number;
  /** Page size (default: 20) */
  limit?: number;
  /** Partner ID */
  id: string;
}

export interface PartnerPublicControllerListPartnerWithdrawalsParams {
  /** Page number (default: 1) */
  page?: number;
  /** Page size (default: 20) */
  limit?: number;
  /** Partner ID */
  id: string;
}

export interface PartnerPublicControllerGetPartnerTransactionsParams {
  /** Page number (default: 1) */
  page?: number;
  /** Page size (default: 20) */
  limit?: number;
  /** Start date (YYYY-MM-DD) */
  fromDate?: string;
  /** End date (YYYY-MM-DD) */
  toDate?: string;
  /** Partner ID */
  id: string;
}

export interface RedirectControllerRedirectParams {
  /** Redirect target: app (default) or bot */
  target?: string;
  /** Referral telegram ID */
  ref?: string;
  /** Yandex Click ID (auto-appended by Yandex Direct) */
  yclid?: string;
  /** Campaign ID from Yandex Direct */
  cid?: string;
  /** Ad ID from Yandex Direct */
  aid?: string;
  /** Yandex ad source marker */
  ya?: string;
  /** UTM term (keyword) */
  utm_term?: string;
}

export interface WikiControllerGetWikiSkinsParams {
  /**
   * Slug оружия, через запятую — OR
   * @maxLength 1000
   * @example "ak-47,awp"
   */
  weapon?: string;
  /**
   * Категории через запятую: pistols, rifles, smgs, heavy, knives, gloves, equipment
   * @maxLength 200
   */
  category?: string;
  /**
   * id редкостей через запятую
   * @maxLength 500
   * @example "rarity_legendary_weapon"
   */
  rarity?: string;
  /**
   * Slug коллекций через запятую
   * @maxLength 1000
   */
  collection?: string;
  /**
   * Slug игровых кейсов через запятую
   * @maxLength 1000
   */
  container?: string;
  /** Только со StatTrak */
  stattrak?: StattrakEnum;
  /** Только с Souvenir */
  souvenir?: SouvenirEnum;
  /**
   * Износы через запятую: fn, mw, ft, ww, bs
   * @maxLength 50
   * @example "fn,mw"
   */
  exterior?: string;
  sort?: WikiSkinSort;
  /**
   * @min 1
   * @max 10000
   * @default 1
   */
  page?: number;
  lang: WikiLang;
}

/** Только со StatTrak */
export enum StattrakEnum {
  Value1 = "1",
}

/** Только с Souvenir */
export enum SouvenirEnum {
  Value1 = "1",
}

/** Только со StatTrak */
export enum WikiControllerGetWikiSkinsParams1StattrakEnum {
  Value1 = "1",
}

/** Только с Souvenir */
export enum WikiControllerGetWikiSkinsParams1SouvenirEnum {
  Value1 = "1",
}

export interface WikiControllerGetWikiContainersParams {
  /** Без вида — все контейнеры */
  kind?: WikiContainerKind;
  /**
   * @min 1
   * @max 10000
   * @default 1
   */
  page?: number;
  lang: WikiLang;
}

export interface WikiControllerGetWikiItemsParams {
  sort?: WikiSkinSort;
  /**
   * @min 1
   * @max 10000
   * @default 1
   */
  page?: number;
  lang: WikiLang;
  type: WikiItemType;
}

export interface WikiControllerSearchWikiParams {
  /**
   * @minLength 2
   * @maxLength 100
   */
  q: string;
  /**
   * @min 1
   * @max 10000
   * @default 1
   */
  page?: number;
  lang: WikiLang;
}

export interface WikiControllerSuggestWikiParams {
  /**
   * @minLength 2
   * @maxLength 100
   */
  q: string;
  lang: WikiLang;
}

export interface NewsControllerGetNewsListParams {
  category?: NewsCategory;
  /**
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * @min 1
   * @max 50
   * @default 20
   */
  limit?: number;
  lang: NewsLang;
}

export interface UserControllerGetProfileStatsParams {
  /** User ID to get public profile stats. If not provided, returns own profile stats. */
  userId?: string;
}

export interface UserControllerGetReferralsParams {
  /**
   * Page number
   * @default "1"
   * @example "1"
   */
  page?: string;
  /**
   * Items per page
   * @default "20"
   * @example "20"
   */
  limit?: string;
}

export interface ContractsControllerPreviewContractParams {
  /**
   * Array of inventory item IDs
   * @example ["uuid1","uuid2","uuid3"]
   */
  itemIds: string[];
}

export interface ContractsControllerGetContractHistoryParams {
  /**
   * Page number
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Items per page
   * @min 1
   * @default 20
   */
  limit?: number;
}

export interface UpgradeControllerGetUpgradeHistoryParams {
  /**
   * Page number
   * @min 1
   * @default 1
   * @example 1
   */
  page?: number;
  /**
   * Items per page
   * @min 1
   * @max 100
   * @default 20
   * @example 20
   */
  perPage?: number;
  /** Number of items to take (max 100) */
  take?: number;
  /** Number of items to skip */
  skip?: number;
}

export interface UpgradeControllerGetUpgradeTopParams {
  /** Период топа по московскому времени */
  period: PeriodEnum;
}

/** Период топа по московскому времени */
export enum PeriodEnum {
  Day = "day",
  Month = "month",
}

/** Период топа по московскому времени */
export enum UpgradeControllerGetUpgradeTopParams1PeriodEnum {
  Day = "day",
  Month = "month",
}

export interface UpgradeControllerGetAvailableUpgradeTargetsParams {
  /**
   * Credits staked — the whole entry when there is no source item, or the amount added on top of one
   * @min 1
   */
  sourceAmount?: number;
  /** Search term for item name */
  searchTerm?: string;
  /** Order of targets */
  order?: OrderEnum;
  /**
   * Min success probability (0..1)
   * @min 0
   * @max 1
   */
  minProbability?: number;
  /**
   * Max success probability (0..1)
   * @min 0
   * @max 1
   */
  maxProbability?: number;
  /** Filter by item category */
  category?: string;
  /** Filter by item type */
  type?: string;
  /** Filter by weapon name */
  weapon?: string;
  /**
   * Page number (1-based)
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Number of items per page
   * @min 1
   * @max 100
   * @default 20
   */
  limit?: number;
  sourceItemId: string;
}

/** Order of targets */
export enum OrderEnum {
  Chance = "chance",
  Multiplier = "multiplier",
}

/** Order of targets */
export enum UpgradeControllerGetAvailableUpgradeTargetsParams1OrderEnum {
  Chance = "chance",
  Multiplier = "multiplier",
}

export interface ShopControllerGetShopItemsParams {
  /**
   * Page number (1-based)
   * @min 1
   * @default 1
   * @example 1
   */
  page?: number;
  /**
   * Number of items per page
   * @min 1
   * @max 100
   * @default 20
   * @example 20
   */
  limit?: number;
  /**
   * Filter by exact hashName (single-item lookup)
   * @example "AK-47 | Redline (Field-Tested)"
   */
  hashName?: string;
  /**
   * Filter by category
   * @example "Rifle"
   */
  category?: string;
  /**
   * Filter by weapon
   * @example "AK-47"
   */
  weapon?: string;
  /**
   * Filter by skin name (part after | in item name)
   * @example "Asiimov"
   */
  skinName?: string;
  /**
   * Filter by type
   * @example "skin"
   */
  type?: TypeEnum;
  /**
   * Filter by wear condition (for skins)
   * @example "Factory New"
   */
  wear?: WearEnum;
  /**
   * Filter by rarity
   * @example "Classified"
   */
  rarity?: string;
  /**
   * Minimum price in credits
   * @min 25000
   * @example 25000
   */
  minPrice?: number;
  /**
   * Maximum price in credits
   * @min 25000
   * @example 100000
   */
  maxPrice?: number;
  /**
   * Filter by StatTrak
   * @example true
   */
  statTrak?: boolean;
  /**
   * Sort order
   * @default "volume_desc"
   * @example "volume_desc"
   */
  sortBy?: SortByEnum;
}

/**
 * Filter by type
 * @example "skin"
 */
export enum TypeEnum {
  Skin = "skin",
  Crate = "crate",
  Keychain = "keychain",
  Graffiti = "graffiti",
  Sticker = "sticker",
  Agent = "agent",
}

/**
 * Filter by wear condition (for skins)
 * @example "Factory New"
 */
export enum WearEnum {
  FactoryNew = "Factory New",
  MinimalWear = "Minimal Wear",
  FieldTested = "Field-Tested",
  WellWorn = "Well-Worn",
  BattleScarred = "Battle-Scarred",
}

/**
 * Sort order
 * @default "volume_desc"
 * @example "volume_desc"
 */
export enum SortByEnum {
  VolumeDesc = "volume_desc",
  VolumeAsc = "volume_asc",
  PriceDesc = "price_desc",
  PriceAsc = "price_asc",
}

/**
 * Filter by type
 * @example "skin"
 */
export enum ShopControllerGetShopItemsParams1TypeEnum {
  Skin = "skin",
  Crate = "crate",
  Keychain = "keychain",
  Graffiti = "graffiti",
  Sticker = "sticker",
  Agent = "agent",
}

/**
 * Filter by wear condition (for skins)
 * @example "Factory New"
 */
export enum ShopControllerGetShopItemsParams1WearEnum {
  FactoryNew = "Factory New",
  MinimalWear = "Minimal Wear",
  FieldTested = "Field-Tested",
  WellWorn = "Well-Worn",
  BattleScarred = "Battle-Scarred",
}

/**
 * Sort order
 * @default "volume_desc"
 * @example "volume_desc"
 */
export enum ShopControllerGetShopItemsParams1SortByEnum {
  VolumeDesc = "volume_desc",
  VolumeAsc = "volume_asc",
  PriceDesc = "price_desc",
  PriceAsc = "price_asc",
}

export interface ShopControllerGetShopSkinsParams {
  /**
   * Weapon name to get skins for
   * @example "AK-47"
   */
  weapon: string;
  /**
   * Skin name pattern to filter by
   * @example "Asiimov"
   */
  skinName?: string;
  /**
   * Filter by rarity name
   * @example "Covert"
   */
  rarity?: string;
  /**
   * Minimum price in rubles
   * @example 100
   */
  minPrice?: number;
  /**
   * Maximum price in rubles
   * @example 1000
   */
  maxPrice?: number;
  /** Sort by field */
  sortBy?: GetShopSkinsSortBy;
}

export interface ShopControllerGetMyShopPurchasesParams {
  /** @example 1 */
  page?: number;
  /** @example 20 */
  limit?: number;
}

export interface CaseControllerGetCaseOpeningsParams {
  /**
   * Page number
   * @default "1"
   * @example "1"
   */
  page?: string;
  /**
   * Items per page
   * @default "20"
   * @example "20"
   */
  limit?: string;
}

export interface InventoryControllerGetInventoryParams {
  /**
   * Page number
   * @default "1"
   * @example "1"
   */
  page?: string;
  /**
   * Items per page
   * @default "20"
   * @example "20"
   */
  limit?: string;
  /**
   * Sort by field
   * @default "acquiredAt"
   */
  sortBy?: SortByEnum1;
  /**
   * Sort order
   * @default "DESC"
   */
  sortOrder?: SortOrderEnum;
  /**
   * Filter by item statuses
   * @example ["AVAILABLE","SOLD"]
   */
  statuses?: StatusesEnum[];
  /**
   * Minimum price filter in credits
   * @example 1000
   */
  minPrice?: number;
  /**
   * Filter by item type
   * @example "skin"
   */
  type?: string;
}

/**
 * Sort by field
 * @default "acquiredAt"
 */
export enum SortByEnum1 {
  AcquiredAt = "acquiredAt",
  AcquiredPrice = "acquiredPrice",
}

/**
 * Sort order
 * @default "DESC"
 */
export enum SortOrderEnum {
  ASC = "ASC",
  DESC = "DESC",
}

export enum StatusesEnum {
  AVAILABLE = "AVAILABLE",
  PROCESSING = "PROCESSING",
  SENT = "SENT",
  CONFIRMED = "CONFIRMED",
  SOLD = "SOLD",
  CONTRACT_CONSUMED = "CONTRACT_CONSUMED",
  UPGRADE_CONSUMED = "UPGRADE_CONSUMED",
}

/**
 * Sort by field
 * @default "acquiredAt"
 */
export enum InventoryControllerGetInventoryParams1SortByEnum {
  AcquiredAt = "acquiredAt",
  AcquiredPrice = "acquiredPrice",
}

/**
 * Sort order
 * @default "DESC"
 */
export enum InventoryControllerGetInventoryParams1SortOrderEnum {
  ASC = "ASC",
  DESC = "DESC",
}

export enum InventoryControllerGetInventoryParams1StatusesEnum {
  AVAILABLE = "AVAILABLE",
  PROCESSING = "PROCESSING",
  SENT = "SENT",
  CONFIRMED = "CONFIRMED",
  SOLD = "SOLD",
  CONTRACT_CONSUMED = "CONTRACT_CONSUMED",
  UPGRADE_CONSUMED = "UPGRADE_CONSUMED",
}

export interface InventoryControllerGetRecentInventoryItemsParams {
  limit: string;
}

export interface InventoryControllerGetTopRecentDropsParams {
  limit: string;
}

export interface SteamInventoryControllerGetSteamInventoryParams {
  /** Whose inventory to read. Omit for your own. */
  userId?: string;
}

export interface XpControllerGetXpHistoryParams {
  /**
   * Page number
   * @default "1"
   */
  page?: string;
  /**
   * Items per page
   * @default "20"
   */
  limit?: string;
}

export interface XpControllerGetXpLeaderboardParams {
  /**
   * Page number
   * @default "1"
   * @example "1"
   */
  page?: string;
  /**
   * Items per page (max 100)
   * @default "20"
   * @example "20"
   */
  limit?: string;
}

export interface DrawsControllerGetWinnersHistoryParams {
  /** Maximum number of winners to return */
  limit?: number;
  /** Filter by draw type */
  type?: TypeEnum1;
}

/** Filter by draw type */
export enum TypeEnum1 {
  Deposit = "deposit",
  Referral = "referral",
  Paid5000 = "paid_5000",
  Paid10000 = "paid_10000",
  Paid25000 = "paid_25000",
}

/** Filter by draw type */
export enum DrawsControllerGetWinnersHistoryParams1TypeEnum {
  Deposit = "deposit",
  Referral = "referral",
  Paid5000 = "paid_5000",
  Paid10000 = "paid_10000",
  Paid25000 = "paid_25000",
}

export interface DrawsControllerGetDrawParticipantsParams {
  /** Page number (default: 1) */
  page?: number;
  /** Items per page (default: 20) */
  limit?: number;
  /** Draw ID */
  id: string;
}

export interface GiveawaysControllerGetParticipantsParams {
  /** Page number (default: 1) */
  page?: number;
  /** Items per page (default: 20) */
  limit?: number;
  /** Giveaway ID */
  id: string;
}

export interface RainsControllerGetHistoryParams {
  page?: number;
  limit?: number;
}

export interface RainsControllerGetParticipantsParams {
  page?: number;
  limit?: number;
  /** Rain ID */
  id: string;
}

export interface DailyGiveawayControllerGetLeaderboardParams {
  page?: number;
  limit?: number;
  id: string;
}

export interface DailyGiveawayControllerGetWinnersParams {
  page?: number;
  limit?: number;
  id: string;
}

export interface ReferralContestControllerGetLeaderboardParams {
  /** Board entries to skip */
  offset?: number;
}

export interface CaseBattleControllerGetActiveCaseBattlesParams {
  /** 2 | 3 | 4 */
  players?: number;
  /** Only 2×2 (true) or only free-for-all (false) */
  team?: boolean;
  /** Only battles the viewer can afford */
  affordable?: boolean;
  sort?: CaseBattleLobbySort;
  mode?: CaseBattleLobbyMode[];
}

export interface CaseBattleControllerGetAllCaseBattleHistoryParams {
  /** Number of battles to skip */
  skip?: number;
  /** Number of battles to take */
  take?: number;
}

export interface CaseBattleControllerGetUserCaseBattleHistoryParams {
  /** Number of battles to skip */
  skip?: number;
  /** Number of battles to take */
  take?: number;
}

export interface RushMidControllerHistoryParams {
  skip?: number;
  take?: number;
}

export interface RushMidControllerRatingParams {
  /** Team size (1/2/5); defaults to 1 */
  mode?: ModeEnum;
}

/** Team size (1/2/5); defaults to 1 */
export enum ModeEnum {
  Value1 = 1,
  Value2 = 2,
  Value5 = 5,
}

/** Team size (1/2/5); defaults to 1 */
export enum RushMidControllerRatingParams1ModeEnum {
  Value1 = 1,
  Value2 = 2,
  Value5 = 5,
}

export interface ArenaControllerHistoryParams {
  skip: string;
  take: string;
}

export interface ArenaControllerRatingParams {
  /** @default 1 */
  mode?: ModeEnum1;
}

/** @default 1 */
export enum ModeEnum1 {
  Value1 = 1,
  Value2 = 2,
  Value5 = 5,
}

/** @default 1 */
export enum ArenaControllerRatingParams1ModeEnum {
  Value1 = 1,
  Value2 = 2,
  Value5 = 5,
}

export interface RouletteControllerHistoryParams {
  limit?: number;
  /** Opaque cursor from a previous page's nextCursor */
  cursor?: string;
}

export interface RouletteControllerFeedParams {
  limit?: number;
  /** Opaque cursor from a previous page's nextCursor */
  cursor?: string;
}

export interface BandRaceControllerGetLeaderboardParams {
  /**
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * @min 1
   * @max 50
   * @default 10
   */
  limit?: number;
}

export interface BandRaceControllerGetWinnersParams {
  /**
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * @min 1
   * @max 50
   * @default 10
   */
  limit?: number;
}

export interface BandFinalControllerGetLeaderboardParams {
  /**
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * @min 1
   * @max 50
   * @default 20
   */
  limit?: number;
  /**
   * Week round id; omitted — the week in progress
   * @format uuid
   */
  roundId?: string;
}

export interface BandFinalControllerGetWinnersParams {
  /**
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * @min 1
   * @max 50
   * @default 20
   */
  limit?: number;
}

export interface AchievementsControllerGetMyParams {
  onlyUnlocked?: boolean;
  hideLockedSecrets?: boolean;
}

export interface AchievementsControllerGetForUserParams {
  onlyUnlocked?: boolean;
  hideLockedSecrets?: boolean;
  userId: string;
}

export interface SurveyControllerMyStatusParams {
  /** Which survey to check. Omit for the original 'default' survey. */
  slug?: string;
}

export interface SteamAuthControllerInitSteamLinkParams {
  source: string;
}

export interface SupportControllerGetMessagesParams {
  /** Opaque cursor from a previous page; walks backwards in time */
  before?: string;
  /**
   * @min 1
   * @max 100
   * @default 50
   */
  limit?: number;
}

export namespace Api {
  /**
   * No description
   * @tags Public
   * @name PublicControllerGetGameStats
   * @summary Get global game statistics counters
   * @request GET:/api/public/game-stats
   * @response `200` `GameStatsResponse` Game statistics
   */
  export namespace PublicControllerGetGameStats {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GameStatsResponse;
  }

  /**
   * @description Returns an item image with a background colored according to its rarity
   * @tags Public
   * @name PublicControllerGetItemImage
   * @summary Get item image with rarity background
   * @request GET:/api/public/item-image
   * @response `200` `File` Item image with rarity background
   * @response `400` `void` Invalid parameters or image processing failed
   * @response `404` `void` Item not found
   */
  export namespace PublicControllerGetItemImage {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Steam market hash name of the item
       * @example "AK-47 | Redline (Field-Tested)"
       */
      hashName: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = File;
  }

  /**
   * @description Returns a looping MP4 of a dropped item with the player who dropped it, for a signed, short-lived token.
   * @tags Public
   * @name PublicControllerGetDropAnimation
   * @summary Get the animated drop card
   * @request GET:/api/public/drop-animation/{version}/drop.mp4
   * @response `200` `File` Looping MP4 animation
   * @response `404` `void` Unknown version, bad signature or expired link
   * @response `503` `void` Animation is temporarily unavailable
   */
  export namespace PublicControllerGetDropAnimation {
    export type RequestParams = {
      /** @example "v5" */
      version: string;
    };
    export type RequestQuery = {
      /** Signed drop token */
      t: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = File;
  }

  /**
   * @description Returns a case image with gray background in JPEG format
   * @tags Public
   * @name PublicControllerGetCaseImage
   * @summary Get case image by ID
   * @request GET:/api/public/case-image/{caseId}
   * @response `200` `File` Case image with gray background in JPEG format
   * @response `400` `void` Invalid parameters or image processing failed
   * @response `404` `void` Case not found
   */
  export namespace PublicControllerGetCaseImage {
    export type RequestParams = {
      /**
       * UUID of the case
       * @example "123e4567-e89b-12d3-a456-426614174000"
       */
      caseId: string;
    };
    export type RequestQuery = {
      /** Return thumbnail version (320x320) */
      thumbnail?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = File;
  }

  /**
   * @description Proxies broadcast images from S3 storage
   * @tags Public
   * @name PublicControllerGetBroadcastImage
   * @summary Get broadcast image
   * @request GET:/api/public/broadcast-images/{filename}
   * @response `200` `File` Broadcast image
   * @response `404` `void` Image not found
   */
  export namespace PublicControllerGetBroadcastImage {
    export type RequestParams = {
      /**
       * Filename of the broadcast image
       * @example "123e4567-e89b-12d3-a456-426614174000.jpg"
       */
      filename: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = File;
  }

  /**
   * No description
   * @tags Public - Partners
   * @name PartnerPublicControllerGetPartnerById
   * @summary Get partner details by ID (public)
   * @request GET:/api/public/partners/{id}
   * @response `200` `Partner` Partner details
   * @response `404` `void` Partner not found
   */
  export namespace PartnerPublicControllerGetPartnerById {
    export type RequestParams = {
      /** Partner ID */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Partner;
  }

  /**
   * No description
   * @tags Public - Partners
   * @name PartnerPublicControllerGetPartnerTransferInfo
   * @summary Get the balance and conversion rate for a partner balance transfer (public)
   * @request GET:/api/public/partners/{id}/transfer-info
   * @response `200` `PartnerTransferInfo` Transfer info
   * @response `404` `void` Partner not found
   */
  export namespace PartnerPublicControllerGetPartnerTransferInfo {
    export type RequestParams = {
      /** Partner ID */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PartnerTransferInfo;
  }

  /**
   * No description
   * @tags Public - Partners
   * @name PartnerPublicControllerTransferToBalance
   * @summary Transfer partner balance to the account balance of the partner owner (public)
   * @request POST:/api/public/partners/{id}/transfer-to-balance
   * @response `200` `TransferPartnerBalanceResponse` Transfer completed
   * @response `400` `void` Invalid amount
   * @response `402` `void` Transfer amount exceeds the partner balance
   * @response `404` `void` Partner not found
   * @response `422` `void` Partner is inactive
   */
  export namespace PartnerPublicControllerTransferToBalance {
    export type RequestParams = {
      /** Partner ID */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = TransferPartnerBalance;
    export type RequestHeaders = {};
    export type ResponseBody = TransferPartnerBalanceResponse;
  }

  /**
   * No description
   * @tags Public - Partners
   * @name PartnerPublicControllerGetPartnerDailyStats
   * @summary Get partner daily statistics (public)
   * @request GET:/api/public/partners/{id}/daily-stats
   * @response `200` `ListPartnerDailyStatsResponse` Daily statistics with pagination
   */
  export namespace PartnerPublicControllerGetPartnerDailyStats {
    export type RequestParams = {
      /** Partner ID */
      id: string;
    };
    export type RequestQuery = {
      /** Start date (YYYY-MM-DD) */
      fromDate: string;
      /** End date (YYYY-MM-DD) */
      toDate: string;
      /** Page number (default: 1) */
      page?: number;
      /** Page size (default: 20) */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListPartnerDailyStatsResponse;
  }

  /**
   * No description
   * @tags Public - Partners
   * @name PartnerPublicControllerListPartnerWithdrawals
   * @summary Get partner withdrawals and deposits (public)
   * @request GET:/api/public/partners/{id}/withdrawals
   * @response `200` `ListPartnerWithdrawalsResponse` Withdrawals list
   */
  export namespace PartnerPublicControllerListPartnerWithdrawals {
    export type RequestParams = {
      /** Partner ID */
      id: string;
    };
    export type RequestQuery = {
      /** Page number (default: 1) */
      page?: number;
      /** Page size (default: 20) */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListPartnerWithdrawalsResponse;
  }

  /**
   * No description
   * @tags Public - Partners
   * @name PartnerPublicControllerGetPartnerTransactions
   * @summary Get partner transactions with pagination and date filters (public)
   * @request GET:/api/public/partners/{id}/transactions
   * @response `200` `ListPartnerTransactionsResponse` Transactions list with pagination
   * @response `404` `void` Partner not found
   */
  export namespace PartnerPublicControllerGetPartnerTransactions {
    export type RequestParams = {
      /** Partner ID */
      id: string;
    };
    export type RequestQuery = {
      /** Page number (default: 1) */
      page?: number;
      /** Page size (default: 20) */
      limit?: number;
      /** Start date (YYYY-MM-DD) */
      fromDate?: string;
      /** End date (YYYY-MM-DD) */
      toDate?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListPartnerTransactionsResponse;
  }

  /**
   * No description
   * @tags Redirect
   * @name RedirectControllerRedirect
   * @summary Redirect to Telegram bot/app with tracking params
   * @request GET:/api/redirect
   * @response `200` `void`
   */
  export namespace RedirectControllerRedirect {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Redirect target: app (default) or bot */
      target?: string;
      /** Referral telegram ID */
      ref?: string;
      /** Yandex Click ID (auto-appended by Yandex Direct) */
      yclid?: string;
      /** Campaign ID from Yandex Direct */
      cid?: string;
      /** Ad ID from Yandex Direct */
      aid?: string;
      /** Yandex ad source marker */
      ya?: string;
      /** UTM term (keyword) */
      utm_term?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Public
   * @name PublicConfigControllerGetConfig
   * @summary Get public application config
   * @request GET:/api/public/config
   * @response `200` `PublicConfigResponse`
   */
  export namespace PublicConfigControllerGetConfig {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PublicConfigResponse;
  }

  /**
   * @description Issues a 302 from our origin so the Referer header matches our domain when the browser navigates to wata.pro.
   * @tags Payment
   * @name WataproRedirectControllerRedirect
   * @summary Redirect to wata.pro hosted payment page
   * @request GET:/api/payment/watapro-sbp/redirect/{invoiceId}
   * @response `200` `void`
   */
  export namespace WataproRedirectControllerRedirect {
    export type RequestParams = {
      invoiceId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Wiki
   * @name WikiControllerGetWikiSitemap
   * @summary Индексируемые страницы вики для sitemap
   * @request GET:/api/wiki/sitemap
   * @response `200` `WikiSitemap`
   */
  export namespace WikiControllerGetWikiSitemap {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WikiSitemap;
  }

  /**
   * No description
   * @tags Wiki
   * @name WikiControllerGetWikiHome
   * @summary Главная вики
   * @request GET:/api/wiki/{lang}/home
   * @response `200` `WikiHome`
   */
  export namespace WikiControllerGetWikiHome {
    export type RequestParams = {
      lang: WikiLang;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WikiHome;
  }

  /**
   * No description
   * @tags Wiki
   * @name WikiControllerGetWikiCategory
   * @summary Страница категории оружия: оружие, скины со статьями, подборки и руководства
   * @request GET:/api/wiki/{lang}/categories/{category}
   * @response `200` `WikiCategoryPage`
   */
  export namespace WikiControllerGetWikiCategory {
    export type RequestParams = {
      lang: WikiLang;
      category: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WikiCategoryPage;
  }

  /**
   * No description
   * @tags Wiki
   * @name WikiControllerGetWikiSkins
   * @summary Каталог скинов с фильтрами
   * @request GET:/api/wiki/{lang}/skins
   * @response `200` `WikiSkinsPage`
   */
  export namespace WikiControllerGetWikiSkins {
    export type RequestParams = {
      lang: WikiLang;
    };
    export type RequestQuery = {
      /**
       * Slug оружия, через запятую — OR
       * @maxLength 1000
       * @example "ak-47,awp"
       */
      weapon?: string;
      /**
       * Категории через запятую: pistols, rifles, smgs, heavy, knives, gloves, equipment
       * @maxLength 200
       */
      category?: string;
      /**
       * id редкостей через запятую
       * @maxLength 500
       * @example "rarity_legendary_weapon"
       */
      rarity?: string;
      /**
       * Slug коллекций через запятую
       * @maxLength 1000
       */
      collection?: string;
      /**
       * Slug игровых кейсов через запятую
       * @maxLength 1000
       */
      container?: string;
      /** Только со StatTrak */
      stattrak?: WikiControllerGetWikiSkinsParams1StattrakEnum;
      /** Только с Souvenir */
      souvenir?: WikiControllerGetWikiSkinsParams1SouvenirEnum;
      /**
       * Износы через запятую: fn, mw, ft, ww, bs
       * @maxLength 50
       * @example "fn,mw"
       */
      exterior?: string;
      sort?: WikiSkinSort;
      /**
       * @min 1
       * @max 10000
       * @default 1
       */
      page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WikiSkinsPage;
  }

  /**
   * No description
   * @tags Wiki
   * @name WikiControllerGetWikiSkin
   * @summary Страница скина; для старого slug — { redirectSlug }, у ножа без раскраски есть weaponSlug
   * @request GET:/api/wiki/{lang}/skins/{slug}
   * @response `200` `(WikiSkinDetails | WikiSkinRedirect)`
   */
  export namespace WikiControllerGetWikiSkin {
    export type RequestParams = {
      lang: WikiLang;
      slug: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WikiSkinDetails | WikiSkinRedirect;
  }

  /**
   * No description
   * @tags Wiki
   * @name WikiControllerGetWikiSkinDrops
   * @summary Последние выпадения скина в играх SHOT во всех износах, StatTrak™ и сувенирных версиях
   * @request GET:/api/wiki/{lang}/skins/{slug}/drops
   * @response `200` `WikiDrops`
   */
  export namespace WikiControllerGetWikiSkinDrops {
    export type RequestParams = {
      lang: WikiLang;
      slug: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WikiDrops;
  }

  /**
   * No description
   * @tags Wiki
   * @name WikiControllerGetWikiWeapon
   * @summary Страница оружия со всеми скинами
   * @request GET:/api/wiki/{lang}/weapons/{slug}
   * @response `200` `WikiWeaponPage`
   */
  export namespace WikiControllerGetWikiWeapon {
    export type RequestParams = {
      lang: WikiLang;
      slug: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WikiWeaponPage;
  }

  /**
   * No description
   * @tags Wiki
   * @name WikiControllerGetWikiWeaponDrops
   * @summary Последние выпадения ножа без раскраски в играх SHOT; у оружия без него — пустой список
   * @request GET:/api/wiki/{lang}/weapons/{slug}/drops
   * @response `200` `WikiDrops`
   */
  export namespace WikiControllerGetWikiWeaponDrops {
    export type RequestParams = {
      lang: WikiLang;
      slug: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WikiDrops;
  }

  /**
   * No description
   * @tags Wiki
   * @name WikiControllerGetWikiContainers
   * @summary Кейсы, капсулы и наборы игры по страницам, с фильтром по виду
   * @request GET:/api/wiki/{lang}/containers
   * @response `200` `WikiContainers`
   */
  export namespace WikiControllerGetWikiContainers {
    export type RequestParams = {
      lang: WikiLang;
    };
    export type RequestQuery = {
      /** Без вида — все контейнеры */
      kind?: WikiContainerKind;
      /**
       * @min 1
       * @max 10000
       * @default 1
       */
      page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WikiContainers;
  }

  /**
   * No description
   * @tags Wiki
   * @name WikiControllerGetWikiItems
   * @summary Список предметов одного типа: наклейки, агенты, брелоки, музыка и другие
   * @request GET:/api/wiki/{lang}/items/{type}
   * @response `200` `WikiItemsPage`
   */
  export namespace WikiControllerGetWikiItems {
    export type RequestParams = {
      lang: WikiLang;
      type: WikiItemType;
    };
    export type RequestQuery = {
      sort?: WikiSkinSort;
      /**
       * @min 1
       * @max 10000
       * @default 1
       */
      page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WikiItemsPage;
  }

  /**
   * No description
   * @tags Wiki
   * @name WikiControllerGetWikiItem
   * @summary Страница предмета; для старого slug — { redirectSlug }
   * @request GET:/api/wiki/{lang}/items/{type}/{slug}
   * @response `200` `(WikiItemDetails | WikiSkinRedirect)`
   */
  export namespace WikiControllerGetWikiItem {
    export type RequestParams = {
      lang: WikiLang;
      type: WikiItemType;
      slug: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WikiItemDetails | WikiSkinRedirect;
  }

  /**
   * No description
   * @tags Wiki
   * @name WikiControllerGetWikiItemDrops
   * @summary Последние выпадения предмета в играх SHOT во всех версиях: эффекты, слэб, цвета, StatTrak™
   * @request GET:/api/wiki/{lang}/items/{type}/{slug}/drops
   * @response `200` `WikiDrops`
   */
  export namespace WikiControllerGetWikiItemDrops {
    export type RequestParams = {
      lang: WikiLang;
      type: WikiItemType;
      slug: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WikiDrops;
  }

  /**
   * No description
   * @tags Wiki
   * @name WikiControllerResolveWikiPaths
   * @summary Страницы вики по market_hash_name пачкой: скин, нож, предмет или контейнер; без страницы — нет в ответе
   * @request POST:/api/wiki/paths
   * @response `200` `WikiPaths`
   */
  export namespace WikiControllerResolveWikiPaths {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = WikiPathsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = WikiPaths;
  }

  /**
   * No description
   * @tags Wiki
   * @name WikiControllerGetWikiContainer
   * @summary Страница игрового кейса
   * @request GET:/api/wiki/{lang}/containers/{slug}
   * @response `200` `WikiContainerPage`
   */
  export namespace WikiControllerGetWikiContainer {
    export type RequestParams = {
      lang: WikiLang;
      slug: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WikiContainerPage;
  }

  /**
   * No description
   * @tags Wiki
   * @name WikiControllerGetWikiCollections
   * @summary Список коллекций
   * @request GET:/api/wiki/{lang}/collections
   * @response `200` `WikiCollections`
   */
  export namespace WikiControllerGetWikiCollections {
    export type RequestParams = {
      lang: WikiLang;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WikiCollections;
  }

  /**
   * No description
   * @tags Wiki
   * @name WikiControllerGetWikiCollection
   * @summary Страница коллекции
   * @request GET:/api/wiki/{lang}/collections/{slug}
   * @response `200` `WikiCollectionPage`
   */
  export namespace WikiControllerGetWikiCollection {
    export type RequestParams = {
      lang: WikiLang;
      slug: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WikiCollectionPage;
  }

  /**
   * No description
   * @tags Wiki
   * @name WikiControllerGetWikiGuides
   * @summary Руководства с опубликованным текстом на языке
   * @request GET:/api/wiki/{lang}/guides
   * @response `200` `WikiGuides`
   */
  export namespace WikiControllerGetWikiGuides {
    export type RequestParams = {
      lang: WikiLang;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WikiGuides;
  }

  /**
   * No description
   * @tags Wiki
   * @name WikiControllerGetWikiGuide
   * @summary Руководство; без опубликованного текста на языке — 404
   * @request GET:/api/wiki/{lang}/guides/{slug}
   * @response `200` `WikiGuidePage`
   */
  export namespace WikiControllerGetWikiGuide {
    export type RequestParams = {
      lang: WikiLang;
      slug: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WikiGuidePage;
  }

  /**
   * No description
   * @tags Wiki
   * @name WikiControllerGetWikiSelections
   * @summary Подборки с опубликованным текстом на языке
   * @request GET:/api/wiki/{lang}/selections
   * @response `200` `WikiSelections`
   */
  export namespace WikiControllerGetWikiSelections {
    export type RequestParams = {
      lang: WikiLang;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WikiSelections;
  }

  /**
   * No description
   * @tags Wiki
   * @name WikiControllerGetWikiSelection
   * @summary Подборка; без опубликованного текста на языке — 404
   * @request GET:/api/wiki/{lang}/selections/{slug}
   * @response `200` `WikiSelectionPage`
   */
  export namespace WikiControllerGetWikiSelection {
    export type RequestParams = {
      lang: WikiLang;
      slug: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WikiSelectionPage;
  }

  /**
   * No description
   * @tags Wiki
   * @name WikiControllerSearchWiki
   * @summary Поиск по скинам, оружию, кейсам и коллекциям
   * @request GET:/api/wiki/{lang}/search
   * @response `200` `WikiSearchPage`
   */
  export namespace WikiControllerSearchWiki {
    export type RequestParams = {
      lang: WikiLang;
    };
    export type RequestQuery = {
      /**
       * @minLength 2
       * @maxLength 100
       */
      q: string;
      /**
       * @min 1
       * @max 10000
       * @default 1
       */
      page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WikiSearchPage;
  }

  /**
   * No description
   * @tags Wiki
   * @name WikiControllerSuggestWiki
   * @summary Автодополнение поиска, до 8 подсказок
   * @request GET:/api/wiki/{lang}/suggest
   * @response `200` `(WikiSearchHit)[]`
   */
  export namespace WikiControllerSuggestWiki {
    export type RequestParams = {
      lang: WikiLang;
    };
    export type RequestQuery = {
      /**
       * @minLength 2
       * @maxLength 100
       */
      q: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WikiSearchHit[];
  }

  /**
   * No description
   * @tags News
   * @name NewsControllerGetNewsSitemap
   * @summary Активные новости для sitemap
   * @request GET:/api/news/sitemap
   * @response `200` `NewsSitemap`
   */
  export namespace NewsControllerGetNewsSitemap {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = NewsSitemap;
  }

  /**
   * No description
   * @tags News
   * @name NewsControllerRegisterView
   * @summary Учесть просмотр публичной страницы активной новости
   * @request POST:/api/news/views
   * @response `200` `NewsViewResult`
   */
  export namespace NewsControllerRegisterView {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RegisterNewsView;
    export type RequestHeaders = {};
    export type ResponseBody = NewsViewResult;
  }

  /**
   * No description
   * @tags News
   * @name NewsControllerGetNewsList
   * @summary Лента активных новостей на языке
   * @request GET:/api/news/{lang}
   * @response `200` `NewsList`
   */
  export namespace NewsControllerGetNewsList {
    export type RequestParams = {
      lang: NewsLang;
    };
    export type RequestQuery = {
      category?: NewsCategory;
      /**
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * @min 1
       * @max 50
       * @default 20
       */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = NewsList;
  }

  /**
   * No description
   * @tags News
   * @name NewsControllerGetNewsArticle
   * @summary Активная новость на языке (без редакторских данных)
   * @request GET:/api/news/{lang}/{slug}
   * @response `200` `NewsArticle`
   */
  export namespace NewsControllerGetNewsArticle {
    export type RequestParams = {
      lang: NewsLang;
      slug: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = NewsArticle;
  }

  /**
   * No description
   * @tags Health
   * @name HealthControllerCheck
   * @summary Basic health check
   * @request GET:/api/health
   * @response `200` `BasicHealth` Service is healthy
   */
  export namespace HealthControllerCheck {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BasicHealth;
  }

  /**
   * No description
   * @tags Health
   * @name HealthControllerReadiness
   * @summary Readiness check with dependencies
   * @request GET:/api/health/ready
   * @response `200` `ReadinessCheck` Service is ready
   * @response `503` `void` Service is not ready
   */
  export namespace HealthControllerReadiness {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ReadinessCheck;
  }

  /**
   * No description
   * @tags Health
   * @name HealthControllerLiveness
   * @summary Liveness check
   * @request GET:/api/health/live
   * @response `200` `HealthCheck` Service is alive
   */
  export namespace HealthControllerLiveness {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = HealthCheck;
  }

  /**
   * No description
   * @tags Users
   * @name UserControllerRegister
   * @summary Register a new user (TMA initData auth)
   * @request POST:/api/users/register
   * @secure
   * @response `201` `RegisterResponse` User successfully registered
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace UserControllerRegister {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RegisterUser;
    export type RequestHeaders = {};
    export type ResponseBody = RegisterResponse;
  }

  /**
   * No description
   * @tags Users
   * @name UserControllerGetProfile
   * @summary Get user profile information
   * @request GET:/api/users/profile
   * @secure
   * @response `200` `UserProfileResponse` User profile retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace UserControllerGetProfile {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UserProfileResponse;
  }

  /**
   * No description
   * @tags Users
   * @name UserControllerGetProfileStats
   * @summary Get user profile statistics (own or public)
   * @request GET:/api/users/profile/stats
   * @response `200` `ProfileStatsResponse` User profile statistics retrieved successfully
   */
  export namespace UserControllerGetProfileStats {
    export type RequestParams = {};
    export type RequestQuery = {
      /** User ID to get public profile stats. If not provided, returns own profile stats. */
      userId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ProfileStatsResponse;
  }

  /**
   * No description
   * @tags Users
   * @name UserControllerGetReferrals
   * @summary Get paginated list of referred users
   * @request GET:/api/users/referrals
   * @secure
   * @response `200` `PaginatedReferralsResponse` Referrals retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace UserControllerGetReferrals {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page number
       * @default "1"
       * @example "1"
       */
      page?: string;
      /**
       * Items per page
       * @default "20"
       * @example "20"
       */
      limit?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedReferralsResponse;
  }

  /**
   * No description
   * @tags Users
   * @name UserControllerGetReferralStats
   * @summary Get referral statistics (total referrals, earned credits, bonus progress)
   * @request GET:/api/users/referral-stats
   * @secure
   * @response `200` `ReferralStatsResponse` Referral statistics retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace UserControllerGetReferralStats {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ReferralStatsResponse;
  }

  /**
   * No description
   * @tags Users
   * @name UserControllerSavePreparedInlineMessage
   * @summary Save prepared inline message for sharing
   * @request POST:/api/users/save-prepared-inline-message
   * @secure
   * @response `200` `SavePreparedInlineMessageResponse` Prepared inline message saved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace UserControllerSavePreparedInlineMessage {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SavePreparedInlineMessage;
    export type RequestHeaders = {};
    export type ResponseBody = SavePreparedInlineMessageResponse;
  }

  /**
   * No description
   * @tags Users
   * @name UserControllerHealthCheck
   * @summary Health check endpoint
   * @request GET:/api/users/health
   * @response `200` `HealthCheckResponse` Service is healthy
   */
  export namespace UserControllerHealthCheck {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = HealthCheckResponse;
  }

  /**
   * No description
   * @tags Home
   * @name HomeControllerGetHome
   * @summary Всё содержимое главного экрана одним запросом
   * @request GET:/api/users/home
   * @secure
   * @response `200` `HomeSnapshot`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace HomeControllerGetHome {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = HomeSnapshot;
  }

  /**
   * No description
   * @tags Contracts
   * @name ContractsControllerExecuteContract
   * @summary Execute contract
   * @request POST:/api/users/contracts/execute
   * @secure
   * @response `200` `ContractResult` Contract executed successfully
   * @response `400` `void` Invalid contract parameters
   * @response `403` `void` Forbidden. User authentication required.
   * @response `404` `void` Items not found or not available
   */
  export namespace ContractsControllerExecuteContract {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ExecuteContract;
    export type RequestHeaders = {};
    export type ResponseBody = ContractResult;
  }

  /**
   * No description
   * @tags Contracts
   * @name ContractsControllerPreviewContract
   * @summary Preview contract price range
   * @request GET:/api/users/contracts/preview
   * @secure
   * @response `200` `ContractPreview` Contract preview calculated successfully
   * @response `400` `void` Invalid preview parameters
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ContractsControllerPreviewContract {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Array of inventory item IDs
       * @example ["uuid1","uuid2","uuid3"]
       */
      itemIds: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ContractPreview;
  }

  /**
   * No description
   * @tags Contracts
   * @name ContractsControllerGetContractHistory
   * @summary Get user contract history
   * @request GET:/api/users/contracts/history
   * @secure
   * @response `200` `ContractHistory` Contract history retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ContractsControllerGetContractHistory {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page number
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Items per page
       * @min 1
       * @default 20
       */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ContractHistory;
  }

  /**
   * @description Calculate the probability and coefficient for an upgrade before performing it
   * @tags Upgrades
   * @name UpgradeControllerCalculateProbability
   * @summary Calculate upgrade probability
   * @request POST:/api/users/upgrades/calculate-probability
   * @secure
   * @response `200` `UpgradeProbabilityResponse` Upgrade probability calculated successfully
   * @response `400` `void` Invalid input data
   * @response `403` `void` Forbidden. User authentication required.
   * @response `404` `void` Item not found
   */
  export namespace UpgradeControllerCalculateProbability {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CalculateProbability;
    export type RequestHeaders = {};
    export type ResponseBody = UpgradeProbabilityResponse;
  }

  /**
   * @description Upgrade one item to a more expensive item
   * @tags Upgrades
   * @name UpgradeControllerPerformItemUpgrade
   * @summary Perform item-to-item upgrade
   * @request POST:/api/users/upgrades/item-to-item
   * @secure
   * @response `201` `UpgradeResult` Upgrade performed successfully
   * @response `400` `void` Invalid upgrade parameters or insufficient item value
   * @response `403` `void` Forbidden. User authentication required.
   * @response `404` `void` Item not found or not owned
   */
  export namespace UpgradeControllerPerformItemUpgrade {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PerformItemUpgrade;
    export type RequestHeaders = {};
    export type ResponseBody = UpgradeResult;
  }

  /**
   * @description Get paginated list of user's upgrade history
   * @tags Upgrades
   * @name UpgradeControllerGetUpgradeHistory
   * @summary Get upgrade history
   * @request GET:/api/users/upgrades/history
   * @secure
   * @response `200` `UpgradeHistoryResponse` Upgrade history retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace UpgradeControllerGetUpgradeHistory {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page number
       * @min 1
       * @default 1
       * @example 1
       */
      page?: number;
      /**
       * Items per page
       * @min 1
       * @max 100
       * @default 20
       * @example 20
       */
      perPage?: number;
      /** Number of items to take (max 100) */
      take?: number;
      /** Number of items to skip */
      skip?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UpgradeHistoryResponse;
  }

  /**
   * @description Biggest winning multipliers for the Moscow day or month, one best upgrade per player
   * @tags Upgrades
   * @name UpgradeControllerGetUpgradeTop
   * @summary Get upgrade top
   * @request GET:/api/users/upgrades/top
   * @secure
   * @response `200` `UpgradeTopResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace UpgradeControllerGetUpgradeTop {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Период топа по московскому времени */
      period: UpgradeControllerGetUpgradeTopParams1PeriodEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UpgradeTopResponse;
  }

  /**
   * @description Get all available items that can be targeted for upgrade from a source item
   * @tags Upgrades
   * @name UpgradeControllerGetAvailableUpgradeTargets
   * @summary Get available upgrade targets
   * @request GET:/api/users/upgrades/available-targets/{sourceItemId}
   * @secure
   * @response `200` `AvailableUpgradeTargetsResponse` Available upgrade targets retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   * @response `404` `void` Source item not found
   */
  export namespace UpgradeControllerGetAvailableUpgradeTargets {
    export type RequestParams = {
      sourceItemId: string;
    };
    export type RequestQuery = {
      /**
       * Credits staked — the whole entry when there is no source item, or the amount added on top of one
       * @min 1
       */
      sourceAmount?: number;
      /** Search term for item name */
      searchTerm?: string;
      /** Order of targets */
      order?: UpgradeControllerGetAvailableUpgradeTargetsParams1OrderEnum;
      /**
       * Min success probability (0..1)
       * @min 0
       * @max 1
       */
      minProbability?: number;
      /**
       * Max success probability (0..1)
       * @min 0
       * @max 1
       */
      maxProbability?: number;
      /** Filter by item category */
      category?: string;
      /** Filter by item type */
      type?: string;
      /** Filter by weapon name */
      weapon?: string;
      /**
       * Page number (1-based)
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Number of items per page
       * @min 1
       * @max 100
       * @default 20
       */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AvailableUpgradeTargetsResponse;
  }

  /**
 * No description
 * @tags Promocodes
 * @name PromocodeControllerActivatePromocode
 * @summary Activate a promocode
 * @request POST:/api/users/promocodes/activate
 * @secure
 * @response `200` `{
    success?: boolean,
    buffId?: string,

}` Promocode activated successfully
 * @response `400` `void` Invalid promocode or user already has active buff
 * @response `403` `void` Forbidden. User authentication required.
 * @response `404` `void` Promocode not found
*/
  export namespace PromocodeControllerActivatePromocode {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ActivatePromocode;
    export type RequestHeaders = {};
    export type ResponseBody = {
      success?: boolean;
      buffId?: string;
    };
  }

  /**
   * No description
   * @tags Promocodes
   * @name PromocodeControllerGetActivePromocodeBuff
   * @summary Get active promocode buff for current user
   * @request GET:/api/users/promocodes/active-buff
   * @secure
   * @response `200` `(ActivePromocodeBuffResponse | null)` Active promocode buff (null if no active buff)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace PromocodeControllerGetActivePromocodeBuff {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ActivePromocodeBuffResponse | null;
  }

  /**
   * No description
   * @tags Promocodes
   * @name PromocodeControllerGetPromocodeHistory
   * @summary Get promocode usage history for current user
   * @request GET:/api/users/promocodes/history
   * @secure
   * @response `200` `PromocodeHistoryResponse` List of used promocodes
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace PromocodeControllerGetPromocodeHistory {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PromocodeHistoryResponse;
  }

  /**
   * No description
   * @tags Promocodes
   * @name PromocodeControllerGetGlobalPromocodeBuff
   * @summary Get active global promocode buff
   * @request GET:/api/users/promocodes/global-buff
   * @response `200` `(GlobalPromocodeBuffResponse | null)` Active global promocode buff (null if no active buff)
   */
  export namespace PromocodeControllerGetGlobalPromocodeBuff {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GlobalPromocodeBuffResponse | null;
  }

  /**
   * No description
   * @tags Wheel
   * @name WheelControllerGetWheelStatus
   * @summary Get wheel status for current user
   * @request GET:/api/users/wheel/status
   * @secure
   * @response `200` `WheelStatusResponse` Wheel status including available spins and segments
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace WheelControllerGetWheelStatus {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WheelStatusResponse;
  }

  /**
   * No description
   * @tags Wheel
   * @name WheelControllerSpinWheel
   * @summary Spin the wheel to get a promocode
   * @request POST:/api/users/wheel/spin
   * @secure
   * @response `200` `SpinWheelResponse` Wheel spun successfully
   * @response `400` `void` No spins available or active wheel promocode exists
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace WheelControllerSpinWheel {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SpinWheelResponse;
  }

  /**
   * No description
   * @tags Profile Task
   * @name ProfileTaskControllerActivateTask
   * @summary Activate specific profile task after user setup
   * @request POST:/api/users/profile-task/activate
   * @secure
   * @response `200` `void` Task activated successfully
   * @response `201` `void`
   * @response `400` `void` Validation failed or task already active
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ProfileTaskControllerActivateTask {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ActivateProfileTask;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Profile Task
   * @name ProfileTaskControllerActivateUsernameTask
   * @summary Activate username in lastName task
   * @request POST:/api/users/profile-task/activate-username
   * @secure
   * @response `200` `void` Username task activated successfully
   * @response `201` `void`
   * @response `400` `void` Validation failed or task already active
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ProfileTaskControllerActivateUsernameTask {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Profile Task
   * @name ProfileTaskControllerActivateBioTask
   * @summary Activate referral link in bio task
   * @request POST:/api/users/profile-task/activate-bio
   * @secure
   * @response `200` `void` Bio task activated successfully
   * @response `201` `void`
   * @response `400` `void` Validation failed or task already active
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ProfileTaskControllerActivateBioTask {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Profile Task
   * @name ProfileTaskControllerGetStatus
   * @summary Get user profile task status
   * @request GET:/api/users/profile-task/status
   * @secure
   * @response `200` `ProfileTaskStatusResponse` Profile task status for both tasks
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ProfileTaskControllerGetStatus {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ProfileTaskStatusResponse;
  }

  /**
   * No description
   * @tags Profile Task
   * @name ProfileTaskControllerClaimReward
   * @summary Claim daily profile task reward for specific task type
   * @request POST:/api/users/profile-task/claim-reward
   * @secure
   * @response `200` `void` Reward claimed successfully
   * @response `201` `void`
   * @response `400` `void` Reward not available
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ProfileTaskControllerClaimReward {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ClaimProfileTaskReward;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Profile Task
   * @name ProfileTaskControllerClaimUsernameReward
   * @summary Claim daily username task reward
   * @request POST:/api/users/profile-task/claim-username-reward
   * @secure
   * @response `200` `void` Username task reward claimed successfully
   * @response `201` `void`
   * @response `400` `void` Reward not available
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ProfileTaskControllerClaimUsernameReward {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Profile Task
   * @name ProfileTaskControllerClaimBioReward
   * @summary Claim daily bio task reward
   * @request POST:/api/users/profile-task/claim-bio-reward
   * @secure
   * @response `200` `void` Bio task reward claimed successfully
   * @response `201` `void`
   * @response `400` `void` Reward not available
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ProfileTaskControllerClaimBioReward {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Shop
   * @name ShopControllerGetShopItems
   * @summary Get shop items with filters
   * @request GET:/api/users/shop/items
   * @response `200` `GetShopItemsResponse` List of shop items
   */
  export namespace ShopControllerGetShopItems {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page number (1-based)
       * @min 1
       * @default 1
       * @example 1
       */
      page?: number;
      /**
       * Number of items per page
       * @min 1
       * @max 100
       * @default 20
       * @example 20
       */
      limit?: number;
      /**
       * Filter by exact hashName (single-item lookup)
       * @example "AK-47 | Redline (Field-Tested)"
       */
      hashName?: string;
      /**
       * Filter by category
       * @example "Rifle"
       */
      category?: string;
      /**
       * Filter by weapon
       * @example "AK-47"
       */
      weapon?: string;
      /**
       * Filter by skin name (part after | in item name)
       * @example "Asiimov"
       */
      skinName?: string;
      /**
       * Filter by type
       * @example "skin"
       */
      type?: ShopControllerGetShopItemsParams1TypeEnum;
      /**
       * Filter by wear condition (for skins)
       * @example "Factory New"
       */
      wear?: ShopControllerGetShopItemsParams1WearEnum;
      /**
       * Filter by rarity
       * @example "Classified"
       */
      rarity?: string;
      /**
       * Minimum price in credits
       * @min 25000
       * @example 25000
       */
      minPrice?: number;
      /**
       * Maximum price in credits
       * @min 25000
       * @example 100000
       */
      maxPrice?: number;
      /**
       * Filter by StatTrak
       * @example true
       */
      statTrak?: boolean;
      /**
       * Sort order
       * @default "volume_desc"
       * @example "volume_desc"
       */
      sortBy?: ShopControllerGetShopItemsParams1SortByEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetShopItemsResponse;
  }

  /**
   * No description
   * @tags Shop
   * @name ShopControllerGetShopSkins
   * @summary Get unique skins for a weapon
   * @request GET:/api/users/shop/skins
   * @response `200` `GetShopSkinsResponse` List of unique skins
   */
  export namespace ShopControllerGetShopSkins {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Weapon name to get skins for
       * @example "AK-47"
       */
      weapon: string;
      /**
       * Skin name pattern to filter by
       * @example "Asiimov"
       */
      skinName?: string;
      /**
       * Filter by rarity name
       * @example "Covert"
       */
      rarity?: string;
      /**
       * Minimum price in rubles
       * @example 100
       */
      minPrice?: number;
      /**
       * Maximum price in rubles
       * @example 1000
       */
      maxPrice?: number;
      /** Sort by field */
      sortBy?: GetShopSkinsSortBy;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetShopSkinsResponse;
  }

  /**
   * No description
   * @tags Shop
   * @name ShopControllerCreatePurchaseInvoice
   * @summary Create invoice for purchasing an item from the shop
   * @request POST:/api/users/shop/create-purchase-invoice
   * @secure
   * @response `200` `CreateShopPurchaseInvoiceResponse` Invoice created successfully
   * @response `400` `void` Item not available or invalid payment provider
   * @response `403` `void` Forbidden. User authentication required.
   * @response `404` `void` Item not found
   */
  export namespace ShopControllerCreatePurchaseInvoice {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateShopPurchaseInvoice;
    export type RequestHeaders = {
      "user-agent": string;
    };
    export type ResponseBody = CreateShopPurchaseInvoiceResponse;
  }

  /**
   * No description
   * @tags Shop
   * @name ShopControllerGetMyShopPurchases
   * @summary Get my shop purchase history
   * @request GET:/api/users/shop/purchases
   * @secure
   * @response `200` `UserShopPurchasesResponse` List of shop purchases
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ShopControllerGetMyShopPurchases {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @example 1 */
      page?: number;
      /** @example 20 */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UserShopPurchasesResponse;
  }

  /**
   * No description
   * @tags Cases
   * @name CaseControllerGetCaseOpenings
   * @summary Get user case opening history
   * @request GET:/api/users/case-openings
   * @secure
   * @response `200` `PaginatedCaseOpeningsResponse` Case openings retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseControllerGetCaseOpenings {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page number
       * @default "1"
       * @example "1"
       */
      page?: string;
      /**
       * Items per page
       * @default "20"
       * @example "20"
       */
      limit?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedCaseOpeningsResponse;
  }

  /**
   * No description
   * @tags Cases
   * @name CaseControllerGetCaseOpeningDetails
   * @summary Get details of a specific case opening
   * @request GET:/api/users/case-openings/{id}
   * @secure
   * @response `200` `CaseOpeningDetailsResponse` Case opening details retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseControllerGetCaseOpeningDetails {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseOpeningDetailsResponse;
  }

  /**
   * No description
   * @tags Cases
   * @name CaseControllerGetCases
   * @summary Get all available cases (public — no country/language filter)
   * @request GET:/api/users/cases
   * @response `200` `(CaseResponse)[]` Cases retrieved successfully
   */
  export namespace CaseControllerGetCases {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseResponse[];
  }

  /**
   * No description
   * @tags Cases
   * @name CaseControllerGetCatalog
   * @summary Cases screen catalog: all shop cases plus active categories with their cases
   * @request GET:/api/users/cases/catalog
   * @response `200` `CaseCatalogResponse` Catalog retrieved successfully
   */
  export namespace CaseControllerGetCatalog {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseCatalogResponse;
  }

  /**
   * No description
   * @tags Cases
   * @name CaseControllerGetUniversalCases
   * @summary Get universal cases without country/language restrictions (for battle creation)
   * @request GET:/api/users/cases/universal
   * @secure
   * @response `200` `(CaseResponse)[]` Universal cases retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseControllerGetUniversalCases {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseResponse[];
  }

  /**
   * No description
   * @tags Cases
   * @name CaseControllerGetCaseDetails
   * @summary Get case details
   * @request GET:/api/users/cases/{id}
   * @response `200` `CaseDetailsResponse` Case details retrieved successfully
   */
  export namespace CaseControllerGetCaseDetails {
    export type RequestParams = {
      /**
       * Case UUID or slug
       * @example "maracana"
       */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseDetailsResponse;
  }

  /**
   * No description
   * @tags Cases
   * @name CaseControllerOpenCase
   * @summary Open a case (count times, defaults to 1)
   * @request POST:/api/users/cases/{id}/open
   * @secure
   * @response `200` `(OpenCaseResponse)[]` Case opened successfully
   * @response `201` `(OpenCaseResponse)[]`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseControllerOpenCase {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = OpenCaseRequest;
    export type RequestHeaders = {};
    export type ResponseBody = OpenCaseResponse[];
  }

  /**
   * No description
   * @tags Inventory
   * @name InventoryControllerGetInventory
   * @summary Get user inventory with pagination
   * @request GET:/api/users/inventory
   * @secure
   * @response `200` `PaginatedInventoryResponse` Inventory retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace InventoryControllerGetInventory {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page number
       * @default "1"
       * @example "1"
       */
      page?: string;
      /**
       * Items per page
       * @default "20"
       * @example "20"
       */
      limit?: string;
      /**
       * Sort by field
       * @default "acquiredAt"
       */
      sortBy?: InventoryControllerGetInventoryParams1SortByEnum;
      /**
       * Sort order
       * @default "DESC"
       */
      sortOrder?: InventoryControllerGetInventoryParams1SortOrderEnum;
      /**
       * Filter by item statuses
       * @example ["AVAILABLE","SOLD"]
       */
      statuses?: InventoryControllerGetInventoryParams1StatusesEnum[];
      /**
       * Minimum price filter in credits
       * @example 1000
       */
      minPrice?: number;
      /**
       * Filter by item type
       * @example "skin"
       */
      type?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedInventoryResponse;
  }

  /**
   * No description
   * @tags Inventory
   * @name InventoryControllerGetInventoryItemDetails
   * @summary Get details of a specific inventory item (publicly viewable)
   * @request GET:/api/users/inventory/{id}
   * @response `200` `UserInventoryItemResponse` Item details retrieved successfully
   */
  export namespace InventoryControllerGetInventoryItemDetails {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UserInventoryItemResponse;
  }

  /**
   * No description
   * @tags Inventory
   * @name InventoryControllerSellInventoryItem
   * @summary Sell an item from inventory
   * @request POST:/api/users/inventory/{id}/sell
   * @secure
   * @response `200` `SellItemResponse` Item sold successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace InventoryControllerSellInventoryItem {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SellItemResponse;
  }

  /**
   * No description
   * @tags Inventory
   * @name InventoryControllerSellAllInventoryItems
   * @summary Sell all available items from inventory
   * @request POST:/api/users/inventory/sell-all
   * @secure
   * @response `200` `SellAllItemsResponse` All items sold successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace InventoryControllerSellAllInventoryItems {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SellAllItemsResponse;
  }

  /**
   * No description
   * @tags Inventory
   * @name InventoryControllerSellInventoryItems
   * @summary Sell selected items from inventory
   * @request POST:/api/users/inventory/sell-batch
   * @secure
   * @response `200` `SellAllItemsResponse` Selected items sold successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace InventoryControllerSellInventoryItems {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SellItems;
    export type RequestHeaders = {};
    export type ResponseBody = SellAllItemsResponse;
  }

  /**
   * No description
   * @tags Inventory
   * @name InventoryControllerGetRecentInventoryItems
   * @summary Get recent items from all users inventories (public)
   * @request GET:/api/users/inventory/recent
   * @response `200` `RecentItemsResponse` Recent items retrieved successfully
   */
  export namespace InventoryControllerGetRecentInventoryItems {
    export type RequestParams = {};
    export type RequestQuery = {
      limit: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RecentItemsResponse;
  }

  /**
   * No description
   * @tags Inventory
   * @name InventoryControllerGetTopRecentDrops
   * @summary Get top drops from the last 24 hours, sorted by price (public)
   * @request GET:/api/users/inventory/top-recent-drops
   * @response `200` `TopRecentDropsResponse` Top recent drops retrieved successfully
   */
  export namespace InventoryControllerGetTopRecentDrops {
    export type RequestParams = {};
    export type RequestQuery = {
      limit: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TopRecentDropsResponse;
  }

  /**
   * No description
   * @tags Inventory
   * @name InventoryControllerWithdrawItem
   * @summary Withdraw item from inventory to Steam
   * @request POST:/api/users/inventory/{id}/withdraw
   * @secure
   * @response `200` `WithdrawItemResponse` Trade initiated successfully
   * @response `201` `WithdrawItemResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace InventoryControllerWithdrawItem {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = WithdrawItem;
    export type RequestHeaders = {};
    export type ResponseBody = WithdrawItemResponse;
  }

  /**
   * No description
   * @tags Inventory
   * @name InventoryControllerUpdateTradeLink
   * @summary Update Steam trade link
   * @request PUT:/api/users/trade-link
   * @secure
   * @response `200` `UpdateTradeLinkResponse` Trade link updated successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace InventoryControllerUpdateTradeLink {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UpdateTradeLink;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateTradeLinkResponse;
  }

  /**
   * @description Returns the stored snapshot without waiting on Steam. Reading your own inventory also queues a refresh, throttled per user; `refreshing` says a newer snapshot is on its way, so poll until it clears. A snapshot only exists for users who linked Steam through OpenID.
   * @tags Steam Inventory
   * @name SteamInventoryControllerGetSteamInventory
   * @summary Last known CS2 inventory snapshot (own or public)
   * @request GET:/api/users/steam-inventory
   * @response `200` `SteamInventoryResponse` Snapshot returned
   */
  export namespace SteamInventoryControllerGetSteamInventory {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Whose inventory to read. Omit for your own. */
      userId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SteamInventoryResponse;
  }

  /**
   * @description Reads stored data only. Matches appear as `pending` right after their share code is discovered and get stats once the demo is parsed by the worker.
   * @tags CS2 Matches
   * @name Cs2MatchesControllerGetMatches
   * @summary CS2 match history link status and recent matches
   * @request GET:/api/users/cs2-matches
   * @secure
   * @response `200` `Cs2MatchesResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace Cs2MatchesControllerGetMatches {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Cs2MatchesResponse;
  }

  /**
   * @description Presence (in CS2 / on a server) is visible only for public profiles; the result is stored on the link if one exists.
   * @tags CS2 Matches
   * @name Cs2MatchesControllerCheckProfile
   * @summary Check whether the Steam profile is public
   * @request POST:/api/users/cs2-matches/check-profile
   * @secure
   * @response `201` `CheckCs2ProfileResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace Cs2MatchesControllerCheckProfile {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CheckCs2ProfileResponse;
  }

  /**
   * @description Requires a linked Steam account. Validates the codes against Steam once; 422 with rule `cs2_invalid_auth_code` / `cs2_invalid_share_code` / `cs2_steam_not_linked` on failure. Without `shareCode` the link stays `awaiting_share_code` and no matches are counted until it is added.
   * @tags CS2 Matches
   * @name Cs2MatchesControllerLink
   * @summary Connect CS2 match history
   * @request POST:/api/users/cs2-matches/link
   * @secure
   * @response `201` `LinkCs2MatchesResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace Cs2MatchesControllerLink {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = LinkCs2Matches;
    export type RequestHeaders = {};
    export type ResponseBody = LinkCs2MatchesResponse;
  }

  /**
   * No description
   * @tags CS2 Matches
   * @name Cs2MatchesControllerUnlink
   * @summary Disconnect CS2 match history; parsed matches are kept
   * @request DELETE:/api/users/cs2-matches/link
   * @secure
   * @response `200` `void`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace Cs2MatchesControllerUnlink {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description For links in `awaiting_share_code` or `invalid_code`. 422 with rule `cs2_invalid_share_code` when Steam rejects it.
   * @tags CS2 Matches
   * @name Cs2MatchesControllerSetShareCode
   * @summary Add or replace the match share code
   * @request POST:/api/users/cs2-matches/share-code
   * @secure
   * @response `201` `SetCs2ShareCodeResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace Cs2MatchesControllerSetShareCode {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetCs2ShareCode;
    export type RequestHeaders = {};
    export type ResponseBody = SetCs2ShareCodeResponse;
  }

  /**
   * @description One check per minute; 422 with rule `cs2_refresh_cooldown` and `retryAfterSec` otherwise.
   * @tags CS2 Matches
   * @name Cs2MatchesControllerRefresh
   * @summary Check for new matches now
   * @request POST:/api/users/cs2-matches/refresh
   * @secure
   * @response `201` `RefreshCs2MatchesResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace Cs2MatchesControllerRefresh {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RefreshCs2MatchesResponse;
  }

  /**
   * No description
   * @tags Payment
   * @name PaymentControllerCreateInvoice
   * @summary Create payment invoice
   * @request POST:/api/users/create-invoice
   * @secure
   * @response `200` `PaymentResponse` Invoice created successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace PaymentControllerCreateInvoice {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateInvoice;
    export type RequestHeaders = {
      "user-agent": string;
    };
    export type ResponseBody = PaymentResponse;
  }

  /**
   * No description
   * @tags Payment
   * @name PaymentControllerGetPaymentSettings
   * @summary Get payment settings
   * @request GET:/api/users/payment-settings
   * @secure
   * @response `200` `PaymentSettingsResponse` Payment settings retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace PaymentControllerGetPaymentSettings {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaymentSettingsResponse;
  }

  /**
   * No description
   * @tags Payment
   * @name PaymentControllerGetPaymentProviders
   * @summary Get payment providers (filtered + ordered for current user)
   * @request GET:/api/users/payment-providers
   * @secure
   * @response `200` `PaymentProvidersResponse` OK
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace PaymentControllerGetPaymentProviders {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      authorization: string;
    };
    export type ResponseBody = PaymentProvidersResponse;
  }

  /**
   * No description
   * @tags Payment
   * @name ClickCardControllerList
   * @summary List bound Click cards
   * @request GET:/api/users/click-cards
   * @secure
   * @response `200` `ClickCardListResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ClickCardControllerList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ClickCardListResponse;
  }

  /**
   * No description
   * @tags Payment
   * @name ClickCardControllerBind
   * @summary Bind a card — Click sends an SMS code
   * @request POST:/api/users/click-cards
   * @secure
   * @response `200` `BindClickCardResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ClickCardControllerBind {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BindClickCard;
    export type RequestHeaders = {};
    export type ResponseBody = BindClickCardResponse;
  }

  /**
   * No description
   * @tags Payment
   * @name ClickCardControllerVerify
   * @summary Confirm a bound card with the SMS code
   * @request POST:/api/users/click-cards/{id}/verify
   * @secure
   * @response `200` `ClickCardResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ClickCardControllerVerify {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = VerifyClickCard;
    export type RequestHeaders = {};
    export type ResponseBody = ClickCardResponse;
  }

  /**
   * No description
   * @tags Payment
   * @name ClickCardControllerPay
   * @summary Charge a bound card
   * @request POST:/api/users/click-cards/{id}/pay
   * @secure
   * @response `200` `PayWithClickCardResponse`
   * @response `403` `void` Forbidden. User authentication required.
   * @response `409` `void` A charge for this amount is already running
   */
  export namespace ClickCardControllerPay {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = PayWithClickCard;
    export type RequestHeaders = {
      "user-agent": string;
    };
    export type ResponseBody = PayWithClickCardResponse;
  }

  /**
   * No description
   * @tags Payment
   * @name ClickCardControllerRemove
   * @summary Remove a bound card
   * @request DELETE:/api/users/click-cards/{id}
   * @secure
   * @response `204` `void`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ClickCardControllerRemove {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Profile Settings
   * @name ProfileSettingsControllerUpdateAnimationSetting
   * @summary Update case opening animation setting
   * @request PUT:/api/users/animation-setting
   * @secure
   * @response `200` `UpdateAnimationSettingResponse` Animation setting updated successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ProfileSettingsControllerUpdateAnimationSetting {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UpdateAnimationSetting;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateAnimationSettingResponse;
  }

  /**
   * No description
   * @tags Profile Settings
   * @name ProfileSettingsControllerToggleNotifications
   * @summary Toggle notifications
   * @request PUT:/api/users/notifications
   * @secure
   * @response `200` `ToggleNotificationsResponse` Notifications setting updated successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ProfileSettingsControllerToggleNotifications {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ToggleNotifications;
    export type RequestHeaders = {};
    export type ResponseBody = ToggleNotificationsResponse;
  }

  /**
   * No description
   * @tags Profile Settings
   * @name ProfileSettingsControllerUpdateLanguage
   * @summary Update user language preference
   * @request PUT:/api/users/language
   * @secure
   * @response `200` `UpdateLanguageResponse` Language updated successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ProfileSettingsControllerUpdateLanguage {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UpdateLanguage;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateLanguageResponse;
  }

  /**
   * No description
   * @tags Home Tasks
   * @name HomeTasksControllerGetDailyBonusStatus
   * @summary Get daily bonus status
   * @request GET:/api/users/daily-bonus/status
   * @secure
   * @response `200` `DailyBonusStatusResponse` Daily bonus status retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace HomeTasksControllerGetDailyBonusStatus {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DailyBonusStatusResponse;
  }

  /**
   * No description
   * @tags Home Tasks
   * @name HomeTasksControllerClaimDailyBonus
   * @summary Claim daily bonus
   * @request POST:/api/users/daily-bonus/claim
   * @secure
   * @response `200` `ClaimDailyBonusResponse` Daily bonus claimed successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace HomeTasksControllerClaimDailyBonus {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ClaimDailyBonusResponse;
  }

  /**
   * No description
   * @tags Home Tasks
   * @name HomeTasksControllerCheckSubscription
   * @summary Check user subscription to all active Telegram channels and award bonuses
   * @request POST:/api/users/check-subscription
   * @secure
   * @response `204` `void` Subscription checks scheduled successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace HomeTasksControllerCheckSubscription {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Home Tasks
   * @name HomeTasksControllerGetSubscriptionChannels
   * @summary Get list of available subscription channels with user subscription status
   * @request GET:/api/users/subscription-channels
   * @secure
   * @response `200` `SubscriptionChannelsResponse` Subscription channels retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace HomeTasksControllerGetSubscriptionChannels {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SubscriptionChannelsResponse;
  }

  /**
   * No description
   * @tags Home Tasks
   * @name HomeTasksControllerGetComebackBonuses
   * @summary Get available comeback bonuses
   * @request GET:/api/users/comeback-bonus
   * @secure
   * @response `200` `ComebackBonusResponse` Comeback bonuses retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace HomeTasksControllerGetComebackBonuses {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ComebackBonusResponse;
  }

  /**
   * No description
   * @tags Home Tasks
   * @name HomeTasksControllerClaimComebackBonus
   * @summary Claim a comeback bonus
   * @request POST:/api/users/comeback-bonus/{id}/claim
   * @secure
   * @response `200` `ClaimComebackBonusResponse` Comeback bonus claimed successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace HomeTasksControllerClaimComebackBonus {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ClaimComebackBonusResponse;
  }

  /**
   * No description
   * @tags Home Tasks
   * @name HomeTasksControllerGetReferralBonusProgress
   * @summary Get progress towards next referral milestone bonus
   * @request GET:/api/users/referral-bonus-progress
   * @secure
   * @response `200` `ReferralBonusProgressResponse` Referral bonus progress retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace HomeTasksControllerGetReferralBonusProgress {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ReferralBonusProgressResponse;
  }

  /**
   * No description
   * @tags Home Tasks
   * @name HomeTasksControllerGetOnboardingConfig
   * @summary Get onboarding screen configuration (task rewards, referral bonuses, case prices)
   * @request GET:/api/users/onboarding-config
   * @secure
   * @response `200` `OnboardingConfigResponse` Onboarding configuration retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace HomeTasksControllerGetOnboardingConfig {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = OnboardingConfigResponse;
  }

  /**
   * No description
   * @tags Home Tasks
   * @name HomeTasksControllerGetBoostChannels
   * @summary Get list of boost channels with user status
   * @request GET:/api/users/boost-channels
   * @secure
   * @response `200` `BoostChannelsStatusResponse` Boost channels retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace HomeTasksControllerGetBoostChannels {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BoostChannelsStatusResponse;
  }

  /**
   * No description
   * @tags Home Tasks
   * @name HomeTasksControllerActivateBoost
   * @summary Activate boost for a channel (after user has boosted via Telegram)
   * @request POST:/api/users/boost-channels/{channelId}/activate
   * @secure
   * @response `200` `ActivateBoostResponse` Boost activated successfully
   * @response `400` `void` Validation failed or boost already active
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace HomeTasksControllerActivateBoost {
    export type RequestParams = {
      channelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ActivateBoostResponse;
  }

  /**
   * No description
   * @tags Home Tasks
   * @name HomeTasksControllerClaimBoostReward
   * @summary Claim daily boost reward
   * @request POST:/api/users/boost-channels/{channelId}/claim
   * @secure
   * @response `200` `ClaimBoostRewardResponse` Boost reward claimed successfully
   * @response `400` `void` Reward not available
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace HomeTasksControllerClaimBoostReward {
    export type RequestParams = {
      channelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ClaimBoostRewardResponse;
  }

  /**
   * No description
   * @tags Chicken Reward
   * @name ChickenRewardControllerTickChickenSpawn
   * @summary Probabilistic chicken spawn tick
   * @request POST:/api/users/chicken/tick
   * @secure
   * @response `200` `ChickenTickResponse` Chicken spawn tick evaluated
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ChickenRewardControllerTickChickenSpawn {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ChickenTickResponse;
  }

  /**
   * No description
   * @tags Chicken Reward
   * @name ChickenRewardControllerClaimChickenReward
   * @summary Claim chicken tap reward
   * @request POST:/api/users/chicken/claim
   * @secure
   * @response `200` `ClaimChickenRewardResponse` Chicken reward claimed successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ChickenRewardControllerClaimChickenReward {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ClaimChickenReward;
    export type RequestHeaders = {};
    export type ResponseBody = ClaimChickenRewardResponse;
  }

  /**
   * @description Resolves avatar via auth_identities: Telegram → Steam → placeholder.
   * @tags Avatar
   * @name AvatarControllerGetUserAvatar
   * @summary Get user avatar by userId
   * @request GET:/api/users/avatar/{userId}
   * @response `200` `void` User avatar image or gray placeholder
   */
  export namespace AvatarControllerGetUserAvatar {
    export type RequestParams = {
      /**
       * User UUID
       * @example "550e8400-e29b-41d4-a716-446655440000"
       */
      userId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags XP
   * @name XpControllerGetXpStatus
   * @summary Get user XP status
   * @request GET:/api/users/xp/status
   * @secure
   * @response `200` `XpStatusResponse` XP status retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace XpControllerGetXpStatus {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = XpStatusResponse;
  }

  /**
   * No description
   * @tags XP
   * @name XpControllerGetXpHistory
   * @summary Get user XP transaction history
   * @request GET:/api/users/xp/history
   * @secure
   * @response `200` `XpHistoryResponse` XP history retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace XpControllerGetXpHistory {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page number
       * @default "1"
       */
      page?: string;
      /**
       * Items per page
       * @default "20"
       */
      limit?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = XpHistoryResponse;
  }

  /**
   * No description
   * @tags XP
   * @name XpControllerGetXpConfig
   * @summary Get XP configuration
   * @request GET:/api/users/xp/config
   * @secure
   * @response `200` `XpConfigResponse` XP configuration retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace XpControllerGetXpConfig {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = XpConfigResponse;
  }

  /**
   * No description
   * @tags XP
   * @name XpControllerGetLevelBonusesStatus
   * @summary Get level bonuses status
   * @request GET:/api/users/xp/level-bonuses
   * @secure
   * @response `200` `LevelBonusesStatusResponse` Level bonuses status retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace XpControllerGetLevelBonusesStatus {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = LevelBonusesStatusResponse;
  }

  /**
   * No description
   * @tags XP
   * @name XpControllerClaimLevelBonus
   * @summary Claim level bonus
   * @request POST:/api/users/xp/level-bonuses/{level}/claim
   * @secure
   * @response `200` `ClaimLevelBonusResponse` Level bonus claimed successfully
   * @response `400` `void` Bonus already claimed, forfeit, or level not reached
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace XpControllerClaimLevelBonus {
    export type RequestParams = {
      /**
       * Level number to claim bonus for
       * @example 5
       */
      level: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ClaimLevelBonusResponse;
  }

  /**
   * No description
   * @tags XP
   * @name XpControllerGetXpLeaderboard
   * @summary Get XP leaderboard with pagination
   * @request GET:/api/users/xp/leaderboard
   * @secure
   * @response `200` `XpLeaderboardResponse` Leaderboard retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace XpControllerGetXpLeaderboard {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page number
       * @default "1"
       * @example "1"
       */
      page?: string;
      /**
       * Items per page (max 100)
       * @default "20"
       * @example "20"
       */
      limit?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = XpLeaderboardResponse;
  }

  /**
   * No description
   * @tags XP
   * @name XpControllerGetXpLeaderboardNeighbors
   * @summary Get neighboring users in XP leaderboard (3 above + current + 3 below = up to 7 users)
   * @request GET:/api/users/xp/leaderboard/neighbors
   * @secure
   * @response `200` `XpLeaderboardNeighborsResponse` Neighbors retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   * @response `404` `void` User not found
   */
  export namespace XpControllerGetXpLeaderboardNeighbors {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = XpLeaderboardNeighborsResponse;
  }

  /**
   * No description
   * @tags Draws
   * @name DrawsControllerGetActiveDraws
   * @summary Get active draws with user participation status
   * @request GET:/api/draws
   * @secure
   * @response `200` `ActiveDrawsResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace DrawsControllerGetActiveDraws {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ActiveDrawsResponse;
  }

  /**
   * No description
   * @tags Draws
   * @name DrawsControllerGetWinnersHistory
   * @summary Get draws winners history
   * @request GET:/api/draws/winners
   * @response `200` `(DrawWinner)[]`
   */
  export namespace DrawsControllerGetWinnersHistory {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Maximum number of winners to return */
      limit?: number;
      /** Filter by draw type */
      type?: DrawsControllerGetWinnersHistoryParams1TypeEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DrawWinner[];
  }

  /**
   * No description
   * @tags Draws
   * @name DrawsControllerGetDrawParticipants
   * @summary Get draw participants with pagination
   * @request GET:/api/draws/{id}/participants
   * @response `200` `DrawParticipants`
   */
  export namespace DrawsControllerGetDrawParticipants {
    export type RequestParams = {
      /** Draw ID */
      id: string;
    };
    export type RequestQuery = {
      /** Page number (default: 1) */
      page?: number;
      /** Items per page (default: 20) */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DrawParticipants;
  }

  /**
   * No description
   * @tags Draws
   * @name DrawsControllerBuyEntry
   * @summary Buy entry to a paid draw
   * @request POST:/api/draws/buy-entry
   * @secure
   * @response `200` `void` Successfully purchased draw entry
   * @response `400` `void` Insufficient balance, already participating, or draw is free
   * @response `403` `void` Forbidden. User authentication required.
   * @response `404` `void` No active draw found for the specified type
   */
  export namespace DrawsControllerBuyEntry {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BuyDrawEntry;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Giveaways
   * @name GiveawaysControllerGetGiveaway
   * @summary Get giveaway details with its case
   * @request GET:/api/giveaways/{id}
   * @response `200` `GiveawayDetailsResponse`
   * @response `404` `void` Giveaway not found
   */
  export namespace GiveawaysControllerGetGiveaway {
    export type RequestParams = {
      /** Giveaway ID */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GiveawayDetailsResponse;
  }

  /**
   * No description
   * @tags Giveaways
   * @name GiveawaysControllerGetParticipants
   * @summary Get giveaway participants with pagination
   * @request GET:/api/giveaways/{id}/participants
   * @response `200` `GiveawayParticipantsResponse`
   */
  export namespace GiveawaysControllerGetParticipants {
    export type RequestParams = {
      /** Giveaway ID */
      id: string;
    };
    export type RequestQuery = {
      /** Page number (default: 1) */
      page?: number;
      /** Items per page (default: 20) */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GiveawayParticipantsResponse;
  }

  /**
   * No description
   * @tags Giveaways
   * @name GiveawaysControllerJoin
   * @summary Join a giveaway
   * @request POST:/api/giveaways/{id}/join
   * @secure
   * @response `200` `JoinGiveawayResponse`
   * @response `400` `void` Giveaway expired or already completed
   * @response `403` `void` Forbidden. User authentication required.
   * @response `404` `void` Giveaway not found
   * @response `422` `void` Cannot participate (already participating, no trade URL, no deposit, IP/referral restriction)
   */
  export namespace GiveawaysControllerJoin {
    export type RequestParams = {
      /** Giveaway ID */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = JoinGiveawayResponse;
  }

  /**
   * No description
   * @tags Rains
   * @name RainsControllerGetCurrent
   * @summary The rain currently open for joining, or null
   * @request GET:/api/rains/current
   * @response `200` `CurrentRainResponse`
   */
  export namespace RainsControllerGetCurrent {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CurrentRainResponse;
  }

  /**
   * @description Rains that granted nothing — empty ones, and completed ones whose draw gates rejected every candidate — are left out: they would render as blank rows. The full picture across every status is in the admin listing.
   * @tags Rains
   * @name RainsControllerGetHistory
   * @summary Past rains that handed out a prize, newest first
   * @request GET:/api/rains/history
   * @response `200` `RainHistoryPage`
   */
  export namespace RainsControllerGetHistory {
    export type RequestParams = {};
    export type RequestQuery = {
      page?: number;
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RainHistoryPage;
  }

  /**
   * No description
   * @tags Rains
   * @name RainsControllerGetParticipants
   * @summary Paginated list of people in the rain
   * @request GET:/api/rains/{id}/participants
   * @response `200` `RainParticipantsPage`
   */
  export namespace RainsControllerGetParticipants {
    export type RequestParams = {
      /** Rain ID */
      id: string;
    };
    export type RequestQuery = {
      page?: number;
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RainParticipantsPage;
  }

  /**
   * No description
   * @tags Rains
   * @name RainsControllerGetById
   * @summary One rain in any status — live, finished or empty
   * @request GET:/api/rains/{id}
   * @response `200` `RainDetailResponse`
   */
  export namespace RainsControllerGetById {
    export type RequestParams = {
      /** Rain ID */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RainDetailResponse;
  }

  /**
   * No description
   * @tags Rains
   * @name RainsControllerJoin
   * @summary Join the rain
   * @request POST:/api/rains/{id}/join
   * @secure
   * @response `200` `JoinRainResponse`
   * @response `400` `void` Rain is not open for joining
   * @response `403` `void` Forbidden. User authentication required.
   * @response `404` `void` Rain not found
   * @response `422` `void` Cannot join (already joined, no trade URL, no deposit, IP/referral/multiacc restriction)
   */
  export namespace RainsControllerJoin {
    export type RequestParams = {
      /** Rain ID */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = JoinRainResponse;
  }

  /**
   * No description
   * @tags Daily Giveaways
   * @name DailyGiveawayControllerGetDailyGiveaways
   * @summary Get active daily giveaways (compact — for home cards)
   * @request GET:/api/users/daily-giveaways
   * @response `200` `DailyGiveawaysResponse`
   */
  export namespace DailyGiveawayControllerGetDailyGiveaways {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DailyGiveawaysResponse;
  }

  /**
   * No description
   * @tags Daily Giveaways
   * @name DailyGiveawayControllerGetDailyGiveawayDetails
   * @summary Get one daily giveaway header (prize, case, round, my place)
   * @request GET:/api/users/daily-giveaways/{id}
   * @response `200` `DailyGiveawayDetailResponse`
   * @response `404` `void` Daily giveaway not found
   */
  export namespace DailyGiveawayControllerGetDailyGiveawayDetails {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DailyGiveawayDetailResponse;
  }

  /**
   * No description
   * @tags Daily Giveaways
   * @name DailyGiveawayControllerGetLeaderboard
   * @summary Paginated leaderboard for the current round
   * @request GET:/api/users/daily-giveaways/{id}/leaderboard
   * @response `200` `DailyGiveawayLeaderboardPage`
   */
  export namespace DailyGiveawayControllerGetLeaderboard {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {
      page?: number;
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DailyGiveawayLeaderboardPage;
  }

  /**
   * No description
   * @tags Daily Giveaways
   * @name DailyGiveawayControllerGetWinners
   * @summary Paginated past winners
   * @request GET:/api/users/daily-giveaways/{id}/winners
   * @response `200` `DailyGiveawayWinnersPage`
   * @response `404` `void` Daily giveaway not found
   */
  export namespace DailyGiveawayControllerGetWinners {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {
      page?: number;
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DailyGiveawayWinnersPage;
  }

  /**
   * No description
   * @tags Referral Contest
   * @name ReferralContestControllerGetLeaderboard
   * @summary August referral contest leaderboard (top inviters by activated referrals)
   * @request GET:/api/users/referral-contest/leaderboard
   * @response `200` `ReferralContestLeaderboardResponse`
   */
  export namespace ReferralContestControllerGetLeaderboard {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Board entries to skip */
      offset?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ReferralContestLeaderboardResponse;
  }

  /**
   * @description Receives updates from Telegram when bot is in webhook mode
   * @tags Webhooks
   * @name WebhookControllerHandleTelegramUpdate
   * @summary Telegram bot webhook
   * @request POST:/api/webhooks/telegram
   * @response `200` `void` Update processed successfully
   * @response `403` `void` Invalid secret token
   */
  export namespace WebhookControllerHandleTelegramUpdate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      "x-telegram-bot-api-secret-token": string;
    };
    export type ResponseBody = void;
  }

  /**
   * @description Receives updates from Telegram for the support bot when in webhook mode
   * @tags Webhooks
   * @name WebhookControllerHandleSupportUpdate
   * @summary Support bot webhook
   * @request POST:/api/webhooks/support
   * @response `200` `void` Update processed successfully
   * @response `403` `void` Invalid secret token
   */
  export namespace WebhookControllerHandleSupportUpdate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      "x-telegram-bot-api-secret-token": string;
    };
    export type ResponseBody = void;
  }

  /**
   * @description Handles Skinsback payment notifications when user completes skin deposit
   * @tags Webhooks
   * @name WebhookControllerHandleSkinsbackWebhook
   * @summary Skinsback payment webhook
   * @request POST:/api/webhooks/payment/skinsback
   * @response `200` `void` Webhook processed successfully
   */
  export namespace WebhookControllerHandleSkinsbackWebhook {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Handles NOROS P2P payment notifications when user completes payment
   * @tags Webhooks
   * @name WebhookControllerHandleNorosP2PWebhook
   * @summary NOROS P2P payment webhook
   * @request POST:/api/webhooks/payment/noros-p2p
   * @response `200` `void` Webhook processed successfully
   */
  export namespace WebhookControllerHandleNorosP2PWebhook {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Handles Wata.pro SBP transaction notifications. Status is re-fetched from API for security.
   * @tags Webhooks
   * @name WebhookControllerHandleWataproSbpWebhook
   * @summary Wata.pro SBP payment webhook
   * @request POST:/api/webhooks/payment/watapro-sbp
   * @response `200` `void` Webhook processed successfully
   */
  export namespace WebhookControllerHandleWataproSbpWebhook {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Receives Safon session state-change notifications. Re-fetches authoritative state via API inside the provider, then dispatches ProcessPaymentWebhookCommand.
   * @tags Webhooks
   * @name WebhookControllerHandleSafonWebhook
   * @summary Safon payment webhook
   * @request POST:/api/webhooks/payment/safon
   * @response `200` `void` Webhook processed successfully
   */
  export namespace WebhookControllerHandleSafonWebhook {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Receives RioPay order state-change callbacks. Re-fetches authoritative state via API inside the provider, then dispatches ProcessPaymentWebhookCommand. Always answers 200 — RioPay fails the order when the callback is not acknowledged.
   * @tags Webhooks
   * @name WebhookControllerHandleRiopayWebhook
   * @summary RioPay SBP payment callback
   * @request POST:/api/webhooks/payment/riopay
   * @response `200` `void` Callback acknowledged
   */
  export namespace WebhookControllerHandleRiopayWebhook {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Receives Uzum acquiring callbacks. The body carries no signature, so the provider re-fetches the authoritative order state via getOrderStatus before crediting. Always answers 200 — Uzum retries otherwise.
   * @tags Webhooks
   * @name WebhookControllerHandleUzumWebhook
   * @summary Uzum Checkout payment callback
   * @request POST:/api/webhooks/payment/uzum
   * @response `200` `void` Callback acknowledged
   */
  export namespace WebhookControllerHandleUzumWebhook {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Receives 2328.io payment notifications. The body carries an HMAC sign, but the provider still re-fetches the authoritative state via /v1/payment/info before crediting. Always answers 200 — 2328 retries up to 5 times otherwise.
   * @tags Webhooks
   * @name WebhookControllerHandle2328Webhook
   * @summary 2328.io crypto payment webhook
   * @request POST:/api/webhooks/payment/2328
   * @response `200` `void` Webhook acknowledged
   */
  export namespace WebhookControllerHandle2328Webhook {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Receives EasyPay Stripe events. The HMAC signature is verified over the raw body before anything is dispatched; an unsigned or stale event is rejected with 401 (EasyPay does not retry 4xx and raises an internal alert instead).
   * @tags Webhooks
   * @name WebhookControllerHandleEasyPayWebhook
   * @summary EasyPay (Stripe USD) payment webhook
   * @request POST:/api/webhooks/payment/easypay
   * @response `200` `void` Webhook processed
   * @response `401` `void` Invalid signature
   */
  export namespace WebhookControllerHandleEasyPayWebhook {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Receives 1Payment status notifications. The md5 sign is verified over the received fields, then the authoritative state is re-fetched via status_payment before crediting. 1Payment retries once a minute for 10 minutes when the callback is not answered 200.
   * @tags Webhooks
   * @name WebhookControllerHandleOnePaymentWebhook
   * @summary 1Payment SBP payment callback
   * @request POST:/api/webhooks/payment/1payment
   * @response `200` `void` Callback processed successfully
   * @response `401` `void` Invalid signature
   */
  export namespace WebhookControllerHandleOnePaymentWebhook {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Click posts a urlencoded Prepare request to validate and reserve the order. The md5 sign_string is verified and a Click error-code envelope is returned.
   * @tags Webhooks
   * @name WebhookControllerHandleClickPrepare
   * @summary Click.uz SHOP API Prepare (action=0)
   * @request POST:/api/webhooks/payment/click/prepare
   * @response `200` `void` Prepare processed
   */
  export namespace WebhookControllerHandleClickPrepare {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Click posts a urlencoded Complete request confirming funds. The md5 sign_string is verified and, on success, the balance is credited via the shared payment chokepoint (idempotent under retries).
   * @tags Webhooks
   * @name WebhookControllerHandleClickComplete
   * @summary Click.uz SHOP API Complete (action=1)
   * @request POST:/api/webhooks/payment/click/complete
   * @response `200` `void` Complete processed
   */
  export namespace WebhookControllerHandleClickComplete {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Realtime
   * @name RealtimeControllerGetToken
   * @summary Get Centrifugo connection token
   * @request GET:/api/users/realtime/token
   * @secure
   * @response `200` `CentrifugoTokenResponse` Token generated successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RealtimeControllerGetToken {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CentrifugoTokenResponse;
  }

  /**
   * No description
   * @tags Realtime
   * @name RealtimeControllerHeartbeat
   * @summary Report current presence (online + activity)
   * @request POST:/api/users/realtime/heartbeat
   * @secure
   * @response `200` `HeartbeatResponse` Heartbeat recorded
   * @response `201` `HeartbeatResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RealtimeControllerHeartbeat {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = HeartbeatRequest;
    export type RequestHeaders = {};
    export type ResponseBody = HeartbeatResponse;
  }

  /**
   * No description
   * @tags Realtime
   * @name RealtimeControllerGetOnlineCount
   * @summary Get online users count (public)
   * @request GET:/api/users/realtime/online
   * @response `200` `OnlineCountResponse` Online count retrieved
   */
  export namespace RealtimeControllerGetOnlineCount {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = OnlineCountResponse;
  }

  /**
   * @description Read-only token limited to drops_feed, online_count and game_stats channels
   * @tags Realtime
   * @name RealtimeControllerGetPublicToken
   * @summary Anonymous Centrifugo connection token (public channels only)
   * @request GET:/api/users/realtime/public-token
   * @response `200` `CentrifugoTokenResponse` Anonymous token generated
   */
  export namespace RealtimeControllerGetPublicToken {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CentrifugoTokenResponse;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerCreateCaseBattle
   * @summary Create a new case battle
   * @request POST:/api/users/case-battles
   * @secure
   * @response `201` `CreateCaseBattleResponse` Case battle created successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseBattleControllerCreateCaseBattle {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateCaseBattleRequest;
    export type RequestHeaders = {};
    export type ResponseBody = CreateCaseBattleResponse;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerGetActiveCaseBattles
   * @summary Lobby: waiting and running case battles
   * @request GET:/api/users/case-battles
   * @response `200` `CaseBattleListResponse`
   */
  export namespace CaseBattleControllerGetActiveCaseBattles {
    export type RequestParams = {};
    export type RequestQuery = {
      /** 2 | 3 | 4 */
      players?: number;
      /** Only 2×2 (true) or only free-for-all (false) */
      team?: boolean;
      /** Only battles the viewer can afford */
      affordable?: boolean;
      sort?: CaseBattleLobbySort;
      mode?: CaseBattleLobbyMode[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseBattleListResponse;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerGetConfig
   * @summary Case battle limits and timings
   * @request GET:/api/users/case-battles/config
   * @response `200` `CaseBattleConfigResponse`
   */
  export namespace CaseBattleControllerGetConfig {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseBattleConfigResponse;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerGetTemplates
   * @summary Battle templates: saved, recent, recommended
   * @request GET:/api/users/case-battles/templates
   * @secure
   * @response `200` `CaseBattleTemplatesResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseBattleControllerGetTemplates {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseBattleTemplatesResponse;
  }

  /**
 * No description
 * @tags Case Battles
 * @name CaseBattleControllerSaveTemplate
 * @summary Save a battle template
 * @request POST:/api/users/case-battles/templates
 * @secure
 * @response `201` `{
    templateId?: string,

}` Template id
 * @response `403` `void` Forbidden. User authentication required.
*/
  export namespace CaseBattleControllerSaveTemplate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SaveCaseBattleTemplateRequest;
    export type RequestHeaders = {};
    export type ResponseBody = {
      templateId?: string;
    };
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerDeleteTemplate
   * @summary Delete a saved battle template
   * @request DELETE:/api/users/case-battles/templates/{id}
   * @secure
   * @response `200` `void`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseBattleControllerDeleteTemplate {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerGetUserActiveBattlesCount
   * @summary Get user active battles count
   * @request GET:/api/users/case-battles/me/active-count
   * @secure
   * @response `200` `UserActiveBattlesCountResponse` User active battles count retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseBattleControllerGetUserActiveBattlesCount {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UserActiveBattlesCountResponse;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerGetAllCaseBattleHistory
   * @summary Get all completed case battles history
   * @request GET:/api/users/case-battles/history/all
   * @response `200` `CaseBattleHistoryPaginatedResponse` All case battles history retrieved successfully
   */
  export namespace CaseBattleControllerGetAllCaseBattleHistory {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Number of battles to skip */
      skip?: number;
      /** Number of battles to take */
      take?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseBattleHistoryPaginatedResponse;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerGetUserCaseBattleHistory
   * @summary Get user case battle history
   * @request GET:/api/users/case-battles/history
   * @secure
   * @response `200` `CaseBattleHistoryPaginatedResponse` Case battle history retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseBattleControllerGetUserCaseBattleHistory {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Number of battles to skip */
      skip?: number;
      /** Number of battles to take */
      take?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseBattleHistoryPaginatedResponse;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerGetCaseBattleDetails
   * @summary Get case battle details
   * @request GET:/api/users/case-battles/{id}
   * @response `200` `CaseBattleDetailsResponse` Case battle details retrieved successfully
   */
  export namespace CaseBattleControllerGetCaseBattleDetails {
    export type RequestParams = {
      /** Case battle ID */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseBattleDetailsResponse;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerGetViewers
   * @summary Who plays and who is watching
   * @request GET:/api/users/case-battles/{id}/viewers
   * @response `200` `CaseBattleViewersResponse`
   */
  export namespace CaseBattleControllerGetViewers {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseBattleViewersResponse;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerJoinCaseBattle
   * @summary Join a case battle
   * @request POST:/api/users/case-battles/{id}/join
   * @secure
   * @response `200` `void` Successfully joined the case battle
   * @response `201` `void`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseBattleControllerJoinCaseBattle {
    export type RequestParams = {
      /** Case battle ID */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = JoinCaseBattleRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerLeaveCaseBattle
   * @summary Leave a case battle
   * @request POST:/api/users/case-battles/{id}/leave
   * @secure
   * @response `200` `void` Successfully left the case battle
   * @response `201` `void`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseBattleControllerLeaveCaseBattle {
    export type RequestParams = {
      /** Case battle ID */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerStartNow
   * @summary Ready to start without waiting for a full roster; starts when every seated player is ready
   * @request POST:/api/users/case-battles/{id}/start-now
   * @secure
   * @response `201` `void`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseBattleControllerStartNow {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = StartNowCaseBattleRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerRematch
   * @summary Start a rematch: same setup, invites to the other players
   * @request POST:/api/users/case-battles/{id}/rematch
   * @secure
   * @response `201` `RematchCaseBattleResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseBattleControllerRematch {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RematchCaseBattleResponse;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerAcceptRematch
   * @summary Accept a rematch invite (joins the rematch battle)
   * @request POST:/api/users/case-battles/{id}/rematch/accept
   * @secure
   * @response `201` `RematchCaseBattleResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseBattleControllerAcceptRematch {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RematchCaseBattleResponse;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerDeclineRematch
   * @summary Decline a rematch invite
   * @request POST:/api/users/case-battles/{id}/rematch/decline
   * @secure
   * @response `201` `RematchCaseBattleResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseBattleControllerDeclineRematch {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RematchCaseBattleResponse;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerSellAll
   * @summary Sell every item won in this battle
   * @request POST:/api/users/case-battles/{id}/sell-all
   * @secure
   * @response `201` `SellAllCaseBattleResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseBattleControllerSellAll {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SellAllCaseBattleResponse;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerReact
   * @summary Send a reaction to everyone watching the battle
   * @request POST:/api/users/case-battles/{id}/reactions
   * @secure
   * @response `201` `void`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseBattleControllerReact {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = ReactCaseBattleRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerView
   * @summary Mark the viewer as watching (repeat every 30 s)
   * @request POST:/api/users/case-battles/{id}/view
   * @secure
   * @response `201` `CaseBattleViewersCountResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseBattleControllerView {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseBattleViewersCountResponse;
  }

  /**
   * No description
   * @tags Case Battles
   * @name CaseBattleControllerLeaveView
   * @summary Viewer closed the battle
   * @request POST:/api/users/case-battles/{id}/view/leave
   * @secure
   * @response `201` `CaseBattleViewersCountResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace CaseBattleControllerLeaveView {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseBattleViewersCountResponse;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerGetConfig
   * @summary Per-user Rush Mid availability (comingSoon = tease the tile, refuse entry)
   * @request GET:/api/users/rush-mid/config
   * @secure
   * @response `200` `RushMidConfigResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerGetConfig {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidConfigResponse;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerCreateOpenGame
   * @summary Create an open game on a side (matchMode 'bots' = solo/party practice — no stake, not listed). When the caller is in a party the ticket/mode/side come from the RATIFIED party row, not the request body — the request config only applies to a solo.
   * @request POST:/api/users/rush-mid/games
   * @secure
   * @response `201` `RushMidSnapshot` Snapshot (OPEN, or BUYING for a bots practice game)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerCreateOpenGame {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateOpenGameRequest;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerListOpenGames
   * @summary List every public open (FORMING) game, newest first
   * @request GET:/api/users/rush-mid/games
   * @secure
   * @response `200` `OpenGamesListResponse` Open games list
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerListOpenGames {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = OpenGamesListResponse;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerListLiveGames
   * @summary List every live (PLAYING) match — the «Идут сейчас» spectate list, newest first
   * @request GET:/api/users/rush-mid/games/live
   * @secure
   * @response `200` `LiveGamesListResponse` Live games list
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerListLiveGames {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = LiveGamesListResponse;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerGetOpenGame
   * @summary One open game by id (404 once it fills, starts or closes)
   * @request GET:/api/users/rush-mid/games/{id}
   * @secure
   * @response `200` `OpenGame` Open game
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerGetOpenGame {
    export type RequestParams = {
      /** Match id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = OpenGame;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerWatchGame
   * @summary Read-only spectator view of a live match (PLAYING/OVER; 404 while BUYING/not started or once gone)
   * @request GET:/api/users/rush-mid/games/{id}/watch
   * @secure
   * @response `200` `RushMidSpectateView` Spectator view
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerWatchGame {
    export type RequestParams = {
      /** Match id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSpectateView;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerJoinOpenGame
   * @summary Join an open game on a side
   * @request POST:/api/users/rush-mid/games/{id}/join
   * @secure
   * @response `201` `RushMidSnapshot` Snapshot (OPEN, or BUYING if the join fills the house)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerJoinOpenGame {
    export type RequestParams = {
      /** Match id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = JoinOpenGameRequest;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerLeaveOpenGame
   * @summary Leave the open game (party leader takes the whole party out)
   * @request POST:/api/users/rush-mid/games/leave
   * @secure
   * @response `201` `RushMidSnapshot` Snapshot (NONE)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerLeaveOpenGame {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerCreateParty
   * @summary Create a party (caller becomes leader); returns the PARTY snapshot + code
   * @request POST:/api/users/rush-mid/party/create
   * @secure
   * @response `201` `RushMidSnapshot` Snapshot (PARTY)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerCreateParty {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerJoinParty
   * @summary Join a party by its secret code
   * @request POST:/api/users/rush-mid/party/join
   * @secure
   * @response `201` `RushMidSnapshot` Snapshot (PARTY)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerJoinParty {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PartyJoinRequest;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerConfigParty
   * @summary Leader-only: set party mode/ticket/side (mode must fit the party size)
   * @request POST:/api/users/rush-mid/party/config
   * @secure
   * @response `201` `RushMidSnapshot` Snapshot (PARTY)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerConfigParty {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PartyConfigRequest;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerLeaveParty
   * @summary Leave the current party — individual for every role (leader hands off to the freshest survivor); frees the leaver's waiting-game seat with a refund
   * @request POST:/api/users/rush-mid/party/leave
   * @secure
   * @response `201` `RushMidSnapshot` Snapshot (NONE)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerLeaveParty {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerKickParty
   * @summary Leader-only: remove a member from the party (FORMING only)
   * @request POST:/api/users/rush-mid/party/kick
   * @secure
   * @response `201` `RushMidSnapshot` Snapshot (PARTY)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerKickParty {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PartyKickRequest;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerSetPartyReady
   * @summary Toggle your own ready flag in the party (leader starts once all ready)
   * @request POST:/api/users/rush-mid/party/ready
   * @secure
   * @response `201` `RushMidSnapshot` Snapshot (PARTY)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerSetPartyReady {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PartyReadyRequest;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerSubmitLoadout
   * @summary Submit this player loadout for a match (starts when all players are ready)
   * @request POST:/api/users/rush-mid/match/{id}/loadout
   * @secure
   * @response `201` `RushMidSnapshot` Snapshot (BUYING / PLAYING)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerSubmitLoadout {
    export type RequestParams = {
      /** Match id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = SubmitLoadoutRequest;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerSubmitAction
   * @summary Submit this player action for the current round (shoot / grenade / medkit)
   * @request POST:/api/users/rush-mid/match/{id}/action
   * @secure
   * @response `201` `RushMidSnapshot` Snapshot (current/next PLAYING round, or OVER)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerSubmitAction {
    export type RequestParams = {
      /** Match id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = SubmitActionRequest;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerLeaveMatch
   * @summary Dismiss a FINISHED match result screen (a live match cannot be left — an absent player is auto-piloted and settles normally)
   * @request POST:/api/users/rush-mid/match/{id}/leave
   * @secure
   * @response `201` `RushMidSnapshot` Snapshot (NONE)
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerLeaveMatch {
    export type RequestParams = {
      /** Match id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerSnapshot
   * @summary Poll the user's current Rush Mid snapshot (single source of truth)
   * @request GET:/api/users/rush-mid/snapshot
   * @secure
   * @response `200` `RushMidSnapshot` Snapshot
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerSnapshot {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSnapshot;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerHistory
   * @summary Get the current user recent Rush Mid matches
   * @request GET:/api/users/rush-mid/history
   * @secure
   * @response `200` `RushMidHistoryResponse` Rush Mid history retrieved successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerHistory {
    export type RequestParams = {};
    export type RequestQuery = {
      skip?: number;
      take?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidHistoryResponse;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerRating
   * @summary The caller's ELO rating + top-50 leaderboard for a mode
   * @request GET:/api/users/rush-mid/rating
   * @secure
   * @response `200` `RushMidRatingResponse` Rating + leaderboard retrieved
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerRating {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Team size (1/2/5); defaults to 1 */
      mode?: RushMidControllerRatingParams1ModeEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidRatingResponse;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerGetSkins
   * @summary The user's saved fighter skin per side (to prefill the lobby picker)
   * @request GET:/api/users/rush-mid/skins
   * @secure
   * @response `200` `RushMidSkinsResponse` Saved skins per side
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerGetSkins {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidSkinsResponse;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerSaveLobbyConfig
   * @summary Persist the solo lobby config (ticket/mode/side/matchMode) on every change, so the lobby restores it on reopen
   * @request POST:/api/users/rush-mid/lobby-config
   * @secure
   * @response `200` `void` saved
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerSaveLobbyConfig {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = JoinMatchmakingRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerSetSkin
   * @summary Save the chosen fighter skin for one side (t / ct)
   * @request PUT:/api/users/rush-mid/skin
   * @secure
   * @response `200` `void` Skin saved
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerSetSkin {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetRushMidSkinRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerSetWeaponSkin
   * @summary Put on (or take off) a weapon skin for one weapon key
   * @request PUT:/api/users/rush-mid/weapon-skin
   * @secure
   * @response `200` `void` Weapon skin saved
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerSetWeaponSkin {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetRushMidWeaponSkinRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerMatchDetail
   * @summary Full detail + replay of one of the user's past matches
   * @request GET:/api/users/rush-mid/match/{id}/detail
   * @secure
   * @response `200` `RushMidMatchDetail` Match detail retrieved
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerMatchDetail {
    export type RequestParams = {
      /** Match id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidMatchDetail;
  }

  /**
   * No description
   * @tags Rush Mid
   * @name RushMidControllerReplay
   * @summary Shareable replay of any finished match (any signed-in user)
   * @request GET:/api/users/rush-mid/replay/{id}
   * @secure
   * @response `200` `RushMidReplay` Replay retrieved
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushMidControllerReplay {
    export type RequestParams = {
      /** Match id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushMidReplay;
  }

  /**
   * No description
   * @tags Arena
   * @name ArenaControllerCosmetics
   * @request GET:/api/users/arena/cosmetics
   * @secure
   * @response `200` `ArenaCosmeticsResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ArenaControllerCosmetics {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ArenaCosmeticsResponse;
  }

  /**
   * No description
   * @tags Arena
   * @name ArenaControllerSetFighter
   * @request POST:/api/users/arena/cosmetics
   * @secure
   * @response `201` `ArenaCosmeticsResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ArenaControllerSetFighter {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetArenaFighter;
    export type RequestHeaders = {};
    export type ResponseBody = ArenaCosmeticsResponse;
  }

  /**
   * No description
   * @tags Arena
   * @name ArenaControllerGames
   * @request GET:/api/users/arena/games
   * @secure
   * @response `200` `ArenaGames`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ArenaControllerGames {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ArenaGames;
  }

  /**
   * No description
   * @tags Arena
   * @name ArenaControllerCreate
   * @request POST:/api/users/arena/games
   * @secure
   * @response `201` `ArenaSnapshot`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ArenaControllerCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ArenaCreateGame;
    export type RequestHeaders = {};
    export type ResponseBody = ArenaSnapshot;
  }

  /**
   * No description
   * @tags Arena
   * @name ArenaControllerLiveGames
   * @request GET:/api/users/arena/games/live
   * @secure
   * @response `200` `ArenaGames`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ArenaControllerLiveGames {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ArenaGames;
  }

  /**
   * No description
   * @tags Arena
   * @name ArenaControllerJoin
   * @request POST:/api/users/arena/games/{id}/join
   * @secure
   * @response `201` `ArenaSnapshot`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ArenaControllerJoin {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = ArenaJoinGame;
    export type RequestHeaders = {};
    export type ResponseBody = ArenaSnapshot;
  }

  /**
   * No description
   * @tags Arena
   * @name ArenaControllerLeave
   * @request POST:/api/users/arena/games/{id}/leave
   * @secure
   * @response `201` `ArenaLeave`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ArenaControllerLeave {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ArenaLeave;
  }

  /**
   * No description
   * @tags Arena
   * @name ArenaControllerSnapshot
   * @request GET:/api/users/arena/matches/{id}/snapshot
   * @secure
   * @response `200` `ArenaSnapshot`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ArenaControllerSnapshot {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ArenaSnapshot;
  }

  /**
   * No description
   * @tags Arena
   * @name ArenaControllerTicket
   * @request POST:/api/users/arena/matches/{id}/ticket
   * @secure
   * @response `201` `ArenaTicket`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ArenaControllerTicket {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ArenaTicket;
  }

  /**
   * No description
   * @tags Arena
   * @name ArenaControllerHistory
   * @request GET:/api/users/arena/history
   * @secure
   * @response `200` `ArenaHistory`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ArenaControllerHistory {
    export type RequestParams = {};
    export type RequestQuery = {
      skip: string;
      take: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ArenaHistory;
  }

  /**
   * No description
   * @tags Arena
   * @name ArenaControllerDetail
   * @request GET:/api/users/arena/matches/{id}/detail
   * @secure
   * @response `200` `ArenaDetail`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ArenaControllerDetail {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ArenaDetail;
  }

  /**
   * No description
   * @tags Arena
   * @name ArenaControllerRating
   * @request GET:/api/users/arena/rating
   * @secure
   * @response `200` `ArenaRatings`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ArenaControllerRating {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @default 1 */
      mode?: ArenaControllerRatingParams1ModeEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ArenaRatings;
  }

  /**
   * No description
   * @tags Arena
   * @name ArenaControllerConfig
   * @request GET:/api/users/arena/config
   * @secure
   * @response `200` `ArenaConfig`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ArenaControllerConfig {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ArenaConfig;
  }

  /**
   * No description
   * @tags Arena
   * @name ArenaPartyControllerCreate
   * @request POST:/api/users/arena/party/create
   * @secure
   * @response `201` `ArenaPartySnapshot`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ArenaPartyControllerCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ArenaPartySnapshot;
  }

  /**
   * No description
   * @tags Arena
   * @name ArenaPartyControllerJoin
   * @request POST:/api/users/arena/party/join
   * @secure
   * @response `201` `ArenaPartySnapshot`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ArenaPartyControllerJoin {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ArenaPartyJoin;
    export type RequestHeaders = {};
    export type ResponseBody = ArenaPartySnapshot;
  }

  /**
   * No description
   * @tags Arena
   * @name ArenaPartyControllerReady
   * @request POST:/api/users/arena/party/ready
   * @secure
   * @response `201` `ArenaPartySnapshot`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ArenaPartyControllerReady {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ArenaPartyReady;
    export type RequestHeaders = {};
    export type ResponseBody = ArenaPartySnapshot;
  }

  /**
   * No description
   * @tags Arena
   * @name ArenaPartyControllerKick
   * @request POST:/api/users/arena/party/kick
   * @secure
   * @response `201` `ArenaPartySnapshot`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ArenaPartyControllerKick {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ArenaPartyKick;
    export type RequestHeaders = {};
    export type ResponseBody = ArenaPartySnapshot;
  }

  /**
   * No description
   * @tags Arena
   * @name ArenaPartyControllerLeave
   * @request POST:/api/users/arena/party/leave
   * @secure
   * @response `201` `ArenaNoParty`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ArenaPartyControllerLeave {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ArenaNoParty;
  }

  /**
   * No description
   * @tags Arena
   * @name ArenaPartyControllerMy
   * @request GET:/api/users/arena/party/my
   * @secure
   * @response `200` `(ArenaPartySnapshot | ArenaNoParty)`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace ArenaPartyControllerMy {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ArenaPartySnapshot | ArenaNoParty;
  }

  /**
   * No description
   * @tags Arena internal
   * @name ArenaInternalControllerStarted
   * @request POST:/api/internal/arena/matches/{id}/started
   * @response `201` `ArenaReportAck`
   */
  export namespace ArenaInternalControllerStarted {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = ArenaStartedReport;
    export type RequestHeaders = {
      "x-arena-signature": string;
    };
    export type ResponseBody = ArenaReportAck;
  }

  /**
   * No description
   * @tags Arena internal
   * @name ArenaInternalControllerProgress
   * @request POST:/api/internal/arena/matches/{id}/progress
   * @response `201` `ArenaReportAck`
   */
  export namespace ArenaInternalControllerProgress {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = ArenaProgressReport;
    export type RequestHeaders = {
      "x-arena-signature": string;
    };
    export type ResponseBody = ArenaReportAck;
  }

  /**
   * No description
   * @tags Arena internal
   * @name ArenaInternalControllerResult
   * @request POST:/api/internal/arena/matches/{id}/result
   * @response `201` `ArenaReportAck`
   */
  export namespace ArenaInternalControllerResult {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = ArenaResultReport;
    export type RequestHeaders = {
      "x-arena-signature": string;
    };
    export type ResponseBody = ArenaReportAck;
  }

  /**
   * No description
   * @tags Roulette
   * @name RouletteControllerGames
   * @summary Ticket presets plus every live game (OPEN + COUNTDOWN) with its stake, seats and bullets
   * @request GET:/api/users/roulette/games
   * @secure
   * @response `200` `RouletteGames`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RouletteControllerGames {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RouletteGames;
  }

  /**
   * No description
   * @tags Roulette
   * @name RouletteControllerCreateGame
   * @summary Create a game with your own ticket, seats and bullets — or seat into an OPEN game with identical parameters
   * @request POST:/api/users/roulette/games
   * @secure
   * @response `201` `RouletteState`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RouletteControllerCreateGame {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RouletteCreateGameRequest;
    export type RequestHeaders = {};
    export type ResponseBody = RouletteState;
  }

  /**
   * No description
   * @tags Roulette
   * @name RouletteControllerJoinGame
   * @summary Join THIS specific game (debits the stake) — refused if full, started or the caller is already seated
   * @request POST:/api/users/roulette/games/{id}/join
   * @secure
   * @response `201` `RouletteState`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RouletteControllerJoinGame {
    export type RequestParams = {
      /** Match (game) id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RouletteState;
  }

  /**
   * No description
   * @tags Roulette
   * @name RouletteControllerLeaveGame
   * @summary Leave a filling lobby (refunds the stake) — refused once the house is full or the game is live
   * @request POST:/api/users/roulette/games/leave
   * @secure
   * @response `201` `RouletteState`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RouletteControllerLeaveGame {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RouletteState;
  }

  /**
   * No description
   * @tags Roulette
   * @name RouletteControllerState
   * @summary Poll the caller's current roulette status: none | match (lobby, countdown or live game)
   * @request GET:/api/users/roulette/state
   * @secure
   * @response `200` `RouletteState`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RouletteControllerState {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RouletteState;
  }

  /**
   * No description
   * @tags Roulette
   * @name RouletteControllerMatch
   * @summary A match snapshot — never leaks the server seed, bullet positions or event log before FINISHED/CANCELLED
   * @request GET:/api/users/roulette/matches/{id}
   * @secure
   * @response `200` `RouletteMatch`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RouletteControllerMatch {
    export type RequestParams = {
      /** Match id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RouletteMatch;
  }

  /**
   * No description
   * @tags Roulette
   * @name RouletteControllerPull
   * @summary Pull the trigger — only the current shooter may call this
   * @request POST:/api/users/roulette/matches/{id}/pull
   * @secure
   * @response `201` `RouletteMatch`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RouletteControllerPull {
    export type RequestParams = {
      /** Match id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RouletteMatch;
  }

  /**
   * No description
   * @tags Roulette
   * @name RouletteControllerSkip
   * @summary Skip your turn (debits the skip cost) — only the current shooter, within the per-player limit
   * @request POST:/api/users/roulette/matches/{id}/skip
   * @secure
   * @response `201` `RouletteMatch`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RouletteControllerSkip {
    export type RequestParams = {
      /** Match id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RouletteMatch;
  }

  /**
   * No description
   * @tags Roulette
   * @name RouletteControllerHistory
   * @summary My finished/cancelled matches, newest first
   * @request GET:/api/users/roulette/history
   * @secure
   * @response `200` `RouletteHistoryResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RouletteControllerHistory {
    export type RequestParams = {};
    export type RequestQuery = {
      limit?: number;
      /** Opaque cursor from a previous page's nextCursor */
      cursor?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RouletteHistoryResponse;
  }

  /**
   * No description
   * @tags Roulette
   * @name RouletteControllerFeed
   * @summary Global feed of every player's finished matches, newest first — headline winner + the skin they won
   * @request GET:/api/users/roulette/feed
   * @secure
   * @response `200` `RouletteFeedResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RouletteControllerFeed {
    export type RequestParams = {};
    export type RequestQuery = {
      limit?: number;
      /** Opaque cursor from a previous page's nextCursor */
      cursor?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RouletteFeedResponse;
  }

  /**
   * No description
   * @tags Roulette
   * @name RouletteControllerFairness
   * @summary Provably-fair reveal — server seed, event log and bullet layouts only once FINISHED/CANCELLED
   * @request GET:/api/users/roulette/matches/{id}/fairness
   * @secure
   * @response `200` `RouletteFairness`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RouletteControllerFairness {
    export type RequestParams = {
      /** Match id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RouletteFairness;
  }

  /**
   * No description
   * @tags Rush Raffle
   * @name RushRaffleControllerGetRounds
   * @summary Today's active raffle rounds, one per ticket tier, ticket ASC
   * @request GET:/api/rush-raffle/rounds
   * @secure
   * @response `200` `RushRaffleRoundsResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushRaffleControllerGetRounds {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushRaffleRoundsResponse;
  }

  /**
   * No description
   * @tags Rush Raffle
   * @name RushRaffleControllerGetRoundDetail
   * @summary One raffle round — prize, leaderboard (top-50), caller stats, winner once completed
   * @request GET:/api/rush-raffle/rounds/{id}
   * @secure
   * @response `200` `RushRaffleRoundDetail`
   * @response `403` `void` Forbidden. User authentication required.
   * @response `404` `void` Round not found
   */
  export namespace RushRaffleControllerGetRoundDetail {
    export type RequestParams = {
      /** Round id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushRaffleRoundDetail;
  }

  /**
   * No description
   * @tags Rush Raffle
   * @name RushRaffleControllerGetWinners
   * @summary Recent completed raffle rounds with a winner, last 14 days, newest first
   * @request GET:/api/rush-raffle/winners
   * @secure
   * @response `200` `RushRaffleWinnersResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushRaffleControllerGetWinners {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushRaffleWinnersResponse;
  }

  /**
   * No description
   * @tags Rush Raffle
   * @name RushRaffleControllerGetMatchAward
   * @summary The caller's raffle ticket award for a finished Rush Mid match (null if none)
   * @request GET:/api/rush-raffle/match/{matchId}/award
   * @secure
   * @response `200` `(RushRaffleMatchAward | null)` null when the caller earned no award for this match
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace RushRaffleControllerGetMatchAward {
    export type RequestParams = {
      /** Match id */
      matchId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RushRaffleMatchAward | null;
  }

  /**
   * No description
   * @tags Band
   * @name BandControllerGetStatus
   * @summary SHOT BAND membership status and balances
   * @request GET:/api/users/band/status
   * @secure
   * @response `200` `BandStatusResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandControllerGetStatus {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandStatusResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandControllerGetTicketPrices
   * @summary Exact SHOT BAND pass price per available payment provider
   * @request GET:/api/users/band/ticket/prices
   * @secure
   * @response `200` `BandTicketPricesResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandControllerGetTicketPrices {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      authorization: string;
    };
    export type ResponseBody = BandTicketPricesResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandControllerCreateTicketInvoice
   * @summary Create a payment invoice for the SHOT BAND ticket
   * @request POST:/api/users/band/create-ticket-invoice
   * @secure
   * @response `201` `BandTicketInvoiceResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandControllerCreateTicketInvoice {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateBandTicketInvoice;
    export type RequestHeaders = {};
    export type ResponseBody = BandTicketInvoiceResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandControllerPayTicketWithClickCard
   * @summary Charge a bound Click card for SHOT BAND access
   * @request POST:/api/users/band/ticket/pay-with-click-card
   * @secure
   * @response `200` `PayBandTicketWithClickCardResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandControllerPayTicketWithClickCard {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PayBandTicketWithClickCard;
    export type RequestHeaders = {};
    export type ResponseBody = PayBandTicketWithClickCardResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandControllerClaimCashback
   * @summary Claim matured SHOT BAND cashback sparks
   * @request POST:/api/users/band/cashback/claim
   * @secure
   * @response `200` `ClaimBandCashbackResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandControllerClaimCashback {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ClaimBandCashbackResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandControllerGetMembersPreview
   * @summary Active member count and a few freshest member ids for the home promo
   * @request GET:/api/users/band/members-preview
   * @secure
   * @response `200` `BandMembersPreviewResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandControllerGetMembersPreview {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandMembersPreviewResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandControllerGetFreeCases
   * @summary Free SHOT BAND case opens unlocked by the day’s wager turnover
   * @request GET:/api/users/band/free-cases
   * @secure
   * @response `200` `BandFreeCasesResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandControllerGetFreeCases {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandFreeCasesResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandControllerGetQuests
   * @summary Today's SHOT BAND daily quests, progress and streak
   * @request GET:/api/users/band/quests
   * @secure
   * @response `200` `BandQuestsResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandControllerGetQuests {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandQuestsResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandControllerClaimQuest
   * @summary Claim a completed SHOT BAND daily quest
   * @request POST:/api/users/band/quests/{questId}/claim
   * @secure
   * @response `200` `BandQuestsResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandControllerClaimQuest {
    export type RequestParams = {
      questId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandQuestsResponse;
  }

  /**
   * No description
   * @tags Band Raffle
   * @name BandRaffleControllerGetRound
   * @summary This week's knife raffle — prize, live pot, caller stats and ticket balance
   * @request GET:/api/users/band-raffle/round
   * @secure
   * @response `200` `BandRaffleRoundResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandRaffleControllerGetRound {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandRaffleRoundResponse;
  }

  /**
   * No description
   * @tags Band Raffle
   * @name BandRaffleControllerInvest
   * @summary Invest raffle tickets into the round — irreversible, members only
   * @request POST:/api/users/band-raffle/round/{id}/invest
   * @secure
   * @response `200` `InvestBandRaffleTicketsResponse`
   * @response `403` `void` Forbidden. User authentication required.
   * @response `404` `void` Round not found
   */
  export namespace BandRaffleControllerInvest {
    export type RequestParams = {
      /** Round id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = InvestBandRaffleTickets;
    export type RequestHeaders = {};
    export type ResponseBody = InvestBandRaffleTicketsResponse;
  }

  /**
   * No description
   * @tags Band Raffle
   * @name BandRaffleControllerGetRoundDetail
   * @summary One raffle round — prize, leaderboard (top-50), caller stats, winner once completed
   * @request GET:/api/users/band-raffle/round/{id}
   * @secure
   * @response `200` `BandRaffleRoundDetail`
   * @response `403` `void` Forbidden. User authentication required.
   * @response `404` `void` Round not found
   */
  export namespace BandRaffleControllerGetRoundDetail {
    export type RequestParams = {
      /** Round id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandRaffleRoundDetail;
  }

  /**
   * No description
   * @tags Band Raffle
   * @name BandRaffleControllerGetWinners
   * @summary Completed weekly rounds with a winner, last 30 days, newest first
   * @request GET:/api/users/band-raffle/winners
   * @secure
   * @response `200` `BandRaffleWinnersResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandRaffleControllerGetWinners {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandRaffleWinnersResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandRaceControllerGetDetails
   * @summary Today's SHOT BAND wager race: prize, timer, my place
   * @request GET:/api/users/band/race/details
   * @secure
   * @response `200` `BandRaceDetailsResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandRaceControllerGetDetails {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandRaceDetailsResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandRaceControllerGetLeaderboard
   * @summary Today's race leaderboard page
   * @request GET:/api/users/band/race/leaderboard
   * @secure
   * @response `200` `BandRaceLeaderboardResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandRaceControllerGetLeaderboard {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * @min 1
       * @max 50
       * @default 10
       */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandRaceLeaderboardResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandRaceControllerGetWinners
   * @summary Past race winners, newest first
   * @request GET:/api/users/band/race/winners
   * @secure
   * @response `200` `BandRaceWinnersResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandRaceControllerGetWinners {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * @min 1
       * @max 50
       * @default 10
       */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandRaceWinnersResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandFinalControllerGetRound
   * @summary SHOT BAND Headliners: the week in progress and the latest closed week
   * @request GET:/api/users/band/final
   * @secure
   * @response `200` `BandFinalResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandFinalControllerGetRound {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandFinalResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandFinalControllerGetBattleInfo
   * @summary Headliners data for a band-funded battle page: state, start time, bank, shares, threshold, split by what each headliner dropped in the battle
   * @request GET:/api/users/band/final/battles/{battleId}
   * @response `200` `BandFinalBattleInfoResponse`
   */
  export namespace BandFinalControllerGetBattleInfo {
    export type RequestParams = {
      battleId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandFinalBattleInfoResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandFinalControllerGetLeaderboard
   * @summary Headliners week table page («Кто в составе»)
   * @request GET:/api/users/band/final/leaderboard
   * @secure
   * @response `200` `BandFinalLeaderboardResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandFinalControllerGetLeaderboard {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * @min 1
       * @max 50
       * @default 20
       */
      limit?: number;
      /**
       * Week round id; omitted — the week in progress
       * @format uuid
       */
      roundId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandFinalLeaderboardResponse;
  }

  /**
   * No description
   * @tags Band
   * @name BandFinalControllerGetWinners
   * @summary Past Headliners weeks, newest first: played ones with places, carried ones marked
   * @request GET:/api/users/band/final/winners
   * @secure
   * @response `200` `BandFinalWinnersResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace BandFinalControllerGetWinners {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * @min 1
       * @max 50
       * @default 20
       */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BandFinalWinnersResponse;
  }

  /**
   * No description
   * @tags Achievements
   * @name AchievementsControllerGetCatalog
   * @summary Full achievement catalog with viewer-aware redaction of hidden rules. Response carries all locales — client picks display lang.
   * @request GET:/api/achievements/catalog
   * @response `200` `CatalogResponse`
   */
  export namespace AchievementsControllerGetCatalog {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CatalogResponse;
  }

  /**
   * No description
   * @tags Achievements
   * @name AchievementsControllerGetMy
   * @summary Authenticated user's merged catalog + unlock + progress view
   * @request GET:/api/users/me/achievements
   * @secure
   * @response `200` `MergedAchievementsResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace AchievementsControllerGetMy {
    export type RequestParams = {};
    export type RequestQuery = {
      onlyUnlocked?: boolean;
      hideLockedSecrets?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MergedAchievementsResponse;
  }

  /**
   * No description
   * @tags Achievements
   * @name AchievementsControllerGetClaimableRewards
   * @summary Sum of rewards for the user's unlocked-but-uncredited achievements (snapshot=0), plus whether they have a payment in the last 30 days and whether the claim endpoint may be called.
   * @request GET:/api/achievements/claimable-rewards
   * @secure
   * @response `200` `ClaimableAchievementRewards`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace AchievementsControllerGetClaimableRewards {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ClaimableAchievementRewards;
  }

  /**
   * No description
   * @tags Achievements
   * @name AchievementsControllerClaimRewards
   * @summary Credit the user's unlocked-but-uncredited achievements (snapshot=0). All-time deposits must cover 100% of the claimable bonus (all-or-nothing). Idempotent — re-claim grants nothing.
   * @request POST:/api/achievements/claim-rewards
   * @secure
   * @response `200` `ClaimAchievementRewardsResult`
   * @response `201` `ClaimAchievementRewardsResult`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace AchievementsControllerClaimRewards {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ClaimAchievementRewardsResult;
  }

  /**
   * No description
   * @tags Achievements
   * @name AchievementsControllerGetForUser
   * @summary Public profile view of another user's achievements; hidden+target-locked redact
   * @request GET:/api/users/{userId}/achievements
   * @response `200` `MergedAchievementsResponse`
   */
  export namespace AchievementsControllerGetForUser {
    export type RequestParams = {
      userId: string;
    };
    export type RequestQuery = {
      onlyUnlocked?: boolean;
      hideLockedSecrets?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MergedAchievementsResponse;
  }

  /**
   * No description
   * @tags Achievements
   * @name AchievementsControllerGetStats
   * @summary Per-key unlock count (Redis-cached 60s) + active-user denominator (Redis-cached 1h). Anon sees 404 for hidden rules.
   * @request GET:/api/achievements/{key}/stats
   * @response `200` `AchievementStats`
   */
  export namespace AchievementsControllerGetStats {
    export type RequestParams = {
      key: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AchievementStats;
  }

  /**
   * No description
   * @tags Achievements
   * @name AchievementsControllerGetRecentReceivers
   * @summary Newest 10 unlocks for a key plus totalReceivers, both served from the Redis cache maintained by the 30-min refresh job. Anti-scrape: requires auth.
   * @request GET:/api/achievements/{key}/recent-receivers
   * @secure
   * @response `200` `RecentReceiversResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace AchievementsControllerGetRecentReceivers {
    export type RequestParams = {
      key: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RecentReceiversResponse;
  }

  /**
   * No description
   * @tags Survey
   * @name SurveyControllerSubmit
   * @summary Submit the product survey. One response per user — 409 if already submitted.
   * @request POST:/api/survey/response
   * @secure
   * @response `201` `SubmitSurveyResult`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace SurveyControllerSubmit {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SubmitSurveyResponse;
    export type RequestHeaders = {};
    export type ResponseBody = SubmitSurveyResult;
  }

  /**
   * No description
   * @tags Survey
   * @name SurveyControllerSaveDraft
   * @summary Upsert partial survey progress. 409 if the survey is already submitted.
   * @request PUT:/api/survey/draft
   * @secure
   * @response `200` `SaveSurveyDraftResult`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace SurveyControllerSaveDraft {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SaveSurveyDraft;
    export type RequestHeaders = {};
    export type ResponseBody = SaveSurveyDraftResult;
  }

  /**
   * No description
   * @tags Survey
   * @name SurveyControllerMyStatus
   * @summary Whether the authenticated user has already submitted a survey (slug, default 'default').
   * @request GET:/api/survey/me/status
   * @secure
   * @response `200` `SurveyStatus`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace SurveyControllerMyStatus {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Which survey to check. Omit for the original 'default' survey. */
      slug?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SurveyStatus;
  }

  /**
 * No description
 * @tags Device Signal
 * @name DeviceSignalControllerReport
 * @summary Report device fingerprint signal
 * @request POST:/api/users/device-signal
 * @secure
 * @response `200` `{
    success?: boolean,

}` Signal recorded
 * @response `403` `void` Forbidden. User authentication required.
*/
  export namespace DeviceSignalControllerReport {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ReportDeviceSignal;
    export type RequestHeaders = {};
    export type ResponseBody = {
      success?: boolean;
    };
  }

  /**
   * No description
   * @tags Auth
   * @name AuthControllerTma
   * @summary Authenticate via Telegram Mini App initData. Idempotent — safe to call on every cold open.
   * @request POST:/api/auth/tma
   * @response `200` `AuthSessionResponse`
   */
  export namespace AuthControllerTma {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TmaAuth;
    export type RequestHeaders = {};
    export type ResponseBody = AuthSessionResponse;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthControllerTelegramWidget
   * @summary Authenticate via Telegram Login Widget (browser web flow)
   * @request POST:/api/auth/telegram-widget
   * @response `200` `AuthSessionResponse`
   */
  export namespace AuthControllerTelegramWidget {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TelegramLogin;
    export type RequestHeaders = {};
    export type ResponseBody = AuthSessionResponse;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthControllerTelegramOidcInit
   * @summary Client ID for the Telegram Login library plus a single-use nonce that the resulting ID token must carry back.
   * @request GET:/api/auth/telegram/oidc/init
   * @response `200` `TelegramOidcInitResponse`
   */
  export namespace AuthControllerTelegramOidcInit {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TelegramOidcInitResponse;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthControllerTelegramOidc
   * @summary Authenticate via a Telegram OpenID Connect ID token (browser web flow)
   * @request POST:/api/auth/telegram/oidc
   * @response `200` `AuthSessionResponse`
   */
  export namespace AuthControllerTelegramOidc {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TelegramOidc;
    export type RequestHeaders = {};
    export type ResponseBody = AuthSessionResponse;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthControllerLogout
   * @summary Destroy session and clear cookie
   * @request POST:/api/auth/logout
   * @response `200` `void`
   */
  export namespace AuthControllerLogout {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthControllerWebHandoffInit
   * @summary Issue a single-use opaque token (Redis, TTL 60s) bound to the caller. Used by the TMA "Open in browser" flow to hand auth off to the web shell without putting initData into a URL hash.
   * @request POST:/api/auth/web-handoff/init
   * @secure
   * @response `200` `WebHandoffInitResponse`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace AuthControllerWebHandoffInit {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WebHandoffInitResponse;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthControllerWebHandoffRedeem
   * @summary Atomically GETDEL the handoff token, create a session cookie, return the session principal.
   * @request POST:/api/auth/web-handoff/redeem
   * @response `200` `AuthSessionResponse`
   */
  export namespace AuthControllerWebHandoffRedeem {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = WebHandoffRedeem;
    export type RequestHeaders = {};
    export type ResponseBody = AuthSessionResponse;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthControllerMe
   * @summary Return current session principal, or 401 if no valid cookie
   * @request GET:/api/auth/me
   * @response `200` `AuthSessionResponse`
   */
  export namespace AuthControllerMe {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AuthSessionResponse;
  }

  /**
   * No description
   * @tags Steam Auth
   * @name SteamAuthControllerInitSteamLink
   * @summary Start Steam linking flow — returns redirect URL
   * @request POST:/api/users/link/steam/init
   * @secure
   * @response `200` `SteamLinkInitResponse` Redirect URL for Steam OpenID
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace SteamAuthControllerInitSteamLink {
    export type RequestParams = {};
    export type RequestQuery = {
      source: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SteamLinkInitResponse;
  }

  /**
   * No description
   * @tags Steam Auth
   * @name SteamAuthControllerLoginSteam
   * @summary Redirect to Steam OpenID for login
   * @request GET:/api/users/login/steam
   * @response `200` `void`
   */
  export namespace SteamAuthControllerLoginSteam {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Steam Auth
   * @name SteamAuthControllerSteamCallback
   * @summary Steam OpenID callback (both link and login flows)
   * @request GET:/api/users/auth/steam/callback
   * @response `200` `void`
   */
  export namespace SteamAuthControllerSteamCallback {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Steam Auth
   * @name SteamAuthControllerConnectSteamToTelegram
   * @summary Connect pending Steam to existing Telegram account
   * @request POST:/api/users/connect/steam
   * @response `200` `AuthSessionResponse` Steam linked, session created
   */
  export namespace SteamAuthControllerConnectSteamToTelegram {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SteamConnect;
    export type RequestHeaders = {};
    export type ResponseBody = AuthSessionResponse;
  }

  /**
   * No description
   * @tags Steam Auth
   * @name SteamAuthControllerRegisterWithSteam
   * @summary Register new account with pending Steam data
   * @request POST:/api/users/register/steam
   * @response `200` `AuthSessionResponse` New account created, session created
   */
  export namespace SteamAuthControllerRegisterWithSteam {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SteamRegister;
    export type RequestHeaders = {};
    export type ResponseBody = AuthSessionResponse;
  }

  /**
   * No description
   * @tags Telegram Link
   * @name TelegramLinkControllerLinkTelegram
   * @summary Link Telegram account to existing user
   * @request POST:/api/users/link/telegram
   * @secure
   * @response `200` `LinkTelegramResponse` Telegram linked successfully
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace TelegramLinkControllerLinkTelegram {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TelegramOidc;
    export type RequestHeaders = {};
    export type ResponseBody = LinkTelegramResponse;
  }

  /**
   * No description
   * @tags Support
   * @name SupportControllerGetSummary
   * @summary Whether support has an unread answer for the caller
   * @request GET:/api/users/support/summary
   * @secure
   * @response `200` `SupportUserSummary`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace SupportControllerGetSummary {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SupportUserSummary;
  }

  /**
   * No description
   * @tags Support
   * @name SupportControllerGetMessages
   * @summary The caller’s own conversation, oldest first, paging backwards in time
   * @request GET:/api/users/support/messages
   * @secure
   * @response `200` `SupportUserMessageList`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace SupportControllerGetMessages {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Opaque cursor from a previous page; walks backwards in time */
      before?: string;
      /**
       * @min 1
       * @max 100
       * @default 50
       */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SupportUserMessageList;
  }

  /**
   * No description
   * @tags Support
   * @name SupportControllerSendMessage
   * @summary Write to support; the first message opens the conversation
   * @request POST:/api/users/support/messages
   * @secure
   * @response `201` `SupportUserMessage`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace SupportControllerSendMessage {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SendSupportMessage;
    export type RequestHeaders = {};
    export type ResponseBody = SupportUserMessage;
  }

  /**
   * No description
   * @tags Support
   * @name SupportControllerGreetInTelegram
   * @summary Ask the bot to greet the caller in their Telegram chat, as if they had sent /start support
   * @request POST:/api/users/support/telegram-greeting
   * @secure
   * @response `204` `void`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace SupportControllerGreetInTelegram {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Support
   * @name SupportControllerSendAttachment
   * @summary Attach a file to the conversation. Global upload limit is 5 MB.
   * @request POST:/api/users/support/attachments
   * @secure
   * @response `201` `SupportUserMessage`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace SupportControllerSendAttachment {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SupportUserMessage;
  }

  /**
   * No description
   * @tags Support
   * @name SupportControllerMarkRead
   * @summary Mark support answers as read and clear the badge
   * @request POST:/api/users/support/read
   * @secure
   * @response `200` `SupportUserSummary`
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace SupportControllerMarkRead {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SupportUserSummary;
  }

  /**
   * No description
   * @tags Support
   * @name SupportControllerGetAttachmentContent
   * @summary Stream one attachment from the caller’s own conversation
   * @request GET:/api/users/support/attachments/{id}/content
   * @secure
   * @response `200` `void` The attachment content
   * @response `403` `void` Forbidden. User authentication required.
   */
  export namespace SupportControllerGetAttachmentContent {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data.data;
    });
  };
}

/**
 * @title SHOT User API
 * @version 1.0
 * @contact
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Public
     * @name PublicControllerGetGameStats
     * @summary Get global game statistics counters
     * @request GET:/api/public/game-stats
     * @response `200` `GameStatsResponse` Game statistics
     */
    publicControllerGetGameStats: (params: RequestParams = {}) =>
      this.request<GameStatsResponse, any>({
        path: `/api/public/game-stats`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Returns an item image with a background colored according to its rarity
     *
     * @tags Public
     * @name PublicControllerGetItemImage
     * @summary Get item image with rarity background
     * @request GET:/api/public/item-image
     * @response `200` `File` Item image with rarity background
     * @response `400` `void` Invalid parameters or image processing failed
     * @response `404` `void` Item not found
     */
    publicControllerGetItemImage: (
      query: PublicControllerGetItemImageParams,
      params: RequestParams = {},
    ) =>
      this.request<File, void>({
        path: `/api/public/item-image`,
        method: "GET",
        query: query,
        format: "blob",
        ...params,
      }),

    /**
     * @description Returns a looping MP4 of a dropped item with the player who dropped it, for a signed, short-lived token.
     *
     * @tags Public
     * @name PublicControllerGetDropAnimation
     * @summary Get the animated drop card
     * @request GET:/api/public/drop-animation/{version}/drop.mp4
     * @response `200` `File` Looping MP4 animation
     * @response `404` `void` Unknown version, bad signature or expired link
     * @response `503` `void` Animation is temporarily unavailable
     */
    publicControllerGetDropAnimation: (
      { version, ...query }: PublicControllerGetDropAnimationParams,
      params: RequestParams = {},
    ) =>
      this.request<File, void>({
        path: `/api/public/drop-animation/${version}/drop.mp4`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns a case image with gray background in JPEG format
     *
     * @tags Public
     * @name PublicControllerGetCaseImage
     * @summary Get case image by ID
     * @request GET:/api/public/case-image/{caseId}
     * @response `200` `File` Case image with gray background in JPEG format
     * @response `400` `void` Invalid parameters or image processing failed
     * @response `404` `void` Case not found
     */
    publicControllerGetCaseImage: (
      { caseId, ...query }: PublicControllerGetCaseImageParams,
      params: RequestParams = {},
    ) =>
      this.request<File, void>({
        path: `/api/public/case-image/${caseId}`,
        method: "GET",
        query: query,
        format: "blob",
        ...params,
      }),

    /**
     * @description Proxies broadcast images from S3 storage
     *
     * @tags Public
     * @name PublicControllerGetBroadcastImage
     * @summary Get broadcast image
     * @request GET:/api/public/broadcast-images/{filename}
     * @response `200` `File` Broadcast image
     * @response `404` `void` Image not found
     */
    publicControllerGetBroadcastImage: (
      filename: string,
      params: RequestParams = {},
    ) =>
      this.request<File, void>({
        path: `/api/public/broadcast-images/${filename}`,
        method: "GET",
        format: "blob",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Public - Partners
     * @name PartnerPublicControllerGetPartnerById
     * @summary Get partner details by ID (public)
     * @request GET:/api/public/partners/{id}
     * @response `200` `Partner` Partner details
     * @response `404` `void` Partner not found
     */
    partnerPublicControllerGetPartnerById: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<Partner, void>({
        path: `/api/public/partners/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Public - Partners
     * @name PartnerPublicControllerGetPartnerTransferInfo
     * @summary Get the balance and conversion rate for a partner balance transfer (public)
     * @request GET:/api/public/partners/{id}/transfer-info
     * @response `200` `PartnerTransferInfo` Transfer info
     * @response `404` `void` Partner not found
     */
    partnerPublicControllerGetPartnerTransferInfo: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<PartnerTransferInfo, void>({
        path: `/api/public/partners/${id}/transfer-info`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Public - Partners
     * @name PartnerPublicControllerTransferToBalance
     * @summary Transfer partner balance to the account balance of the partner owner (public)
     * @request POST:/api/public/partners/{id}/transfer-to-balance
     * @response `200` `TransferPartnerBalanceResponse` Transfer completed
     * @response `400` `void` Invalid amount
     * @response `402` `void` Transfer amount exceeds the partner balance
     * @response `404` `void` Partner not found
     * @response `422` `void` Partner is inactive
     */
    partnerPublicControllerTransferToBalance: (
      id: string,
      data: TransferPartnerBalance,
      params: RequestParams = {},
    ) =>
      this.request<TransferPartnerBalanceResponse, void>({
        path: `/api/public/partners/${id}/transfer-to-balance`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Public - Partners
     * @name PartnerPublicControllerGetPartnerDailyStats
     * @summary Get partner daily statistics (public)
     * @request GET:/api/public/partners/{id}/daily-stats
     * @response `200` `ListPartnerDailyStatsResponse` Daily statistics with pagination
     */
    partnerPublicControllerGetPartnerDailyStats: (
      { id, ...query }: PartnerPublicControllerGetPartnerDailyStatsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListPartnerDailyStatsResponse, any>({
        path: `/api/public/partners/${id}/daily-stats`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Public - Partners
     * @name PartnerPublicControllerListPartnerWithdrawals
     * @summary Get partner withdrawals and deposits (public)
     * @request GET:/api/public/partners/{id}/withdrawals
     * @response `200` `ListPartnerWithdrawalsResponse` Withdrawals list
     */
    partnerPublicControllerListPartnerWithdrawals: (
      { id, ...query }: PartnerPublicControllerListPartnerWithdrawalsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListPartnerWithdrawalsResponse, any>({
        path: `/api/public/partners/${id}/withdrawals`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Public - Partners
     * @name PartnerPublicControllerGetPartnerTransactions
     * @summary Get partner transactions with pagination and date filters (public)
     * @request GET:/api/public/partners/{id}/transactions
     * @response `200` `ListPartnerTransactionsResponse` Transactions list with pagination
     * @response `404` `void` Partner not found
     */
    partnerPublicControllerGetPartnerTransactions: (
      { id, ...query }: PartnerPublicControllerGetPartnerTransactionsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListPartnerTransactionsResponse, void>({
        path: `/api/public/partners/${id}/transactions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Redirect
     * @name RedirectControllerRedirect
     * @summary Redirect to Telegram bot/app with tracking params
     * @request GET:/api/redirect
     * @response `200` `void`
     */
    redirectControllerRedirect: (
      query: RedirectControllerRedirectParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/redirect`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Public
     * @name PublicConfigControllerGetConfig
     * @summary Get public application config
     * @request GET:/api/public/config
     * @response `200` `PublicConfigResponse`
     */
    publicConfigControllerGetConfig: (params: RequestParams = {}) =>
      this.request<PublicConfigResponse, any>({
        path: `/api/public/config`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Issues a 302 from our origin so the Referer header matches our domain when the browser navigates to wata.pro.
     *
     * @tags Payment
     * @name WataproRedirectControllerRedirect
     * @summary Redirect to wata.pro hosted payment page
     * @request GET:/api/payment/watapro-sbp/redirect/{invoiceId}
     * @response `200` `void`
     */
    wataproRedirectControllerRedirect: (
      invoiceId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/payment/watapro-sbp/redirect/${invoiceId}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wiki
     * @name WikiControllerGetWikiSitemap
     * @summary Индексируемые страницы вики для sitemap
     * @request GET:/api/wiki/sitemap
     * @response `200` `WikiSitemap`
     */
    wikiControllerGetWikiSitemap: (params: RequestParams = {}) =>
      this.request<WikiSitemap, any>({
        path: `/api/wiki/sitemap`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wiki
     * @name WikiControllerGetWikiHome
     * @summary Главная вики
     * @request GET:/api/wiki/{lang}/home
     * @response `200` `WikiHome`
     */
    wikiControllerGetWikiHome: (lang: WikiLang, params: RequestParams = {}) =>
      this.request<WikiHome, any>({
        path: `/api/wiki/${lang}/home`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wiki
     * @name WikiControllerGetWikiCategory
     * @summary Страница категории оружия: оружие, скины со статьями, подборки и руководства
     * @request GET:/api/wiki/{lang}/categories/{category}
     * @response `200` `WikiCategoryPage`
     */
    wikiControllerGetWikiCategory: (
      lang: WikiLang,
      category: string,
      params: RequestParams = {},
    ) =>
      this.request<WikiCategoryPage, any>({
        path: `/api/wiki/${lang}/categories/${category}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wiki
     * @name WikiControllerGetWikiSkins
     * @summary Каталог скинов с фильтрами
     * @request GET:/api/wiki/{lang}/skins
     * @response `200` `WikiSkinsPage`
     */
    wikiControllerGetWikiSkins: (
      { lang, ...query }: WikiControllerGetWikiSkinsParams,
      params: RequestParams = {},
    ) =>
      this.request<WikiSkinsPage, any>({
        path: `/api/wiki/${lang}/skins`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wiki
     * @name WikiControllerGetWikiSkin
     * @summary Страница скина; для старого slug — { redirectSlug }, у ножа без раскраски есть weaponSlug
     * @request GET:/api/wiki/{lang}/skins/{slug}
     * @response `200` `(WikiSkinDetails | WikiSkinRedirect)`
     */
    wikiControllerGetWikiSkin: (
      lang: WikiLang,
      slug: string,
      params: RequestParams = {},
    ) =>
      this.request<WikiSkinDetails | WikiSkinRedirect, any>({
        path: `/api/wiki/${lang}/skins/${slug}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wiki
     * @name WikiControllerGetWikiSkinDrops
     * @summary Последние выпадения скина в играх SHOT во всех износах, StatTrak™ и сувенирных версиях
     * @request GET:/api/wiki/{lang}/skins/{slug}/drops
     * @response `200` `WikiDrops`
     */
    wikiControllerGetWikiSkinDrops: (
      lang: WikiLang,
      slug: string,
      params: RequestParams = {},
    ) =>
      this.request<WikiDrops, any>({
        path: `/api/wiki/${lang}/skins/${slug}/drops`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wiki
     * @name WikiControllerGetWikiWeapon
     * @summary Страница оружия со всеми скинами
     * @request GET:/api/wiki/{lang}/weapons/{slug}
     * @response `200` `WikiWeaponPage`
     */
    wikiControllerGetWikiWeapon: (
      lang: WikiLang,
      slug: string,
      params: RequestParams = {},
    ) =>
      this.request<WikiWeaponPage, any>({
        path: `/api/wiki/${lang}/weapons/${slug}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wiki
     * @name WikiControllerGetWikiWeaponDrops
     * @summary Последние выпадения ножа без раскраски в играх SHOT; у оружия без него — пустой список
     * @request GET:/api/wiki/{lang}/weapons/{slug}/drops
     * @response `200` `WikiDrops`
     */
    wikiControllerGetWikiWeaponDrops: (
      lang: WikiLang,
      slug: string,
      params: RequestParams = {},
    ) =>
      this.request<WikiDrops, any>({
        path: `/api/wiki/${lang}/weapons/${slug}/drops`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wiki
     * @name WikiControllerGetWikiContainers
     * @summary Кейсы, капсулы и наборы игры по страницам, с фильтром по виду
     * @request GET:/api/wiki/{lang}/containers
     * @response `200` `WikiContainers`
     */
    wikiControllerGetWikiContainers: (
      { lang, ...query }: WikiControllerGetWikiContainersParams,
      params: RequestParams = {},
    ) =>
      this.request<WikiContainers, any>({
        path: `/api/wiki/${lang}/containers`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wiki
     * @name WikiControllerGetWikiItems
     * @summary Список предметов одного типа: наклейки, агенты, брелоки, музыка и другие
     * @request GET:/api/wiki/{lang}/items/{type}
     * @response `200` `WikiItemsPage`
     */
    wikiControllerGetWikiItems: (
      { lang, type, ...query }: WikiControllerGetWikiItemsParams,
      params: RequestParams = {},
    ) =>
      this.request<WikiItemsPage, any>({
        path: `/api/wiki/${lang}/items/${type}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wiki
     * @name WikiControllerGetWikiItem
     * @summary Страница предмета; для старого slug — { redirectSlug }
     * @request GET:/api/wiki/{lang}/items/{type}/{slug}
     * @response `200` `(WikiItemDetails | WikiSkinRedirect)`
     */
    wikiControllerGetWikiItem: (
      lang: WikiLang,
      type: WikiItemType,
      slug: string,
      params: RequestParams = {},
    ) =>
      this.request<WikiItemDetails | WikiSkinRedirect, any>({
        path: `/api/wiki/${lang}/items/${type}/${slug}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wiki
     * @name WikiControllerGetWikiItemDrops
     * @summary Последние выпадения предмета в играх SHOT во всех версиях: эффекты, слэб, цвета, StatTrak™
     * @request GET:/api/wiki/{lang}/items/{type}/{slug}/drops
     * @response `200` `WikiDrops`
     */
    wikiControllerGetWikiItemDrops: (
      lang: WikiLang,
      type: WikiItemType,
      slug: string,
      params: RequestParams = {},
    ) =>
      this.request<WikiDrops, any>({
        path: `/api/wiki/${lang}/items/${type}/${slug}/drops`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wiki
     * @name WikiControllerResolveWikiPaths
     * @summary Страницы вики по market_hash_name пачкой: скин, нож, предмет или контейнер; без страницы — нет в ответе
     * @request POST:/api/wiki/paths
     * @response `200` `WikiPaths`
     */
    wikiControllerResolveWikiPaths: (
      data: WikiPathsRequest,
      params: RequestParams = {},
    ) =>
      this.request<WikiPaths, any>({
        path: `/api/wiki/paths`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wiki
     * @name WikiControllerGetWikiContainer
     * @summary Страница игрового кейса
     * @request GET:/api/wiki/{lang}/containers/{slug}
     * @response `200` `WikiContainerPage`
     */
    wikiControllerGetWikiContainer: (
      lang: WikiLang,
      slug: string,
      params: RequestParams = {},
    ) =>
      this.request<WikiContainerPage, any>({
        path: `/api/wiki/${lang}/containers/${slug}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wiki
     * @name WikiControllerGetWikiCollections
     * @summary Список коллекций
     * @request GET:/api/wiki/{lang}/collections
     * @response `200` `WikiCollections`
     */
    wikiControllerGetWikiCollections: (
      lang: WikiLang,
      params: RequestParams = {},
    ) =>
      this.request<WikiCollections, any>({
        path: `/api/wiki/${lang}/collections`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wiki
     * @name WikiControllerGetWikiCollection
     * @summary Страница коллекции
     * @request GET:/api/wiki/{lang}/collections/{slug}
     * @response `200` `WikiCollectionPage`
     */
    wikiControllerGetWikiCollection: (
      lang: WikiLang,
      slug: string,
      params: RequestParams = {},
    ) =>
      this.request<WikiCollectionPage, any>({
        path: `/api/wiki/${lang}/collections/${slug}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wiki
     * @name WikiControllerGetWikiGuides
     * @summary Руководства с опубликованным текстом на языке
     * @request GET:/api/wiki/{lang}/guides
     * @response `200` `WikiGuides`
     */
    wikiControllerGetWikiGuides: (lang: WikiLang, params: RequestParams = {}) =>
      this.request<WikiGuides, any>({
        path: `/api/wiki/${lang}/guides`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wiki
     * @name WikiControllerGetWikiGuide
     * @summary Руководство; без опубликованного текста на языке — 404
     * @request GET:/api/wiki/{lang}/guides/{slug}
     * @response `200` `WikiGuidePage`
     */
    wikiControllerGetWikiGuide: (
      lang: WikiLang,
      slug: string,
      params: RequestParams = {},
    ) =>
      this.request<WikiGuidePage, any>({
        path: `/api/wiki/${lang}/guides/${slug}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wiki
     * @name WikiControllerGetWikiSelections
     * @summary Подборки с опубликованным текстом на языке
     * @request GET:/api/wiki/{lang}/selections
     * @response `200` `WikiSelections`
     */
    wikiControllerGetWikiSelections: (
      lang: WikiLang,
      params: RequestParams = {},
    ) =>
      this.request<WikiSelections, any>({
        path: `/api/wiki/${lang}/selections`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wiki
     * @name WikiControllerGetWikiSelection
     * @summary Подборка; без опубликованного текста на языке — 404
     * @request GET:/api/wiki/{lang}/selections/{slug}
     * @response `200` `WikiSelectionPage`
     */
    wikiControllerGetWikiSelection: (
      lang: WikiLang,
      slug: string,
      params: RequestParams = {},
    ) =>
      this.request<WikiSelectionPage, any>({
        path: `/api/wiki/${lang}/selections/${slug}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wiki
     * @name WikiControllerSearchWiki
     * @summary Поиск по скинам, оружию, кейсам и коллекциям
     * @request GET:/api/wiki/{lang}/search
     * @response `200` `WikiSearchPage`
     */
    wikiControllerSearchWiki: (
      { lang, ...query }: WikiControllerSearchWikiParams,
      params: RequestParams = {},
    ) =>
      this.request<WikiSearchPage, any>({
        path: `/api/wiki/${lang}/search`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wiki
     * @name WikiControllerSuggestWiki
     * @summary Автодополнение поиска, до 8 подсказок
     * @request GET:/api/wiki/{lang}/suggest
     * @response `200` `(WikiSearchHit)[]`
     */
    wikiControllerSuggestWiki: (
      { lang, ...query }: WikiControllerSuggestWikiParams,
      params: RequestParams = {},
    ) =>
      this.request<WikiSearchHit[], any>({
        path: `/api/wiki/${lang}/suggest`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name NewsControllerGetNewsSitemap
     * @summary Активные новости для sitemap
     * @request GET:/api/news/sitemap
     * @response `200` `NewsSitemap`
     */
    newsControllerGetNewsSitemap: (params: RequestParams = {}) =>
      this.request<NewsSitemap, any>({
        path: `/api/news/sitemap`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name NewsControllerRegisterView
     * @summary Учесть просмотр публичной страницы активной новости
     * @request POST:/api/news/views
     * @response `200` `NewsViewResult`
     */
    newsControllerRegisterView: (
      data: RegisterNewsView,
      params: RequestParams = {},
    ) =>
      this.request<NewsViewResult, any>({
        path: `/api/news/views`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name NewsControllerGetNewsList
     * @summary Лента активных новостей на языке
     * @request GET:/api/news/{lang}
     * @response `200` `NewsList`
     */
    newsControllerGetNewsList: (
      { lang, ...query }: NewsControllerGetNewsListParams,
      params: RequestParams = {},
    ) =>
      this.request<NewsList, any>({
        path: `/api/news/${lang}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name NewsControllerGetNewsArticle
     * @summary Активная новость на языке (без редакторских данных)
     * @request GET:/api/news/{lang}/{slug}
     * @response `200` `NewsArticle`
     */
    newsControllerGetNewsArticle: (
      lang: NewsLang,
      slug: string,
      params: RequestParams = {},
    ) =>
      this.request<NewsArticle, any>({
        path: `/api/news/${lang}/${slug}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Health
     * @name HealthControllerCheck
     * @summary Basic health check
     * @request GET:/api/health
     * @response `200` `BasicHealth` Service is healthy
     */
    healthControllerCheck: (params: RequestParams = {}) =>
      this.request<BasicHealth, any>({
        path: `/api/health`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Health
     * @name HealthControllerReadiness
     * @summary Readiness check with dependencies
     * @request GET:/api/health/ready
     * @response `200` `ReadinessCheck` Service is ready
     * @response `503` `void` Service is not ready
     */
    healthControllerReadiness: (params: RequestParams = {}) =>
      this.request<ReadinessCheck, void>({
        path: `/api/health/ready`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Health
     * @name HealthControllerLiveness
     * @summary Liveness check
     * @request GET:/api/health/live
     * @response `200` `HealthCheck` Service is alive
     */
    healthControllerLiveness: (params: RequestParams = {}) =>
      this.request<HealthCheck, any>({
        path: `/api/health/live`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerRegister
     * @summary Register a new user (TMA initData auth)
     * @request POST:/api/users/register
     * @secure
     * @response `201` `RegisterResponse` User successfully registered
     * @response `403` `void` Forbidden. User authentication required.
     */
    userControllerRegister: (data: RegisterUser, params: RequestParams = {}) =>
      this.request<RegisterResponse, void>({
        path: `/api/users/register`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerGetProfile
     * @summary Get user profile information
     * @request GET:/api/users/profile
     * @secure
     * @response `200` `UserProfileResponse` User profile retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    userControllerGetProfile: (params: RequestParams = {}) =>
      this.request<UserProfileResponse, void>({
        path: `/api/users/profile`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerGetProfileStats
     * @summary Get user profile statistics (own or public)
     * @request GET:/api/users/profile/stats
     * @response `200` `ProfileStatsResponse` User profile statistics retrieved successfully
     */
    userControllerGetProfileStats: (
      query: UserControllerGetProfileStatsParams,
      params: RequestParams = {},
    ) =>
      this.request<ProfileStatsResponse, any>({
        path: `/api/users/profile/stats`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerGetReferrals
     * @summary Get paginated list of referred users
     * @request GET:/api/users/referrals
     * @secure
     * @response `200` `PaginatedReferralsResponse` Referrals retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    userControllerGetReferrals: (
      query: UserControllerGetReferralsParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedReferralsResponse, void>({
        path: `/api/users/referrals`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerGetReferralStats
     * @summary Get referral statistics (total referrals, earned credits, bonus progress)
     * @request GET:/api/users/referral-stats
     * @secure
     * @response `200` `ReferralStatsResponse` Referral statistics retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    userControllerGetReferralStats: (params: RequestParams = {}) =>
      this.request<ReferralStatsResponse, void>({
        path: `/api/users/referral-stats`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerSavePreparedInlineMessage
     * @summary Save prepared inline message for sharing
     * @request POST:/api/users/save-prepared-inline-message
     * @secure
     * @response `200` `SavePreparedInlineMessageResponse` Prepared inline message saved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    userControllerSavePreparedInlineMessage: (
      data: SavePreparedInlineMessage,
      params: RequestParams = {},
    ) =>
      this.request<SavePreparedInlineMessageResponse, void>({
        path: `/api/users/save-prepared-inline-message`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerHealthCheck
     * @summary Health check endpoint
     * @request GET:/api/users/health
     * @response `200` `HealthCheckResponse` Service is healthy
     */
    userControllerHealthCheck: (params: RequestParams = {}) =>
      this.request<HealthCheckResponse, any>({
        path: `/api/users/health`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home
     * @name HomeControllerGetHome
     * @summary Всё содержимое главного экрана одним запросом
     * @request GET:/api/users/home
     * @secure
     * @response `200` `HomeSnapshot`
     * @response `403` `void` Forbidden. User authentication required.
     */
    homeControllerGetHome: (params: RequestParams = {}) =>
      this.request<HomeSnapshot, void>({
        path: `/api/users/home`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contracts
     * @name ContractsControllerExecuteContract
     * @summary Execute contract
     * @request POST:/api/users/contracts/execute
     * @secure
     * @response `200` `ContractResult` Contract executed successfully
     * @response `400` `void` Invalid contract parameters
     * @response `403` `void` Forbidden. User authentication required.
     * @response `404` `void` Items not found or not available
     */
    contractsControllerExecuteContract: (
      data: ExecuteContract,
      params: RequestParams = {},
    ) =>
      this.request<ContractResult, void>({
        path: `/api/users/contracts/execute`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contracts
     * @name ContractsControllerPreviewContract
     * @summary Preview contract price range
     * @request GET:/api/users/contracts/preview
     * @secure
     * @response `200` `ContractPreview` Contract preview calculated successfully
     * @response `400` `void` Invalid preview parameters
     * @response `403` `void` Forbidden. User authentication required.
     */
    contractsControllerPreviewContract: (
      query: ContractsControllerPreviewContractParams,
      params: RequestParams = {},
    ) =>
      this.request<ContractPreview, void>({
        path: `/api/users/contracts/preview`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contracts
     * @name ContractsControllerGetContractHistory
     * @summary Get user contract history
     * @request GET:/api/users/contracts/history
     * @secure
     * @response `200` `ContractHistory` Contract history retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    contractsControllerGetContractHistory: (
      query: ContractsControllerGetContractHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<ContractHistory, void>({
        path: `/api/users/contracts/history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Calculate the probability and coefficient for an upgrade before performing it
     *
     * @tags Upgrades
     * @name UpgradeControllerCalculateProbability
     * @summary Calculate upgrade probability
     * @request POST:/api/users/upgrades/calculate-probability
     * @secure
     * @response `200` `UpgradeProbabilityResponse` Upgrade probability calculated successfully
     * @response `400` `void` Invalid input data
     * @response `403` `void` Forbidden. User authentication required.
     * @response `404` `void` Item not found
     */
    upgradeControllerCalculateProbability: (
      data: CalculateProbability,
      params: RequestParams = {},
    ) =>
      this.request<UpgradeProbabilityResponse, void>({
        path: `/api/users/upgrades/calculate-probability`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Upgrade one item to a more expensive item
     *
     * @tags Upgrades
     * @name UpgradeControllerPerformItemUpgrade
     * @summary Perform item-to-item upgrade
     * @request POST:/api/users/upgrades/item-to-item
     * @secure
     * @response `201` `UpgradeResult` Upgrade performed successfully
     * @response `400` `void` Invalid upgrade parameters or insufficient item value
     * @response `403` `void` Forbidden. User authentication required.
     * @response `404` `void` Item not found or not owned
     */
    upgradeControllerPerformItemUpgrade: (
      data: PerformItemUpgrade,
      params: RequestParams = {},
    ) =>
      this.request<UpgradeResult, void>({
        path: `/api/users/upgrades/item-to-item`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get paginated list of user's upgrade history
     *
     * @tags Upgrades
     * @name UpgradeControllerGetUpgradeHistory
     * @summary Get upgrade history
     * @request GET:/api/users/upgrades/history
     * @secure
     * @response `200` `UpgradeHistoryResponse` Upgrade history retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    upgradeControllerGetUpgradeHistory: (
      query: UpgradeControllerGetUpgradeHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<UpgradeHistoryResponse, void>({
        path: `/api/users/upgrades/history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Biggest winning multipliers for the Moscow day or month, one best upgrade per player
     *
     * @tags Upgrades
     * @name UpgradeControllerGetUpgradeTop
     * @summary Get upgrade top
     * @request GET:/api/users/upgrades/top
     * @secure
     * @response `200` `UpgradeTopResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    upgradeControllerGetUpgradeTop: (
      query: UpgradeControllerGetUpgradeTopParams,
      params: RequestParams = {},
    ) =>
      this.request<UpgradeTopResponse, void>({
        path: `/api/users/upgrades/top`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all available items that can be targeted for upgrade from a source item
     *
     * @tags Upgrades
     * @name UpgradeControllerGetAvailableUpgradeTargets
     * @summary Get available upgrade targets
     * @request GET:/api/users/upgrades/available-targets/{sourceItemId}
     * @secure
     * @response `200` `AvailableUpgradeTargetsResponse` Available upgrade targets retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     * @response `404` `void` Source item not found
     */
    upgradeControllerGetAvailableUpgradeTargets: (
      {
        sourceItemId,
        ...query
      }: UpgradeControllerGetAvailableUpgradeTargetsParams,
      params: RequestParams = {},
    ) =>
      this.request<AvailableUpgradeTargetsResponse, void>({
        path: `/api/users/upgrades/available-targets/${sourceItemId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Promocodes
 * @name PromocodeControllerActivatePromocode
 * @summary Activate a promocode
 * @request POST:/api/users/promocodes/activate
 * @secure
 * @response `200` `{
    success?: boolean,
    buffId?: string,

}` Promocode activated successfully
 * @response `400` `void` Invalid promocode or user already has active buff
 * @response `403` `void` Forbidden. User authentication required.
 * @response `404` `void` Promocode not found
 */
    promocodeControllerActivatePromocode: (
      data: ActivatePromocode,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          buffId?: string;
        },
        void
      >({
        path: `/api/users/promocodes/activate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Promocodes
     * @name PromocodeControllerGetActivePromocodeBuff
     * @summary Get active promocode buff for current user
     * @request GET:/api/users/promocodes/active-buff
     * @secure
     * @response `200` `(ActivePromocodeBuffResponse | null)` Active promocode buff (null if no active buff)
     * @response `403` `void` Forbidden. User authentication required.
     */
    promocodeControllerGetActivePromocodeBuff: (params: RequestParams = {}) =>
      this.request<ActivePromocodeBuffResponse | null, void>({
        path: `/api/users/promocodes/active-buff`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Promocodes
     * @name PromocodeControllerGetPromocodeHistory
     * @summary Get promocode usage history for current user
     * @request GET:/api/users/promocodes/history
     * @secure
     * @response `200` `PromocodeHistoryResponse` List of used promocodes
     * @response `403` `void` Forbidden. User authentication required.
     */
    promocodeControllerGetPromocodeHistory: (params: RequestParams = {}) =>
      this.request<PromocodeHistoryResponse, void>({
        path: `/api/users/promocodes/history`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Promocodes
     * @name PromocodeControllerGetGlobalPromocodeBuff
     * @summary Get active global promocode buff
     * @request GET:/api/users/promocodes/global-buff
     * @response `200` `(GlobalPromocodeBuffResponse | null)` Active global promocode buff (null if no active buff)
     */
    promocodeControllerGetGlobalPromocodeBuff: (params: RequestParams = {}) =>
      this.request<GlobalPromocodeBuffResponse | null, any>({
        path: `/api/users/promocodes/global-buff`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wheel
     * @name WheelControllerGetWheelStatus
     * @summary Get wheel status for current user
     * @request GET:/api/users/wheel/status
     * @secure
     * @response `200` `WheelStatusResponse` Wheel status including available spins and segments
     * @response `403` `void` Forbidden. User authentication required.
     */
    wheelControllerGetWheelStatus: (params: RequestParams = {}) =>
      this.request<WheelStatusResponse, void>({
        path: `/api/users/wheel/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wheel
     * @name WheelControllerSpinWheel
     * @summary Spin the wheel to get a promocode
     * @request POST:/api/users/wheel/spin
     * @secure
     * @response `200` `SpinWheelResponse` Wheel spun successfully
     * @response `400` `void` No spins available or active wheel promocode exists
     * @response `403` `void` Forbidden. User authentication required.
     */
    wheelControllerSpinWheel: (params: RequestParams = {}) =>
      this.request<SpinWheelResponse, void>({
        path: `/api/users/wheel/spin`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profile Task
     * @name ProfileTaskControllerActivateTask
     * @summary Activate specific profile task after user setup
     * @request POST:/api/users/profile-task/activate
     * @secure
     * @response `200` `void` Task activated successfully
     * @response `201` `void`
     * @response `400` `void` Validation failed or task already active
     * @response `403` `void` Forbidden. User authentication required.
     */
    profileTaskControllerActivateTask: (
      data: ActivateProfileTask,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/users/profile-task/activate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profile Task
     * @name ProfileTaskControllerActivateUsernameTask
     * @summary Activate username in lastName task
     * @request POST:/api/users/profile-task/activate-username
     * @secure
     * @response `200` `void` Username task activated successfully
     * @response `201` `void`
     * @response `400` `void` Validation failed or task already active
     * @response `403` `void` Forbidden. User authentication required.
     */
    profileTaskControllerActivateUsernameTask: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/users/profile-task/activate-username`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profile Task
     * @name ProfileTaskControllerActivateBioTask
     * @summary Activate referral link in bio task
     * @request POST:/api/users/profile-task/activate-bio
     * @secure
     * @response `200` `void` Bio task activated successfully
     * @response `201` `void`
     * @response `400` `void` Validation failed or task already active
     * @response `403` `void` Forbidden. User authentication required.
     */
    profileTaskControllerActivateBioTask: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/users/profile-task/activate-bio`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profile Task
     * @name ProfileTaskControllerGetStatus
     * @summary Get user profile task status
     * @request GET:/api/users/profile-task/status
     * @secure
     * @response `200` `ProfileTaskStatusResponse` Profile task status for both tasks
     * @response `403` `void` Forbidden. User authentication required.
     */
    profileTaskControllerGetStatus: (params: RequestParams = {}) =>
      this.request<ProfileTaskStatusResponse, void>({
        path: `/api/users/profile-task/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profile Task
     * @name ProfileTaskControllerClaimReward
     * @summary Claim daily profile task reward for specific task type
     * @request POST:/api/users/profile-task/claim-reward
     * @secure
     * @response `200` `void` Reward claimed successfully
     * @response `201` `void`
     * @response `400` `void` Reward not available
     * @response `403` `void` Forbidden. User authentication required.
     */
    profileTaskControllerClaimReward: (
      data: ClaimProfileTaskReward,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/users/profile-task/claim-reward`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profile Task
     * @name ProfileTaskControllerClaimUsernameReward
     * @summary Claim daily username task reward
     * @request POST:/api/users/profile-task/claim-username-reward
     * @secure
     * @response `200` `void` Username task reward claimed successfully
     * @response `201` `void`
     * @response `400` `void` Reward not available
     * @response `403` `void` Forbidden. User authentication required.
     */
    profileTaskControllerClaimUsernameReward: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/users/profile-task/claim-username-reward`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profile Task
     * @name ProfileTaskControllerClaimBioReward
     * @summary Claim daily bio task reward
     * @request POST:/api/users/profile-task/claim-bio-reward
     * @secure
     * @response `200` `void` Bio task reward claimed successfully
     * @response `201` `void`
     * @response `400` `void` Reward not available
     * @response `403` `void` Forbidden. User authentication required.
     */
    profileTaskControllerClaimBioReward: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/users/profile-task/claim-bio-reward`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shop
     * @name ShopControllerGetShopItems
     * @summary Get shop items with filters
     * @request GET:/api/users/shop/items
     * @response `200` `GetShopItemsResponse` List of shop items
     */
    shopControllerGetShopItems: (
      query: ShopControllerGetShopItemsParams,
      params: RequestParams = {},
    ) =>
      this.request<GetShopItemsResponse, any>({
        path: `/api/users/shop/items`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shop
     * @name ShopControllerGetShopSkins
     * @summary Get unique skins for a weapon
     * @request GET:/api/users/shop/skins
     * @response `200` `GetShopSkinsResponse` List of unique skins
     */
    shopControllerGetShopSkins: (
      query: ShopControllerGetShopSkinsParams,
      params: RequestParams = {},
    ) =>
      this.request<GetShopSkinsResponse, any>({
        path: `/api/users/shop/skins`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shop
     * @name ShopControllerCreatePurchaseInvoice
     * @summary Create invoice for purchasing an item from the shop
     * @request POST:/api/users/shop/create-purchase-invoice
     * @secure
     * @response `200` `CreateShopPurchaseInvoiceResponse` Invoice created successfully
     * @response `400` `void` Item not available or invalid payment provider
     * @response `403` `void` Forbidden. User authentication required.
     * @response `404` `void` Item not found
     */
    shopControllerCreatePurchaseInvoice: (
      data: CreateShopPurchaseInvoice,
      params: RequestParams = {},
    ) =>
      this.request<CreateShopPurchaseInvoiceResponse, void>({
        path: `/api/users/shop/create-purchase-invoice`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shop
     * @name ShopControllerGetMyShopPurchases
     * @summary Get my shop purchase history
     * @request GET:/api/users/shop/purchases
     * @secure
     * @response `200` `UserShopPurchasesResponse` List of shop purchases
     * @response `403` `void` Forbidden. User authentication required.
     */
    shopControllerGetMyShopPurchases: (
      query: ShopControllerGetMyShopPurchasesParams,
      params: RequestParams = {},
    ) =>
      this.request<UserShopPurchasesResponse, void>({
        path: `/api/users/shop/purchases`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CaseControllerGetCaseOpenings
     * @summary Get user case opening history
     * @request GET:/api/users/case-openings
     * @secure
     * @response `200` `PaginatedCaseOpeningsResponse` Case openings retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseControllerGetCaseOpenings: (
      query: CaseControllerGetCaseOpeningsParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedCaseOpeningsResponse, void>({
        path: `/api/users/case-openings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CaseControllerGetCaseOpeningDetails
     * @summary Get details of a specific case opening
     * @request GET:/api/users/case-openings/{id}
     * @secure
     * @response `200` `CaseOpeningDetailsResponse` Case opening details retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseControllerGetCaseOpeningDetails: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<CaseOpeningDetailsResponse, void>({
        path: `/api/users/case-openings/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CaseControllerGetCases
     * @summary Get all available cases (public — no country/language filter)
     * @request GET:/api/users/cases
     * @response `200` `(CaseResponse)[]` Cases retrieved successfully
     */
    caseControllerGetCases: (params: RequestParams = {}) =>
      this.request<CaseResponse[], any>({
        path: `/api/users/cases`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CaseControllerGetCatalog
     * @summary Cases screen catalog: all shop cases plus active categories with their cases
     * @request GET:/api/users/cases/catalog
     * @response `200` `CaseCatalogResponse` Catalog retrieved successfully
     */
    caseControllerGetCatalog: (params: RequestParams = {}) =>
      this.request<CaseCatalogResponse, any>({
        path: `/api/users/cases/catalog`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CaseControllerGetUniversalCases
     * @summary Get universal cases without country/language restrictions (for battle creation)
     * @request GET:/api/users/cases/universal
     * @secure
     * @response `200` `(CaseResponse)[]` Universal cases retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseControllerGetUniversalCases: (params: RequestParams = {}) =>
      this.request<CaseResponse[], void>({
        path: `/api/users/cases/universal`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CaseControllerGetCaseDetails
     * @summary Get case details
     * @request GET:/api/users/cases/{id}
     * @response `200` `CaseDetailsResponse` Case details retrieved successfully
     */
    caseControllerGetCaseDetails: (id: string, params: RequestParams = {}) =>
      this.request<CaseDetailsResponse, any>({
        path: `/api/users/cases/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CaseControllerOpenCase
     * @summary Open a case (count times, defaults to 1)
     * @request POST:/api/users/cases/{id}/open
     * @secure
     * @response `200` `(OpenCaseResponse)[]` Case opened successfully
     * @response `201` `(OpenCaseResponse)[]`
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseControllerOpenCase: (
      id: string,
      data: OpenCaseRequest,
      params: RequestParams = {},
    ) =>
      this.request<OpenCaseResponse[], void>({
        path: `/api/users/cases/${id}/open`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory
     * @name InventoryControllerGetInventory
     * @summary Get user inventory with pagination
     * @request GET:/api/users/inventory
     * @secure
     * @response `200` `PaginatedInventoryResponse` Inventory retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    inventoryControllerGetInventory: (
      query: InventoryControllerGetInventoryParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedInventoryResponse, void>({
        path: `/api/users/inventory`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory
     * @name InventoryControllerGetInventoryItemDetails
     * @summary Get details of a specific inventory item (publicly viewable)
     * @request GET:/api/users/inventory/{id}
     * @response `200` `UserInventoryItemResponse` Item details retrieved successfully
     */
    inventoryControllerGetInventoryItemDetails: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<UserInventoryItemResponse, any>({
        path: `/api/users/inventory/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory
     * @name InventoryControllerSellInventoryItem
     * @summary Sell an item from inventory
     * @request POST:/api/users/inventory/{id}/sell
     * @secure
     * @response `200` `SellItemResponse` Item sold successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    inventoryControllerSellInventoryItem: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<SellItemResponse, void>({
        path: `/api/users/inventory/${id}/sell`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory
     * @name InventoryControllerSellAllInventoryItems
     * @summary Sell all available items from inventory
     * @request POST:/api/users/inventory/sell-all
     * @secure
     * @response `200` `SellAllItemsResponse` All items sold successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    inventoryControllerSellAllInventoryItems: (params: RequestParams = {}) =>
      this.request<SellAllItemsResponse, void>({
        path: `/api/users/inventory/sell-all`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory
     * @name InventoryControllerSellInventoryItems
     * @summary Sell selected items from inventory
     * @request POST:/api/users/inventory/sell-batch
     * @secure
     * @response `200` `SellAllItemsResponse` Selected items sold successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    inventoryControllerSellInventoryItems: (
      data: SellItems,
      params: RequestParams = {},
    ) =>
      this.request<SellAllItemsResponse, void>({
        path: `/api/users/inventory/sell-batch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory
     * @name InventoryControllerGetRecentInventoryItems
     * @summary Get recent items from all users inventories (public)
     * @request GET:/api/users/inventory/recent
     * @response `200` `RecentItemsResponse` Recent items retrieved successfully
     */
    inventoryControllerGetRecentInventoryItems: (
      query: InventoryControllerGetRecentInventoryItemsParams,
      params: RequestParams = {},
    ) =>
      this.request<RecentItemsResponse, any>({
        path: `/api/users/inventory/recent`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory
     * @name InventoryControllerGetTopRecentDrops
     * @summary Get top drops from the last 24 hours, sorted by price (public)
     * @request GET:/api/users/inventory/top-recent-drops
     * @response `200` `TopRecentDropsResponse` Top recent drops retrieved successfully
     */
    inventoryControllerGetTopRecentDrops: (
      query: InventoryControllerGetTopRecentDropsParams,
      params: RequestParams = {},
    ) =>
      this.request<TopRecentDropsResponse, any>({
        path: `/api/users/inventory/top-recent-drops`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory
     * @name InventoryControllerWithdrawItem
     * @summary Withdraw item from inventory to Steam
     * @request POST:/api/users/inventory/{id}/withdraw
     * @secure
     * @response `200` `WithdrawItemResponse` Trade initiated successfully
     * @response `201` `WithdrawItemResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    inventoryControllerWithdrawItem: (
      id: string,
      data: WithdrawItem,
      params: RequestParams = {},
    ) =>
      this.request<WithdrawItemResponse, void>({
        path: `/api/users/inventory/${id}/withdraw`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory
     * @name InventoryControllerUpdateTradeLink
     * @summary Update Steam trade link
     * @request PUT:/api/users/trade-link
     * @secure
     * @response `200` `UpdateTradeLinkResponse` Trade link updated successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    inventoryControllerUpdateTradeLink: (
      data: UpdateTradeLink,
      params: RequestParams = {},
    ) =>
      this.request<UpdateTradeLinkResponse, void>({
        path: `/api/users/trade-link`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the stored snapshot without waiting on Steam. Reading your own inventory also queues a refresh, throttled per user; `refreshing` says a newer snapshot is on its way, so poll until it clears. A snapshot only exists for users who linked Steam through OpenID.
     *
     * @tags Steam Inventory
     * @name SteamInventoryControllerGetSteamInventory
     * @summary Last known CS2 inventory snapshot (own or public)
     * @request GET:/api/users/steam-inventory
     * @response `200` `SteamInventoryResponse` Snapshot returned
     */
    steamInventoryControllerGetSteamInventory: (
      query: SteamInventoryControllerGetSteamInventoryParams,
      params: RequestParams = {},
    ) =>
      this.request<SteamInventoryResponse, any>({
        path: `/api/users/steam-inventory`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Reads stored data only. Matches appear as `pending` right after their share code is discovered and get stats once the demo is parsed by the worker.
     *
     * @tags CS2 Matches
     * @name Cs2MatchesControllerGetMatches
     * @summary CS2 match history link status and recent matches
     * @request GET:/api/users/cs2-matches
     * @secure
     * @response `200` `Cs2MatchesResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    cs2MatchesControllerGetMatches: (params: RequestParams = {}) =>
      this.request<Cs2MatchesResponse, void>({
        path: `/api/users/cs2-matches`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Presence (in CS2 / on a server) is visible only for public profiles; the result is stored on the link if one exists.
     *
     * @tags CS2 Matches
     * @name Cs2MatchesControllerCheckProfile
     * @summary Check whether the Steam profile is public
     * @request POST:/api/users/cs2-matches/check-profile
     * @secure
     * @response `201` `CheckCs2ProfileResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    cs2MatchesControllerCheckProfile: (params: RequestParams = {}) =>
      this.request<CheckCs2ProfileResponse, void>({
        path: `/api/users/cs2-matches/check-profile`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Requires a linked Steam account. Validates the codes against Steam once; 422 with rule `cs2_invalid_auth_code` / `cs2_invalid_share_code` / `cs2_steam_not_linked` on failure. Without `shareCode` the link stays `awaiting_share_code` and no matches are counted until it is added.
     *
     * @tags CS2 Matches
     * @name Cs2MatchesControllerLink
     * @summary Connect CS2 match history
     * @request POST:/api/users/cs2-matches/link
     * @secure
     * @response `201` `LinkCs2MatchesResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    cs2MatchesControllerLink: (
      data: LinkCs2Matches,
      params: RequestParams = {},
    ) =>
      this.request<LinkCs2MatchesResponse, void>({
        path: `/api/users/cs2-matches/link`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CS2 Matches
     * @name Cs2MatchesControllerUnlink
     * @summary Disconnect CS2 match history; parsed matches are kept
     * @request DELETE:/api/users/cs2-matches/link
     * @secure
     * @response `200` `void`
     * @response `403` `void` Forbidden. User authentication required.
     */
    cs2MatchesControllerUnlink: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/users/cs2-matches/link`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description For links in `awaiting_share_code` or `invalid_code`. 422 with rule `cs2_invalid_share_code` when Steam rejects it.
     *
     * @tags CS2 Matches
     * @name Cs2MatchesControllerSetShareCode
     * @summary Add or replace the match share code
     * @request POST:/api/users/cs2-matches/share-code
     * @secure
     * @response `201` `SetCs2ShareCodeResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    cs2MatchesControllerSetShareCode: (
      data: SetCs2ShareCode,
      params: RequestParams = {},
    ) =>
      this.request<SetCs2ShareCodeResponse, void>({
        path: `/api/users/cs2-matches/share-code`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description One check per minute; 422 with rule `cs2_refresh_cooldown` and `retryAfterSec` otherwise.
     *
     * @tags CS2 Matches
     * @name Cs2MatchesControllerRefresh
     * @summary Check for new matches now
     * @request POST:/api/users/cs2-matches/refresh
     * @secure
     * @response `201` `RefreshCs2MatchesResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    cs2MatchesControllerRefresh: (params: RequestParams = {}) =>
      this.request<RefreshCs2MatchesResponse, void>({
        path: `/api/users/cs2-matches/refresh`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerCreateInvoice
     * @summary Create payment invoice
     * @request POST:/api/users/create-invoice
     * @secure
     * @response `200` `PaymentResponse` Invoice created successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    paymentControllerCreateInvoice: (
      data: CreateInvoice,
      params: RequestParams = {},
    ) =>
      this.request<PaymentResponse, void>({
        path: `/api/users/create-invoice`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerGetPaymentSettings
     * @summary Get payment settings
     * @request GET:/api/users/payment-settings
     * @secure
     * @response `200` `PaymentSettingsResponse` Payment settings retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    paymentControllerGetPaymentSettings: (params: RequestParams = {}) =>
      this.request<PaymentSettingsResponse, void>({
        path: `/api/users/payment-settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerGetPaymentProviders
     * @summary Get payment providers (filtered + ordered for current user)
     * @request GET:/api/users/payment-providers
     * @secure
     * @response `200` `PaymentProvidersResponse` OK
     * @response `403` `void` Forbidden. User authentication required.
     */
    paymentControllerGetPaymentProviders: (params: RequestParams = {}) =>
      this.request<PaymentProvidersResponse, void>({
        path: `/api/users/payment-providers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name ClickCardControllerList
     * @summary List bound Click cards
     * @request GET:/api/users/click-cards
     * @secure
     * @response `200` `ClickCardListResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    clickCardControllerList: (params: RequestParams = {}) =>
      this.request<ClickCardListResponse, void>({
        path: `/api/users/click-cards`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name ClickCardControllerBind
     * @summary Bind a card — Click sends an SMS code
     * @request POST:/api/users/click-cards
     * @secure
     * @response `200` `BindClickCardResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    clickCardControllerBind: (
      data: BindClickCard,
      params: RequestParams = {},
    ) =>
      this.request<BindClickCardResponse, void>({
        path: `/api/users/click-cards`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name ClickCardControllerVerify
     * @summary Confirm a bound card with the SMS code
     * @request POST:/api/users/click-cards/{id}/verify
     * @secure
     * @response `200` `ClickCardResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    clickCardControllerVerify: (
      id: string,
      data: VerifyClickCard,
      params: RequestParams = {},
    ) =>
      this.request<ClickCardResponse, void>({
        path: `/api/users/click-cards/${id}/verify`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name ClickCardControllerPay
     * @summary Charge a bound card
     * @request POST:/api/users/click-cards/{id}/pay
     * @secure
     * @response `200` `PayWithClickCardResponse`
     * @response `403` `void` Forbidden. User authentication required.
     * @response `409` `void` A charge for this amount is already running
     */
    clickCardControllerPay: (
      id: string,
      data: PayWithClickCard,
      params: RequestParams = {},
    ) =>
      this.request<PayWithClickCardResponse, void>({
        path: `/api/users/click-cards/${id}/pay`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name ClickCardControllerRemove
     * @summary Remove a bound card
     * @request DELETE:/api/users/click-cards/{id}
     * @secure
     * @response `204` `void`
     * @response `403` `void` Forbidden. User authentication required.
     */
    clickCardControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/users/click-cards/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profile Settings
     * @name ProfileSettingsControllerUpdateAnimationSetting
     * @summary Update case opening animation setting
     * @request PUT:/api/users/animation-setting
     * @secure
     * @response `200` `UpdateAnimationSettingResponse` Animation setting updated successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    profileSettingsControllerUpdateAnimationSetting: (
      data: UpdateAnimationSetting,
      params: RequestParams = {},
    ) =>
      this.request<UpdateAnimationSettingResponse, void>({
        path: `/api/users/animation-setting`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profile Settings
     * @name ProfileSettingsControllerToggleNotifications
     * @summary Toggle notifications
     * @request PUT:/api/users/notifications
     * @secure
     * @response `200` `ToggleNotificationsResponse` Notifications setting updated successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    profileSettingsControllerToggleNotifications: (
      data: ToggleNotifications,
      params: RequestParams = {},
    ) =>
      this.request<ToggleNotificationsResponse, void>({
        path: `/api/users/notifications`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profile Settings
     * @name ProfileSettingsControllerUpdateLanguage
     * @summary Update user language preference
     * @request PUT:/api/users/language
     * @secure
     * @response `200` `UpdateLanguageResponse` Language updated successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    profileSettingsControllerUpdateLanguage: (
      data: UpdateLanguage,
      params: RequestParams = {},
    ) =>
      this.request<UpdateLanguageResponse, void>({
        path: `/api/users/language`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home Tasks
     * @name HomeTasksControllerGetDailyBonusStatus
     * @summary Get daily bonus status
     * @request GET:/api/users/daily-bonus/status
     * @secure
     * @response `200` `DailyBonusStatusResponse` Daily bonus status retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    homeTasksControllerGetDailyBonusStatus: (params: RequestParams = {}) =>
      this.request<DailyBonusStatusResponse, void>({
        path: `/api/users/daily-bonus/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home Tasks
     * @name HomeTasksControllerClaimDailyBonus
     * @summary Claim daily bonus
     * @request POST:/api/users/daily-bonus/claim
     * @secure
     * @response `200` `ClaimDailyBonusResponse` Daily bonus claimed successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    homeTasksControllerClaimDailyBonus: (params: RequestParams = {}) =>
      this.request<ClaimDailyBonusResponse, void>({
        path: `/api/users/daily-bonus/claim`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home Tasks
     * @name HomeTasksControllerCheckSubscription
     * @summary Check user subscription to all active Telegram channels and award bonuses
     * @request POST:/api/users/check-subscription
     * @secure
     * @response `204` `void` Subscription checks scheduled successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    homeTasksControllerCheckSubscription: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/users/check-subscription`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home Tasks
     * @name HomeTasksControllerGetSubscriptionChannels
     * @summary Get list of available subscription channels with user subscription status
     * @request GET:/api/users/subscription-channels
     * @secure
     * @response `200` `SubscriptionChannelsResponse` Subscription channels retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    homeTasksControllerGetSubscriptionChannels: (params: RequestParams = {}) =>
      this.request<SubscriptionChannelsResponse, void>({
        path: `/api/users/subscription-channels`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home Tasks
     * @name HomeTasksControllerGetComebackBonuses
     * @summary Get available comeback bonuses
     * @request GET:/api/users/comeback-bonus
     * @secure
     * @response `200` `ComebackBonusResponse` Comeback bonuses retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    homeTasksControllerGetComebackBonuses: (params: RequestParams = {}) =>
      this.request<ComebackBonusResponse, void>({
        path: `/api/users/comeback-bonus`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home Tasks
     * @name HomeTasksControllerClaimComebackBonus
     * @summary Claim a comeback bonus
     * @request POST:/api/users/comeback-bonus/{id}/claim
     * @secure
     * @response `200` `ClaimComebackBonusResponse` Comeback bonus claimed successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    homeTasksControllerClaimComebackBonus: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<ClaimComebackBonusResponse, void>({
        path: `/api/users/comeback-bonus/${id}/claim`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home Tasks
     * @name HomeTasksControllerGetReferralBonusProgress
     * @summary Get progress towards next referral milestone bonus
     * @request GET:/api/users/referral-bonus-progress
     * @secure
     * @response `200` `ReferralBonusProgressResponse` Referral bonus progress retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    homeTasksControllerGetReferralBonusProgress: (params: RequestParams = {}) =>
      this.request<ReferralBonusProgressResponse, void>({
        path: `/api/users/referral-bonus-progress`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home Tasks
     * @name HomeTasksControllerGetOnboardingConfig
     * @summary Get onboarding screen configuration (task rewards, referral bonuses, case prices)
     * @request GET:/api/users/onboarding-config
     * @secure
     * @response `200` `OnboardingConfigResponse` Onboarding configuration retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    homeTasksControllerGetOnboardingConfig: (params: RequestParams = {}) =>
      this.request<OnboardingConfigResponse, void>({
        path: `/api/users/onboarding-config`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home Tasks
     * @name HomeTasksControllerGetBoostChannels
     * @summary Get list of boost channels with user status
     * @request GET:/api/users/boost-channels
     * @secure
     * @response `200` `BoostChannelsStatusResponse` Boost channels retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    homeTasksControllerGetBoostChannels: (params: RequestParams = {}) =>
      this.request<BoostChannelsStatusResponse, void>({
        path: `/api/users/boost-channels`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home Tasks
     * @name HomeTasksControllerActivateBoost
     * @summary Activate boost for a channel (after user has boosted via Telegram)
     * @request POST:/api/users/boost-channels/{channelId}/activate
     * @secure
     * @response `200` `ActivateBoostResponse` Boost activated successfully
     * @response `400` `void` Validation failed or boost already active
     * @response `403` `void` Forbidden. User authentication required.
     */
    homeTasksControllerActivateBoost: (
      channelId: string,
      params: RequestParams = {},
    ) =>
      this.request<ActivateBoostResponse, void>({
        path: `/api/users/boost-channels/${channelId}/activate`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home Tasks
     * @name HomeTasksControllerClaimBoostReward
     * @summary Claim daily boost reward
     * @request POST:/api/users/boost-channels/{channelId}/claim
     * @secure
     * @response `200` `ClaimBoostRewardResponse` Boost reward claimed successfully
     * @response `400` `void` Reward not available
     * @response `403` `void` Forbidden. User authentication required.
     */
    homeTasksControllerClaimBoostReward: (
      channelId: string,
      params: RequestParams = {},
    ) =>
      this.request<ClaimBoostRewardResponse, void>({
        path: `/api/users/boost-channels/${channelId}/claim`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chicken Reward
     * @name ChickenRewardControllerTickChickenSpawn
     * @summary Probabilistic chicken spawn tick
     * @request POST:/api/users/chicken/tick
     * @secure
     * @response `200` `ChickenTickResponse` Chicken spawn tick evaluated
     * @response `403` `void` Forbidden. User authentication required.
     */
    chickenRewardControllerTickChickenSpawn: (params: RequestParams = {}) =>
      this.request<ChickenTickResponse, void>({
        path: `/api/users/chicken/tick`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chicken Reward
     * @name ChickenRewardControllerClaimChickenReward
     * @summary Claim chicken tap reward
     * @request POST:/api/users/chicken/claim
     * @secure
     * @response `200` `ClaimChickenRewardResponse` Chicken reward claimed successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    chickenRewardControllerClaimChickenReward: (
      data: ClaimChickenReward,
      params: RequestParams = {},
    ) =>
      this.request<ClaimChickenRewardResponse, void>({
        path: `/api/users/chicken/claim`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Resolves avatar via auth_identities: Telegram → Steam → placeholder.
     *
     * @tags Avatar
     * @name AvatarControllerGetUserAvatar
     * @summary Get user avatar by userId
     * @request GET:/api/users/avatar/{userId}
     * @response `200` `void` User avatar image or gray placeholder
     */
    avatarControllerGetUserAvatar: (
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/users/avatar/${userId}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags XP
     * @name XpControllerGetXpStatus
     * @summary Get user XP status
     * @request GET:/api/users/xp/status
     * @secure
     * @response `200` `XpStatusResponse` XP status retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    xpControllerGetXpStatus: (params: RequestParams = {}) =>
      this.request<XpStatusResponse, void>({
        path: `/api/users/xp/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags XP
     * @name XpControllerGetXpHistory
     * @summary Get user XP transaction history
     * @request GET:/api/users/xp/history
     * @secure
     * @response `200` `XpHistoryResponse` XP history retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    xpControllerGetXpHistory: (
      query: XpControllerGetXpHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<XpHistoryResponse, void>({
        path: `/api/users/xp/history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags XP
     * @name XpControllerGetXpConfig
     * @summary Get XP configuration
     * @request GET:/api/users/xp/config
     * @secure
     * @response `200` `XpConfigResponse` XP configuration retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    xpControllerGetXpConfig: (params: RequestParams = {}) =>
      this.request<XpConfigResponse, void>({
        path: `/api/users/xp/config`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags XP
     * @name XpControllerGetLevelBonusesStatus
     * @summary Get level bonuses status
     * @request GET:/api/users/xp/level-bonuses
     * @secure
     * @response `200` `LevelBonusesStatusResponse` Level bonuses status retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    xpControllerGetLevelBonusesStatus: (params: RequestParams = {}) =>
      this.request<LevelBonusesStatusResponse, void>({
        path: `/api/users/xp/level-bonuses`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags XP
     * @name XpControllerClaimLevelBonus
     * @summary Claim level bonus
     * @request POST:/api/users/xp/level-bonuses/{level}/claim
     * @secure
     * @response `200` `ClaimLevelBonusResponse` Level bonus claimed successfully
     * @response `400` `void` Bonus already claimed, forfeit, or level not reached
     * @response `403` `void` Forbidden. User authentication required.
     */
    xpControllerClaimLevelBonus: (level: number, params: RequestParams = {}) =>
      this.request<ClaimLevelBonusResponse, void>({
        path: `/api/users/xp/level-bonuses/${level}/claim`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags XP
     * @name XpControllerGetXpLeaderboard
     * @summary Get XP leaderboard with pagination
     * @request GET:/api/users/xp/leaderboard
     * @secure
     * @response `200` `XpLeaderboardResponse` Leaderboard retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    xpControllerGetXpLeaderboard: (
      query: XpControllerGetXpLeaderboardParams,
      params: RequestParams = {},
    ) =>
      this.request<XpLeaderboardResponse, void>({
        path: `/api/users/xp/leaderboard`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags XP
     * @name XpControllerGetXpLeaderboardNeighbors
     * @summary Get neighboring users in XP leaderboard (3 above + current + 3 below = up to 7 users)
     * @request GET:/api/users/xp/leaderboard/neighbors
     * @secure
     * @response `200` `XpLeaderboardNeighborsResponse` Neighbors retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     * @response `404` `void` User not found
     */
    xpControllerGetXpLeaderboardNeighbors: (params: RequestParams = {}) =>
      this.request<XpLeaderboardNeighborsResponse, void>({
        path: `/api/users/xp/leaderboard/neighbors`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Draws
     * @name DrawsControllerGetActiveDraws
     * @summary Get active draws with user participation status
     * @request GET:/api/draws
     * @secure
     * @response `200` `ActiveDrawsResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    drawsControllerGetActiveDraws: (params: RequestParams = {}) =>
      this.request<ActiveDrawsResponse, void>({
        path: `/api/draws`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Draws
     * @name DrawsControllerGetWinnersHistory
     * @summary Get draws winners history
     * @request GET:/api/draws/winners
     * @response `200` `(DrawWinner)[]`
     */
    drawsControllerGetWinnersHistory: (
      query: DrawsControllerGetWinnersHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<DrawWinner[], any>({
        path: `/api/draws/winners`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Draws
     * @name DrawsControllerGetDrawParticipants
     * @summary Get draw participants with pagination
     * @request GET:/api/draws/{id}/participants
     * @response `200` `DrawParticipants`
     */
    drawsControllerGetDrawParticipants: (
      { id, ...query }: DrawsControllerGetDrawParticipantsParams,
      params: RequestParams = {},
    ) =>
      this.request<DrawParticipants, any>({
        path: `/api/draws/${id}/participants`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Draws
     * @name DrawsControllerBuyEntry
     * @summary Buy entry to a paid draw
     * @request POST:/api/draws/buy-entry
     * @secure
     * @response `200` `void` Successfully purchased draw entry
     * @response `400` `void` Insufficient balance, already participating, or draw is free
     * @response `403` `void` Forbidden. User authentication required.
     * @response `404` `void` No active draw found for the specified type
     */
    drawsControllerBuyEntry: (data: BuyDrawEntry, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/draws/buy-entry`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Giveaways
     * @name GiveawaysControllerGetGiveaway
     * @summary Get giveaway details with its case
     * @request GET:/api/giveaways/{id}
     * @response `200` `GiveawayDetailsResponse`
     * @response `404` `void` Giveaway not found
     */
    giveawaysControllerGetGiveaway: (id: string, params: RequestParams = {}) =>
      this.request<GiveawayDetailsResponse, void>({
        path: `/api/giveaways/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Giveaways
     * @name GiveawaysControllerGetParticipants
     * @summary Get giveaway participants with pagination
     * @request GET:/api/giveaways/{id}/participants
     * @response `200` `GiveawayParticipantsResponse`
     */
    giveawaysControllerGetParticipants: (
      { id, ...query }: GiveawaysControllerGetParticipantsParams,
      params: RequestParams = {},
    ) =>
      this.request<GiveawayParticipantsResponse, any>({
        path: `/api/giveaways/${id}/participants`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Giveaways
     * @name GiveawaysControllerJoin
     * @summary Join a giveaway
     * @request POST:/api/giveaways/{id}/join
     * @secure
     * @response `200` `JoinGiveawayResponse`
     * @response `400` `void` Giveaway expired or already completed
     * @response `403` `void` Forbidden. User authentication required.
     * @response `404` `void` Giveaway not found
     * @response `422` `void` Cannot participate (already participating, no trade URL, no deposit, IP/referral restriction)
     */
    giveawaysControllerJoin: (id: string, params: RequestParams = {}) =>
      this.request<JoinGiveawayResponse, void>({
        path: `/api/giveaways/${id}/join`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rains
     * @name RainsControllerGetCurrent
     * @summary The rain currently open for joining, or null
     * @request GET:/api/rains/current
     * @response `200` `CurrentRainResponse`
     */
    rainsControllerGetCurrent: (params: RequestParams = {}) =>
      this.request<CurrentRainResponse, any>({
        path: `/api/rains/current`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Rains that granted nothing — empty ones, and completed ones whose draw gates rejected every candidate — are left out: they would render as blank rows. The full picture across every status is in the admin listing.
     *
     * @tags Rains
     * @name RainsControllerGetHistory
     * @summary Past rains that handed out a prize, newest first
     * @request GET:/api/rains/history
     * @response `200` `RainHistoryPage`
     */
    rainsControllerGetHistory: (
      query: RainsControllerGetHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<RainHistoryPage, any>({
        path: `/api/rains/history`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rains
     * @name RainsControllerGetParticipants
     * @summary Paginated list of people in the rain
     * @request GET:/api/rains/{id}/participants
     * @response `200` `RainParticipantsPage`
     */
    rainsControllerGetParticipants: (
      { id, ...query }: RainsControllerGetParticipantsParams,
      params: RequestParams = {},
    ) =>
      this.request<RainParticipantsPage, any>({
        path: `/api/rains/${id}/participants`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rains
     * @name RainsControllerGetById
     * @summary One rain in any status — live, finished or empty
     * @request GET:/api/rains/{id}
     * @response `200` `RainDetailResponse`
     */
    rainsControllerGetById: (id: string, params: RequestParams = {}) =>
      this.request<RainDetailResponse, any>({
        path: `/api/rains/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rains
     * @name RainsControllerJoin
     * @summary Join the rain
     * @request POST:/api/rains/{id}/join
     * @secure
     * @response `200` `JoinRainResponse`
     * @response `400` `void` Rain is not open for joining
     * @response `403` `void` Forbidden. User authentication required.
     * @response `404` `void` Rain not found
     * @response `422` `void` Cannot join (already joined, no trade URL, no deposit, IP/referral/multiacc restriction)
     */
    rainsControllerJoin: (id: string, params: RequestParams = {}) =>
      this.request<JoinRainResponse, void>({
        path: `/api/rains/${id}/join`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Daily Giveaways
     * @name DailyGiveawayControllerGetDailyGiveaways
     * @summary Get active daily giveaways (compact — for home cards)
     * @request GET:/api/users/daily-giveaways
     * @response `200` `DailyGiveawaysResponse`
     */
    dailyGiveawayControllerGetDailyGiveaways: (params: RequestParams = {}) =>
      this.request<DailyGiveawaysResponse, any>({
        path: `/api/users/daily-giveaways`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Daily Giveaways
     * @name DailyGiveawayControllerGetDailyGiveawayDetails
     * @summary Get one daily giveaway header (prize, case, round, my place)
     * @request GET:/api/users/daily-giveaways/{id}
     * @response `200` `DailyGiveawayDetailResponse`
     * @response `404` `void` Daily giveaway not found
     */
    dailyGiveawayControllerGetDailyGiveawayDetails: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<DailyGiveawayDetailResponse, void>({
        path: `/api/users/daily-giveaways/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Daily Giveaways
     * @name DailyGiveawayControllerGetLeaderboard
     * @summary Paginated leaderboard for the current round
     * @request GET:/api/users/daily-giveaways/{id}/leaderboard
     * @response `200` `DailyGiveawayLeaderboardPage`
     */
    dailyGiveawayControllerGetLeaderboard: (
      { id, ...query }: DailyGiveawayControllerGetLeaderboardParams,
      params: RequestParams = {},
    ) =>
      this.request<DailyGiveawayLeaderboardPage, any>({
        path: `/api/users/daily-giveaways/${id}/leaderboard`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Daily Giveaways
     * @name DailyGiveawayControllerGetWinners
     * @summary Paginated past winners
     * @request GET:/api/users/daily-giveaways/{id}/winners
     * @response `200` `DailyGiveawayWinnersPage`
     * @response `404` `void` Daily giveaway not found
     */
    dailyGiveawayControllerGetWinners: (
      { id, ...query }: DailyGiveawayControllerGetWinnersParams,
      params: RequestParams = {},
    ) =>
      this.request<DailyGiveawayWinnersPage, void>({
        path: `/api/users/daily-giveaways/${id}/winners`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Referral Contest
     * @name ReferralContestControllerGetLeaderboard
     * @summary August referral contest leaderboard (top inviters by activated referrals)
     * @request GET:/api/users/referral-contest/leaderboard
     * @response `200` `ReferralContestLeaderboardResponse`
     */
    referralContestControllerGetLeaderboard: (
      query: ReferralContestControllerGetLeaderboardParams,
      params: RequestParams = {},
    ) =>
      this.request<ReferralContestLeaderboardResponse, any>({
        path: `/api/users/referral-contest/leaderboard`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Receives updates from Telegram when bot is in webhook mode
     *
     * @tags Webhooks
     * @name WebhookControllerHandleTelegramUpdate
     * @summary Telegram bot webhook
     * @request POST:/api/webhooks/telegram
     * @response `200` `void` Update processed successfully
     * @response `403` `void` Invalid secret token
     */
    webhookControllerHandleTelegramUpdate: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/webhooks/telegram`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Receives updates from Telegram for the support bot when in webhook mode
     *
     * @tags Webhooks
     * @name WebhookControllerHandleSupportUpdate
     * @summary Support bot webhook
     * @request POST:/api/webhooks/support
     * @response `200` `void` Update processed successfully
     * @response `403` `void` Invalid secret token
     */
    webhookControllerHandleSupportUpdate: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/webhooks/support`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Handles Skinsback payment notifications when user completes skin deposit
     *
     * @tags Webhooks
     * @name WebhookControllerHandleSkinsbackWebhook
     * @summary Skinsback payment webhook
     * @request POST:/api/webhooks/payment/skinsback
     * @response `200` `void` Webhook processed successfully
     */
    webhookControllerHandleSkinsbackWebhook: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/webhooks/payment/skinsback`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Handles NOROS P2P payment notifications when user completes payment
     *
     * @tags Webhooks
     * @name WebhookControllerHandleNorosP2PWebhook
     * @summary NOROS P2P payment webhook
     * @request POST:/api/webhooks/payment/noros-p2p
     * @response `200` `void` Webhook processed successfully
     */
    webhookControllerHandleNorosP2PWebhook: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/webhooks/payment/noros-p2p`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Handles Wata.pro SBP transaction notifications. Status is re-fetched from API for security.
     *
     * @tags Webhooks
     * @name WebhookControllerHandleWataproSbpWebhook
     * @summary Wata.pro SBP payment webhook
     * @request POST:/api/webhooks/payment/watapro-sbp
     * @response `200` `void` Webhook processed successfully
     */
    webhookControllerHandleWataproSbpWebhook: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/webhooks/payment/watapro-sbp`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Receives Safon session state-change notifications. Re-fetches authoritative state via API inside the provider, then dispatches ProcessPaymentWebhookCommand.
     *
     * @tags Webhooks
     * @name WebhookControllerHandleSafonWebhook
     * @summary Safon payment webhook
     * @request POST:/api/webhooks/payment/safon
     * @response `200` `void` Webhook processed successfully
     */
    webhookControllerHandleSafonWebhook: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/webhooks/payment/safon`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Receives RioPay order state-change callbacks. Re-fetches authoritative state via API inside the provider, then dispatches ProcessPaymentWebhookCommand. Always answers 200 — RioPay fails the order when the callback is not acknowledged.
     *
     * @tags Webhooks
     * @name WebhookControllerHandleRiopayWebhook
     * @summary RioPay SBP payment callback
     * @request POST:/api/webhooks/payment/riopay
     * @response `200` `void` Callback acknowledged
     */
    webhookControllerHandleRiopayWebhook: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/webhooks/payment/riopay`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Receives Uzum acquiring callbacks. The body carries no signature, so the provider re-fetches the authoritative order state via getOrderStatus before crediting. Always answers 200 — Uzum retries otherwise.
     *
     * @tags Webhooks
     * @name WebhookControllerHandleUzumWebhook
     * @summary Uzum Checkout payment callback
     * @request POST:/api/webhooks/payment/uzum
     * @response `200` `void` Callback acknowledged
     */
    webhookControllerHandleUzumWebhook: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/webhooks/payment/uzum`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Receives 2328.io payment notifications. The body carries an HMAC sign, but the provider still re-fetches the authoritative state via /v1/payment/info before crediting. Always answers 200 — 2328 retries up to 5 times otherwise.
     *
     * @tags Webhooks
     * @name WebhookControllerHandle2328Webhook
     * @summary 2328.io crypto payment webhook
     * @request POST:/api/webhooks/payment/2328
     * @response `200` `void` Webhook acknowledged
     */
    webhookControllerHandle2328Webhook: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/webhooks/payment/2328`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Receives EasyPay Stripe events. The HMAC signature is verified over the raw body before anything is dispatched; an unsigned or stale event is rejected with 401 (EasyPay does not retry 4xx and raises an internal alert instead).
     *
     * @tags Webhooks
     * @name WebhookControllerHandleEasyPayWebhook
     * @summary EasyPay (Stripe USD) payment webhook
     * @request POST:/api/webhooks/payment/easypay
     * @response `200` `void` Webhook processed
     * @response `401` `void` Invalid signature
     */
    webhookControllerHandleEasyPayWebhook: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/webhooks/payment/easypay`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Receives 1Payment status notifications. The md5 sign is verified over the received fields, then the authoritative state is re-fetched via status_payment before crediting. 1Payment retries once a minute for 10 minutes when the callback is not answered 200.
     *
     * @tags Webhooks
     * @name WebhookControllerHandleOnePaymentWebhook
     * @summary 1Payment SBP payment callback
     * @request POST:/api/webhooks/payment/1payment
     * @response `200` `void` Callback processed successfully
     * @response `401` `void` Invalid signature
     */
    webhookControllerHandleOnePaymentWebhook: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/webhooks/payment/1payment`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Click posts a urlencoded Prepare request to validate and reserve the order. The md5 sign_string is verified and a Click error-code envelope is returned.
     *
     * @tags Webhooks
     * @name WebhookControllerHandleClickPrepare
     * @summary Click.uz SHOP API Prepare (action=0)
     * @request POST:/api/webhooks/payment/click/prepare
     * @response `200` `void` Prepare processed
     */
    webhookControllerHandleClickPrepare: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/webhooks/payment/click/prepare`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Click posts a urlencoded Complete request confirming funds. The md5 sign_string is verified and, on success, the balance is credited via the shared payment chokepoint (idempotent under retries).
     *
     * @tags Webhooks
     * @name WebhookControllerHandleClickComplete
     * @summary Click.uz SHOP API Complete (action=1)
     * @request POST:/api/webhooks/payment/click/complete
     * @response `200` `void` Complete processed
     */
    webhookControllerHandleClickComplete: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/webhooks/payment/click/complete`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Realtime
     * @name RealtimeControllerGetToken
     * @summary Get Centrifugo connection token
     * @request GET:/api/users/realtime/token
     * @secure
     * @response `200` `CentrifugoTokenResponse` Token generated successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    realtimeControllerGetToken: (params: RequestParams = {}) =>
      this.request<CentrifugoTokenResponse, void>({
        path: `/api/users/realtime/token`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Realtime
     * @name RealtimeControllerHeartbeat
     * @summary Report current presence (online + activity)
     * @request POST:/api/users/realtime/heartbeat
     * @secure
     * @response `200` `HeartbeatResponse` Heartbeat recorded
     * @response `201` `HeartbeatResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    realtimeControllerHeartbeat: (
      data: HeartbeatRequest,
      params: RequestParams = {},
    ) =>
      this.request<HeartbeatResponse, void>({
        path: `/api/users/realtime/heartbeat`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Realtime
     * @name RealtimeControllerGetOnlineCount
     * @summary Get online users count (public)
     * @request GET:/api/users/realtime/online
     * @response `200` `OnlineCountResponse` Online count retrieved
     */
    realtimeControllerGetOnlineCount: (params: RequestParams = {}) =>
      this.request<OnlineCountResponse, any>({
        path: `/api/users/realtime/online`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Read-only token limited to drops_feed, online_count and game_stats channels
     *
     * @tags Realtime
     * @name RealtimeControllerGetPublicToken
     * @summary Anonymous Centrifugo connection token (public channels only)
     * @request GET:/api/users/realtime/public-token
     * @response `200` `CentrifugoTokenResponse` Anonymous token generated
     */
    realtimeControllerGetPublicToken: (params: RequestParams = {}) =>
      this.request<CentrifugoTokenResponse, any>({
        path: `/api/users/realtime/public-token`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerCreateCaseBattle
     * @summary Create a new case battle
     * @request POST:/api/users/case-battles
     * @secure
     * @response `201` `CreateCaseBattleResponse` Case battle created successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseBattleControllerCreateCaseBattle: (
      data: CreateCaseBattleRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateCaseBattleResponse, void>({
        path: `/api/users/case-battles`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerGetActiveCaseBattles
     * @summary Lobby: waiting and running case battles
     * @request GET:/api/users/case-battles
     * @response `200` `CaseBattleListResponse`
     */
    caseBattleControllerGetActiveCaseBattles: (
      query: CaseBattleControllerGetActiveCaseBattlesParams,
      params: RequestParams = {},
    ) =>
      this.request<CaseBattleListResponse, any>({
        path: `/api/users/case-battles`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerGetConfig
     * @summary Case battle limits and timings
     * @request GET:/api/users/case-battles/config
     * @response `200` `CaseBattleConfigResponse`
     */
    caseBattleControllerGetConfig: (params: RequestParams = {}) =>
      this.request<CaseBattleConfigResponse, any>({
        path: `/api/users/case-battles/config`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerGetTemplates
     * @summary Battle templates: saved, recent, recommended
     * @request GET:/api/users/case-battles/templates
     * @secure
     * @response `200` `CaseBattleTemplatesResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseBattleControllerGetTemplates: (params: RequestParams = {}) =>
      this.request<CaseBattleTemplatesResponse, void>({
        path: `/api/users/case-battles/templates`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Case Battles
 * @name CaseBattleControllerSaveTemplate
 * @summary Save a battle template
 * @request POST:/api/users/case-battles/templates
 * @secure
 * @response `201` `{
    templateId?: string,

}` Template id
 * @response `403` `void` Forbidden. User authentication required.
 */
    caseBattleControllerSaveTemplate: (
      data: SaveCaseBattleTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          templateId?: string;
        },
        void
      >({
        path: `/api/users/case-battles/templates`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerDeleteTemplate
     * @summary Delete a saved battle template
     * @request DELETE:/api/users/case-battles/templates/{id}
     * @secure
     * @response `200` `void`
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseBattleControllerDeleteTemplate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/users/case-battles/templates/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerGetUserActiveBattlesCount
     * @summary Get user active battles count
     * @request GET:/api/users/case-battles/me/active-count
     * @secure
     * @response `200` `UserActiveBattlesCountResponse` User active battles count retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseBattleControllerGetUserActiveBattlesCount: (
      params: RequestParams = {},
    ) =>
      this.request<UserActiveBattlesCountResponse, void>({
        path: `/api/users/case-battles/me/active-count`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerGetAllCaseBattleHistory
     * @summary Get all completed case battles history
     * @request GET:/api/users/case-battles/history/all
     * @response `200` `CaseBattleHistoryPaginatedResponse` All case battles history retrieved successfully
     */
    caseBattleControllerGetAllCaseBattleHistory: (
      query: CaseBattleControllerGetAllCaseBattleHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<CaseBattleHistoryPaginatedResponse, any>({
        path: `/api/users/case-battles/history/all`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerGetUserCaseBattleHistory
     * @summary Get user case battle history
     * @request GET:/api/users/case-battles/history
     * @secure
     * @response `200` `CaseBattleHistoryPaginatedResponse` Case battle history retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseBattleControllerGetUserCaseBattleHistory: (
      query: CaseBattleControllerGetUserCaseBattleHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<CaseBattleHistoryPaginatedResponse, void>({
        path: `/api/users/case-battles/history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerGetCaseBattleDetails
     * @summary Get case battle details
     * @request GET:/api/users/case-battles/{id}
     * @response `200` `CaseBattleDetailsResponse` Case battle details retrieved successfully
     */
    caseBattleControllerGetCaseBattleDetails: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<CaseBattleDetailsResponse, any>({
        path: `/api/users/case-battles/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerGetViewers
     * @summary Who plays and who is watching
     * @request GET:/api/users/case-battles/{id}/viewers
     * @response `200` `CaseBattleViewersResponse`
     */
    caseBattleControllerGetViewers: (id: string, params: RequestParams = {}) =>
      this.request<CaseBattleViewersResponse, any>({
        path: `/api/users/case-battles/${id}/viewers`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerJoinCaseBattle
     * @summary Join a case battle
     * @request POST:/api/users/case-battles/{id}/join
     * @secure
     * @response `200` `void` Successfully joined the case battle
     * @response `201` `void`
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseBattleControllerJoinCaseBattle: (
      id: string,
      data: JoinCaseBattleRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/users/case-battles/${id}/join`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerLeaveCaseBattle
     * @summary Leave a case battle
     * @request POST:/api/users/case-battles/{id}/leave
     * @secure
     * @response `200` `void` Successfully left the case battle
     * @response `201` `void`
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseBattleControllerLeaveCaseBattle: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/users/case-battles/${id}/leave`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerStartNow
     * @summary Ready to start without waiting for a full roster; starts when every seated player is ready
     * @request POST:/api/users/case-battles/{id}/start-now
     * @secure
     * @response `201` `void`
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseBattleControllerStartNow: (
      id: string,
      data: StartNowCaseBattleRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/users/case-battles/${id}/start-now`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerRematch
     * @summary Start a rematch: same setup, invites to the other players
     * @request POST:/api/users/case-battles/{id}/rematch
     * @secure
     * @response `201` `RematchCaseBattleResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseBattleControllerRematch: (id: string, params: RequestParams = {}) =>
      this.request<RematchCaseBattleResponse, void>({
        path: `/api/users/case-battles/${id}/rematch`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerAcceptRematch
     * @summary Accept a rematch invite (joins the rematch battle)
     * @request POST:/api/users/case-battles/{id}/rematch/accept
     * @secure
     * @response `201` `RematchCaseBattleResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseBattleControllerAcceptRematch: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<RematchCaseBattleResponse, void>({
        path: `/api/users/case-battles/${id}/rematch/accept`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerDeclineRematch
     * @summary Decline a rematch invite
     * @request POST:/api/users/case-battles/{id}/rematch/decline
     * @secure
     * @response `201` `RematchCaseBattleResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseBattleControllerDeclineRematch: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<RematchCaseBattleResponse, void>({
        path: `/api/users/case-battles/${id}/rematch/decline`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerSellAll
     * @summary Sell every item won in this battle
     * @request POST:/api/users/case-battles/{id}/sell-all
     * @secure
     * @response `201` `SellAllCaseBattleResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseBattleControllerSellAll: (id: string, params: RequestParams = {}) =>
      this.request<SellAllCaseBattleResponse, void>({
        path: `/api/users/case-battles/${id}/sell-all`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerReact
     * @summary Send a reaction to everyone watching the battle
     * @request POST:/api/users/case-battles/{id}/reactions
     * @secure
     * @response `201` `void`
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseBattleControllerReact: (
      id: string,
      data: ReactCaseBattleRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/users/case-battles/${id}/reactions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerView
     * @summary Mark the viewer as watching (repeat every 30 s)
     * @request POST:/api/users/case-battles/{id}/view
     * @secure
     * @response `201` `CaseBattleViewersCountResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseBattleControllerView: (id: string, params: RequestParams = {}) =>
      this.request<CaseBattleViewersCountResponse, void>({
        path: `/api/users/case-battles/${id}/view`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Case Battles
     * @name CaseBattleControllerLeaveView
     * @summary Viewer closed the battle
     * @request POST:/api/users/case-battles/{id}/view/leave
     * @secure
     * @response `201` `CaseBattleViewersCountResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    caseBattleControllerLeaveView: (id: string, params: RequestParams = {}) =>
      this.request<CaseBattleViewersCountResponse, void>({
        path: `/api/users/case-battles/${id}/view/leave`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerGetConfig
     * @summary Per-user Rush Mid availability (comingSoon = tease the tile, refuse entry)
     * @request GET:/api/users/rush-mid/config
     * @secure
     * @response `200` `RushMidConfigResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerGetConfig: (params: RequestParams = {}) =>
      this.request<RushMidConfigResponse, void>({
        path: `/api/users/rush-mid/config`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerCreateOpenGame
     * @summary Create an open game on a side (matchMode 'bots' = solo/party practice — no stake, not listed). When the caller is in a party the ticket/mode/side come from the RATIFIED party row, not the request body — the request config only applies to a solo.
     * @request POST:/api/users/rush-mid/games
     * @secure
     * @response `201` `RushMidSnapshot` Snapshot (OPEN, or BUYING for a bots practice game)
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerCreateOpenGame: (
      data: CreateOpenGameRequest,
      params: RequestParams = {},
    ) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/games`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerListOpenGames
     * @summary List every public open (FORMING) game, newest first
     * @request GET:/api/users/rush-mid/games
     * @secure
     * @response `200` `OpenGamesListResponse` Open games list
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerListOpenGames: (params: RequestParams = {}) =>
      this.request<OpenGamesListResponse, void>({
        path: `/api/users/rush-mid/games`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerListLiveGames
     * @summary List every live (PLAYING) match — the «Идут сейчас» spectate list, newest first
     * @request GET:/api/users/rush-mid/games/live
     * @secure
     * @response `200` `LiveGamesListResponse` Live games list
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerListLiveGames: (params: RequestParams = {}) =>
      this.request<LiveGamesListResponse, void>({
        path: `/api/users/rush-mid/games/live`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerGetOpenGame
     * @summary One open game by id (404 once it fills, starts or closes)
     * @request GET:/api/users/rush-mid/games/{id}
     * @secure
     * @response `200` `OpenGame` Open game
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerGetOpenGame: (id: string, params: RequestParams = {}) =>
      this.request<OpenGame, void>({
        path: `/api/users/rush-mid/games/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerWatchGame
     * @summary Read-only spectator view of a live match (PLAYING/OVER; 404 while BUYING/not started or once gone)
     * @request GET:/api/users/rush-mid/games/{id}/watch
     * @secure
     * @response `200` `RushMidSpectateView` Spectator view
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerWatchGame: (id: string, params: RequestParams = {}) =>
      this.request<RushMidSpectateView, void>({
        path: `/api/users/rush-mid/games/${id}/watch`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerJoinOpenGame
     * @summary Join an open game on a side
     * @request POST:/api/users/rush-mid/games/{id}/join
     * @secure
     * @response `201` `RushMidSnapshot` Snapshot (OPEN, or BUYING if the join fills the house)
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerJoinOpenGame: (
      id: string,
      data: JoinOpenGameRequest,
      params: RequestParams = {},
    ) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/games/${id}/join`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerLeaveOpenGame
     * @summary Leave the open game (party leader takes the whole party out)
     * @request POST:/api/users/rush-mid/games/leave
     * @secure
     * @response `201` `RushMidSnapshot` Snapshot (NONE)
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerLeaveOpenGame: (params: RequestParams = {}) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/games/leave`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerCreateParty
     * @summary Create a party (caller becomes leader); returns the PARTY snapshot + code
     * @request POST:/api/users/rush-mid/party/create
     * @secure
     * @response `201` `RushMidSnapshot` Snapshot (PARTY)
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerCreateParty: (params: RequestParams = {}) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/party/create`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerJoinParty
     * @summary Join a party by its secret code
     * @request POST:/api/users/rush-mid/party/join
     * @secure
     * @response `201` `RushMidSnapshot` Snapshot (PARTY)
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerJoinParty: (
      data: PartyJoinRequest,
      params: RequestParams = {},
    ) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/party/join`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerConfigParty
     * @summary Leader-only: set party mode/ticket/side (mode must fit the party size)
     * @request POST:/api/users/rush-mid/party/config
     * @secure
     * @response `201` `RushMidSnapshot` Snapshot (PARTY)
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerConfigParty: (
      data: PartyConfigRequest,
      params: RequestParams = {},
    ) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/party/config`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerLeaveParty
     * @summary Leave the current party — individual for every role (leader hands off to the freshest survivor); frees the leaver's waiting-game seat with a refund
     * @request POST:/api/users/rush-mid/party/leave
     * @secure
     * @response `201` `RushMidSnapshot` Snapshot (NONE)
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerLeaveParty: (params: RequestParams = {}) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/party/leave`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerKickParty
     * @summary Leader-only: remove a member from the party (FORMING only)
     * @request POST:/api/users/rush-mid/party/kick
     * @secure
     * @response `201` `RushMidSnapshot` Snapshot (PARTY)
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerKickParty: (
      data: PartyKickRequest,
      params: RequestParams = {},
    ) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/party/kick`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerSetPartyReady
     * @summary Toggle your own ready flag in the party (leader starts once all ready)
     * @request POST:/api/users/rush-mid/party/ready
     * @secure
     * @response `201` `RushMidSnapshot` Snapshot (PARTY)
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerSetPartyReady: (
      data: PartyReadyRequest,
      params: RequestParams = {},
    ) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/party/ready`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerSubmitLoadout
     * @summary Submit this player loadout for a match (starts when all players are ready)
     * @request POST:/api/users/rush-mid/match/{id}/loadout
     * @secure
     * @response `201` `RushMidSnapshot` Snapshot (BUYING / PLAYING)
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerSubmitLoadout: (
      id: string,
      data: SubmitLoadoutRequest,
      params: RequestParams = {},
    ) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/match/${id}/loadout`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerSubmitAction
     * @summary Submit this player action for the current round (shoot / grenade / medkit)
     * @request POST:/api/users/rush-mid/match/{id}/action
     * @secure
     * @response `201` `RushMidSnapshot` Snapshot (current/next PLAYING round, or OVER)
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerSubmitAction: (
      id: string,
      data: SubmitActionRequest,
      params: RequestParams = {},
    ) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/match/${id}/action`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerLeaveMatch
     * @summary Dismiss a FINISHED match result screen (a live match cannot be left — an absent player is auto-piloted and settles normally)
     * @request POST:/api/users/rush-mid/match/{id}/leave
     * @secure
     * @response `201` `RushMidSnapshot` Snapshot (NONE)
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerLeaveMatch: (id: string, params: RequestParams = {}) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/match/${id}/leave`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerSnapshot
     * @summary Poll the user's current Rush Mid snapshot (single source of truth)
     * @request GET:/api/users/rush-mid/snapshot
     * @secure
     * @response `200` `RushMidSnapshot` Snapshot
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerSnapshot: (params: RequestParams = {}) =>
      this.request<RushMidSnapshot, void>({
        path: `/api/users/rush-mid/snapshot`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerHistory
     * @summary Get the current user recent Rush Mid matches
     * @request GET:/api/users/rush-mid/history
     * @secure
     * @response `200` `RushMidHistoryResponse` Rush Mid history retrieved successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerHistory: (
      query: RushMidControllerHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<RushMidHistoryResponse, void>({
        path: `/api/users/rush-mid/history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerRating
     * @summary The caller's ELO rating + top-50 leaderboard for a mode
     * @request GET:/api/users/rush-mid/rating
     * @secure
     * @response `200` `RushMidRatingResponse` Rating + leaderboard retrieved
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerRating: (
      query: RushMidControllerRatingParams,
      params: RequestParams = {},
    ) =>
      this.request<RushMidRatingResponse, void>({
        path: `/api/users/rush-mid/rating`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerGetSkins
     * @summary The user's saved fighter skin per side (to prefill the lobby picker)
     * @request GET:/api/users/rush-mid/skins
     * @secure
     * @response `200` `RushMidSkinsResponse` Saved skins per side
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerGetSkins: (params: RequestParams = {}) =>
      this.request<RushMidSkinsResponse, void>({
        path: `/api/users/rush-mid/skins`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerSaveLobbyConfig
     * @summary Persist the solo lobby config (ticket/mode/side/matchMode) on every change, so the lobby restores it on reopen
     * @request POST:/api/users/rush-mid/lobby-config
     * @secure
     * @response `200` `void` saved
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerSaveLobbyConfig: (
      data: JoinMatchmakingRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/users/rush-mid/lobby-config`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerSetSkin
     * @summary Save the chosen fighter skin for one side (t / ct)
     * @request PUT:/api/users/rush-mid/skin
     * @secure
     * @response `200` `void` Skin saved
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerSetSkin: (
      data: SetRushMidSkinRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/users/rush-mid/skin`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerSetWeaponSkin
     * @summary Put on (or take off) a weapon skin for one weapon key
     * @request PUT:/api/users/rush-mid/weapon-skin
     * @secure
     * @response `200` `void` Weapon skin saved
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerSetWeaponSkin: (
      data: SetRushMidWeaponSkinRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/users/rush-mid/weapon-skin`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerMatchDetail
     * @summary Full detail + replay of one of the user's past matches
     * @request GET:/api/users/rush-mid/match/{id}/detail
     * @secure
     * @response `200` `RushMidMatchDetail` Match detail retrieved
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerMatchDetail: (id: string, params: RequestParams = {}) =>
      this.request<RushMidMatchDetail, void>({
        path: `/api/users/rush-mid/match/${id}/detail`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Mid
     * @name RushMidControllerReplay
     * @summary Shareable replay of any finished match (any signed-in user)
     * @request GET:/api/users/rush-mid/replay/{id}
     * @secure
     * @response `200` `RushMidReplay` Replay retrieved
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushMidControllerReplay: (id: string, params: RequestParams = {}) =>
      this.request<RushMidReplay, void>({
        path: `/api/users/rush-mid/replay/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Arena
     * @name ArenaControllerCosmetics
     * @request GET:/api/users/arena/cosmetics
     * @secure
     * @response `200` `ArenaCosmeticsResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    arenaControllerCosmetics: (params: RequestParams = {}) =>
      this.request<ArenaCosmeticsResponse, void>({
        path: `/api/users/arena/cosmetics`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Arena
     * @name ArenaControllerSetFighter
     * @request POST:/api/users/arena/cosmetics
     * @secure
     * @response `201` `ArenaCosmeticsResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    arenaControllerSetFighter: (
      data: SetArenaFighter,
      params: RequestParams = {},
    ) =>
      this.request<ArenaCosmeticsResponse, void>({
        path: `/api/users/arena/cosmetics`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Arena
     * @name ArenaControllerGames
     * @request GET:/api/users/arena/games
     * @secure
     * @response `200` `ArenaGames`
     * @response `403` `void` Forbidden. User authentication required.
     */
    arenaControllerGames: (params: RequestParams = {}) =>
      this.request<ArenaGames, void>({
        path: `/api/users/arena/games`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Arena
     * @name ArenaControllerCreate
     * @request POST:/api/users/arena/games
     * @secure
     * @response `201` `ArenaSnapshot`
     * @response `403` `void` Forbidden. User authentication required.
     */
    arenaControllerCreate: (
      data: ArenaCreateGame,
      params: RequestParams = {},
    ) =>
      this.request<ArenaSnapshot, void>({
        path: `/api/users/arena/games`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Arena
     * @name ArenaControllerLiveGames
     * @request GET:/api/users/arena/games/live
     * @secure
     * @response `200` `ArenaGames`
     * @response `403` `void` Forbidden. User authentication required.
     */
    arenaControllerLiveGames: (params: RequestParams = {}) =>
      this.request<ArenaGames, void>({
        path: `/api/users/arena/games/live`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Arena
     * @name ArenaControllerJoin
     * @request POST:/api/users/arena/games/{id}/join
     * @secure
     * @response `201` `ArenaSnapshot`
     * @response `403` `void` Forbidden. User authentication required.
     */
    arenaControllerJoin: (
      id: string,
      data: ArenaJoinGame,
      params: RequestParams = {},
    ) =>
      this.request<ArenaSnapshot, void>({
        path: `/api/users/arena/games/${id}/join`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Arena
     * @name ArenaControllerLeave
     * @request POST:/api/users/arena/games/{id}/leave
     * @secure
     * @response `201` `ArenaLeave`
     * @response `403` `void` Forbidden. User authentication required.
     */
    arenaControllerLeave: (id: string, params: RequestParams = {}) =>
      this.request<ArenaLeave, void>({
        path: `/api/users/arena/games/${id}/leave`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Arena
     * @name ArenaControllerSnapshot
     * @request GET:/api/users/arena/matches/{id}/snapshot
     * @secure
     * @response `200` `ArenaSnapshot`
     * @response `403` `void` Forbidden. User authentication required.
     */
    arenaControllerSnapshot: (id: string, params: RequestParams = {}) =>
      this.request<ArenaSnapshot, void>({
        path: `/api/users/arena/matches/${id}/snapshot`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Arena
     * @name ArenaControllerTicket
     * @request POST:/api/users/arena/matches/{id}/ticket
     * @secure
     * @response `201` `ArenaTicket`
     * @response `403` `void` Forbidden. User authentication required.
     */
    arenaControllerTicket: (id: string, params: RequestParams = {}) =>
      this.request<ArenaTicket, void>({
        path: `/api/users/arena/matches/${id}/ticket`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Arena
     * @name ArenaControllerHistory
     * @request GET:/api/users/arena/history
     * @secure
     * @response `200` `ArenaHistory`
     * @response `403` `void` Forbidden. User authentication required.
     */
    arenaControllerHistory: (
      query: ArenaControllerHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<ArenaHistory, void>({
        path: `/api/users/arena/history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Arena
     * @name ArenaControllerDetail
     * @request GET:/api/users/arena/matches/{id}/detail
     * @secure
     * @response `200` `ArenaDetail`
     * @response `403` `void` Forbidden. User authentication required.
     */
    arenaControllerDetail: (id: string, params: RequestParams = {}) =>
      this.request<ArenaDetail, void>({
        path: `/api/users/arena/matches/${id}/detail`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Arena
     * @name ArenaControllerRating
     * @request GET:/api/users/arena/rating
     * @secure
     * @response `200` `ArenaRatings`
     * @response `403` `void` Forbidden. User authentication required.
     */
    arenaControllerRating: (
      query: ArenaControllerRatingParams,
      params: RequestParams = {},
    ) =>
      this.request<ArenaRatings, void>({
        path: `/api/users/arena/rating`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Arena
     * @name ArenaControllerConfig
     * @request GET:/api/users/arena/config
     * @secure
     * @response `200` `ArenaConfig`
     * @response `403` `void` Forbidden. User authentication required.
     */
    arenaControllerConfig: (params: RequestParams = {}) =>
      this.request<ArenaConfig, void>({
        path: `/api/users/arena/config`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Arena
     * @name ArenaPartyControllerCreate
     * @request POST:/api/users/arena/party/create
     * @secure
     * @response `201` `ArenaPartySnapshot`
     * @response `403` `void` Forbidden. User authentication required.
     */
    arenaPartyControllerCreate: (params: RequestParams = {}) =>
      this.request<ArenaPartySnapshot, void>({
        path: `/api/users/arena/party/create`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Arena
     * @name ArenaPartyControllerJoin
     * @request POST:/api/users/arena/party/join
     * @secure
     * @response `201` `ArenaPartySnapshot`
     * @response `403` `void` Forbidden. User authentication required.
     */
    arenaPartyControllerJoin: (
      data: ArenaPartyJoin,
      params: RequestParams = {},
    ) =>
      this.request<ArenaPartySnapshot, void>({
        path: `/api/users/arena/party/join`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Arena
     * @name ArenaPartyControllerReady
     * @request POST:/api/users/arena/party/ready
     * @secure
     * @response `201` `ArenaPartySnapshot`
     * @response `403` `void` Forbidden. User authentication required.
     */
    arenaPartyControllerReady: (
      data: ArenaPartyReady,
      params: RequestParams = {},
    ) =>
      this.request<ArenaPartySnapshot, void>({
        path: `/api/users/arena/party/ready`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Arena
     * @name ArenaPartyControllerKick
     * @request POST:/api/users/arena/party/kick
     * @secure
     * @response `201` `ArenaPartySnapshot`
     * @response `403` `void` Forbidden. User authentication required.
     */
    arenaPartyControllerKick: (
      data: ArenaPartyKick,
      params: RequestParams = {},
    ) =>
      this.request<ArenaPartySnapshot, void>({
        path: `/api/users/arena/party/kick`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Arena
     * @name ArenaPartyControllerLeave
     * @request POST:/api/users/arena/party/leave
     * @secure
     * @response `201` `ArenaNoParty`
     * @response `403` `void` Forbidden. User authentication required.
     */
    arenaPartyControllerLeave: (params: RequestParams = {}) =>
      this.request<ArenaNoParty, void>({
        path: `/api/users/arena/party/leave`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Arena
     * @name ArenaPartyControllerMy
     * @request GET:/api/users/arena/party/my
     * @secure
     * @response `200` `(ArenaPartySnapshot | ArenaNoParty)`
     * @response `403` `void` Forbidden. User authentication required.
     */
    arenaPartyControllerMy: (params: RequestParams = {}) =>
      this.request<ArenaPartySnapshot | ArenaNoParty, void>({
        path: `/api/users/arena/party/my`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Arena internal
     * @name ArenaInternalControllerStarted
     * @request POST:/api/internal/arena/matches/{id}/started
     * @response `201` `ArenaReportAck`
     */
    arenaInternalControllerStarted: (
      id: string,
      data: ArenaStartedReport,
      params: RequestParams = {},
    ) =>
      this.request<ArenaReportAck, any>({
        path: `/api/internal/arena/matches/${id}/started`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Arena internal
     * @name ArenaInternalControllerProgress
     * @request POST:/api/internal/arena/matches/{id}/progress
     * @response `201` `ArenaReportAck`
     */
    arenaInternalControllerProgress: (
      id: string,
      data: ArenaProgressReport,
      params: RequestParams = {},
    ) =>
      this.request<ArenaReportAck, any>({
        path: `/api/internal/arena/matches/${id}/progress`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Arena internal
     * @name ArenaInternalControllerResult
     * @request POST:/api/internal/arena/matches/{id}/result
     * @response `201` `ArenaReportAck`
     */
    arenaInternalControllerResult: (
      id: string,
      data: ArenaResultReport,
      params: RequestParams = {},
    ) =>
      this.request<ArenaReportAck, any>({
        path: `/api/internal/arena/matches/${id}/result`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roulette
     * @name RouletteControllerGames
     * @summary Ticket presets plus every live game (OPEN + COUNTDOWN) with its stake, seats and bullets
     * @request GET:/api/users/roulette/games
     * @secure
     * @response `200` `RouletteGames`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rouletteControllerGames: (params: RequestParams = {}) =>
      this.request<RouletteGames, void>({
        path: `/api/users/roulette/games`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roulette
     * @name RouletteControllerCreateGame
     * @summary Create a game with your own ticket, seats and bullets — or seat into an OPEN game with identical parameters
     * @request POST:/api/users/roulette/games
     * @secure
     * @response `201` `RouletteState`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rouletteControllerCreateGame: (
      data: RouletteCreateGameRequest,
      params: RequestParams = {},
    ) =>
      this.request<RouletteState, void>({
        path: `/api/users/roulette/games`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roulette
     * @name RouletteControllerJoinGame
     * @summary Join THIS specific game (debits the stake) — refused if full, started or the caller is already seated
     * @request POST:/api/users/roulette/games/{id}/join
     * @secure
     * @response `201` `RouletteState`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rouletteControllerJoinGame: (id: string, params: RequestParams = {}) =>
      this.request<RouletteState, void>({
        path: `/api/users/roulette/games/${id}/join`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roulette
     * @name RouletteControllerLeaveGame
     * @summary Leave a filling lobby (refunds the stake) — refused once the house is full or the game is live
     * @request POST:/api/users/roulette/games/leave
     * @secure
     * @response `201` `RouletteState`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rouletteControllerLeaveGame: (params: RequestParams = {}) =>
      this.request<RouletteState, void>({
        path: `/api/users/roulette/games/leave`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roulette
     * @name RouletteControllerState
     * @summary Poll the caller's current roulette status: none | match (lobby, countdown or live game)
     * @request GET:/api/users/roulette/state
     * @secure
     * @response `200` `RouletteState`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rouletteControllerState: (params: RequestParams = {}) =>
      this.request<RouletteState, void>({
        path: `/api/users/roulette/state`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roulette
     * @name RouletteControllerMatch
     * @summary A match snapshot — never leaks the server seed, bullet positions or event log before FINISHED/CANCELLED
     * @request GET:/api/users/roulette/matches/{id}
     * @secure
     * @response `200` `RouletteMatch`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rouletteControllerMatch: (id: string, params: RequestParams = {}) =>
      this.request<RouletteMatch, void>({
        path: `/api/users/roulette/matches/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roulette
     * @name RouletteControllerPull
     * @summary Pull the trigger — only the current shooter may call this
     * @request POST:/api/users/roulette/matches/{id}/pull
     * @secure
     * @response `201` `RouletteMatch`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rouletteControllerPull: (id: string, params: RequestParams = {}) =>
      this.request<RouletteMatch, void>({
        path: `/api/users/roulette/matches/${id}/pull`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roulette
     * @name RouletteControllerSkip
     * @summary Skip your turn (debits the skip cost) — only the current shooter, within the per-player limit
     * @request POST:/api/users/roulette/matches/{id}/skip
     * @secure
     * @response `201` `RouletteMatch`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rouletteControllerSkip: (id: string, params: RequestParams = {}) =>
      this.request<RouletteMatch, void>({
        path: `/api/users/roulette/matches/${id}/skip`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roulette
     * @name RouletteControllerHistory
     * @summary My finished/cancelled matches, newest first
     * @request GET:/api/users/roulette/history
     * @secure
     * @response `200` `RouletteHistoryResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rouletteControllerHistory: (
      query: RouletteControllerHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<RouletteHistoryResponse, void>({
        path: `/api/users/roulette/history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roulette
     * @name RouletteControllerFeed
     * @summary Global feed of every player's finished matches, newest first — headline winner + the skin they won
     * @request GET:/api/users/roulette/feed
     * @secure
     * @response `200` `RouletteFeedResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rouletteControllerFeed: (
      query: RouletteControllerFeedParams,
      params: RequestParams = {},
    ) =>
      this.request<RouletteFeedResponse, void>({
        path: `/api/users/roulette/feed`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roulette
     * @name RouletteControllerFairness
     * @summary Provably-fair reveal — server seed, event log and bullet layouts only once FINISHED/CANCELLED
     * @request GET:/api/users/roulette/matches/{id}/fairness
     * @secure
     * @response `200` `RouletteFairness`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rouletteControllerFairness: (id: string, params: RequestParams = {}) =>
      this.request<RouletteFairness, void>({
        path: `/api/users/roulette/matches/${id}/fairness`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Raffle
     * @name RushRaffleControllerGetRounds
     * @summary Today's active raffle rounds, one per ticket tier, ticket ASC
     * @request GET:/api/rush-raffle/rounds
     * @secure
     * @response `200` `RushRaffleRoundsResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushRaffleControllerGetRounds: (params: RequestParams = {}) =>
      this.request<RushRaffleRoundsResponse, void>({
        path: `/api/rush-raffle/rounds`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Raffle
     * @name RushRaffleControllerGetRoundDetail
     * @summary One raffle round — prize, leaderboard (top-50), caller stats, winner once completed
     * @request GET:/api/rush-raffle/rounds/{id}
     * @secure
     * @response `200` `RushRaffleRoundDetail`
     * @response `403` `void` Forbidden. User authentication required.
     * @response `404` `void` Round not found
     */
    rushRaffleControllerGetRoundDetail: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<RushRaffleRoundDetail, void>({
        path: `/api/rush-raffle/rounds/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Raffle
     * @name RushRaffleControllerGetWinners
     * @summary Recent completed raffle rounds with a winner, last 14 days, newest first
     * @request GET:/api/rush-raffle/winners
     * @secure
     * @response `200` `RushRaffleWinnersResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushRaffleControllerGetWinners: (params: RequestParams = {}) =>
      this.request<RushRaffleWinnersResponse, void>({
        path: `/api/rush-raffle/winners`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rush Raffle
     * @name RushRaffleControllerGetMatchAward
     * @summary The caller's raffle ticket award for a finished Rush Mid match (null if none)
     * @request GET:/api/rush-raffle/match/{matchId}/award
     * @secure
     * @response `200` `(RushRaffleMatchAward | null)` null when the caller earned no award for this match
     * @response `403` `void` Forbidden. User authentication required.
     */
    rushRaffleControllerGetMatchAward: (
      matchId: string,
      params: RequestParams = {},
    ) =>
      this.request<RushRaffleMatchAward | null, void>({
        path: `/api/rush-raffle/match/${matchId}/award`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandControllerGetStatus
     * @summary SHOT BAND membership status and balances
     * @request GET:/api/users/band/status
     * @secure
     * @response `200` `BandStatusResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandControllerGetStatus: (params: RequestParams = {}) =>
      this.request<BandStatusResponse, void>({
        path: `/api/users/band/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandControllerGetTicketPrices
     * @summary Exact SHOT BAND pass price per available payment provider
     * @request GET:/api/users/band/ticket/prices
     * @secure
     * @response `200` `BandTicketPricesResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandControllerGetTicketPrices: (params: RequestParams = {}) =>
      this.request<BandTicketPricesResponse, void>({
        path: `/api/users/band/ticket/prices`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandControllerCreateTicketInvoice
     * @summary Create a payment invoice for the SHOT BAND ticket
     * @request POST:/api/users/band/create-ticket-invoice
     * @secure
     * @response `201` `BandTicketInvoiceResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandControllerCreateTicketInvoice: (
      data: CreateBandTicketInvoice,
      params: RequestParams = {},
    ) =>
      this.request<BandTicketInvoiceResponse, void>({
        path: `/api/users/band/create-ticket-invoice`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandControllerPayTicketWithClickCard
     * @summary Charge a bound Click card for SHOT BAND access
     * @request POST:/api/users/band/ticket/pay-with-click-card
     * @secure
     * @response `200` `PayBandTicketWithClickCardResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandControllerPayTicketWithClickCard: (
      data: PayBandTicketWithClickCard,
      params: RequestParams = {},
    ) =>
      this.request<PayBandTicketWithClickCardResponse, void>({
        path: `/api/users/band/ticket/pay-with-click-card`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandControllerClaimCashback
     * @summary Claim matured SHOT BAND cashback sparks
     * @request POST:/api/users/band/cashback/claim
     * @secure
     * @response `200` `ClaimBandCashbackResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandControllerClaimCashback: (params: RequestParams = {}) =>
      this.request<ClaimBandCashbackResponse, void>({
        path: `/api/users/band/cashback/claim`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandControllerGetMembersPreview
     * @summary Active member count and a few freshest member ids for the home promo
     * @request GET:/api/users/band/members-preview
     * @secure
     * @response `200` `BandMembersPreviewResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandControllerGetMembersPreview: (params: RequestParams = {}) =>
      this.request<BandMembersPreviewResponse, void>({
        path: `/api/users/band/members-preview`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandControllerGetFreeCases
     * @summary Free SHOT BAND case opens unlocked by the day’s wager turnover
     * @request GET:/api/users/band/free-cases
     * @secure
     * @response `200` `BandFreeCasesResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandControllerGetFreeCases: (params: RequestParams = {}) =>
      this.request<BandFreeCasesResponse, void>({
        path: `/api/users/band/free-cases`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandControllerGetQuests
     * @summary Today's SHOT BAND daily quests, progress and streak
     * @request GET:/api/users/band/quests
     * @secure
     * @response `200` `BandQuestsResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandControllerGetQuests: (params: RequestParams = {}) =>
      this.request<BandQuestsResponse, void>({
        path: `/api/users/band/quests`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandControllerClaimQuest
     * @summary Claim a completed SHOT BAND daily quest
     * @request POST:/api/users/band/quests/{questId}/claim
     * @secure
     * @response `200` `BandQuestsResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandControllerClaimQuest: (questId: string, params: RequestParams = {}) =>
      this.request<BandQuestsResponse, void>({
        path: `/api/users/band/quests/${questId}/claim`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band Raffle
     * @name BandRaffleControllerGetRound
     * @summary This week's knife raffle — prize, live pot, caller stats and ticket balance
     * @request GET:/api/users/band-raffle/round
     * @secure
     * @response `200` `BandRaffleRoundResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandRaffleControllerGetRound: (params: RequestParams = {}) =>
      this.request<BandRaffleRoundResponse, void>({
        path: `/api/users/band-raffle/round`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band Raffle
     * @name BandRaffleControllerInvest
     * @summary Invest raffle tickets into the round — irreversible, members only
     * @request POST:/api/users/band-raffle/round/{id}/invest
     * @secure
     * @response `200` `InvestBandRaffleTicketsResponse`
     * @response `403` `void` Forbidden. User authentication required.
     * @response `404` `void` Round not found
     */
    bandRaffleControllerInvest: (
      id: string,
      data: InvestBandRaffleTickets,
      params: RequestParams = {},
    ) =>
      this.request<InvestBandRaffleTicketsResponse, void>({
        path: `/api/users/band-raffle/round/${id}/invest`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band Raffle
     * @name BandRaffleControllerGetRoundDetail
     * @summary One raffle round — prize, leaderboard (top-50), caller stats, winner once completed
     * @request GET:/api/users/band-raffle/round/{id}
     * @secure
     * @response `200` `BandRaffleRoundDetail`
     * @response `403` `void` Forbidden. User authentication required.
     * @response `404` `void` Round not found
     */
    bandRaffleControllerGetRoundDetail: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<BandRaffleRoundDetail, void>({
        path: `/api/users/band-raffle/round/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band Raffle
     * @name BandRaffleControllerGetWinners
     * @summary Completed weekly rounds with a winner, last 30 days, newest first
     * @request GET:/api/users/band-raffle/winners
     * @secure
     * @response `200` `BandRaffleWinnersResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandRaffleControllerGetWinners: (params: RequestParams = {}) =>
      this.request<BandRaffleWinnersResponse, void>({
        path: `/api/users/band-raffle/winners`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandRaceControllerGetDetails
     * @summary Today's SHOT BAND wager race: prize, timer, my place
     * @request GET:/api/users/band/race/details
     * @secure
     * @response `200` `BandRaceDetailsResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandRaceControllerGetDetails: (params: RequestParams = {}) =>
      this.request<BandRaceDetailsResponse, void>({
        path: `/api/users/band/race/details`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandRaceControllerGetLeaderboard
     * @summary Today's race leaderboard page
     * @request GET:/api/users/band/race/leaderboard
     * @secure
     * @response `200` `BandRaceLeaderboardResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandRaceControllerGetLeaderboard: (
      query: BandRaceControllerGetLeaderboardParams,
      params: RequestParams = {},
    ) =>
      this.request<BandRaceLeaderboardResponse, void>({
        path: `/api/users/band/race/leaderboard`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandRaceControllerGetWinners
     * @summary Past race winners, newest first
     * @request GET:/api/users/band/race/winners
     * @secure
     * @response `200` `BandRaceWinnersResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandRaceControllerGetWinners: (
      query: BandRaceControllerGetWinnersParams,
      params: RequestParams = {},
    ) =>
      this.request<BandRaceWinnersResponse, void>({
        path: `/api/users/band/race/winners`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandFinalControllerGetRound
     * @summary SHOT BAND Headliners: the week in progress and the latest closed week
     * @request GET:/api/users/band/final
     * @secure
     * @response `200` `BandFinalResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandFinalControllerGetRound: (params: RequestParams = {}) =>
      this.request<BandFinalResponse, void>({
        path: `/api/users/band/final`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandFinalControllerGetBattleInfo
     * @summary Headliners data for a band-funded battle page: state, start time, bank, shares, threshold, split by what each headliner dropped in the battle
     * @request GET:/api/users/band/final/battles/{battleId}
     * @response `200` `BandFinalBattleInfoResponse`
     */
    bandFinalControllerGetBattleInfo: (
      battleId: string,
      params: RequestParams = {},
    ) =>
      this.request<BandFinalBattleInfoResponse, any>({
        path: `/api/users/band/final/battles/${battleId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandFinalControllerGetLeaderboard
     * @summary Headliners week table page («Кто в составе»)
     * @request GET:/api/users/band/final/leaderboard
     * @secure
     * @response `200` `BandFinalLeaderboardResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandFinalControllerGetLeaderboard: (
      query: BandFinalControllerGetLeaderboardParams,
      params: RequestParams = {},
    ) =>
      this.request<BandFinalLeaderboardResponse, void>({
        path: `/api/users/band/final/leaderboard`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Band
     * @name BandFinalControllerGetWinners
     * @summary Past Headliners weeks, newest first: played ones with places, carried ones marked
     * @request GET:/api/users/band/final/winners
     * @secure
     * @response `200` `BandFinalWinnersResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    bandFinalControllerGetWinners: (
      query: BandFinalControllerGetWinnersParams,
      params: RequestParams = {},
    ) =>
      this.request<BandFinalWinnersResponse, void>({
        path: `/api/users/band/final/winners`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Achievements
     * @name AchievementsControllerGetCatalog
     * @summary Full achievement catalog with viewer-aware redaction of hidden rules. Response carries all locales — client picks display lang.
     * @request GET:/api/achievements/catalog
     * @response `200` `CatalogResponse`
     */
    achievementsControllerGetCatalog: (params: RequestParams = {}) =>
      this.request<CatalogResponse, any>({
        path: `/api/achievements/catalog`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Achievements
     * @name AchievementsControllerGetMy
     * @summary Authenticated user's merged catalog + unlock + progress view
     * @request GET:/api/users/me/achievements
     * @secure
     * @response `200` `MergedAchievementsResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    achievementsControllerGetMy: (
      query: AchievementsControllerGetMyParams,
      params: RequestParams = {},
    ) =>
      this.request<MergedAchievementsResponse, void>({
        path: `/api/users/me/achievements`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Achievements
     * @name AchievementsControllerGetClaimableRewards
     * @summary Sum of rewards for the user's unlocked-but-uncredited achievements (snapshot=0), plus whether they have a payment in the last 30 days and whether the claim endpoint may be called.
     * @request GET:/api/achievements/claimable-rewards
     * @secure
     * @response `200` `ClaimableAchievementRewards`
     * @response `403` `void` Forbidden. User authentication required.
     */
    achievementsControllerGetClaimableRewards: (params: RequestParams = {}) =>
      this.request<ClaimableAchievementRewards, void>({
        path: `/api/achievements/claimable-rewards`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Achievements
     * @name AchievementsControllerClaimRewards
     * @summary Credit the user's unlocked-but-uncredited achievements (snapshot=0). All-time deposits must cover 100% of the claimable bonus (all-or-nothing). Idempotent — re-claim grants nothing.
     * @request POST:/api/achievements/claim-rewards
     * @secure
     * @response `200` `ClaimAchievementRewardsResult`
     * @response `201` `ClaimAchievementRewardsResult`
     * @response `403` `void` Forbidden. User authentication required.
     */
    achievementsControllerClaimRewards: (params: RequestParams = {}) =>
      this.request<ClaimAchievementRewardsResult, void>({
        path: `/api/achievements/claim-rewards`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Achievements
     * @name AchievementsControllerGetForUser
     * @summary Public profile view of another user's achievements; hidden+target-locked redact
     * @request GET:/api/users/{userId}/achievements
     * @response `200` `MergedAchievementsResponse`
     */
    achievementsControllerGetForUser: (
      { userId, ...query }: AchievementsControllerGetForUserParams,
      params: RequestParams = {},
    ) =>
      this.request<MergedAchievementsResponse, any>({
        path: `/api/users/${userId}/achievements`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Achievements
     * @name AchievementsControllerGetStats
     * @summary Per-key unlock count (Redis-cached 60s) + active-user denominator (Redis-cached 1h). Anon sees 404 for hidden rules.
     * @request GET:/api/achievements/{key}/stats
     * @response `200` `AchievementStats`
     */
    achievementsControllerGetStats: (key: string, params: RequestParams = {}) =>
      this.request<AchievementStats, any>({
        path: `/api/achievements/${key}/stats`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Achievements
     * @name AchievementsControllerGetRecentReceivers
     * @summary Newest 10 unlocks for a key plus totalReceivers, both served from the Redis cache maintained by the 30-min refresh job. Anti-scrape: requires auth.
     * @request GET:/api/achievements/{key}/recent-receivers
     * @secure
     * @response `200` `RecentReceiversResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    achievementsControllerGetRecentReceivers: (
      key: string,
      params: RequestParams = {},
    ) =>
      this.request<RecentReceiversResponse, void>({
        path: `/api/achievements/${key}/recent-receivers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Survey
     * @name SurveyControllerSubmit
     * @summary Submit the product survey. One response per user — 409 if already submitted.
     * @request POST:/api/survey/response
     * @secure
     * @response `201` `SubmitSurveyResult`
     * @response `403` `void` Forbidden. User authentication required.
     */
    surveyControllerSubmit: (
      data: SubmitSurveyResponse,
      params: RequestParams = {},
    ) =>
      this.request<SubmitSurveyResult, void>({
        path: `/api/survey/response`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Survey
     * @name SurveyControllerSaveDraft
     * @summary Upsert partial survey progress. 409 if the survey is already submitted.
     * @request PUT:/api/survey/draft
     * @secure
     * @response `200` `SaveSurveyDraftResult`
     * @response `403` `void` Forbidden. User authentication required.
     */
    surveyControllerSaveDraft: (
      data: SaveSurveyDraft,
      params: RequestParams = {},
    ) =>
      this.request<SaveSurveyDraftResult, void>({
        path: `/api/survey/draft`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Survey
     * @name SurveyControllerMyStatus
     * @summary Whether the authenticated user has already submitted a survey (slug, default 'default').
     * @request GET:/api/survey/me/status
     * @secure
     * @response `200` `SurveyStatus`
     * @response `403` `void` Forbidden. User authentication required.
     */
    surveyControllerMyStatus: (
      query: SurveyControllerMyStatusParams,
      params: RequestParams = {},
    ) =>
      this.request<SurveyStatus, void>({
        path: `/api/survey/me/status`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Device Signal
 * @name DeviceSignalControllerReport
 * @summary Report device fingerprint signal
 * @request POST:/api/users/device-signal
 * @secure
 * @response `200` `{
    success?: boolean,

}` Signal recorded
 * @response `403` `void` Forbidden. User authentication required.
 */
    deviceSignalControllerReport: (
      data: ReportDeviceSignal,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
        },
        void
      >({
        path: `/api/users/device-signal`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerTma
     * @summary Authenticate via Telegram Mini App initData. Idempotent — safe to call on every cold open.
     * @request POST:/api/auth/tma
     * @response `200` `AuthSessionResponse`
     */
    authControllerTma: (data: TmaAuth, params: RequestParams = {}) =>
      this.request<AuthSessionResponse, any>({
        path: `/api/auth/tma`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerTelegramWidget
     * @summary Authenticate via Telegram Login Widget (browser web flow)
     * @request POST:/api/auth/telegram-widget
     * @response `200` `AuthSessionResponse`
     */
    authControllerTelegramWidget: (
      data: TelegramLogin,
      params: RequestParams = {},
    ) =>
      this.request<AuthSessionResponse, any>({
        path: `/api/auth/telegram-widget`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerTelegramOidcInit
     * @summary Client ID for the Telegram Login library plus a single-use nonce that the resulting ID token must carry back.
     * @request GET:/api/auth/telegram/oidc/init
     * @response `200` `TelegramOidcInitResponse`
     */
    authControllerTelegramOidcInit: (params: RequestParams = {}) =>
      this.request<TelegramOidcInitResponse, any>({
        path: `/api/auth/telegram/oidc/init`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerTelegramOidc
     * @summary Authenticate via a Telegram OpenID Connect ID token (browser web flow)
     * @request POST:/api/auth/telegram/oidc
     * @response `200` `AuthSessionResponse`
     */
    authControllerTelegramOidc: (
      data: TelegramOidc,
      params: RequestParams = {},
    ) =>
      this.request<AuthSessionResponse, any>({
        path: `/api/auth/telegram/oidc`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerLogout
     * @summary Destroy session and clear cookie
     * @request POST:/api/auth/logout
     * @response `200` `void`
     */
    authControllerLogout: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/auth/logout`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerWebHandoffInit
     * @summary Issue a single-use opaque token (Redis, TTL 60s) bound to the caller. Used by the TMA "Open in browser" flow to hand auth off to the web shell without putting initData into a URL hash.
     * @request POST:/api/auth/web-handoff/init
     * @secure
     * @response `200` `WebHandoffInitResponse`
     * @response `403` `void` Forbidden. User authentication required.
     */
    authControllerWebHandoffInit: (params: RequestParams = {}) =>
      this.request<WebHandoffInitResponse, void>({
        path: `/api/auth/web-handoff/init`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerWebHandoffRedeem
     * @summary Atomically GETDEL the handoff token, create a session cookie, return the session principal.
     * @request POST:/api/auth/web-handoff/redeem
     * @response `200` `AuthSessionResponse`
     */
    authControllerWebHandoffRedeem: (
      data: WebHandoffRedeem,
      params: RequestParams = {},
    ) =>
      this.request<AuthSessionResponse, any>({
        path: `/api/auth/web-handoff/redeem`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerMe
     * @summary Return current session principal, or 401 if no valid cookie
     * @request GET:/api/auth/me
     * @response `200` `AuthSessionResponse`
     */
    authControllerMe: (params: RequestParams = {}) =>
      this.request<AuthSessionResponse, any>({
        path: `/api/auth/me`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Steam Auth
     * @name SteamAuthControllerInitSteamLink
     * @summary Start Steam linking flow — returns redirect URL
     * @request POST:/api/users/link/steam/init
     * @secure
     * @response `200` `SteamLinkInitResponse` Redirect URL for Steam OpenID
     * @response `403` `void` Forbidden. User authentication required.
     */
    steamAuthControllerInitSteamLink: (
      query: SteamAuthControllerInitSteamLinkParams,
      params: RequestParams = {},
    ) =>
      this.request<SteamLinkInitResponse, void>({
        path: `/api/users/link/steam/init`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Steam Auth
     * @name SteamAuthControllerLoginSteam
     * @summary Redirect to Steam OpenID for login
     * @request GET:/api/users/login/steam
     * @response `200` `void`
     */
    steamAuthControllerLoginSteam: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/users/login/steam`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Steam Auth
     * @name SteamAuthControllerSteamCallback
     * @summary Steam OpenID callback (both link and login flows)
     * @request GET:/api/users/auth/steam/callback
     * @response `200` `void`
     */
    steamAuthControllerSteamCallback: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/users/auth/steam/callback`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Steam Auth
     * @name SteamAuthControllerConnectSteamToTelegram
     * @summary Connect pending Steam to existing Telegram account
     * @request POST:/api/users/connect/steam
     * @response `200` `AuthSessionResponse` Steam linked, session created
     */
    steamAuthControllerConnectSteamToTelegram: (
      data: SteamConnect,
      params: RequestParams = {},
    ) =>
      this.request<AuthSessionResponse, any>({
        path: `/api/users/connect/steam`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Steam Auth
     * @name SteamAuthControllerRegisterWithSteam
     * @summary Register new account with pending Steam data
     * @request POST:/api/users/register/steam
     * @response `200` `AuthSessionResponse` New account created, session created
     */
    steamAuthControllerRegisterWithSteam: (
      data: SteamRegister,
      params: RequestParams = {},
    ) =>
      this.request<AuthSessionResponse, any>({
        path: `/api/users/register/steam`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Telegram Link
     * @name TelegramLinkControllerLinkTelegram
     * @summary Link Telegram account to existing user
     * @request POST:/api/users/link/telegram
     * @secure
     * @response `200` `LinkTelegramResponse` Telegram linked successfully
     * @response `403` `void` Forbidden. User authentication required.
     */
    telegramLinkControllerLinkTelegram: (
      data: TelegramOidc,
      params: RequestParams = {},
    ) =>
      this.request<LinkTelegramResponse, void>({
        path: `/api/users/link/telegram`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Support
     * @name SupportControllerGetSummary
     * @summary Whether support has an unread answer for the caller
     * @request GET:/api/users/support/summary
     * @secure
     * @response `200` `SupportUserSummary`
     * @response `403` `void` Forbidden. User authentication required.
     */
    supportControllerGetSummary: (params: RequestParams = {}) =>
      this.request<SupportUserSummary, void>({
        path: `/api/users/support/summary`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Support
     * @name SupportControllerGetMessages
     * @summary The caller’s own conversation, oldest first, paging backwards in time
     * @request GET:/api/users/support/messages
     * @secure
     * @response `200` `SupportUserMessageList`
     * @response `403` `void` Forbidden. User authentication required.
     */
    supportControllerGetMessages: (
      query: SupportControllerGetMessagesParams,
      params: RequestParams = {},
    ) =>
      this.request<SupportUserMessageList, void>({
        path: `/api/users/support/messages`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Support
     * @name SupportControllerSendMessage
     * @summary Write to support; the first message opens the conversation
     * @request POST:/api/users/support/messages
     * @secure
     * @response `201` `SupportUserMessage`
     * @response `403` `void` Forbidden. User authentication required.
     */
    supportControllerSendMessage: (
      data: SendSupportMessage,
      params: RequestParams = {},
    ) =>
      this.request<SupportUserMessage, void>({
        path: `/api/users/support/messages`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Support
     * @name SupportControllerGreetInTelegram
     * @summary Ask the bot to greet the caller in their Telegram chat, as if they had sent /start support
     * @request POST:/api/users/support/telegram-greeting
     * @secure
     * @response `204` `void`
     * @response `403` `void` Forbidden. User authentication required.
     */
    supportControllerGreetInTelegram: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/users/support/telegram-greeting`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Support
     * @name SupportControllerSendAttachment
     * @summary Attach a file to the conversation. Global upload limit is 5 MB.
     * @request POST:/api/users/support/attachments
     * @secure
     * @response `201` `SupportUserMessage`
     * @response `403` `void` Forbidden. User authentication required.
     */
    supportControllerSendAttachment: (params: RequestParams = {}) =>
      this.request<SupportUserMessage, void>({
        path: `/api/users/support/attachments`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Support
     * @name SupportControllerMarkRead
     * @summary Mark support answers as read and clear the badge
     * @request POST:/api/users/support/read
     * @secure
     * @response `200` `SupportUserSummary`
     * @response `403` `void` Forbidden. User authentication required.
     */
    supportControllerMarkRead: (params: RequestParams = {}) =>
      this.request<SupportUserSummary, void>({
        path: `/api/users/support/read`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Support
     * @name SupportControllerGetAttachmentContent
     * @summary Stream one attachment from the caller’s own conversation
     * @request GET:/api/users/support/attachments/{id}/content
     * @secure
     * @response `200` `void` The attachment content
     * @response `403` `void` Forbidden. User authentication required.
     */
    supportControllerGetAttachmentContent: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/users/support/attachments/${id}/content`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
}
